window.templates = {
  twitchChat: `<div data-component="twitch-chat">
      <div 
        v-if="model.isOnline"
        style="
          position: fixed; 
          top: 10px; 
          left: 10px; 
          padding: 5px 10px; 
          background: rgba(0, 255, 0, 0.2); 
          color: #00ff00; 
          font-weight: bold; 
          border: 1px solid #00ff00; 
          border-radius: 8px; 
          backdrop-filter: blur(5px); 
          z-index: 9999;
        ">
        ? Online
      </div>
      <div 
        v-else
        style="
          position: fixed; 
          top: 10px; 
          left: 10px; 
          padding: 5px 10px;  
          background: rgba(255, 0, 0, 0.2); 
          color: #ff5100ff; 
          font-weight: bold; 
          border: 1px solid #ff0000ff; 
          border-radius: 8px; 
          backdrop-filter: blur(5px); 
          z-index: 9999;
        ">
        ? Offline
      </div>
  </div>`,

  openPack: `
    <div data-component="open-pack" class="always-display" v-bind:class="{ show: model.packLoaded, 'show': model.packLoaded }">
    <canvas id="galaxy" v-show="galaxyVisible"></canvas>
    <div class="black-hole" :style="holeStyle"></div>
    <div
      v-for="(card, i) in explodedCards"
      :key="'ex-' + i"
      class="exploded-card"
      :style="card.style"
    ></div>
    <!-- Pack Opening Overlay -->
      <div class="open-pack-wrapper" v-bind:class="{ show: model.packLoaded, 'show-overlay': model.obsOverlay.visible }">
        <div class="open-pack-container collapsed" :class="{ 'with-overlay': model.obsOverlay.visible }">
          <h2 v-if="model.twitchDisplayName" :title="model.twitchDisplayName[0].twitchDisplayName">{{ model.twitchDisplayName[0].twitchDisplayName }}</h2>
          <div id="opened-cards" class="opened-cards-wrapper">
            <div class="opened-cards">
            <component
              v-for="card in model.userCards"
              :key="card.id"
              :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
              :card="card"
              v-bind:show="false"
            ></component>
            </div>
          </div>
          <playing-card
            id="cover"
            class="cover"
            v-bind:card="model.card[0]"
            :class="model.pack"
            v-bind:cover="true"
            >
          </playing-card>
        </div>
      </div>

      <!-- OBS Overlay Modal/Panel -->
      <div v-if="model.obsOverlay.visible" class="obs-overlay-wrapper pack-overlay-wrapper" :class="'mode-' + model.obsOverlay.mode">
        <div class="obs-overlay-container pack-overlay">
          <div class="obs-overlay-header">
            <h2>🎁 Pack Openings</h2>
            <div class="obs-header-controls">
              <select v-model="model.obsOverlay.mode" class="obs-mode-select" title="Display mode">
                <option value="modal">Modal</option>
                <option value="side">Side Panel</option>
                <option value="bottom">Bottom</option>
              </select>
              <button class="obs-close-btn" @click="toggleObsOverlay()">✕</button>
            </div>
          </div>

          <div class="obs-overlay-content pack-overlay-content">
            <!-- Pack Info Display -->
            <div class="obs-pack-info">
              <div class="pack-title" v-if="model.pack">
                <h3>{{ model.pack.name }} Pack</h3>
              </div>
              <div class="pack-stats" v-if="model.userCards">
                <span class="stat-item">
                  <strong>Cards:</strong> {{ model.userCards.length }}
                </span>
                <span class="stat-item" v-if="model.twitchDisplayName">
                  <strong>Player:</strong> {{ model.twitchDisplayName[0].twitchDisplayName }}
                </span>
              </div>
            </div>

            <!-- Cards Preview Grid -->
            <div class="obs-cards-grid" v-if="model.userCards && model.userCards.length > 0">
              <div v-for="card in model.userCards" :key="card.id" class="obs-card-preview">
                <div class="card-image" :style="{ backgroundImage: 'url(/images/cards/' + card.cardId + '.png)' }"></div>
                <div class="card-tier" :class="'tier-' + card.tier">
                  {{ card.tier }}
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div v-else class="obs-empty">
              <p>No cards to display</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  showMedal: `
    <div data-component="show-medal" class="always-display">
      <div v-if="model.medal" v-bind:class="{ show: model.show }">
        <div>
          <h2 title="Achievement Unlocked">Achievement Unlocked</h2>
          <h3 :title="model.medal.name">{{ model.medal.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.medal.src" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.medal.twitchProfileImage">-->
          <h3 :title="model.medal.twitchDisplayName">{{ model.medal.twitchDisplayName }}</h3>
          <h4 :title="model.medal.description">{{ model.medal.description }}</h4>
        </div>
      </div>
    </div>
  `,

  showKey: `
    <div data-component="show-key" class="always-display">
      <div v-if="model.key" v-bind:class="{ show: model.show }">
        <div>
          <h2>Key Used</h2>
          <h3>{{ model.key.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.key.src" :data-id="model.key.keyId" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.key.twitchProfileImage">-->
          <h3>{{ model.key.twitchDisplayName }}</h3>
          <h4>{{ model.key.description }}</h4>
        </div>
      </div>
    </div>
  `,

  receivedKey: `
    <div data-component="received-key" class="always-display">
      <div v-if="model.key" v-bind:class="{ show: model.show }">
        <div>
          <h2>Key Received</h2>
          <h3>{{ model.key.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.key.src" :data-id="model.key.keyId" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.key.twitchProfileImage">-->
          <h3>{{ model.key.twitchDisplayName }}</h3>
          <h4>{{ model.key.description }}</h4>
        </div>
      </div>
    </div>
  `,

  receivedPack: `
    <div data-component="received-pack" class="always-display">
      <div v-if="model.pack" v-bind:class="{ show: model.show }">
        <div>
          <h2>Pack Received</h2>
          <h3>{{ model.pack.name }}</h3>
        </div>
        <div class="video-container">
          <img :src="model.pack.src" />
        </div>
        <div>
          <h3>{{ model.pack.twitchDisplayName }}</h3>
        </div>
      </div>
    </div>
  `,

battleArena: `
  <div data-component="battle-arena" class="always-display" v-if="shouldShowBattle()">
    <!-- Visibility Change Notification -->
    <div v-if="model.notification.visible" class="visibility-notification" :class="model.notification.type">
      <div class="notification-content">
        <span class="notification-message">{{ model.notification.message }}</span>
        <button class="notification-close" @click="model.notification.visible = false">✕</button>
      </div>
    </div>

    <!--<button v-on:click="stop()">stop battle</button>-->
    <!---->
      <div v-if="model.singleMode" id="singleMode">
          <div class="content">
          <!--<div class="stupid-log"></div>-->
              <div class="arena" v-bind:class="{ show: model.show.cards }">
                <div class="arena-row">
                  <div class="cards-side cards-left cards-1">
                    <div class="card-stack">
                      <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards1"></playing-card>
                    </div>
                  </div>
                  <div class="log-panel log" v-bind:class="{ show: model.show.logs }">
                    <div class="log-title">Battle Log</div>
                    <div v-for="log in model.logs" class="log-entry" :class="['log-' + log.type, log.tier ? 'tier-' + log.tier : '', log.tier === 1 ? 'tier-prime' : '', log.tier === 2 ? 'tier-ultra' : '', log.tier === 3 ? 'tier-legendary' : '']">
                      <div class="log-message">{{ log.message }}</div>
                      <div v-if="log.type === 'attack' && log.meta" class="log-details">
                        <span v-if="log.meta.physicalDamage > 0" class="damage-physical">
                          ⚔️ {{ log.meta.physicalDamage }} ({{ log.meta.pAtk }}-{{ log.meta.armor }})
                        </span>
                        <span v-if="log.meta.magicDamage > 0" class="damage-magic">
                          ✨ {{ log.meta.magicDamage }} ({{ log.meta.mAtk }}-{{ log.meta.ward }})
                        </span>
                        <span v-if="log.meta.critical" class="damage-critical">💥 CRIT!</span>
                      </div>
                    </div>
                  </div>
                  <div class="cards-side cards-right cards-2">
                    <div class="card-stack">
                      <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards2"></playing-card>
                    </div>
                  </div>
                </div>
              </div>
        </div>
      
        <div class="winner" v-bind:class="{ show: model.show.winner }">
          <h2 class="white">The Winner Is:</h2>
          <div class="winner-user"></div>
            <div class="user-quest" v-bind:class="{ 'show': model.questUser }">
              <div class="reward-completed">
                <p>Quest Complete</p>
              </div>
              <div class="battle-quest-container" :id="getIndex(index)" v-for="(quest, index) in model.questCards" :key="index">
                <div class="battle-quest-name">{{quest.name}}</div>
              </div>
            </div>
        </div>
        <div class="stolen-card" v-bind:class="{ show: model.show.stolenCard }">
          <h2 class="white">Card Stolen:</h2>
          <playing-card v-if="model.stolenCard" v-bind:card="model.stolenCard" v-bind:show="'true'"></playing-card>
        </div>
    </div>
    <!--Show if the tournament battle option is not single-->
    <div v-else>
          <div id="first_round" class="content show">
              <div class="show-players">
                  <div class="section">
                      <teamSections  v-bind:user="user" v-bind:show="model.show.cards" v-bind:showUsers="model.show.users" v-bind:team="1" v-for="user in model.team1"></teamSections>
                  </div>
                  <div class="section-center log" v-bind:class="{ show: model.show.logs }">
                      <div v-for="log in model.logs" class="log-entry" :class="['log-' + log.type, log.tier ? 'tier-' + log.tier : '', log.tier === 1 ? 'tier-prime' : '', log.tier === 2 ? 'tier-ultra' : '', log.tier === 3 ? 'tier-legendary' : '']">
                        <div class="log-message">{{ log.message }}</div>
                        <div v-if="log.type === 'attack' && log.meta" class="log-details">
                          <span v-if="log.meta.physicalDamage > 0" class="damage-physical">
                            ⚔️ {{ log.meta.physicalDamage }} ({{ log.meta.pAtk }}-{{ log.meta.armor }})
                          </span>
                          <span v-if="log.meta.magicDamage > 0" class="damage-magic">
                            ✨ {{ log.meta.magicDamage }} ({{ log.meta.mAtk }}-{{ log.meta.ward }})
                          </span>
                          <span v-if="log.meta.critical" class="damage-critical">💥 CRIT!</span>
                        </div>
                      </div>
                  </div>
                  <div class="section" >
                      <teamSections  v-bind:user="user" v-bind:show="model.show.cards" v-bind:showUsers="model.show.users" v-bind:team="2" v-for="user in model.team2"></teamSections>
                  </div>
              </div>
          </div>
      </div>

      <div v-if="model.setUserData"">
         <div class="row profile_intro" v-bind:class="{ show: model.show.profile_intro, move: model.show.move }">  
                <div class="col user1">
                    <h1 v-if="model.type !== 'undefined'" class="whitespace-text">{{model.user1.twitchDisplayName}}</h1>
                    <userTeamProfile v-bind:team="team" v-for="team in model.team1"></userTeamProfile>
                </div>
                <div class="col vs">
                    <h1 class="white">VS</h1>
                </div>
                <div class="col user2">
                    <h1 v-if="model.type !== 'undefined'" class="whitespace-text">{{model.user2.twitchDisplayName}}</h1>
                    <userTeamProfile v-bind:team="team" v-for="team in model.team2"></userTeamProfile>
                </div>
            </div>
      </div>
      <div v-else>
             <div class="row info" v-bind:class="{ show: model.show.users, move: model.show.move }">
                  <div class="col-5 user user1">
                    <img :src="model.user1.twitchProfileImage">
                    <img src="/images/name-frame-01.png">
                    <div>
                      <h2>{{ model.user1.twitchDisplayName }}</h2>
                    </div>
                    <div class="battle-tooltip-reward">
                      <div class="user-quest tooltip show" v-if="model.questUser">
                        <div class="reward-completed">
                          <p>Quest Completed!</p>
                        </div>
                        <div class="battle-quest-container" v-for="(quest, index) in model.questCards" :key="index">
                          <div class="battle-quest-name">{{index}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
              
                  <div class="col-2 vs">
                    <h1 class="white">VS</h1>
                  </div>
            
                  <div class="col-5 user user2">
                    <img :src="model.user2.twitchProfileImage">
                    <img src="/images/name-frame-01.png">
                    <div>
                      <h2>{{ model.user2.twitchDisplayName }}</h2>
                    </div>
                  </div>

              </div>
      </div>

      <!-- OBS Overlay Toggle Button -->
      <button class="obs-overlay-toggle obs-battle-toggle" @click="toggleObsOverlay()" title="Toggle OBS Overlay">
        <span v-if="model.obsOverlay.connected" class="obs-status-online">⊙</span>
        <span v-else class="obs-status-offline">⊗</span>
        OBS
      </button>

      <!-- OBS Overlay Modal/Panel -->
      <div v-if="model.obsOverlay.visible" class="obs-overlay-wrapper" :class="'mode-' + model.obsOverlay.mode">
        <div v-if="model.obsOverlay.mode === 'fullscreen'" class="obs-fullscreen-overlay">
          <!-- Fullscreen Mode: Show OBS overlay content -->
          <div class="obs-overlay-container fullscreen">
            <div class="obs-overlay-header">
              <h2>⚔️ Battles & 🎁 Packs</h2>
              <div class="obs-header-controls">
                <select v-model="model.obsOverlay.viewerPreference" @change="saveObsViewerPreference(model.obsOverlay.viewerPreference)" class="obs-mode-select" title="What battles & packs do you want to see?">
                  <option value="all">All Content</option>
                  <option value="mine">Only My Content</option>
                  <option value="others">Only Others' Content</option>
                </select>
                <select v-model="model.obsOverlay.mode" class="obs-mode-select">
                  <option value="modal">Modal</option>
                  <option value="side">Side Panel</option>
                  <option value="bottom">Bottom</option>
                  <option value="fullscreen">Fullscreen</option>
                </select>
                <button class="obs-close-btn" @click="toggleObsOverlay()">✕</button>
              </div>
            </div>

            <div class="obs-overlay-content fullscreen-content">
              <!-- Visibility Indicator -->
              <div class="obs-visibility-badge" :class="model.obsOverlay.overlayVisibility">
                <span v-if="model.obsOverlay.overlayVisibility === 'all'">👁️ All Battles & Packs</span>
                <span v-else>🔒 Only Your Battles & Packs</span>
              </div>

              <!-- Battles Section -->
              <div class="obs-section battles-section">
                <h3>⚔️ Battles ({{ model.obsOverlay.battles.length }})</h3>
                <div v-if="model.obsOverlay.battles.length === 0" class="obs-empty">
                  No active battles
                </div>
                <div v-for="battle in model.obsOverlay.battles" :key="battle.id" class="obs-battle-item">
                  <span class="obs-vs">{{ battle.user1Name }} vs {{ battle.user2Name }}</span>
                </div>
              </div>

              <!-- Packs Section -->
              <div class="obs-section packs-section">
                <h3>🎁 Packs ({{ model.obsOverlay.packs.length }})</h3>
                <div v-if="model.obsOverlay.packs.length === 0" class="obs-empty">
                  No recent packs
                </div>
                <div v-for="pack in model.obsOverlay.packs" :key="pack.id" class="obs-pack-item">
                  <span class="obs-pack-name">{{ pack.userName }}</span>
                  <span class="obs-pack-type">{{ pack.packType }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="obs-overlay-modal" :class="'mode-' + model.obsOverlay.mode">
          <div class="obs-overlay-container">
            <div class="obs-overlay-header">
              <h3>⚔️ & 🎁 OBS Overlay</h3>
              <div class="obs-header-controls">
                <select v-model="model.obsOverlay.viewerPreference" @change="saveObsViewerPreference(model.obsOverlay.viewerPreference)" class="obs-mode-select" title="What battles & packs do you want to see?">
                  <option value="all">All Content</option>
                  <option value="mine">Only My Content</option>
                  <option value="others">Only Others' Content</option>
                </select>
                <select v-model="model.obsOverlay.mode" class="obs-mode-select">
                  <option value="modal">Modal</option>
                  <option value="side">Side Panel</option>
                  <option value="bottom">Bottom</option>
                  <option value="fullscreen">Fullscreen</option>
                </select>
                <button class="obs-close-btn" @click="toggleObsOverlay()">✕</button>
              </div>
            </div>

            <div class="obs-overlay-content">
              <!-- Visibility Indicator -->
              <div class="obs-visibility-badge" :class="model.obsOverlay.overlayVisibility">
                <span v-if="model.obsOverlay.overlayVisibility === 'all'">👁️ All</span>
                <span v-else>🔒 Own</span>
              </div>

              <!-- Battles -->
              <div class="obs-battles-list">
                <h4>Battles: {{ model.obsOverlay.battles.length }}</h4>
                <div v-if="model.obsOverlay.battles.length === 0" class="obs-empty">
                  No battles
                </div>
                <div v-for="battle in model.obsOverlay.battles.slice(0, 5)" :key="battle.id" class="obs-item">
                  <span>⚔️ {{ battle.user1Name }} vs {{ battle.user2Name }}</span>
                </div>
              </div>

              <!-- Packs -->
              <div class="obs-packs-list">
                <h4>Packs: {{ model.obsOverlay.packs.length }}</h4>
                <div v-if="model.obsOverlay.packs.length === 0" class="obs-empty">
                  No packs
                </div>
                <div v-for="pack in model.obsOverlay.packs.slice(0, 5)" :key="pack.id" class="obs-item">
                  <span>🎁 {{ pack.userName }} - {{ pack.packType }}</span>
                </div>
              </div>
            </div>

            <div class="obs-overlay-footer">
              <small v-if="model.obsOverlay.connected" class="obs-status">🟢 Connected</small>
              <small v-else class="obs-status">🔴 Disconnected</small>
            </div>
          </div>
        </div>
      </div>
  </div>
`,

tournamentArena: `
<div data-component="tournament-arena" class="always-display">
  <div class="content" v-if="!model.hasTournament">
    <div class="no-tournament">
      <h1>No Active Tournament</h1>
    </div>
  </div>
  <div v-else class="container">
    <div class="tournament-container">
      <div class="tournament-match" v-if="!model.tournamentBattle">
          <div class="drawer-overlay tournament-list">
            <div class="drawer is-open tournament-bg" id="topContainer">
              <div class="drawer-content players-list">
                <button @click="autoFill" v-if="!model.autofill">Auto Fill Brackets</button>
                <button @click="autoFillReset" v-else>Reset</button>
                <span :draggable="queue.active"  @contextmenu.prevent="showContextMenu" @dragstart="onDragStart($event, queue, null, 0)" @dragend="onDragEnd"  @drop="onDrop($event, queue)" @dragover.prevent="onDragOver"  @dragleave="onDragLeave" v-for="queue in model.queues" :data-id="queue.id">{{queue.twitchDisplayName}}  <div class="count" v-if="queue.team_count">{{queue.team_count}}/{{queue.total}}</div><div class="count faction-logo" v-if="queue.factionId != null"><img :src="\`\${root}/images/faction/\${queue.factionId}.png\`" alt="Faction Image" :style="{ width: '20px', height: '20px' }"></div></span>
              </div>
            </div>
          </div>
        <div id="panzoom">
          <div class="tournament-grid-container">
            <div class="tournament-grid-item">
              <div class="">
                <div class="bracket1">
                  <div v-if="model.bracket1 && model.bracket1.length" v-for="(round, index) in model.bracket1" :key="index">
                    <div v-for="(player, playerIndex) in round" :key="playerIndex">
                      <ul>
                        <li draggable="true" @dragstart="onDragStart($event, player, playerIndex, 1)" @dragend="onDragEnd" @dragover.prevent="onDragOver" @drop="onDrop($event, 1, playerIndex)"  :data-value="playerIndex"> <p class="overflow-hidden">{{ player ? player.twitchDisplayName : ' ' }}</p><div class="count faction-logo" v-if="player && player.factionId != null"><img :src="\`\${root}/images/faction/\${player.factionId}.png\`" alt="Faction Image" :style="{ width: '20px', height: '20px' }"></div></li>
                      </ul>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
            <div class="tournament-grid-item">
              <div class="row">
                <div class="tournament-title">
                  <h1>{{model.tournament.name}}</h1>
                </div>
              </div>
              <div class="row">
                <div class="match-item">
                  <img src="http://localhost/application/images/trophy.png" width="100px">
                </div>
              </div>
              <div class="row">
                <div class="match-item">
                  <div class="bracket1 finals">
                    <div>
                      <div>
                        <ul>
                          <li><p class="overflow-hidden"></p></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="match-item">
                  <img src="http://localhost/application/images/bg-tournament-logo.png" width="100px">
                </div>
              </div>
              <div class="row">
                  <div class="match-item">
                    <button v-on:click="startTournament()">START</button>
                  </div>
              </div>
            </div>
            <div class="tournament-grid-item">
              <div class="">
                <div class="bracket2">
                  <div  v-for="(round, index) in model.bracket2" :key="index">
                    <div v-for="(player, playerIndex) in round" :key="playerIndex">
                      <ul>
                        <li draggable="true" @dragstart="onDragStart($event, player, playerIndex, 2)" @dragover.prevent="onDragOver" @drop="onDrop($event, 2,playerIndex)"> <p class="overflow-hidden"></p>{{ player ? player.twitchDisplayName : ' ' }}<div class="count faction-logo" v-if="player && player.factionId != null"><img :src="\`\${root}/images/faction/\${player.factionId}.png\`" alt="Faction Image" :style="{ width: '20px', height: '20px' }"></div></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
  <div v-else class="tournament-match">
    <div class="drawer-overlay tournament-list">
      <div class="drawer is-open tournament-bg" id="topContainer">
        <div class="drawer-content players-list">
          <span v-bind:class="{eliminated: players.status === 'Lose'}" v-for="(players, index) in model.tournamentPlayers" :data-id="players.id">{{players.twitchDisplayName}}<div class="count faction-logo" v-if="players.factionId != null"><img :src="\`\${root}/images/faction/\${players.factionId}.png\`" alt="Faction Image" :style="{ width: '20px', height: '20px' }"></div></span>
        </div>
      </div>
    </div>
      <div id="panzoom">
          <div class="tournament-grid-container">
            <div class="tournament-grid-item">
              <div class="">
                <div class="bracket1">
                  <div v-if="model.bracket1 && model.bracket1.length" v-for="(round, index) in model.bracket1" :key="index">
                    <div v-for="(player, playerIndex) in round" :key="playerIndex">
                      <ul>
                        <li> <p class="overflow-hidden">{{ player ? player.twitchDisplayName : ' ' }}</p><div class="count faction-logo" v-if="player && player.factionId != null"><img :src="\`\${root}/images/faction/\${player.factionId}.png\`" alt="Faction Image" :style="{ width: '20px', height: '20px' }"></div></li>
                      </ul>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
            <div class="tournament-grid-item">
              <div class="row">
                <div class="tournament-title">
                  <h1>{{model.tournament.name}} Tournament</h1>
                </div>
              </div>
              <div class="row">
                <div class="match-item">
                  <img src="http://localhost/application/images/trophy.png" width="100px">
                </div>
              </div>
              <div class="row" :style="alignStart">
                <div class="match-item">
                  <div class="bracket1 finals">
                    <div>
                      <div>
                        <ul>
                          <li v-bind:class="{fire: !isEmpty(model.tournamentWinner)}"><p class="overflow-hidden">{{model.tournamentWinner.twitchDisplayName}}</p></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="match-item">
                  <img src="http://localhost/application/images/bg-tournament-logo.png" width="100px">
                </div>
              </div>
            </div>
            <div class="tournament-grid-item">
              <div class="">
                <div class="bracket2">
                  <div  v-for="(round, index) in model.bracket2" :key="index">
                    <div v-for="(player, playerIndex) in round" :key="playerIndex">
                      <ul>
                        <li> <p class="overflow-hidden"></p>{{ player ? player.twitchDisplayName : ' ' }}<div class="count faction-logo" v-if="player && player.factionId != null"><img :src="\`\${root}/images/faction/\${player.factionId}.png\`" alt="Faction Image" :style="{ width: '20px', height: '20px' }"></div></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
  </div>
    
      <div class="panzoom-controls">
        <button @click="zoomIn"><i class="bi bi-zoom-in"></i> Zoom In</button>
        <button @click="zoomOut" id="zoom-out"><i class="bi bi-zoom-out"></i> Zoom Out</button>
        <button @click="destroy" v-if="!model.pause"> <i class="bi bi-stop-fill"></i> Pause</button> 
        <button v-else @click="resumePan"><i class="bi bi-play-fill"></i> Enable Panning</button>
        <button @click="reset" id="reset-zoom">Reset Zoom</button>
      </div>
      <div class="tournament-champion">
      <div>
        <div class="user-champion" v-bind:class="{ show: model.show.users, move: model.show.move }">
        
          <div class="user user1" v-for="(users, index) in model.champ.user"  >
          
                <img :src="users.twitchProfileImage">
                <img src="/images/name-frame-01.png">
                <div>
                  <h2>{{ users.twitchDisplayName }}</h2>
                </div>
          </div>
        </div>
        <div class="user-champion-label">
        <h1>Finale Champion</h1>
      </div>
      </div>
      
    
        <canvas id="confettiCanvas"></canvas>
        <canvas id="fireworksCanvas"></canvas>
        <canvas id="balloonCanvas"></canvas>
      </div>
      <div class="modal">
          <div class="modal-content">
                <h1>{{model.message}}</h1>
              <button type="button" data-button="save" @click="confirmChampion" >Confirm</button>
          </div>
      </div>
    </div>
  </div>

</div>  
`,

tournamentComponent: `
  <div data-component="tournament-arena" class="always-display">
    <div id="panzoom">
      <div class="tournament-grid-container">
        <div class="tournament-grid-item">
          <div class="">
            <div class="bracket1">
              <div v-if="model.bracket1 && model.bracket1.length" v-for="(round, index) in model.bracket1" :key="index">
                <div v-for="(player, playerIndex) in round" :key="playerIndex">
                  <ul>
                    <li> <p class="overflow-hidden">{{ player ? player.twitchDisplayName : ' ' }}</p></li>
                  </ul>
                </div>
              </div>
            </div> 
          </div>
        </div>
        <div class="tournament-grid-item">
          <div class="row">
            <div class="tournament-title">
              <h1>{{model.tournament.name}} Tournament</h1>
            </div>
          </div>
          <div class="row">
            <div class="match-item">
              <img src="http://localhost/application/images/trophy.png" width="100px">
            </div>
          </div>
          <div class="row">
            <div class="match-item">
              <div class="bracket1 finals">
                <div>
                  <div>
                    <ul>
                      <li><p class="overflow-hidden"></p></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="match-item">
              <img src="http://localhost/application/images/bg-tournament-logo.png" width="100px">
            </div>
          </div>
        </div>
        <div class="tournament-grid-item">
          <div class="">
            <div class="bracket2">
              <div  v-for="(round, index) in model.bracket2" :key="index">
                <div v-for="(player, playerIndex) in round" :key="playerIndex">
                  <ul>
                    <li> <p class="overflow-hidden">{{ player ? player.twitchDisplayName : ' ' }}</p></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
`,

teamBattleArena: `
    <div data-component="battle-arena" class="always-display">
      <!--<button v-on:click="stop()">stop battle</button>-->

     
        <div id="first_round" class="content show">
            <div class="show-players">
              <div class="section">
                <teamSections  v-bind:user="user" v-bind:show="model.show.cards" v-bind:showUsers="model.show.users" v-bind:team="1" v-for="user in model.team1"></teamSections>
              </div>
              <div class="section-center log" v-bind:class="{ show: model.show.logs }">
                      <div v-for="log in model.logs" class="log-entry" :class="['log-' + log.type, log.tier ? 'tier-' + log.tier : '', log.tier === 1 ? 'tier-prime' : '', log.tier === 2 ? 'tier-ultra' : '', log.tier === 3 ? 'tier-legendary' : '']">
                        <div class="log-message">{{ log.message }}</div>
                        <div v-if="log.type === 'attack' && log.meta" class="log-details">
                          <span v-if="log.meta.physicalDamage > 0" class="damage-physical">
                            ⚔️ {{ log.meta.physicalDamage }} ({{ log.meta.pAtk }}-{{ log.meta.armor }})
                          </span>
                          <span v-if="log.meta.magicDamage > 0" class="damage-magic">
                            ✨ {{ log.meta.magicDamage }} ({{ log.meta.mAtk }}-{{ log.meta.ward }})
                          </span>
                          <span v-if="log.meta.critical" class="damage-critical">💥 CRIT!</span>
                        </div>
                      </div>
              </div>
              <div class="section" >
                <teamSections  v-bind:user="user" v-bind:show="model.show.cards" v-bind:showUsers="model.show.users" v-bind:team="2" v-bind:cardBacking="model.team2Backing" v v-for="user in model.team2"></teamSections>
              </div>
            </div>
        </div>


        <div id="final_round" class="content" v-bind:class="{ show: model.finalBattle }">
            <div class="row cards" v-bind:class="{ show: model.show.cards }">
              <div class="col-4 cards-1-final">
                <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards1"></playing-card>
              </div>
              <div class="col-4">
                <div class="log" v-bind:class="{ show: model.show.logs }">
                  <div v-for="log in model.logs" class="log-entry" :class="['log-' + log.type, log.tier ? 'tier-' + log.tier : '', log.tier === 1 ? 'tier-prime' : '', log.tier === 2 ? 'tier-ultra' : '', log.tier === 3 ? 'tier-legendary' : '']">
                    <div class="log-message">{{ log.message }}</div>
                    <div v-if="log.type === 'attack' && log.meta" class="log-details">
                      <span v-if="log.meta.physicalDamage > 0" class="damage-physical">
                        ⚔️ {{ log.meta.physicalDamage }} ({{ log.meta.pAtk }}-{{ log.meta.armor }})
                      </span>
                      <span v-if="log.meta.magicDamage > 0" class="damage-magic">
                        ✨ {{ log.meta.magicDamage }} ({{ log.meta.mAtk }}-{{ log.meta.ward }})
                      </span>
                      <span v-if="log.meta.critical" class="damage-critical">💥 CRIT!</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4 cards-2-final">
                <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards2"></playing-card>
              </div>
        </div>
         
        <div class="row profile_intro" v-bind:class="{ show: model.show.profile_intro }">  
           
            <div class="col user1">
              <h1 v-if="!model.streamer1">Team 1</h1>
              <h1 v-else>{{model.streamer1}}</h1>
              <userTeamProfile v-bind:team="team" v-for="team in model.team1"></userTeamProfile>
            </div>
            <div class="col vs">
              <h1 class="white">VS</h1>
            </div>
            <div class="col user2">
              <h1 v-if="!model.streamer2">Team 2</h1>
              <h1 v-else>{{model.streamer2}}</h1>
              <userTeamProfile v-bind:team="team" v-for="team in model.team2"></userTeamProfile>
            </div>
        </div>
      
      <div class="winner" v-bind:class="{ show: model.show.winner }">
        <h2 class="white">The Winner Is:</h2>
        <div></div>
      </div>
      <div class="stolen-card" v-bind:class="{ show: model.show.stolenCard }">
        <h2 class="white">Card Stolen:</h2>
        <playing-card v-if="model.stolenCard" v-bind:card="model.stolenCard" v-bind:show="'true'"></playing-card>
      </div>
    </div>  
`,

teamSections: `
      <div data-component="teamSections" class="always-display row-tournament" :id="user.user.twitchId"  :data-id="user.user.twitchId">
        <div :class="[team == '1' ? 'ltr-container' : 'rtl-container' ]"">
            <div class="user tournament" v-bind:class="{ show: showUsers }">
              <img :src="user.user.twitchProfileImage">
               <div class="eliminated-icon">?</div>
              <div>
                <h2>{{ user.user.twitchDisplayName }}</h2>
              </div>
            </div>
             <div class="cards team-battle" v-bind:class="{show}">
                <div :class="[team == '1' ? 'cards-1 cards-tournament' : 'cards-2 cards-tournament']">
                  <playing-card v-bind:card="card" v-bind:show="false" v-for="card in user.cards"></playing-card>
                </div>
              </div>
        < /div>
      </div>
`,

userTeamProfile: `
  <div data-component="team-profile" class="user_img" :id="team.user.twitchId" :data-id="team.user.twitchId">
      <img src="/images/name-frame-01.png">
      <img :src="team.user.twitchProfileImage">
      <div>
        <h2>{{ team.user.twitchDisplayName }}</h2>
      </div>
  </div>
`,

playingCard: `
 <div data-component="playing-card" :key="card.id"  draggable="true"  @contextmenu.prevent="showContextMenu" @dragstart="onDragStart" @dragend="onDragEnd"  @drop="onDrop($event, card)" @dragover.prevent="onDragOver"  @dragleave="onDragLeave"  :id="card.id" :data-id="card.id" class="playing-card-container" :class="{ show: model.show, selected: card.selected, on_drop: model.isDragging, 'has-delta-equipped': card.equippedDelta || card.deltaCardKey }" :data-number="card.cardNumber" :data-cooldown="card.cooldown" :data-hidden="card.name == ''" :data-count="card.count" :data-level="card.level" :data-xp="card.currentXP" v-on:click="select(card)">
  <div class="playing-card-wrapper">
    <div class="circle" v-if="cover" v-bind:class="{ beating: model.isBeating }" v-on:click="cardReveal()">
      <span class="shockwave"></span>
      <span class="shockwave delay"></span>
       <span class="circle-text">Tap to open</span>
    </div>
    <div class="playing-card " v-bind:class="{  flipped: model.show, disabled: card.name === '' }"  v-on:click="flip(card.id)"  >
    <!--<div class="playing-card">-->
      <div class="playing-card-face playing-card-backing" :style="{ backgroundImage: 'url(' + (card.backingId ? root + '/images/card-backs/' + card.backingId + '.png' : root + '/images/Back.png') + ')', backgroundSize: 'cover', backgroundPosition: 'center' }"></div>
      <div v-if="card.name == ''" class="playing-card-face playing-card-front disabled" :data-tier="card.tier">
        <!--<i class="question bi-question-circle"></i>-->
      </div>
      <div v-if="card.name" class="playing-card-face playing-card-front" :data-tier="card.tier" :style="{'background-image': 'url(' + card.image + ')'}">
        <div class="playing-card-front-frame">

          <i v-if="card.selected"  class="check bi-check-circle-fill"></i>
          <i  v-if="card.cardNumber" class="x-circle bi bi-x-circle-fill"></i>

          <div class="equipped-indicators">
            <div v-if="card.hasBone || card.equippedBone" class="equipped-indicator bone-indicator" :title="card.equippedBone ? 'Bone Equipped: ' + card.equippedBone.name : 'Bone Card Equipped'"><i class="bi bi-lightning-charge-fill"></i></div>
            <div v-if="card.deltaCardKey" class="equipped-indicator delta-indicator" :title="'Delta Card: ' + card.deltaCard" @click.stop="$root.$emit('showDeltaInfo', { card: card, delta: card.equippedDelta })" style="cursor:pointer"><i class="bi bi-triangle-fill"></i></div>
          </div>

          <div class="top">
            <p :title="card.name.split(' ')[0].slice(0, 7)">{{ card.name.split(' ')[0].slice(0, 7) }}</p>
            <span class="tooltip">
              {{ model.tooltipMessage }}
            </span>
          </div>

          <div v-if="model.timer" class="cooldown-timers">
            <span>  
              <p>Cooldown</p>
              <p>{{ card.cooldown }}</p>
            </span>
          </div>

          <div class="bottom is-hidden">
            <div class="ability" :title="'Ability: ' + (card.ability || 'NONE')" :data-description="card.description">Ability: {{ card.ability || 'NONE' }}</div>
            <div class="stats battle-stats">
              <p data-stat="hp" :title="card.hp " v-if="card.hp !== undefined"><span class="stat-label" :title="'HP'">HP</span><span class="stat-value" :title="card.hp">{{ card.hp }}</span></p>
              <p data-stat="mana" :title="card.currentMana" v-if="card.currentMana !== undefined"><span class="stat-label" :title="'MANA'">MANA</span><span class="stat-value" :title="card.currentMana">{{ card.currentMana }}</span></p>
              <p data-stat="stamina" :title="card.currentStamina" v-if="card.currentStamina !== undefined"><span class="stat-label" :title="'STA'">STA</span><span class="stat-value" :title="card.currentStamina">{{ card.currentStamina }}</span></p>
              <p data-stat="pAtk" :title="'P-ATK ' + (card.pAtk || card.attack)"><span class="stat-label" :title="'P-ATK'">P-ATK</span><span class="stat-value" :title="card.pAtk || card.attack ">{{ card.pAtk || card.attack }}</span></p>
              <p data-stat="mAtk" :title="'M-ATK ' + (card.mAtk || 0)"><span class="stat-label" :title="'M-ATK'">M-ATK</span><span class="stat-value" :title=" card.mAtk || 0 ">{{ card.mAtk || 0 }}</span></p>
              <p data-stat="armor" :title="'ARMOR ' + (card.armor || card.defence)"><span class="stat-label" :title="'ARMOR'">ARMOR</span><span class="stat-value" :title=" card.armor || card.defence ">{{ card.armor || card.defence }}</span></p>
              <p data-stat="ward" :title="'WARD ' + (card.ward || 0)"><span class="stat-label" :title="'WARD'" :title="'WARD'">WARD</span><span class="stat-value" :title=" card.ward || 0">{{ card.ward || 0 }}</span></p>
              <p data-stat="speed" :title="'SPD ' + card.speed"><span class="stat-label" :title="'SPD'">SPD</span><span class="stat-value" :title=" card.speed ">{{ card.speed }}</span></p>
              <p data-stat="accuracy" :title="'ACC ' + card.accuracy"><span class="stat-label" :title="'ACC'">ACC</span><span class="stat-value" :title="card.accuracy ">{{ card.accuracy }}</span></p>
              <p data-stat="critChance" :title="'CRIT ' + (card.critChance || 5) + '%'"><span class="stat-label" :title="'CRIT'">CRIT</span><span class="stat-value" :title="(card.critChance || 5) + '%'">{{ card.critChance || 5 }}%</span></p>
              <p data-stat="critDmg" :title="'CRIT-DMG ' + (card.critDmg || 150) + '%'"><span class="stat-label" :title="'CRIT-DMG'">CRIT-DMG</span><span class="stat-value" :title="(card.critDmg || 150) + '%'">{{ card.critDmg || 150 }}%</span></p>
              
            </div>

          </div>
          
          <div class="info is-visible">
            <p class="number" v-if="card.cardNumber">Battle Number: #{{ card.cardNumber }}</p>
            <p class="count" v-if="card.cardNumber && card.count"  :title="'Own: ' + card.count">Own: {{card.count}}</p>
            <div v-if="cardStatus === 'Legacy'" class="card-status-badge" :class="cardStatus.toLowerCase()">{{ cardStatus }}</div>
          </div>

          <!-- XP Bar Row -->
          <div v-if="card.level && card.level > 0" class="card-xp-row" :class="'xp-tier-' + card.tier" :title="'Level ' + card.level + ' — XP: ' + (card.currentXP || 0) + '/' + (card.level * 100)">
          <div class="card-level-badge">{{ card.level }}</div>
          <div class="card-xp-bar">
              <div class="card-xp-fill" :style="{ width: model.xpReady ? Math.min(100, ((card.currentXP || 0) / (card.level * 100)) * 100) + '%' : '0%' }"></div>
              <span class="card-xp-label">XP</span>
              <span class="card-xp-value">{{ card.currentXP || 0 }}/{{ card.level * 100 }}</span>
            </div>

          </div>

          <!-- Bone Slot Indicators -->
          <div v-if="card.level && card.level > 0" class="card-bone-slots">
            <span class="bone-slot bone-mercury" :class="{ equipped: card.mercury_bone }" title="Mercury — Speed"></span>
            <span class="bone-slot bone-orion"   :class="{ equipped: card.orion_bone   }" title="Orion — Accuracy"></span>
            <span class="bone-slot bone-force"   :class="{ equipped: card.force_bone   }" title="Force"></span>
            <span class="bone-slot bone-wrath"   :class="{ equipped: card.wrath_bone   }" title="Wrath — P-ATK"></span>
            <span class="bone-slot bone-aegis"   :class="{ equipped: card.aegis_bone   }" title="Aegis — Armor &amp; Ward"></span>
            <span class="bone-slot bone-gaia"    :class="{ equipped: card.gaia_bone    }" title="Gaia — HP"></span>
          </div>

          <!-- Resource Bars (HP/Stamina/Mana) - shown during battles -->
          <!--<div v-if="card.currentStamina !== undefined || card.currentMana !== undefined || (card.hp !== undefined && card.originalHp !== undefined)" class="resource-bars">
            <div class="resource-bar hp-bar" :title="'HP: ' + card.hp + '/' + (card.originalHp || card.hp)" v-if="card.hp !== undefined && card.originalHp !== undefined">
              <div class="resource-fill hp-fill" :style="{width: ((card.hp || 0) / (card.originalHp || card.hp || 100) * 100) + '%'}"></div>
              <span class="resource-label">HP</span>
              <span class="resource-value">{{card.hp}}/{{card.originalHp || card.hp}}</span>
            </div>
            <div class="resource-bar stamina-bar" :title="'Stamina: ' + card.currentStamina + '/' + card.maxStamina" v-if="card.currentStamina !== undefined">
              <div class="resource-fill stamina-fill" :style="{width: ((card.currentStamina || 0) / (card.maxStamina || 100) * 100) + '%'}"></div>
              <span class="resource-label">STA</span>
              <span class="resource-value">{{card.currentStamina}}/{{card.maxStamina}}</span>
            </div>
            <div class="resource-bar mana-bar" :title="'Mana: ' + card.currentMana + '/' + card.maxMana" v-if="card.currentMana !== undefined">
              <div class="resource-fill mana-fill" :style="{width: ((card.currentMana || 0) / (card.maxMana || 100) * 100) + '%'}"></div>
              <span class="resource-label">MNA</span>
              <span class="resource-value">{{card.currentMana}}/{{card.maxMana}}</span>
            </div>
          </div> -->

          <!-- Active trait badges — shown during battle when card has status effects -->
          <div class="trait-badges" v-if="card.activeTraits && Object.keys(card.activeTraits).length > 0">
            <span
              v-for="(data, traitName) in card.activeTraits"
              :key="traitName"
              class="trait-badge"
              :class="'trait-' + traitName"
              :title="(data.label || traitName) + (data.turnsLeft < 9999 ? ' (' + data.turnsLeft + ' turns left)' : '')"
            >{{ data.label || traitName }}<span class="trait-turns" v-if="data.turnsLeft < 9999"> {{ data.turnsLeft }}</span></span>
          </div>

        </div>
      </div>
    </div>
    <div v-if="card.quantity" class="reward-value-show">{{card.quantity}}x</div>
    <div v-if="model.menuVisible" :style="'top:' +model.menuY+ 'px', 'right' + model.menuX + 'px'"  class="context-menu">
      <div v-if="card.favorites == 0" @click="addFavorites"><i class="bi bi-star"></i> Add to favorites</div>
      <div v-else @click="removeFavorites"><i class="bi bi-x-circle"></i> Remove to favorites</div>
    </div>

    <div v-if="model.menuVisible" class="overlay" @click="closeContextMenu"></div>
  </div>

</div>
`,

userInventory: `
<div data-component="user-inventory" :id="inventory.id"  :data-number="inventory.id">
    <div class="grid-item inventory"  @drop="onDrop($event, inventory)" @dragover.prevent>
      <div class="tier-upgrade dump" @click="openDump" id="dump_button" v-if="Number(inventory.tier) <= Number(inventory.total_tier)" @mouseenter="showInventoryTooltip($event)" @mouseleave="hideInventoryTooltip">
        {{model.dumpCardCount}}
      </div>

      <div v-if="!model.timer" class="cooldown-timers">

        <div v-if="inventory.isChest" class="inv-slot" @mouseenter="showInvSlotTooltip($event)" @mouseleave="hideInvSlotTooltip">
          <div class="chest-container is-chest vibrate"
            :data-id="inventory.id"
            :style="{'background-image': 'url(' + model.image + ')'}"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
            @click="openChest"
            >
            <span class="multiplier">{{inventory.count}}x</span>
          </div>
          <span class="inv-slot-name">{{ inventory.name }}</span>
        </div>

        <div v-else-if="inventory.keyId ">
          <img :src="model.image" style="height: 150px; width: 75px;">
        </div>

        <div v-else-if="inventory.image" class="inv-slot" @click="activate(inventory)" @mouseenter="showInvSlotTooltip($event)" @mouseleave="hideInvSlotTooltip">
          <div class="inv-slot-icon" :style="{ backgroundImage: \`url(\${root}/\${inventory.image})\` }">
            <div v-if="inventory.cooldown" class="inv-slot-cooldown-overlay">
              <span class="inv-slot-cooldown-text">{{ model.timer }}</span>
            </div>
          </div>
          <span class="inv-slot-name">{{ inventory.name }}</span>
        </div>

        <div v-else>
          <h4 v-on:click="activate(inventory)" >{{ Number(inventory.tier) > 2 ?  inventory.name + ' Tier '+ (Number(inventory.tier) - 1): inventory.name }}</h4>
        </div>
        
      </div>
      <div v-else>
       <div class="inv-slot" @mouseenter="showInvSlotTooltip($event)" @mouseleave="hideInvSlotTooltip">
          <div class="inv-slot-icon" :style="{ backgroundImage: \`url(\${root}/\${inventory.image})\` }">
            <div v-if="inventory.cooldown" class="inv-slot-cooldown-overlay">
              <span class="inv-slot-cooldown-text">{{ model.timer }}</span>
            </div>
          </div>
          <span class="inv-slot-name">{{ inventory.name }}</span>
        </div>
      </div>
    
  </div>
  
  </div>
  `,

  userQuest: `
  <div data-component="user-quest" :key="quest.questId" :id="quest.questId" :index="index" class="grid-quest-item" data-row-span="3" :data-id="quest.questId" :data-number="quest.questId">
   

         <div class="profile-card" @click="showQuestDetails(quest,index)"  v-bind:class="{ 'active': index === activeIndex, 'reward-claimed': quest.active }"  >
            <img :src="\`\${root}/images/quest/\${quest.questId}.png\`" alt="Profile Image" class="profile-image">
            <div class="profile-info">
                <h4 class="profile-title">{{quest.questName}}</h4>
                <p class="profile-description">{{quest.description}}</p>
            </div>
            <div class="icon-container">

            </div>
        </div>

        
</div>
`,

specialCard: `
 <div data-component="special-card" draggable="true" @dragend="onDragEnd" @dragstart="onDragStart" :key="card.id" :id="card.id" :data-id="card.id" class="playing-card-container delta-card-slot" :class="{ show: model.show, selected: card.selected, 'delta-in-use': card.inUse }" :data-number="card.cardNumber" :data-cooldown="card.cooldown" :data-hidden="card.name == ''" :data-count="card.count" :data-level="card.level" :data-xp="card.currentXP" v-on:click="select(card)">
  <span v-if="card.inUse" class="delta-in-use-label">In Use</span>
  <div class="playing-card-wrapper">
    <div class="playing-card" v-on:click="flip(card.id)" v-bind:class="{ spinning: model.spinning === true, flipped: model.show, disabled: !card.owned }" >
    <!--<div class="playing-card">-->
      <div class="playing-card-face playing-card-backing"></div>
      <div v-if="card.name == ''" class="playing-card-face playing-card-front disabled" :data-tier="card.tier ? card.tier : '6'">
        <!--<i class="question bi-question-circle"></i>-->
      </div>
      <div v-if="card.name" class="playing-card-face playing-card-front" :data-tier="card.tier" :style="{'background-image': 'url(' + card.image + ')'}">
        <div class="playing-card-front-frame">

          <i v-if="card.selected"  class="check bi-check-circle-fill"></i>
          <i  v-if="card.cardNumber" class="x-circle bi bi-x-circle-fill"></i>

          <div class="equipped-indicators">
            <div v-if="card.hasBone || card.equippedBone" class="equipped-indicator bone-indicator" :title="card.equippedBone ? 'Bone Equipped: ' + card.equippedBone.name : 'Bone Card Equipped'"><i class="bi bi-lightning-charge-fill"></i></div>
            <div v-if="card.equippedDelta" class="equipped-indicator delta-indicator" :title="'Delta Card: ' + card.equippedDelta.name" @click.stop="$root.$emit('showDeltaInfo', { card: card, delta: card.equippedDelta })" style="cursor:pointer"><i class="bi bi-triangle-fill"></i></div>
          </div>

          <div class="top">
            <p :title="card.name.split(' ')[0].slice(0, 7)">{{ card.name.split(' ')[0].slice(0, 7) }}</p>
            <span class="tooltip" >{{model.tooltipMessage}}</span>
          </div>

          <div class="bottom is-hidden">
            <div class="ability"> {{ card.description }}</div>
            <div class="stats battle-stats">
              <p data-stat="effect" :title="card.effect " v-if="card.effect !== undefined"><span class="stat-value" :title="card.hp">{{ card.effect }}</span></p>
            </div>
          </div>
          
          <div class="info is-visible">
           
            <p class="number" v-if="card.cardNumber">Battle Number: #{{ card.cardNumber }}</p>
            <p class="count" v-if="card.cardNumber && card.count" :title="'Own: ' + card.count">Own: {{card.count}}</p>
          </div>
        </div>
      </div>
    </div>
          
    <div v-if="model.menuVisible" :style="'top:' +model.menuY+ 'px', 'right' + model.menuX + 'px'"  class="context-menu">
      <div v-if="card.favorites == 0" @click="addFavorites"><i class="bi bi-star"></i> Add to favorites</div>
      <div v-else @click="removeFavorites"><i class="bi bi-x-circle"></i> Remove to favorites</div>
    </div>

    <div v-if="model.menuVisible" class="overlay" @click="closeContextMenu"></div>
  </div>
</div>
`,


  navigation: `
    <div data-component="navigation" class="always-display">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'queues' }" v-on:click="click('queues')">Queues</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'leaderboard' }" v-on:click="click('leaderboard')">Leaderboard</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'cards' }" v-on:click="click('cards')">Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'temp_cards' }" v-on:click="click('temp_cards')">Event Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'special' }" v-on:click="click('special')">Specialcards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'exclusive-cards' }" v-on:click="click('exclusive-cards')">Exclusive Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'exotic-cards' }" v-on:click="click('exotic-cards')">Exotic Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'bone-cards' }" v-on:click="click('bone-cards')">Bone Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'packs' }" v-on:click="click('packs')">Packs/Chests</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'types' }" v-on:click="click('types')">Types</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'abilities' }" v-on:click="click('abilities')">Abilities</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'traits' }" v-on:click="click('traits')">Abilities/Traits</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'delta_cards' }" v-on:click="click('delta_cards')">Delta Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'keys' }" v-on:click="click('keys')">Keys</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'medals' }" v-on:click="click('medals')">Achievements</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'Admin' }" v-on:click="click('Admin')">Admin</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'settings' }" v-on:click="click('settings')">Settings</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'store' }" v-on:click="click('store')">Store</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'quest' }" v-on:click="click('quest')">Quest</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'faction' }" v-on:click="click('faction')">Faction</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'seasonal' }" v-on:click="click('seasonal')">Season Controls</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'admin-tournament' }" v-on:click="click('admin-tournament')">Tournament</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'announcement' }" v-on:click="click('announcement')">Announcement</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'battle_frames' }" v-on:click="click('battle_frames')">Battle Frames</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'logs' }" v-on:click="click('logs')">Mods History</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'subs' }" v-on:click="click('subs')">Subscription</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'events' }" v-on:click="click('events')">Events</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'admin_reward_points' }" v-on:click="click('admin_reward_points')">Reward Points</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'reward_frames' }" v-on:click="click('reward_frames')">Reward Frames/Backgrounds</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'redemption_catalog' }" v-on:click="click('redemption_catalog')">Redemption Catalog</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'redemption_approval' }" v-on:click="click('redemption_approval')">Redemption Approval</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'user_subs' }" v-on:click="click('user_subs')">User Subscriptions</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'user' }" v-on:click="click('user')">User Management</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'featured_streamers' }" v-on:click="click('featured_streamers')">Featured Streamers</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'traits' }" v-on:click="click('traits')">Traits</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'card_back' }" v-on:click="click('card_back')">Card Back</button>
        </li>
      </ul>
    </div>
  `,

  navigation2: `
    <div data-component="navigation" class="always-display light">
      <ul class="nav nav-pills justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'cards' }" v-on:click="click('cards')"><i class="bi-collection-fill"></i> Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'medals' }" v-on:click="click('medals')"><i class="bi bi-award-fill"></i> Achievements</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'keys' }" v-on:click="click('keys')"><i class="bi bi-key-fill"></i> Keys</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'tags' }" v-on:click="click('tags')"><i class="bi bi-tag-fill"></i> Dog Tags</button>
        </li>
      </ul>
       <ul class="nav nav-tabs justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'yours' }" v-on:click="cards('yours')">Your Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'normal' }" v-on:click="cards('normal')">Standard</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'ultras' }" v-on:click="cards('ultras')">Ultras</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'legendary' }" v-on:click="cards('legendary')">Legendary</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'variants' }" v-on:click="cards('variants')">Variant</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'ultimates' }" v-on:click="cards('ultimates')">Ultimates</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'delta' }" v-on:click="cards('delta')">Deltas</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'exotic_cards' }" v-on:click="cards('exotic_cards')">Exotic</button>
        </li>
      </ul>
    </div>
  `,

  navigation3: `
   <nav class="hq-nav">
    <div class="nav-container">
      <span class="hq-badge">
        <i class="bi bi-currency-dollar"></i>{{model.barks}}
      </span>
      <button class="toggle-btn" aria-label="Toggle menu" aria-expanded="false" v-on:click="openMenu">
        <i class="bi bi-list"></i>
      </button>
      <div class="menu" v-bind:class="{active: model.toggleOpen}">
        <a href="#" v-bind:class="{ active: model.page == 'openPack' }" v-on:click="click('openPack')">
          <img src="images/hq_image/packs.png" alt="Faction" width="30" height="30"> Open Pack
        </a>
        <a href="#" v-bind:class="{ active: model.page == 'faction' }" v-on:click="click('faction')">
          <img src="images/hq_image/faction.png" alt="Faction" width="30" height="30"> Faction
        </a>
        <a href="#" v-bind:class="{ active: model.page == 'cards' }" v-on:click="click('cards')">
          <img src="images/hq_image/cards_management.png" alt="Cards Management" width="30" height="30"> Cards Management
        </a>
        <a href="#" v-bind:class="{ active: model.page == 'deepstats' }" v-on:click="click('deepstats')">
          <img src="images/hq_image/deep_stats.png" alt="Deep Stats" width="30" height="30"> Deep Stats
        </a>
        <a href="#" v-bind:class="{ active: model.page == 'quest' }" v-on:click="click('quest')">
         <img src="images/hq_image/quest.png" alt="Faction" width="30" height="30"> Quest
        </a>
        <a href="#" v-bind:class="{ active: model.page == 'bot' }" v-on:click="click('bot')">
          <img src="images/hq_image/bot.png" alt="Faction" width="30" height="30"> AI Bot
        </a>
        <a href="#" v-bind:class="{ active: model.page == 'events' }" v-on:click="click('events')">
          <img src="images/hq_image/event.png" alt="Faction" width="30" height="30"> Events
        </a>
        <a href="#" v-bind:class="{ active: model.page == 'store' }" v-on:click="click('store')">
          <img src="images/hq_image/store.png" alt="Faction" width="30" height="30"> Store
        </a>
      </div>
    </div>
  </nav>
`,

userManagement: `
  <div data-component="user-management">
    <section>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="header">
                <h4>Users</h4>
              </div>

               <div class="row form" v-bind:class="{ visible: model.edit }">
                  <div>
                    <i class="bi-x-lg close" v-on:click="reset()"></i> 
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Twitch Email.">Email</label>
                      <input class="form-control" disabled v-model="model.user.email" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="role">Role</label>
                      <select v-model="model.user.role" @change="selectedRole">
                        <option v-for="role in model.roles" :key="role.value" :value="role.value">
                          {{ role.name }}
                        </option>
                      </select>
                    </div>
                 
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  </div>
                </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                  
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Profile Image</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Twitch Name</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Twitch Email</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Role">Packs</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Role">Role</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" >Date Joined</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div>
                    <div class="row data" v-for="user in model.users" v-on:click="edit(user.id)">
                      <div class="col-1">
                        <img :src="user.twitchProfileImage" :style="{ width: '75px', height: '75px' }"/>
                      </div>
                      <div class="col-2">
                        {{user.twitchDisplayName}}
                      </div>
                       <div class="col-3">
                        {{user.twitchEmail}}
                      </div>
                      <div class="col-1">
                        {{user.packs}}
                      </div>
                      <div class="col-1">
                        {{user.role}}
                      </div>
                      <div class="col-3" :title="user.dateJoined">
                        {{user.dateJoined}}
                      </div>

                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  </div>

`,

leaderBoardNavigation: `
<div data-component="leaderboard-navigation">
  <ul class="nav nav-pills justify-content-center">
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'single' }" v-on:click="click('single')">Single</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'team' }" v-on:click="click('team')">Team</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'factionleaderoard' }" v-on:click="click('factionleaderoard')">Faction</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'seasonal' }" v-on:click="click('seasonal')">Seasonal</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'streamer_community' }" v-on:click="click('streamer_community')">Streamer Community</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'legacySingle' }" v-on:click="click('legacySingle')">Legacy (Single)</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'legacyTeam' }" v-on:click="click('legacyTeam')">Legacy (Team)</button>
    </li>
  </ul>
</div>
`,

hqCardsNavigation: `
  <div data-component="hq-cards-navigation">
     <div class="hq-nav-tabs">
          <button class="nav-item" v-bind:class="{ active: model.cards == 'yours' }" v-on:click="cards('yours')">Your Cards</button>

          <button class="nav-item" v-bind:class="{ active: model.cards == 'bone_cards' }" v-on:click="cards('bone_cards')">Special Bone Cards</button>

          <button class="nav-item" v-bind:class="{ active: model.cards == 'ascension_cards' }" v-on:click="cards('ascension_cards')">Ascension Cards</button>
   
          <button class="nav-item" v-bind:class="{ active: model.cards == 'variant_cards' }" v-on:click="cards('variant_cards')">Variant Cards</button>

          <button class="nav-item" v-bind:class="{ active: model.cards == 'delta_cards' }" v-on:click="cards('delta_cards')">Delta Cards</button>

          <button class="nav-item" v-bind:class="{ active: model.cards == 'exotic' }" v-on:click="cards('exotic')">Exotic Cards</button>
 
          <button class="nav-item" v-bind:class="{ active: model.cards == 'favorites' }" v-on:click="cards('favorites')"><i class="bi bi-star"></i> Favorites</button>

          <button class="nav-item" v-bind:class="{ active: model.cards == 'legacy' }" v-on:click="cards('legacy')">🏛️ Legacy</button>

      <div/>
  </div>
`,

  settings: `
    <div data-component="settings">
      <section>
        <div class="row">
          <div class="col-12">
            <!-- Settings Table Card -->
            <div class="card">
              <div class="header">
                <h4><i class="bi-gear-fill"></i> System Settings</h4>
              </div>

              <div class="admin-table-wrapper settings-table-wrapper">
                <table class="admin-table settings-table">
                  <thead>
                    <tr>
                      <th class="th-setting-name">
                        <i class="bi-info-circle"></i> Setting
                      </th>
                      <th class="th-setting-type">
                        <i class="bi-tag"></i> Type
                      </th>
                      <th class="th-setting-value">
                        <i class="bi-sliders"></i> Value / Control
                      </th>
                      <th class="th-setting-actions">
                        <i class="bi-lightning"></i> Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="admin-table-row settings-row" v-for="setting in model.settings" :key="setting.id">
                      <td class="td-setting-name">
                        <div class="settings-name-cell">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" :title="setting.description">
                            {{ setting.description }}
                          </label>
                        </div>
                      </td>
                      <td class="td-setting-type">
                        <span class="settings-type-badge" :class="setting.type">
                          <i v-if="setting.type == 'boolean'" class="bi-toggle-on"></i>
                          <i v-else class="bi-input-cursor-text"></i>
                          {{ setting.type === 'boolean' ? 'Toggle' : 'Text' }}
                        </span>
                      </td>
                      <td class="td-setting-value">
                        <div v-if="setting.type == 'boolean'" class="settings-control-boolean">
                          <div class="form-check form-switch modern-switch">
                            <input 
                              v-model="setting.value" 
                              type="checkbox" 
                              class="form-check-input" 
                              @change="save(setting.id)"
                              :id="'setting-' + setting.id">
                            <label class="form-check-label" :for="'setting-' + setting.id">
                              <span class="switch-label">{{ setting.value ? 'Enabled' : 'Disabled' }}</span>
                            </label>
                          </div>
                        </div>
                        <div v-if="setting.type == 'value'" class="settings-control-value">
                          <div class="input-group">
                            <input 
                              v-model="setting.value" 
                              type="text" 
                              class="form-control modern-input"
                              :placeholder="'Enter value...'">
                          </div>
                        </div>
                      </td>
                      <td class="td-setting-actions">
                        <div class="settings-actions">
                          <button 
                            v-if="setting.type == 'value'" 
                            class="settings-save-btn" 
                            data-button="submit" 
                            v-on:click="save(setting.id)"
                            title="Save Setting">
                            <i class="bi-check-lg"></i>
                            <span>Save</span>
                          </button>
                          <span v-else class="settings-auto-saved">
                            <i class="bi-check-circle"></i>
                            <span>Auto-saved</span>
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="!model.settings || model.settings.length === 0">
                      <td colspan="4" class="empty-table-state">
                        <div class="empty-content">
                          <i class="bi-inbox"></i>
                          <p>No settings available</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Twitch Integration Card -->
            <div class="card">
              <div class="header">
                <h4><i class="bi-twitch"></i> Twitch Integration</h4>
              </div>
              <div class="settings-integration-card">
                <div class="integration-content">
                  <div class="integration-info">
                    <i class="bi-link-45deg"></i>
                    <div>
                      <h5>Update Twitch Permissions</h5>
                      <p>Update Twitch permissions for stream handling and management.</p>
                    </div>
                  </div>
                  <div class="integration-action">
                    <a data-button="twitch-admin" class="twitch-connect-btn">
                      <i class="bi-twitch"></i> 
                      <span>Connect With Twitch</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Streamer Battles Section -->
            <div class="settings-component-section">
              <div v-if="model.hasResult">
                <streamerBattles></streamerBattles>
              </div>
              <div v-else class="card settings-component-empty">
                <div class="settings-empty-content">
                  <i class="bi-info-circle"></i>
                  <p>Streamer battles are not available at this time.</p>
                </div>
              </div>
            </div>

            <!-- Streamer Tournament Section -->
            <div class="settings-component-section">
              <streamerTournament></streamerTournament>
            </div>

            <!--<div class="col-12">
              <adminfactionPoints></adminfactionPoints>
            </div>-->

          </div>
        </div>
      </section>
    </div>  
  `,

  queues: `
    <div data-component="queues">
      <section class="queues-container">
        
        <!-- Current Battle Section - Full Width -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="queue-card queue-card-primary">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-primary">
                    <i class="bi-lightning-charge-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Current Battle</h4>
                    <p class="queue-subtitle">Active battle in progress</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <currentBattle></currentBattle>
              </div>
            </div>
          </div>
        </div>

        <!-- Primary Queue Section - Two Column -->
        <div class="row mb-4">
          <div class="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div class="queue-card queue-card-pack">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-pack">
                    <i class="bi-box-seam-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Open Pack Queue</h4>
                    <p class="queue-subtitle">Pack opening requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <unlockQueue></unlockQueue>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="queue-card queue-card-battle">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-battle">
                    <i class="bi-sword-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Battle Queue</h4>
                    <p class="queue-subtitle">Pending battle requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <battleQueue></battleQueue>
              </div>
            </div>
          </div>
        </div>

        <!-- Secondary Queue Section - Two Column -->
        <div class="row mb-4">
          <div class="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div class="queue-card queue-card-streamer">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-streamer">
                    <i class="bi-broadcast-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Streamer Queue</h4>
                    <p class="queue-subtitle">Streamer requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <streamersQueue></streamersQueue>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="queue-card queue-card-tournament">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-tournament">
                    <i class="bi-trophy-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Tournament Queue</h4>
                    <p class="queue-subtitle">Tournament entries</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <tournamentsQueue></tournamentsQueue>
              </div>
            </div>
          </div>
        </div>

        <!-- Team Battle Queue Section - Full Width -->
        <div class="row">
          <div class="col-12">
            <div class="queue-card queue-card-team">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-team">
                    <i class="bi-people-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Team Battle Queue</h4>
                    <p class="queue-subtitle">Team battle requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <teamBattleQueue></teamBattleQueue>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  `,

  mods: `
    <div data-component="queues">
      <section>

        <div class="row">
          
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Current Battle</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <currentBattle></currentBattle>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Battle Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <battleQueue></battleQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-6">
              <givePack></givePack>
          </div>

          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Open Pack Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <unlockQueue></unlockQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>



      </section>
    </div>
  `,

  streamersNavigation: `
  <div class="always-display mb-2" data-component="streamers-navigation">
     <ul class="nav nav-tabs data-cards justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'queues' }" v-on:click="page('queues')">Queues</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'streamer-settings' }" v-on:click="page('streamer-settings')">Streamer Settings</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'redemption' }" v-on:click="page('redemption')">
            <i class="bi-gem"></i> Reward Points
          </button>
        </li>
        <li class="nav-item" v-if="model.isStreamer">
          <button class="nav-link" v-bind:class="{ active: model.page == 'admin' }" v-on:click="page('admin')">Admin</button>
        </li>
        <li class="nav-item" v-if="model.isStreamer && model.canAccessTournament">
          <button class="nav-link" v-bind:class="{ active: model.page == 'admin-tournament' }" v-on:click="page('admin-tournament')">Tournament</button>
        </li>
        <li class="nav-item" v-if="model.isStreamer && model.canAccessEvents">
          <button class="nav-link" v-bind:class="{ active: model.page == 'streamer-events' }" v-on:click="page('streamer-events')">
            <i class="bi-calendar-event"></i> Events
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'logs' }" v-on:click="page('logs')">Logs</button>
        </li>
      </ul>
  </div>
`,

  streamers: `
  <div data-component="queues">
    <section class="queues-container">
        
        <!-- Current Battle Section - Full Width -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="queue-card queue-card-primary">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-primary">
                    <i class="bi-lightning-charge-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Current Battle</h4>
                    <p class="queue-subtitle">Active battle in progress</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <currentBattle></currentBattle>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Cards Section -->
        <div class="row mb-4">
          <!-- Inventory Overview Container -->
          <div class="col-12">
            <div class="inventory-container">
              <div class="inventory-container-header">
                <h4><i class="bi-box-seam-fill"></i> Inventory Overview</h4>
                <p class="inventory-subtitle">Remaining packs, keys, and exclusive cards available to give</p>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                  <givePack></givePack>
                </div>
                <div class="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                  <giveKey></giveKey>
                </div>
                <div class="col-lg-4 col-md-12">
                  <giveExclusiveCard></giveExclusiveCard>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Primary Queue Section - Two Column -->
        <div class="row mb-4">
          <div class="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div class="queue-card queue-card-pack">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-pack">
                    <i class="bi-box-seam-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Open Pack Queue</h4>
                    <p class="queue-subtitle">Pack opening requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <unlockQueue></unlockQueue>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="queue-card queue-card-battle">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-battle">
                    <i class="bi-sword-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Battle Queue</h4>
                    <p class="queue-subtitle">Pending battle requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <battleQueue></battleQueue>
              </div>
            </div>
          </div>
        </div>

        <!-- Secondary Queue Section - Two Column -->
        <div class="row mb-4">
          <div class="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div class="queue-card queue-card-streamer-battle">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-streamer-battle">
                    <i class="bi-broadcast-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Streamers Battle Queue</h4>
                    <p class="queue-subtitle">Streamer battle requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <streamerBattleQueue></streamerBattleQueue>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="queue-card queue-card-event">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-event">
                    <i class="bi-calendar-event-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Event Queue</h4>
                    <p class="queue-subtitle">Event requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <event-queue></event-queue>
              </div>
            </div>
          </div>
        </div>

        <!-- Tertiary Queue Section - Two Column -->
        <div class="row mb-4">
          <div class="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div class="queue-card queue-card-streamer">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-streamer">
                    <i class="bi-broadcast-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Streamers Queue</h4>
                    <p class="queue-subtitle">Streamer requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <streamersQueue></streamersQueue>
              </div>
            </div>
          </div>
        </div>

        <!-- Team Battle Queue Section - Full Width -->
        <div class="row">
          <div class="col-12">
            <div class="queue-card queue-card-team">
              <div class="queue-card-header">
                <div class="queue-header-content">
                  <div class="queue-icon-wrapper queue-icon-team">
                    <i class="bi-people-fill"></i>
                  </div>
                  <div class="queue-title-group">
                    <h4 class="queue-title">Team Battle Queue</h4>
                    <p class="queue-subtitle">Team battle requests</p>
                  </div>
                </div>
              </div>
              <div class="queue-card-body">
                <teamBattleQueue></teamBattleQueue>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
`,

eventQueue: `
  <div data-component="event-queue" class="always-display">
    <section>
      <div v-if="!model.isLoading" class="loading">
        <div class="loader1"></div>
        <p>please wait...</p>
      </div>
      <div class="row" v-else>
        <div class="col-12">
          <div class="row columns">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="user: Twich display name">Username</label>
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name">Team Name</label>
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name">Event Name</label>
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom"></label>
              </div>
          </div>

          <div v-if="!model.hasResults">
            <h4 class="no-records">No Users queued</h4>
          </div>

          <div v-if="model.hasResults">
            <div class="row data" v-for="queue in model.queues" :key="queue.twitchId">
              <div class="col-3" :title="queue.username">{{queue.username}}</div>
              <div class="col-3" :title="cardNames(queue.cards)">{{queue.teamName}}</div>
              <div class="col-3" :title="queue.event.name">{{queue.event.name}}</div>
              <div class="col-3">
                <button data-button="start"  v-on:click="accept(queue)" class="small">Accept</button>
                <button data-button="cancel" v-on:click="cancel(queue)" class="small">Decline</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
`,

streamersSettings: `
<div data-component="streamer-settings">
   <section>
        <div class="row">



        <streamer-obs-settings></streamer-obs-settings>
          <div class="col-12">

            <div class="row" v-for="setting in model.settings">
              <div class="col-12">
                <div class="card" v-if="setting.key === 'stealcards' || setting.key === 'autobattle' || setting.key === 'autoopen'">
                  <div class="row setting">
                    <div class="col-6 col-md-8">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">{{ setting.description }}</label>
                    </div>
                    <div class="col-6 col-md-4">
                      <div v-if="setting.type == 'boolean'" class="form-check form-switch">
                        <input v-model="setting.value" type="checkbox" class="form-check-input" @change="save(setting.id)">
                      </div>
                      <div v-if="setting.type == 'value'">
                        <input v-model="setting.value" type="text">
                        <button class="top-margin" data-button="submit" v-on:click="save(setting.id)">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
          <div class="col-12">
            <streamerBattles></streamerBattles>
          </div>
            
          <div class="row">
            <div class="col-12">
                <div class="card">
                  <div class="row setting">
                    <div class="col-4 col-md-8">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Update Twitch permissions for steam handling.</label>
                    </div>
                    <div class="col-8 col-md-4">
                      <a data-button="twitch-admin">
                        <i class="bi-twitch"></i> 
                        Connect With Twitch
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
</div>
`,

unlockQueue: `
  <div data-component="unlock-queue" class="always-display">
    <section>
      <div v-if="!model.isLoading" class="loading">
        <div class="loader1"></div>
        <p>please wait...</p>
      </div>
      <div class="row" v-else>
        <div class="col-12">
          <div class="row columns">
            <div class="col-4">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: The users Twich display name.">User</label>
            </div>
            <div class="col-4">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Pack: The pack that is being unlocked.">Pack</label>
            </div>
            <div class="col-4"></div>
          </div>
          <div v-if="!model.hasResults">
            <h4 class="no-records">No Card Unlock Requests</h4>
          </div>
          <div v-if="model.hasResults">
            <div class="row data" v-if="unlock.active" v-for="unlock in model.unlocks">
              <div class="col-3" :title="unlock.twitchDisplayName">
                {{ unlock.twitchDisplayName[0].twitchDisplayName }}
              </div>
              <div class="col-3" :title="model.packs[unlock.packId].name">
                <span v-if="model.packs[unlock.packId]">{{ model.packs[unlock.packId].name }}</span>
              </div>
              <div class="col-6">
                <button data-button="open" v-on:click="open(unlock.id)" class="small"  v-bind:class="{ 'is-disabled': unlock.disabled }">Open</button>
                <button data-button="cancel" v-on:click="cancel(unlock.id)" class="small">Cancel</button>
                <button data-button="open" v-on:click="sendToHq(unlock.id, unlock.twitchDisplayName[0].twitchId)" class="small"  v-bind:class="{ 'is-disabled': unlock.hq }">Send to HQ</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
`,

HQunlockQueue: `
  <div data-component="hq-unlock-queue" class="always-display">
    <section>
      <div class="row">
        <div class="col-12">
          <div v-if="!model.hasOpen">

           <div class="queue-section">
            <div class="queue-stats">
                <div class="stat-item">
                    <div class="stat-number">{{model.packStatus.packs}}</div>
                    <div class="stat-label">Total Packs</div>
                </div>
                <div class="stat-item">
                    <div class="stat-number">{{model.packStatus.readyToOpen}}</div>
                    <div class="stat-label">Ready to Open</div>
                </div>
                <div class="stat-item">
                    <div class="stat-number">{{model.packStatus.opened}}</div>
                    <div class="stat-label">Opened</div>
                </div>
            </div>

            <div class="section-title">
                Available Packs
            </div>

            <div class="pack-grid">
                <div class="pack-item" v-if="unlock.active" v-for="unlock in model.unlocks" style="opacity: 1; transform: translateY(0px); transition: 0.6s;">
                    <div class="pack-header">
                        <div class="pack-icon">🔥</div>
                        <div class="pack-info">
                            <p>Ready to open</p>
                        </div>
                    </div>
                    <div class="pack-details">
                    <div class="pack-container">
                      <playing-card
                          id="hq-cover"
                          class="cover"
                          v-bind:card="model.card[0]"
                          v-bind:show="false"
                          :style="getPackImageStyle(unlock.packId)"
                          >
                        </playing-card>
                    </div>

                        <div class="pack-type">{{ model.packs[unlock.packId].name }}</div>
                        <div class="pack-rarity">{{getPackInfo(unlock.packId)}}</div>
                    </div>
                    <div class="pack-actions">
                        <button class="btn btn-open" v-on:click="openQueue(unlock.id, unlock.channelId)" v-bind:class="{ 'is-disabled': unlock.disabled }">Open Pack</button>
                        <button class="btn btn-cancel"  v-on:click="cancel(unlock.id)">Cancel</button>
                    </div>
                </div>

            </div>
        </div>

          </div>
          <div v-else>
            <div data-component="open-pack-hq" class="always-display">
              <button class="hq-close-btn" v-on:click="closePack()">&#10005;</button>
              <canvas id="galaxy-hq" v-show="galaxyVisible"></canvas>
              <div class="black-hole" :style="holeStyle"></div>
              <div
                v-for="(card, i) in explodedCards"
                :key="'ex-' + i"
                class="exploded-card"
                :style="card.style"
              ></div>
              <div class="content">
                <div class="open-pack-wrapper-hq" v-bind:class="{ show: model.packLoaded }">
                  <div class="open-pack-container collapsed">
                    <div id="opened-cards" class="opened-cards-wrapper">
                      <div class="opened-cards">
                          <component
                            v-for="card in model.userCards"
                            class="scaled"
                            :key="card.id"
                            v-bind:card="card"
                            :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
                            :card="card"
                            v-bind:show="false"
                          ></component>

                      </div>
                    </div>
                    <playing-card
                      id="hq-cover"
                      class="cover pulse"
                      :class="model.pack.name"
                      v-bind:card="model.card[0]"
                      v-bind:show="false"
                      v-bind:cover="true"
                      :style="[getPackImageStyle(model.pack.id), packStyle]"
                      >
                    </playing-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  </div>
`,

adminAnnouncement: `
  <div data-component="admin-announcement">
    <section class="quest-line-section">
      <div class="quest-line-container">
        
        <!-- Header Panel -->
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-megaphone"></i>
              <div>
                <h2>Announcements</h2>
                <p class="admin-subtitle quest-subtitle">Manage system announcements</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>New Announcement</span>
            </button>
          </div>
        </div>

        <!-- Edit Form Sidebar -->
        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: enable a announcement.">Active</label>
                <div class="form-check form-switch">
                  <input v-model="model.announcement.active" type="checkbox" class="form-check-input">
                </div>
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Announcement name">Announcement Name</label>
                <input class="form-control" v-model="model.announcement.name" type="text">
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Announcement Description">Description</label>
                <textarea cols="50" type="text" class="form-control" v-model="model.announcement.description"></textarea>
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Announcement Description">From</label>
                <input rows="4" cols="50" type="datetime-local" class="form-control" v-model="model.announcement.from"></input>
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Announcement Description">To</label>
                <input rows="4" cols="50" type="datetime-local" class="form-control" v-model="model.announcement.to"></input>
              </div>
              <div v-if="model.announcement.id"  class="upload">
                <file-upload
                  :multiple="true"
                  upload-type="announcement"
                  :upload-id="model.announcement.id"
                  accepted-types="image/*,video/*"
                  :max-size="20 * 1024 * 1024"
                  :existing-images="model.announcement.images"
                  :allow-remove-existing="true"
                  :image-base-url="getAnnouncementUrl()"
                  @upload-success="handleMediaUpload">
                </file-upload>
              </div>
              <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Announcement
              </button>
            </div>
          </div>
        </div>

        <!-- Announcement Table -->
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-toggle">
                  <i class="bi-eye"></i>
                </th>
                <th class="th-level">Active</th>
                <th class="th-name">Name</th>
                <th class="th-rules">Description</th>
                <th class="th-date">Start</th>
                <th class="th-date">End</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(announcement, index) in model.announcements" :key="index">
                <tr class="admin-table-row quest-row" :class="{ 'expanded': model.expandedRow === index }">
                  <td class="td-toggle" @click="toggleDetails(index, announcement)">
                    <button class="admin-toggle-btn toggle-btn" :class="{ 'active': model.expandedRow === index }">
                      <i v-if="model.expandedRow === index" class="bi-eye-fill"></i>
                      <i v-else class="bi-eye-slash"></i>
                    </button>
                  </td>
                  <td class="td-level">
                    <i v-if="announcement.active == true" class="bi-check-lg"></i> 
                    <i v-if="announcement.active == false" class="bi-x-lg"></i> 
                  </td>
                  <td class="td-name">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ announcement.name }}</span>
                    </div>
                  </td>
                  <td class="td-rules">
                    <span class="admin-rules-text rules-text" :title="announcement.description">{{ announcement.description }}</span>
                  </td>
                  <td class="td-date">
                    {{ announcement.startDate }}
                  </td>
                  <td class="td-date">
                    {{ announcement.endDate }}
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(announcement.id)" title="Edit Announcement">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
                
                <!-- Expanded Details Row -->
                <tr class="admin-details-row quest-details-row" v-show="model.expandedRow === index">
                  <td colspan="7">
                    <div class="admin-details-panel quest-details-panel">
                      <div class="details-grid">
                        <!-- Preview Mode Toggle -->
                        <div class="preview-mode-toggle">
                          <button 
                            class="preview-mode-btn"
                            :class="{ active: previewMode === 'single' }"
                            @click="previewMode = 'single'">
                            Single View
                          </button>
                          <button 
                            class="preview-mode-btn"
                            :class="{ active: previewMode === 'multi' }"
                            @click="previewMode = 'multi'">
                            Multi-Device Preview
                          </button>
                        </div>

                        <!-- Multi-Device Preview -->
                        <div v-if="previewMode === 'multi'" class="device-preview-container">
                          <!-- Mobile Preview -->
                          <div class="device-preview-wrapper">
                            <div class="device-label">📱 Mobile</div>
                            <div class="device-frame mobile">
                              <div class="device-preview-content">
                                <div class="device-announcement-preview">
                                  <div class="image-slider">
                                    <div 
                                      v-for="(slide, idx) in slides" 
                                      :key="'mobile-' + idx"
                                      class="slide"
                                      :class="{ active: currentSlideIndex === idx }">
                                      <img :src="slide" :alt="'Slide ' + (idx + 1)" />
                                    </div>
                                  </div>
                                  <div class="slider-dots">
                                    <span 
                                      v-for="(slide, idx) in announcement.images" 
                                      :key="'mobile-dot-' + idx"
                                      class="dot" 
                                      :class="{ active: currentSlideIndex === idx }">
                                    </span>
                                  </div>
                                  <div class="content-overlay" :style="overlayStyle">
                                    <h1 class="announcement-title" :style="titleStyle">
                                      {{ model.announcement.name }}
                                    </h1>
                                    <p class="announcement-description" :style="descriptionStyle">
                                      {{ model.announcement.description }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Tablet Preview -->
                          <div class="device-preview-wrapper">
                            <div class="device-label">📱 Tablet</div>
                            <div class="device-frame tablet">
                              <div class="device-preview-content">
                                <div class="device-announcement-preview">
                                  <div class="image-slider">
                                    <div 
                                      v-for="(slide, idx) in slides" 
                                      :key="'tablet-' + idx"
                                      class="slide"
                                      :class="{ active: currentSlideIndex === idx }">
                                      <img :src="slide" :alt="'Slide ' + (idx + 1)" />
                                    </div>
                                  </div>
                                  <div class="slider-dots">
                                    <span 
                                      v-for="(slide, idx) in announcement.images" 
                                      :key="'tablet-dot-' + idx"
                                      class="dot" 
                                      :class="{ active: currentSlideIndex === idx }">
                                    </span>
                                  </div>
                                  <div class="content-overlay" :style="overlayStyle">
                                    <h1 class="announcement-title" :style="titleStyle">
                                      {{ model.announcement.name }}
                                    </h1>
                                    <p class="announcement-description" :style="descriptionStyle">
                                      {{ model.announcement.description }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Desktop Preview -->
                          <div class="device-preview-wrapper">
                            <div class="device-label">🖥️ Desktop</div>
                            <div class="device-frame desktop">
                              <div class="device-preview-content">
                                <div class="device-announcement-preview">
                                  <div class="image-slider">
                                    <div 
                                      v-for="(slide, idx) in slides" 
                                      :key="'desktop-' + idx"
                                      class="slide"
                                      :class="{ active: currentSlideIndex === idx }">
                                      <img :src="slide" :alt="'Slide ' + (idx + 1)" />
                                    </div>
                                  </div>
                                  <div class="slider-dots">
                                    <span 
                                      v-for="(slide, idx) in announcement.images" 
                                      :key="'desktop-dot-' + idx"
                                      class="dot" 
                                      :class="{ active: currentSlideIndex === idx }">
                                    </span>
                                  </div>
                                  <div class="content-overlay" :style="overlayStyle">
                                    <h1 class="announcement-title" :style="titleStyle">
                                      {{ model.announcement.name }}
                                    </h1>
                                    <p class="announcement-description" :style="descriptionStyle">
                                      {{ model.announcement.description }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Original Single View (existing code) -->
                        <div v-if="previewMode === 'single'" class="announcement-container">
                          <div class="admin-announcement-container">
                            <!-- Your existing single preview code here -->
                            <div class="image-slider">
                              <div 
                                v-for="(slide, index) in slides" 
                                :key="index"
                                class="slide"
                                :class="{ active: currentSlideIndex === index }">
                                <img :src="slide" :alt="'Slide ' + (index + 1)" />
                              </div>
                            </div>

                            <div class="slider-dots">
                              <span 
                                v-for="(slide, index) in announcement.images" 
                                :key="index"
                                class="dot" 
                                :class="{ active: currentSlideIndex === index }"
                                @click="currentSlide(index)">
                              </span>
                            </div>
                            
                            <div class="announcement-timer">⏳ {{model.timer}}</div>
                            
                            <div class="content-overlay" :style="overlayStyle">
                              <h1 class="announcement-title" :style="titleStyle">
                                {{ model.announcement.name }}
                              </h1>
                              <p class="announcement-description" :style="descriptionStyle">
                                {{ model.announcement.description }}
                              </p>
                            </div>
                          </div>

                          <!-- Editor Panel -->
                          <div class="editor-panel">
                            <h2>Live Editor</h2>
                            
                            <div class="editor-section">
                              <label for="titleSize">Title Font Size (rem)</label>
                              <input 
                                type="range" 
                                id="titleSize" 
                                min="1" 
                                max="4" 
                                step="0.1" 
                                v-model.number="model.announcement.titleSize">
                              <div class="value-display">Current: <span>{{ model.announcement.titleSize }}</span>rem</div>
                            </div>

                            <div class="editor-section">
                              <label for="descSize">Description Font Size (rem)</label>
                              <input 
                                type="range" 
                                id="descSize" 
                                min="0.8" 
                                max="2" 
                                step="0.1" 
                                v-model.number="model.announcement.descSize">
                              <div class="value-display">Current: <span>{{ model.announcement.descSize }}</span>rem</div>
                            </div>

                            <div class="editor-section">
                              <label for="verticalPos">Vertical Position</label>
                              <select id="verticalPos" v-model="model.announcement.verticalPos">
                                <option value="bottom">Bottom (Default)</option>
                                <option value="center">Center</option>
                                <option value="top">Top</option>
                              </select>
                            </div>

                            <div class="editor-section">
                              <label for="horizontalPos">Horizontal Alignment</label>
                              <select id="horizontalPos" v-model="model.announcement.horizontalPos">
                                <option value="left">Left (Default)</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                              </select>
                            </div>

                            <div class="editor-section">
                              <label for="announcementName">Announcement Name</label>
                              <input 
                                type="text" 
                                id="announcementName" 
                                v-model="model.announcement.name">
                            </div>

                            <div class="editor-section">
                              <label for="announcementDesc">Announcement Description</label>
                              <textarea 
                                id="announcementDesc" 
                                rows="3" 
                                v-model="model.announcement.description">
                              </textarea>
                            </div>

                            <div class="editor-section">
                              <label for="startDate">Start Date</label>
                              <input 
                                type="datetime-local" 
                                id="startDate" 
                                v-model="model.announcement.from">
                            </div>

                            <div class="editor-section">
                              <label for="endDate">End Date</label>
                              <input 
                                type="datetime-local" 
                                id="endDate" 
                                v-model="model.announcement.to">
                            </div>

                            <div class="editor-section">
                              <div v-if="model.announcement.id" class="upload">
                                <file-upload
                                  :multiple="true"
                                  upload-type="announcement"
                                  :upload-id="model.announcement.id"
                                  accepted-types="image/*,video/*"
                                  :max-size="20 * 1024 * 1024"
                                  :existing-images="model.announcement.images"
                                  :allow-remove-existing="true"
                                  :image-base-url="getAnnouncementUrl()"
                                  @upload-success="handleMediaUpload">
                                </file-upload>
                              </div>
                            </div>
                            
                            <div class="editor-section">  
                              <button @click="save" class="btn-primary">Save Announcement</button>
                              <button @click="resetToDefaults" class="btn-secondary">Reset to Defaults</button>
                            </div>
                          </div>
                        </div>

                        <!-- Editor Panel for Multi-Device View -->
                        <div v-if="previewMode === 'multi'" class="announcement-container" style="margin-top: 20px;">
                          <div class="editor-panel" style="max-width: 100%; width: 100%;">
                            <h2>Live Editor</h2>
                            
                            <div class="editor-section">
                              <label for="titleSize">Title Font Size (rem)</label>
                              <input 
                                type="range" 
                                id="titleSize" 
                                min="1" 
                                max="4" 
                                step="0.1" 
                                v-model.number="model.announcement.titleSize">
                              <div class="value-display">Current: <span>{{ model.announcement.titleSize }}</span>rem</div>
                            </div>

                            <div class="editor-section">
                              <label for="descSize">Description Font Size (rem)</label>
                              <input 
                                type="range" 
                                id="descSize" 
                                min="0.8" 
                                max="2" 
                                step="0.1" 
                                v-model.number="model.announcement.descSize">
                              <div class="value-display">Current: <span>{{ model.announcement.descSize }}</span>rem</div>
                            </div>

                            <div class="editor-section">
                              <label for="verticalPos">Vertical Position</label>
                              <select id="verticalPos" v-model="model.announcement.verticalPos">
                                <option value="bottom">Bottom (Default)</option>
                                <option value="center">Center</option>
                                <option value="top">Top</option>
                              </select>
                            </div>

                            <div class="editor-section">
                              <label for="horizontalPos">Horizontal Alignment</label>
                              <select id="horizontalPos" v-model="model.announcement.horizontalPos">
                                <option value="left">Left (Default)</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                              </select>
                            </div>

                            <div class="editor-section">
                              <label for="announcementName">Announcement Name</label>
                              <input 
                                type="text" 
                                id="announcementName" 
                                v-model="model.announcement.name">
                            </div>

                            <div class="editor-section">
                              <label for="announcementDesc">Announcement Description</label>
                              <textarea 
                                id="announcementDesc" 
                                rows="3" 
                                v-model="model.announcement.description">
                              </textarea>
                            </div>

                            <div class="editor-section">
                              <label for="startDate">Start Date</label>
                              <input 
                                type="datetime-local" 
                                id="startDate" 
                                v-model="model.announcement.from">
                            </div>

                            <div class="editor-section">
                              <label for="endDate">End Date</label>
                              <input 
                                type="datetime-local" 
                                id="endDate" 
                                v-model="model.announcement.to">
                            </div>

                            <div class="editor-section">
                              <div v-if="model.announcement.id" class="upload">
                                <file-upload
                                  :multiple="true"
                                  upload-type="announcement"
                                  :upload-id="model.announcement.id"
                                  accepted-types="image/*,video/*"
                                  :max-size="20 * 1024 * 1024"
                                  :existing-images="model.announcement.images"
                                  :allow-remove-existing="true"
                                  :image-base-url="getAnnouncementUrl()"
                                  @upload-success="handleMediaUpload">
                                </file-upload>
                              </div>
                            </div>
                            
                            <div class="editor-section">  
                              <button @click="save" class="btn-primary">Save Announcement</button>
                              <button @click="resetToDefaults" class="btn-secondary">Reset to Defaults</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>
`,

  keyQueue: `
    <div data-component="key-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: The users Twich display name.">User</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Key: The keys name.">Key</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Keys Uses</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="key.queue" v-for="key in model.keys">
                <div class="col-4" :title="key.twitchDisplayName">
                  {{ key.twitchDisplayName }}
                </div>
                <div class="col-4" :title="key.name">
                  {{ key.name }}
                </div>
                <div class="col-4">
                  <button data-button="use" v-on:click="use(key.id)" class="small">Use</button>
                  <button data-button="cancel" v-on:click="cancel(key.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  battleQueue: `
    <div data-component="battle-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
     
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display name of user 1.">User 1</label>
              </div>
              <!--
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: The cards of user 1.">Cards 1</label>
              </div>
              -->
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display name of user 2.">User 2</label>
              </div>
              <!--
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: The cards of user 2.">Cards 2</label>
              </div>
              -->
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Users queued</h4>
            </div>
            <div else>
              <div class="row data" v-if="battle.queue" v-for="battle in model.battles">
                <div class="col-4" :title="battle.user1TwitchDisplayName">
                  {{ battle.twitch1DisplayName[0].twitchDisplayName }}
                </div>
                <!--
                <div class="col-2" :title="battle.user1Cards">
                  {{ battle.user1Cards }}
                </div>
                -->
                <div class="col-4" :title="battle.user2TwitchDisplayName">
                  {{ battle.twitch2DisplayName[0].twitchDisplayName }}
                </div>
                <!--
                <div class="col-2" :title="battle.user2Cards">
                  {{ battle.user2Cards }}
                </div>
                -->
                <div class="col-4">
                  <button data-button="start" v-on:click="start(battle.id)" class="small">Start</button>
                  <button data-button="cancel" v-on:click="cancel(battle.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  streamerBattleQueue: `
  <div data-component="battle-queue" class="always-display">
    <section>
        <div v-if="!model.isLoading" class="loading">
          <div class="loader1"></div>
          <p>waiting for players...</p>
        </div>
        <div v-else>
            <div class="col-12">
              <div class="row columns">
                <div class="col-3">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display Team 1.">Team 1</label>
                </div>
                <!--
                <div class="col-3">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: The cards of user 1.">Cards 1</label>
                </div>
                -->
                <div class="col-3">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display Team 2.">Team 2</label>
                </div>
                <!--
                <div class="col-3">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: The cards of user 2.">Cards 2</label>
                </div>
                -->
                <div class="col-3">Mode</div>
                <div class="col-3"></div>
              </div>
              <div v-if="!model.hasResults">
                <h4 class="no-records">No Streamer Battles Requests</h4>
              </div>
              <div v-if="model.hasResults">
                <div class="row data" v-for="battle in model.battles" :key="battle.id">
                  <div class="col-3" :title="getPlayerDisplayNames(battle, 1)">
                    <div v-if="battle.isSquad">
                      {{battle.playerTeam1}}
                    </div>
                    <div v-else-if="battle.streamerBattle  && !battle.isSquad">
                      {{ battle.streamerAccept[0].twitchDisplayName}}
                    </div>
                    <div v-else>
                      {{ battle.user1TwitchDisplayName}},{{ battle.user2TwitchDisplayName}},{{ battle.user3TwitchDisplayName}},{{ battle.user4TwitchDisplayName}}
                    </div>
                  </div>
      
                  <div class="col-3" :title="getPlayerDisplayNames(battle, 2)">
    
                    <div v-if="battle.isSquad">
                      {{battle.playerTeam2}}
                    </div>
                    <div v-else-if="battle.streamerBattle  && !battle.isSquad">
                      {{ battle.streamerChallenge[0].twitchDisplayName}}
                    </div>
                    <div v-else>
                        {{ battle.user5TwitchDisplayName}},{{ battle.user6TwitchDisplayName}},{{ battle.user7TwitchDisplayName}},{{ battle.user8TwitchDisplayName}}
                    </div>
        
                  </div>
                  <div class="col-3">
                    <span>
                        {{ 
                          
                            battle.tournamentId === null && battle.streamerAccept === null 
                                ? battle.type 
                                : battle.tournamentId !== null && battle.streamerAccept === null 
                                    ? 'Tournament' 
                                    : battle.streamerAccept !== null && battle.tournamentId === null 
                                        ? 'Streamer' 
                                        : battle.tournamentId !== null && battle.streamerAccept !== null 
                                            ? 'Streamer Tournament' 
                                            : '' 
                        }}
                    </span>
                  </div>
                  <div class="col-3">
                    <button data-button="start" v-on:click="start(battle)" class="small">Start</button>
                    <button data-button="cancel" v-on:click="cancel(battle)" class="small">Cancel</button>
                  </div>
                    
                </div>
              </div>
          </div>
        </div>
    </section>
  </div>
`,

  teamBattleQueue: `
 <div data-component="battle-queue" class="always-display">
    <section>
        <div>
         <div>
            <div class="col-12">
              <div class="row columns">
                <div class="col-4">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display Team 1.">Team 1</label>
                </div>
                <!--
                <div class="col-2">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: The cards of user 1.">Cards 1</label>
                </div>
                -->
                <div class="col-4">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display Team 2.">Team 2</label>
                </div>
                <!--
                <div class="col-2">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: The cards of user 2.">Cards 2</label>
                </div>
                -->
                <div class="col-2">Mode</div>
                <div class="col-2"></div>
              </div>
              <div v-if="!model.hasResults">
                <h4 class="no-records">No Team Battles Available</h4>
              </div>
              <div v-else>
                <div class="row data" v-for="battle in model.battles" :key="battle.id">
                  <div class="col-4" :title="getPlayerDisplayNames(battle, 1)">
                    <div v-if="battle.isSquad">
                      {{battle.playerTeam1}}
                    </div>
                    <div v-else>
                      {{ battle.user1TwitchDisplayName}},{{ battle.user2TwitchDisplayName}},{{ battle.user3TwitchDisplayName}},{{ battle.user4TwitchDisplayName}}
                    </div>
                  </div>
      
                  <div class="col-4" :title="getPlayerDisplayNames(battle, 2)">
    
                    <div v-if="battle.isSquad">
                      {{battle.playerTeam2}}
                    </div>
                    <div v-else>
                        {{ battle.user5TwitchDisplayName}},{{ battle.user6TwitchDisplayName}},{{ battle.user7TwitchDisplayName}},{{ battle.user8TwitchDisplayName}}
                    </div>
        
                  </div>
                  <div class="col-2">
                    <span>
                        {{ 
                          
                            battle.tournamentId === null && battle.streamerAccept === null 
                                ? battle.type 
                                : battle.tournamentId !== null && battle.streamerAccept === null 
                                    ? 'Tournament' 
                                    : battle.streamerAccept !== null && battle.tournamentId === null 
                                        ? 'Streamer' 
                                        : battle.tournamentId !== null && battle.streamerAccept !== null 
                                            ? 'Streamer Tournament' 
                                            : '' 
                        }}
                    </span>
                  </div>
                  <div class="col-2">
                    <button data-button="start" v-on:click="start(battle)" class="small">Start</button>
                    <button data-button="cancel" v-on:click="cancel(battle)" class="small">Cancel</button>
                  </div>
                    
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  </div>
`,

streamersQueue: `
  <div data-component="battle-queue" class="always-display">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="row columns">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="user: Twich display name">Username</label>
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name">Team Name</label>
              </div>
              <div class="col-3">Is Faction</div>
              <div class="col-3">Action</div>
          </div>

          <div v-if="!model.hasResults">
            <h4 class="no-records">No Users queued</h4>
          </div>

          <div v-if="model.hasResults">
            <div class="row data" v-for="queue in model.queues" :key="queue.twitchId">
              <div class="col-3" :title="queue.username">{{ queue.username }}</div>
              <div class="col-3" :title="cardNames(queue.cards)">{{ queue.teamName }}</div>
              <div class="col-3" :title="queue.faction">{{ queue.faction }}</div>
              <div class="col-3">
                <div v-if="queue.status == 1">
                   <button data-button="start"  class="small is-disabled">Accepted</button>
                   <button data-button="cancel" v-on:click="cancel({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName, id: queue.id})" class="small">Cancel</button>
                </div>
                <div v-else>
                  <button data-button="start"  v-on:click="accept({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName, id: queue.id})" class="small">Accept</button>
                  <button data-button="cancel" v-on:click="decline({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName, id: queue.id})" class="small">Decline</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
`,

tournamentsQueue: `
  <div data-component="battle-queue" class="always-display">
    <section>
      <div class="row">
        <div class="col-12">

          <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="user: Twich display name">Username</label>
              </div>
            <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name">Team Name</label>
              </div>
              <div class="col-4"></div>
          </div>

          <div v-if="!model.hasResults">
            <h4 class="no-records">No Users queued</h4>
          </div>

          <div v-if="model.hasResults">
            <div class="row data" v-for="queue in model.queues" :key="queue.twitchId">
              <div class="col-4" :title="queue.username">{{ queue.twitchDisplayName }}</div>
              <div class="col-4" :title="queue.teamName">{{ queue.teamName }}</div>
              <div class="col-4">
                <div v-if="queue.status == 1">
                   <button data-button="start"  class="small is-disabled">Accepted</button>
                   <button data-button="cancel" v-on:click="cancel({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName, id: queue.id})" class="small">Cancel</button>
                </div>
                <div v-else>
                  <button data-button="start"  v-on:click="accept({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName})" class="small">Accept</button>
                  <button data-button="cancel" v-on:click="decline({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName, id: queue.id})" class="small">Decline</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
`,

  currentBattle: `
    <div data-component="current-battle" class="always-display">
      <section>
        <div>
           <div class="row" v-if="model.battle.mode === 'single'">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-4">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display name of user 1.">User 1</label>
                  </div>
                  <div class="col-4">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display name of user 2.">User 2</label>
                  </div>
                  <div class="col-2">Mode</div>
                  <div class="col-2"></div>
                </div>
                <div v-if="!model.hasResults">
                  <h4 class="no-records">No Battle Running</h4>
                </div>
                <div v-if="model.hasResults">
                  <div class="row data" v-if="model.battle.mode === 'single'">
                    <div class="col-4" :title="model.battle.user1TwitchDisplayName">
                      {{ model.battle.user1TwitchDisplayName[0].twitchDisplayName }}
                    </div>
                    <div class="col-4" :title="model.battle.user2TwitchDisplayName">
                      {{ model.battle.user2TwitchDisplayName[0].twitchDisplayName  }}
                    </div>
                    <div class="col-2" :title="model.battle.user2TwitchDisplayName">
                      {{ model.battle.mode  }}
                    </div>
                    <div class="col-2">
                      <button data-button="queue" v-on:click="queue(model.battle.id, true)" class="small">Queue</button>
                      <button data-button="cancel" v-on:click="cancel(model.battle.id, true)" class="small">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
            <div class="col-12">
              <div class="row columns">
                <div class="col-4">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display Team 1.">Team 1</label>
                </div>
                <!--
                <div class="col-2">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: The cards of user 1.">Cards 1</label>
                </div>
                -->
                <div class="col-4">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display Team 2.">Team 2</label>
                </div>
                <!--
                <div class="col-2">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: The cards of user 2.">Cards 2</label>
                </div>
                -->
                <div class="col-2">Mode</div>
                <div class="col-2"></div>
              </div>
              <div v-if="!model.hasResults">
                <h4 class="no-records">No batttles available</h4>
              </div>
              <div v-if="model.hasResults">
                <div class="row data"">
                  <div class="col-4" :title="getPlayerDisplayNames(model.battle, 1)">
                    <div v-if="model.battle.isSquad ">
                      {{ model.battle.playerTeam1}}
                    </div>
                    <div v-else-if="model.battle.streamerBattle  && !model.battle.isSquad">
                      {{ model.battle.streamerAccept[0].twitchDisplayName}}
                    </div>
                    <div v-else>
                      {{ team1DisplayNames }}
                    </div>
                  </div>
      
                  <div class="col-4" :title="getPlayerDisplayNames(model.battle, 2)">
    
                    <div v-if="model.battle.isSquad ">
                      {{model.battle.playerTeam2}}
                    </div>
                    <div v-else-if="model.battle.streamerBattle && !model.battle.isSquad">
                      {{ model.battle.streamerChallenge[0].twitchDisplayName}}
                    </div>
                    <div v-else>
                          {{ team2DisplayNames }}
                    </div>
        
                  </div>
                  <div class="col-2">
                    <span>
                        {{ 
                            model.battle.tournamentId === null && model.battle.streamerAccept === null 
                                ? model.battle.type 
                                : model.battle.tournamentId !== null && model.battle.streamerAccept === null 
                                    ? 'Tournament' 
                                    : model.battle.streamerAccept !== null && model.battle.tournamentId === null 
                                        ? 'Streamer' 
                                        : model.battle.tournamentId !== null && model.battle.streamerAccept !== null 
                                            ? 'Streamer Tournament' 
                                            : '' 
                        }}
                    </span>
                  </div>
                  <div class="col-2">
                    <button data-button="queue" v-on:click="queue(model.battle, false)" class="small">Queue</button>
                    <button data-button="cancel" v-on:click="cancel(model.battle, false)" class="small">Cancel</button>
                  </div>
                    
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  leaderboard:`
    <div data-component="leaderboard" class="leaderboard">
      <section>
        <div v-if="!model.isLoggedIn" class="loading-container">
            <span class="loader"></span>
            <p>please wait...</p>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Leaderboard</h4>
              </div>
              
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="user in model.top" v-if="user">
                      <div class="user">
                        <div class="info">
                          <img :src="user.twitchProfileImage" />
                          <span class="trophy">
                            <i class="bi-trophy-fill"></i>
                          </span>
                          <p class="name" :title="user.twitchDisplayName">{{ user.twitchDisplayName }}</p>
                        </div>
                        <div class="wins">
                          <p>{{ user.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Username</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Packs</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Cards</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">Keys</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">XP</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">Level</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="user in model.users">
                      <div class="col-3 col-md-3 info">
                        <img :src="user.twitchProfileImage" />
                        <p :title="user.twitchDisplayName">{{ user.twitchDisplayName }}</p>
                      </div>
                      <div class="col-2">
                        <img v-for="a in user.achievements" :data-id="a.id" :src="a.image" class="medal"/>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.wins }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.losses }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.packs }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.cards }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.keys }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.xp }}</p>
                      </div>
                       <div class="col-1 d-md-block">
                        <p>{{user.level}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  teamLeaderBoard: `
    <div data-component="team-leaderboard"  class="leaderboard">
       <section>
        <div v-if="!model.isLoggedIn" class="loading-container">
            <span class="loader"></span>
            <p>please wait...</p>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <div class="header-container">
                  <h4>Team Leaderboard</h4>
                    <select class="form-select seasonal" v-model="model.selectedOption" @change="getSelectedOption">
                    <option v-for="option in model.options"  v-bind:value="option.value">
                         {{ option.value }}
                    </option>
                  </select>
                </div>
              </div>
              
             <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="user in model.top.filter(u => u && u.teamId)" :key="user.teamId">
                      <div class="user">
                        <div class="team-info">
                          <div class="member" v-for="(member, index) in user.members" :key="index">
                            <img :src="member.twitchProfileImage" />
                            <p :title="member.twitchDisplayName">{{ member.twitchDisplayName }}</p>
                          </div>
                        </div>
                        <span class="trophy">
                          <i class="bi-trophy-fill"></i>
                        </span>
                        <p class="name" :title="user.twitchDisplayName">{{ user.teamName }}</p>
                        <div class="wins">
                          <p>{{ user.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Team Name</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                    </div>
                  <div v-for="(member, index) in model.memberCount" :key="index" class="col-1 d-md-block">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" :title="member.twitchDisplayName">Player {{ index + 1 }}</label>
                  </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="team in model.teams">
                      <div class="col-3 col-md-3 info">
                        <p :title="team.teamName">{{ team.teamName }}</p>
                      </div>
                      <div class="col-3">
                        achievements
                      </div>
                      <div v-for="(member, index) in team.members" :key="index" class="col-1" :class="{ 'd-md-block': index > 1 }">
                        <img :src="member.twitchProfileImage" />
                        <p :title="member.twitchDisplayName">{{ member.twitchDisplayName }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ team.wins }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ team.losses }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  factionLeaderBoard: `
    <div data-component="factionleaderboard" class="leaderboard">
     <section>
      <div v-if="!model.isLoggedIn" class="loading-container">
          <span class="loader"></span>
          <p>please wait...</p>
        </div>
        <div class="row" v-else>
          <div class="col-12">
            <div class="card">

              <div class="header">
                <img v-if="model.id" :src="\`\${root}/images/faction/\${model.id}.png\`" alt="Faction Image" :style="{ width: '30px', height: '30px' }"><h4>{{model.factionName}} Leaderboard</h4>
              </div>
              
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="(user, index) in model.top">
                      <div class="user">
                        <div class="info">
                          <img :src="user.user[0].twitchProfileImage" />
                          <span class="trophy">
                            <i class="bi-trophy-fill"></i>
                          </span>
                          <p class="name" :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                        </div>
                        <div class="wins">
                          <p>{{ user.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-7 col-md-7">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Username</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Points</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="user in model.users">
                      <div class="col-7 col-md-7 info">
                        <img :src="user.user[0].twitchProfileImage" />
                        <p :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                      </div>
                      <div class="col-2">
                        <img v-for="a in user.achievements" :data-id="a.id" :src="a.image" class="medal"/>
                      </div>
                      <div class="col-1 col-md-1">
                       <p>{{ user.totalPoints }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.wins }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.loss }}</p>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  seasonalLeaderBoard: `
    <div data-component="seasonalleaderboard" class="leaderboard">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <div class="header-container">
                  <h4>Seasonal Leaderboard</h4>
                    <select class="form-select seasonal" v-model="model.selectedSeason" @change="selectedOption">
                    <option v-for="(value, key) in model.seasons" v-bind:value="value">
                      Season {{ value.id }}
                    </option>
                  </select>
                </div>
              </div>
              
              <div v-if="!model.isLoggedIn" class="loading-container">
                  <span class="loader"></span>
                  <p>please wait...</p>
              </div>
              <div v-else>
              <div class="tab-container">
               <div class="tabd title" v-bind:class="{ active: model.tab == 'single'}" @click="showTab('single')">Single</div>
                <div class="tabd title" v-bind:class="{ active: model.tab == 'team'}" @click="showTab('team')">Team</div>
              </div>
              <div class="tab-content">
                <div class="stats-content" v-bind:class="{ active: model.tab == 'single'}">
                    <div class="row">
                      <div class="col-12">
                        <div class="row columns">
                          <div class="col-4 top" v-for="(user, index) in model.singleTop" v-if="user && user.user && user.user[0]">
                            <div class="user">
                              <div class="info">
                                <img :src="user.user[0].twitchProfileImage" />
                                <span class="trophy">
                                  <i class="bi-trophy-fill"></i>
                                </span>
                                <p class="name" :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                              </div>
                              <div class="wins">
                                <p>{{ user.wins }} Wins</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div class="row columns headers">
                          <div class="col-3 col-md-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Streamer</label>
                          </div>
                          <div class="col-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                          </div>
                          <div class="col-3 col-md-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                          </div>
                          <div class="col-3 col-md-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                          </div>
                        </div>
                      <div class="table">
                        <div class="row data " v-for="user in model.single" v-if="user.user && user.user.length > 0">
                          <div class="col-3 col-md-3 info">
                            <img :src="user.user[0].twitchProfileImage" />
                            <p :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                          </div>
                          <div class="col-3">
                            achievements
                          </div>
                          <div class="col-3 col-md-3">
                            <p>{{ user.wins }}</p>
                          </div>
                          <div class="col-3 d-md-block">
                            <p>{{ user.losses }}</p>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                
                </div>
                <div class="stats-content" v-bind:class="{ active: model.tab == 'team'}">
                    <div class="header-container">
                      <h4>Team Leaderboard</h4>
                        <select class="form-select seasonal" v-model="model.selectedOption" @change="getSelectedOption">
                        <option v-for="option in model.options"  v-bind:value="option.value">
                            {{ option.value }}
                        </option>
                      </select>
                    </div>


                   <div class="row">
                      <div class="col-12">
                        <div class="row columns">
                          <div class="col-4 top" v-for="user in model.topTeams.filter(u => u && u.teamId)" :key="user.teamId">
                            <div class="user">
                              <div class="team-info">
                                <div class="member" v-for="(member, index) in user.members" :key="index">
                                  <img :src="member.twitchProfileImage" />
                                  <p :title="member.twitchDisplayName">{{ member.twitchDisplayName }}</p>
                                </div>
                              </div>
                              <span class="trophy">
                                <i class="bi-trophy-fill"></i>
                              </span>
                              <p class="name" :title="user.twitchDisplayName">{{ user.teamName }}</p>
                              <div class="wins">
                                <p>{{ user.wins }} Wins</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row">
                      <div class="col-12">
                        <div class="row columns headers">
                          <div class="col-3 col-md-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Team Name</label>
                          </div>
                          <div class="col-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                          </div>
                          <div v-for="(member, index) in model.memberCount" :key="index" class="col-1 d-md-block">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" :title="member.twitchDisplayName">Player {{ index + 1 }}</label>
                          </div>
                          <div class="col-1 col-md-1">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                          </div>
                          <div class="col-1 col-md-1">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                          </div>
                        </div>
                        <div class="table">
                          <div class="row data" v-for="team in model.teams">
                            <div class="col-3 col-md-3 info">
                              <p :title="team.teamName">{{ team.teamName }}</p>
                            </div>
                            <div class="col-3">
                              achievements
                            </div>
                       
                            <div v-for="(member, index) in team.members" :key="index" class="col-1" :class="{ 'd-md-block': index > 1 }">
                              <img :src="member.twitchProfileImage" />
                              <p :title="member.twitchDisplayName">{{ member.twitchDisplayName }}</p>
                            </div>
                    
                    
                            <div class="col-1 d-md-block">
                              <p>{{ team.wins }}</p>
                            </div>
                            <div class="col-1 d-md-block">
                              <p>{{ team.losses }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

              
                
                </div>
              </div>
              </div>
              
              

            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  streamersCommunityLeaderBoard: `
    <div data-component="streamer_community_leaderboard" class="leaderboard">
      <section>
       <div v-if="!model.isLoggedIn" class="loading-container">
          <span class="loader"></span>
          <p>please wait...</p>
      </div>
        <div class="row" v-else>
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Streamers Leaderboard</h4>
              </div>
              
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="(user, index) in model.top" v-if="user && user.user && user.user[0]">
                      <div class="user">
                        <div class="info">
                          <img :src="user.user[0].twitchProfileImage" />
                          <span class="trophy">
                            <i class="bi-trophy-fill"></i>
                          </span>
                          <p class="name" :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                        </div>
                        <div class="wins">
                          <p>{{ user.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Streamer</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                    </div>
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data streamers" v-for="user in model.users" title="open streamers community leaderboard" v-on:click="showCommunity(user.user[0].twitchId)">
                      <div class="col-3 col-md-3 info">
                        <img :src="user.user[0].twitchProfileImage" />
                        <p :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                      </div>
                      <div class="col-3">
                        achievements
                      </div>
                      <div class="col-3 col-md-3">
                        <p>{{ user.wins }}</p>
                      </div>
                      <div class="col-3 d-md-block">
                        <p>{{ user.losses }}</p>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
        <div class="streamers-community">
          <div class="streamers-content">
            <div class="col-12">
            <div class="card">

              <div class="header">
                <div class="header-container">
                  <i class="bi bi-arrow-left-square-fill" v-on:click="closeModal"></i><h4>{{model.selectedStreamer.twitchDisplayName}} Community Leaderboard</h4>
                </div>
              </div>
              
            <div v-if="!model.isLoggedIn" class="loading-container">
                <span class="loader"></span>
                <p>please wait...</p>
            </div>
            <div v-else>
              <div class="tab-container">
                <div class="tabd title" v-bind:class="{ active: model.tab == 'single'}" @click="showTab('single')">Single</div>
                <div class="tabd title" v-bind:class="{ active: model.tab == 'team'}" @click="showTab('team')">Team</div>
              </div>

              
              <div class="tab-content">
                <div class="stats-content" v-bind:class="{ active: model.tab == 'single'}">

                    <div class="row">
                      <div class="col-12">
                        <div class="row columns">
                          <div class="col-4 top" v-for="(user, index) in model.communityTop" v-if="user && user.user && user.user[0]">
                            <div class="user">
                              <div class="info">
                                <img :src="user.user[0].twitchProfileImage" />
                                <span class="trophy">
                                  <i class="bi-trophy-fill"></i>
                                </span>
                                <p class="name" :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                              </div>
                              <div class="wins">
                                <p>{{ user.wins }} Wins</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div class="row columns headers">
                          <div class="col-3 col-md-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Streamer</label>
                          </div>
                          <div class="col-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                          </div>
                          <div class="col-3 col-md-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                          </div>
                          <div class="col-3 col-md-3">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                          </div>
                        </div>
                        <div class="table">
                          <div class="row data streamers" v-for="user in model.community" v-if="user && user.user && user.user[0]">
                            <div class="col-3 col-md-3 info">
                              <img :src="user.user[0].twitchProfileImage" />
                              <p :title="user.user[0].twitchDisplayName">{{ user.user[0].twitchDisplayName }}</p>
                            </div>
                            <div class="col-3">
                              achievements
                            </div>
                            <div class="col-3 col-md-3">
                              <p>{{ user.wins }}</p>
                            </div>
                            <div class="col-3 d-md-block">
                              <p>{{ user.losses }}</p>
                            </div>
                      
                          </div>
                        </div>
                      </div>
                    </div>
                
                </div>
                <div class="stats-content" v-bind:class="{ active: model.tab == 'team'}">


                  <div class="row">
                    <div class="col-12">
                      <div class="row columns">
                        <div class="col-4 top" v-for="user in model.topTeams" v-if="user">
                          <div class="user">
                            <div class="team-info">

                            <div class="member" v-for="(member, index) in user.members" :key="index">
                              <img :src="member.twitchProfileImage" />
                              <p :title="member.twitchDisplayName">{{ member.twitchDisplayName }}</p>
                            </div>
                      
                            </div>
                              <span class="trophy">
                                <i class="bi-trophy-fill"></i>
                              </span>
                              <p class="name" :title="user.twitchDisplayName">{{ user.teamName }}</p>
                            <div class="wins">
                              <p>{{ user.wins }} Wins</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="row columns headers">
                        <div class="col-3 col-md-3">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Team Name</label>
                        </div>
                        <div class="col-3">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                        </div>
                        <div class="col-1 d-md-block">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Player 1</label>
                        </div>
                        <div class="col-1 d-md-block">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Player 2</label>
                        </div>
                        <div class="col-1 d-md-block">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">Player 3</label>
                        </div>
                        <div class="col-1 d-md-block">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">Player 4</label>
                        </div>
                        <div class="col-1 col-md-1">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                        </div>
                        <div class="col-1 col-md-1">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                        </div>
                      </div>
                      <div class="table">
                        <div class="row data" v-for="team in model.teams">
                          <div class="col-3 col-md-3 info">
                            <p :title="team.teamName">{{ team.teamName }}</p>
                          </div>
                          <div class="col-3">
                            achievements
                          </div>


                          <div v-for="(member, index) in team.members" :key="index" class="col-1" :class="{ 'd-md-block': index > 1 }">
                            <img :src="member.twitchProfileImage" />
                            <p :title="member.twitchDisplayName">{{ member.twitchDisplayName }}</p>
                          </div>


                          <div class="col-1 d-md-block">
                            <p>{{ team.wins }}</p>
                          </div>
                          <div class="col-1 d-md-block">
                            <p>{{ team.losses }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                 
              
                
                </div>
              </div>
            
            </div>
              
            </div>
          </div>
          </div>


          </div>
        </div>
      </section>
    </div>
  `,

  admin: `
    <div data-component="admin">
      <section>
        <div class="row">
          <div class="col-12" v-if="!model.isStreamer">
            <givePack></givePack>
          </div>
          <div class="col-12" v-if="!model.isStreamer">
            <giveKey></giveKey>
          </div>
          <div class="col-12 admin-mod-row">
            <div class="row">
              <div class="col-6">
                <addMod></addMod>
              </div>
              <div class="col-6">
                <removeMod></removeMod>
              </div>
            </div>
          </div>
          <div class="col-12">
            <medalAdmin></medalAdmin>
          </div>
          <div class="col-12" v-if="!model.isStreamer">
            <addStreamer></addStreamer>
          </div>
          <div class="col-12">
            <battleAdmin></battleAdmin>
          </div>
        </div>
      </section>
    </div>
  `,

  givePack: `
    <div data-component="give-pack" class="always-display">
      <div class="card queue-card queue-card-action">
        <div class="header">
          <div class="queue-header-content">
            <div class="queue-icon-wrapper queue-icon-pack">
              <i class="bi-box-seam-fill"></i>
            </div>
            <div class="queue-title-group">
              <h4 class="queue-title">Give Pack</h4>
              <p class="queue-subtitle">Give packs to viewers</p>
            </div>
          </div>
        </div>
        <div class="queue-card-body">
          <div v-if="!model.isLoading" class="loading">
            <div class="loader1"></div>
            <p>please wait...</p>
          </div>
          <div v-else-if="model.isLoading && !model.hasResult" class="loading">
            <p>No Subscriptions Found</p>
          </div>

          <div v-if="model.isLoading && model.hasResult">
            <div class="action-card-content">
              <div class="pack-inventory-section">
                <div class="inventory-header">
                  <i class="bi-inbox"></i>
                  <span>Pack Inventory</span>
                </div>
                <div class="inventory-list">
                  <div class="inventory-item" v-for="pack in model.streamerPacks" :key="pack.type" v-if="pack && pack.type">
                    <div class="inventory-item-content">
                      <div class="inventory-image-wrapper" v-if="getPackImageUrl(pack)">
                        <img :src="getPackImageUrl(pack)" :alt="pack.type + ' pack'" class="inventory-image pack-image">
                      </div>
                      <div class="inventory-info">
                        <span class="pack-name">{{ pack.type }}</span>
                        <span class="pack-count">{{ pack.count }} remaining</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!model.streamerPacks || model.streamerPacks.length === 0" class="empty-inventory">
                    <p>No packs available</p>
                  </div>
                </div>
              </div>

              <div class="action-form-section">
                <div class="form-group">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">
                    <i class="bi-person"></i> Display Name
                  </label>
                  <input class="form-control modern-input search" name="unlock-user" v-on:keyup="searchUsers()" type="text" placeholder="Search viewer...">
                </div>
                <div class="form-group">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Pack: Select a pack you want to give to a user.">
                    <i class="bi-box-seam"></i> Select Pack
                  </label>
                  <select class="form-select modern-select" v-model="model.packId">
                    <option value="">-- Select Pack --</option>
                    <option v-for="(value, key) in model.packs" v-bind:value="key" v-if="value.streamerShow">
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <div class="form-check form-switch modern-switch">
                    <input type="checkbox" class="form-check-input" @click="toggle" :id="'send-hq-pack'">
                    <label class="form-check-label" for="send-hq-pack">
                      <i class="bi-house-door"></i>
                      <span>Send to User's HQ</span>
                    </label>
                  </div>
                </div>
                <button class="settings-save-btn action-submit-btn" data-button="submit" v-on:click="save()">
                  <i class="bi-check-lg"></i>
                  <span>Give Pack</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

streamerBattles: `
  <div data-component="streamer-battles" class="always-display">
    <div class="card">
      <div class="header">
        <h4><i class="bi-people-fill"></i> Streamer Battles</h4>
        <button 
          v-if="!model.state" 
          class="admin-add-btn streamer-add-btn" 
          data-button="save" 
          v-on:click="addTeam()">
          <i class="bi-plus-lg"></i>
          <span>Add Team</span>
        </button>
        <button 
          v-else 
          class="admin-action-btn admin-cancel-btn" 
          data-button="cancel" 
          v-on:click="cancelTeam()">
          <i class="bi-x-lg"></i>
          <span>Cancel</span>
        </button>
      </div>

      <div v-if="!model.isLoading" class="loading">
        <div class="loader1"></div>
        <p>Loading teams...</p>
      </div>

      <div v-else>
        <!-- Add Team Form -->
        <div v-if="model.state" class="streamer-form-panel">
          <div class="streamer-form-content">
            <div class="form-group">
              <label>
                <i class="bi-tag"></i> Stream Team Name
              </label>
              <input 
                type="text" 
                class="form-control modern-input streamer-team" 
                v-model="model.teamName" 
                v-on:keyup="cleanName"
                placeholder="Enter team name...">
              <p class="validation-message success" v-if="model.validName && model.teamName != ''">
                <i class="bi-check-circle"></i> {{ model.teamvalidate }}
              </p>
              <p class="validation-message error" v-if="!model.validName && model.teamName != ''">
                <i class="bi-exclamation-circle"></i> {{ model.teamvalidate }}
              </p>
            </div>
            <button 
              data-button="submit" 
              class="settings-save-btn" 
              v-bind:class="{'is-disabled': !model.validName}" 
              v-on:click="saveStreamTeam()">
              <i class="bi-check-lg"></i>
              <span>Save Team</span>
            </button>
          </div>
        </div>

        <!-- Teams Table -->
        <div v-if="model.hasResult && model.teams && model.teams.length > 0" class="admin-table-wrapper streamer-table-wrapper">
          <table class="admin-table streamer-table">
            <thead>
              <tr>
                <th class="th-toggle">
                  <i class="bi-eye"></i>
                </th>
                <th class="th-name">Team Name</th>
                <th class="th-status">Status</th>
                <th class="th-faction">Faction</th>
                <th class="th-members">Members</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(team, index) in model.teams" :key="index">
                <!-- Main Team Row -->
                <tr class="admin-table-row streamer-row" :class="{ 'expanded': model.expandedRow === index }">
                  <td class="td-toggle" @click="toggleDetails(index)">
                    <button class="admin-toggle-btn toggle-btn" :class="{ 'active': model.expandedRow === index }">
                      <i v-if="model.expandedRow === index" class="bi-eye-fill"></i>
                      <i v-else class="bi-eye-slash"></i>
                    </button>
                  </td>
                  <td class="td-name" @click="toggleDetails(index)">
                    <div class="admin-name-cell streamer-name-cell">
                      <span class="admin-name streamer-name">{{ team.teamName }}</span>
                    </div>
                  </td>
                  <td class="td-status">
                    <span class="status-badge" :class="team.active ? 'active' : 'inactive'">
                      <i :class="team.active ? 'bi-play-circle-fill' : 'bi-pause-circle-fill'"></i>
                      {{ team.active ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td class="td-faction">
                    <div class="form-check form-switch modern-switch compact">
                      <input 
                        type="checkbox" 
                        class="form-check-input" 
                        v-model="team.faction" 
                        @change="enableFaction(team, index)"
                        :id="'faction-' + index">
                      <label class="form-check-label" :for="'faction-' + index">
                        <span class="switch-label">{{ team.faction ? 'Enabled' : 'Disabled' }}</span>
                      </label>
                    </div>
                  </td>
                  <td class="td-members">
                    <span class="members-count">
                      <i class="bi-people"></i>
                      {{ Object.values(team.streamTeam || {}).reduce((total, members) => total + (Array.isArray(members) ? members.length : 0), 0) }} member(s)
                    </span>
                  </td>
                  <td class="td-actions">
                    <button 
                      v-if="team.active"
                      class="admin-action-btn admin-cancel-btn action-btn cancel-btn" 
                      v-on:click.stop="cancelStream(team.id, index)" 
                      title="Cancel Stream">
                      <i class="bi-stop-fill"></i>
                    </button>
                    <button 
                      v-else
                      class="admin-action-btn admin-edit-btn action-btn edit-btn" 
                      v-on:click.stop="openStream(team.id, index)" 
                      title="Open Stream">
                      <i class="bi-play-fill"></i>
                    </button>
                  </td>
                </tr>
                
                <!-- Expanded Details Row -->
                <tr class="admin-details-row streamer-details-row" v-show="model.expandedRow === index">
                  <td colspan="6">
                    <div class="admin-details-panel streamer-details-panel">
                      <div class="streamer-team-details">
                        <h5><i class="bi-person-lines-fill"></i> Team Members</h5>
                        
                        <div class="admin-table-wrapper streamer-members-wrapper">
                          <table class="admin-table streamer-members-table">
                            <thead>
                              <tr>
                                <th class="th-name">Username</th>
                                <th class="th-team">Team Name</th>
                                <th class="th-cards">Cards</th>
                                <th class="th-faction">Faction</th>
                                <th class="th-actions">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(userKey, userIndex) in Object.keys(team.streamTeam || {})" :key="userIndex">
                                <tr 
                                  v-for="(user, teamIndex) in (team.streamTeam[userKey] || [])" 
                                  :key="userKey + '-' + teamIndex" 
                                  class="admin-table-row streamer-member-row">
                                  <td class="td-name">
                                    <div class="streamer-member-name">
                                      <i class="bi-person-circle"></i>
                                      <span>{{ user.twitchDisplayName }}</span>
                                    </div>
                                  </td>
                                  <td class="td-team">
                                    <span class="team-name-badge">{{ user.team.name }}</span>
                                  </td>
                                  <td class="td-cards">
                                    <div class="cards-preview" :title="cardNames(user.team.card || [])">
                                      <div class="image-tooltip">
                                        <div class="image-grid">
                                          <img 
                                            v-for="(card, cardIndex) in (user.team.card || [])" 
                                            :key="cardIndex"
                                            :src="getCardImage(card)" 
                                            :alt="card.name || 'Card'"
                                            class="card-image"
                                          />
                                        </div>
                                      </div>
                                      <span class="cards-count">
                                        <i class="bi-collection"></i>
                                        {{ (user.team.card || []).length }} card(s)
                                      </span>
                                    </div>
                                  </td>
                                  <td class="td-faction">
                                    <span class="faction-badge">
                                      {{ user.factionName || 'None' }}
                                    </span>
                                  </td>
                                  <td class="td-actions">
                                    <button 
                                      class="admin-action-btn admin-cancel-btn action-btn kick-btn" 
                                      @click.stop="removeUser({username: user.twitchDisplayName, twitchId: user.twitchId, teamName: user.team, id: team.id})" 
                                      title="Remove Member">
                                      <i class="bi-person-x"></i>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                              <tr v-if="Object.keys(team.streamTeam || {}).length === 0 || Object.values(team.streamTeam || {}).every(arr => !Array.isArray(arr) || arr.length === 0)">
                                <td colspan="5" class="empty-table-state">
                                  <div class="empty-content">
                                    <i class="bi-inbox"></i>
                                    <p>No members in this team</p>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <!-- Empty State -->
        <div v-else class="empty-table-state">
          <div class="empty-content">
            <i class="bi-people"></i>
            <p>No teams created yet</p>
            <button 
              v-if="!model.state" 
              class="admin-add-btn streamer-add-btn small" 
              v-on:click="addTeam()">
              <i class="bi-plus-lg"></i>
              <span>Create First Team</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
`,

streamerTournament: `
    <div data-component="streamer-tournaments" class="always-display">
      <div class="card">
        <div class="header">
          <h4><i class="bi-trophy-fill"></i> Streamer Tournament</h4>
          <button 
            v-if="!model.state"
            class="admin-add-btn tournament-start-btn" 
            data-button="save" 
            v-on:click="startTournament()">
            <i class="bi-play-fill"></i>
            <span>Start Tournament</span>
          </button>
          <button 
            v-else
            class="admin-action-btn admin-cancel-btn tournament-stop-btn" 
            v-on:click="stopTournament()" 
            title="Stop Tournament">
            <i class="bi-stop-fill"></i>
            <span>Stop Tournament</span>
          </button>
        </div>
        
        <div class="tournament-status-panel">
          <div class="tournament-status-content">
            <div class="tournament-status-info">
              <div class="status-indicator" :class="model.state ? 'active' : 'inactive'">
                <i :class="model.state ? 'bi-trophy' : 'bi-trophy-fill'"></i>
              </div>
              <div>
                <h5>{{ model.state ? 'Tournament Active' : 'Tournament Inactive' }}</h5>
                <p>{{ model.state ? 'The streamer tournament is currently running' : 'No tournament is currently active. Start a tournament to begin.' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
`,

adminfactionPoints: `
    <div data-component="admin-faction-points" class="always-display">
      <div class="card">
        <div class="row setting">

          <div class="col-11">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Faction Points</label>
          </div>
          <div class="col-1">
            <input type="text" v-model="model.factionPoints.faction">
          </div>
        
          <div class="col-11">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Non Faction Points</label>
          </div>
          <div class="col-1">
            <input type="text" v-model="model.factionPoints.nonFaction">
          </div>
       
          <div class="col-11">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" v-model="model.factionPoints.tournamentRound">Tournament Round</label>
          </div>
          <div class="col-1">
             <input  type="text" v-model="model.factionPoints.tournamentRound">
          </div>

          <div class="col-11">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Tournament Finals</label>
          </div>
          <div class="col-1">
             <input  type="text" v-model="model.factionPoints.tournamentRound">
          </div>
           <div class="col-12 col-md-8">
           </div>
          <div class="col-6 col-md-4">
            <div class="p-10">
              <button class="top-margin" v-on:click="save" data-button="submit">Save</button>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
`,

streamerTeams: `
  <section>
      <div class="row">
        <div class="col-12">

          <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="user: Twich display name">Username</label>
              </div>
            <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name">Team Name</label>
              </div>
              <div class="col-4"></div>
          </div>

          <div v-if="!model.hasResults">
            <h4 class="no-records">No Users queued</h4>
          </div>

          <div v-if="model.hasResults">
            <div class="row data" v-for="queue in model.queues" :key="queue.twitchId">
              <div class="col-4" :title="queue.username">{{ queue.username }}</div>
              <div class="col-4" :title="queue.teamName">{{ queue.teamName }}</div>
              <div class="col-4">
                <div v-if="queue.status == 1">
                   <button data-button="start"  class="small is-disabled">Accepted</button>
                   <button data-button="cancel" v-on:click="cancel({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName, id: queue.id})" class="small">Cancel</button>
                </div>
                <div v-else>
                  <button data-button="start"  v-on:click="accept({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName})" class="small">Accept</button>
                  <button data-button="cancel" v-on:click="decline({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName, id: queue.id})" class="small">Decline</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
`,

streamerBattles1: `
<div data-component="streamer-teams" class="always-display">
  <div class="card">
    <div class="row setting">
      <div class="col-6 col-md-8">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Streamer Battles</label>
      </div>
      <div class="col-6 col-md-4">
        <div  class="form-check form-switch">
          <input type="checkbox" v-model="model.state" class="form-check-input" @change="saveStreamerBattleState($event)" />
        </div>
      </div>
    </div>
  </div>
</div>
`,

giveKey: `
  <div data-component="give-key" class="always-display">
    <div class="card queue-card queue-card-action">
      <div class="header">
        <div class="queue-header-content">
          <div class="queue-icon-wrapper queue-icon-key">
            <i class="bi-key-fill"></i>
          </div>
          <div class="queue-title-group">
            <h4 class="queue-title">Give Keys</h4>
            <p class="queue-subtitle">Give keys to viewers</p>
          </div>
        </div>
      </div>
      <div class="queue-card-body">
        <div class="action-card-content">
          <div class="key-inventory-section">
            <div class="inventory-header">
              <i class="bi-inbox"></i>
              <span>Key Inventory</span>
            </div>
            <div class="inventory-list">
              <div class="inventory-item" v-for="streamer_keys in model.streamerKeys" :key="streamer_keys.id" v-if="streamer_keys && streamer_keys.key && streamer_keys.key.length > 0">
                <div class="inventory-item-content">
                  <div class="inventory-image-wrapper" v-if="getKeyImageUrl(streamer_keys)">
                    <img :src="getKeyImageUrl(streamer_keys)" :alt="streamer_keys.key[0].name + ' key'" class="inventory-image key-image">
                  </div>
                  <div class="inventory-info">
                    <span class="key-name">{{ streamer_keys.key[0].name }}</span>
                    <span class="key-count">{{ streamer_keys.remaining_keys }} remaining</span>
                  </div>
                </div>
              </div>
              <div v-if="!model.streamerKeys || Object.keys(model.streamerKeys).length === 0" class="empty-inventory">
                <p>No keys available</p>
              </div>
            </div>
          </div>

          <div class="action-form-section">
            <div class="form-group">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">
                <i class="bi-person"></i> Display Name
              </label>
              <input class="form-control modern-input search" name="key-user" v-on:keyup="searchUsers()" type="text" placeholder="Search viewer...">
            </div>
            <div class="form-group">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Key: Select a key you want to give to a user.">
                <i class="bi-key"></i> Select Key
              </label>
              <select class="form-select modern-select" v-model="model.keyId">
                <option value="">-- Select Key --</option>
                <option v-for="(value, key) in model.keys" v-bind:value="key">
                  {{ value.name }} - {{ value.description }}
                </option>
              </select>
            </div>
            <button class="settings-save-btn action-submit-btn" data-button="submit" v-on:click="save()">
              <i class="bi-check-lg"></i>
              <span>Give Key</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
`,

  addMod: `
    <div data-component="add-mod" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Add Mod</h4>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="mod-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-12">
                <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  removeMod: `
    <div data-component="remove-mod" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Remove Mod</h4>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="remove-mod-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-12">
                <button class="top-margin" data-button="submit" v-on:click="save()">Remove Mod</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  addStreamer: `
  <div data-component="add-streamer" class="always-display">
    <div class="card">

      <div class="header margin">
        <h4>Add Streamer</h4>
        <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
              <input class="form-control search" name="streamer-user" v-on:keyup="searchUsers('add')" type="text">
            </div>
            <div v-if="model.streamerOption" class="col-12">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="tier: select user tier.">Select Tier</label>
              <select class="form-select" v-model="model.streamer.userTier">
                <option  v-for="userTier in model.userTiers" :key="userTier.value" :value="userTier.value">
                  {{ userTier.name }}
                </option>
              </select>
            </div>
            <div v-if="model.streamerOption" class="col-12">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Subscription.">Subscription (Months)</label>
              <select class="form-control" v-model="model.streamer.months_subscription" >
                <option value="">-- Select a number --</option>
                <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

    </div>
     <div class="card">

      <div class="header margin">
        <h4>Remove Streamer</h4>
        <button class="top-margin" data-button="submit" v-on:click="removeStreamer()">Save</button>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
              <input class="form-control search" name="remove-streamer-user" v-on:keyup="searchUsers('remove')" type="text">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  `,


  battleAdmin: `
    <div data-component="battle-admin" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Battles</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: Search for Twich display name of user 1.">User 1 Display Name</label>
                <input class="form-control search" name="battle-user1" v-on:keyup="searchUsers('battle-user1')"  type="text">
              </div>
              <div class="col-12">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: Enter the cards for user 1.">Cards 1</label>
                <input class="form-control" v-model="model.battle.user1Cards" type="text">
              </div>
              <div class="col-12">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: Search for Twich display name of user 1.">User 2 Display Name</label>
                <input class="form-control search" name="battle-user2" v-on:keyup="searchUsers('battle-user2')" type="text">
              </div>
              <div class="col-12">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: Enter the cards for user 2.">Cards 2</label>
                <input class="form-control" v-model="model.battle.user2Cards" type="text">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  medalAdmin: `
    <div data-component="medal-admin" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Achievements</h4>
          <button class="top-margin" data-button="submit" v-on:click="add()">Save</button>
          <button class="top-margin" data-button="submit" v-on:click="get()">Get</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: Search for Twich display name of the users medal you want to load.">Display Name</label>
                <input class="form-control search" name="medal-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Achievement: Select a medal you want to give to a user.">Select Achievement</label>
                <select class="form-select" v-model="model.medalId">
                  <option v-for="(value, key) in model.allMedals" v-bind:value="key">
                    {{ value.name }} - {{ value.description }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-11">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Medal Name: The name of the medal the user has.">Medal</label>
              </div>
              <div class="col-1 edit">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete: Click to delete the medal.">Delete</label>
              </div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">{{ model.error }}</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-for="medal in model.medals" v-if="!medal.deleted">
                <div class="col-11">
                  {{ medal.name }}
                </div>
                <div class="col-1 edit">
                  <i class="bi-trash" v-on:click="remove(medal.id)"></i> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  cardAbiltities: `
    <div data-component="card-abilities">
      <section class="quest-line-section">
        <div class="quest-line-container">
          <div class="admin-header-panel quest-header-panel">
            <div class="admin-header-content quest-header-content">
              <div class="admin-header-title quest-header-title">
                <i class="bi-lightning-charge"></i>
                <div>
                  <h2>Abilities</h2>
                  <p class="admin-subtitle quest-subtitle">Manage card abilities</p>
                </div>
              </div>
              <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
                <i class="bi-plus-lg"></i>
                <span>Add Ability</span>
              </button>
            </div>
          </div>

          <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
            <div>
              <i class="bi-x-lg close" v-on:click="reset()"></i> 
              <div class="col-12 scroll_sidebar">
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an ability so it can be used.">Active</label>
                  <div class="form-check form-switch">
                    <input v-model="model.ability.active" type="checkbox" class="form-check-input">
                  </div>
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Abilities name.">Name</label>
                  <input class="form-control" v-model="model.ability.name" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the ability works.">Description</label>
                  <input class="form-control" v-model="model.ability.description" type="text">
                </div>
                <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                  <i class="bi-check-lg"></i> Save Ability
                </button>
              </div>
            </div>
          </div>
          
          <div class="admin-table-wrapper quest-table-wrapper">
            <table class="admin-table quest-table">
              <thead>
                <tr>
                  <th class="th-level">Active</th>
                  <th class="th-name">Name</th>
                  <th class="th-rules">Description</th>
                  <th class="th-level">Function ID</th>
                  <th class="th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="ability in model.abilities" :key="ability.id">
                  <tr class="admin-table-row quest-row" v-on:click="edit(ability.id)">
                    <td class="td-level">
                      <i v-if="ability.active == true" class="bi-check-lg"></i> 
                      <i v-if="ability.active == false" class="bi-x-lg"></i> 
                    </td>
                    <td class="td-name">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="admin-name quest-name">{{ ability.name }}</span>
                      </div>
                    </td>
                    <td class="td-rules">
                      <span class="admin-rules-text rules-text" :title="ability.description">{{ ability.description }}</span>
                    </td>
                    <td class="td-level">
                      {{ ability.id }}
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(ability.id)" title="Edit Ability">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  `,

  adminTraits: `
    <div data-component="admin-traits">
      <section class="quest-line-section">
        <div class="quest-line-container">
          <div class="admin-header-panel quest-header-panel">
            <div class="admin-header-content quest-header-content">
              <div class="admin-header-title quest-header-title">
                <i class="bi-lightning-charge-fill"></i>
                <div>
                  <h2>Traits</h2>
                  <p class="admin-subtitle quest-subtitle">View and annotate battle status traits</p>
                </div>
              </div>
              <button class="admin-create-btn" v-on:click="create()">
                <i class="bi-plus-lg"></i> Create New Trait
              </button>
            </div>
          </div>

          <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
            <div>
              <i class="bi-x-lg close" v-on:click="reset()"></i>
              <div class="col-12 scroll_sidebar">
                <div v-if="!model.creating">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="ID: The trait slug used in code — read only.">ID</label>
                  <input class="form-control" v-model="model.trait.id" type="text" disabled>
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The display name shown in the battle UI and logs.">Name</label>
                  <input class="form-control" v-model="model.trait.name" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Description of the trait effect.">Description</label>
                  <input class="form-control" v-model="model.trait.description" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Category: The gameplay group this trait belongs to.">Category</label>
                  <select class="form-control" v-model="model.trait.category">
                    <option value="">— Select category —</option>
                    <option value="dot">Damage Over Time</option>
                    <option value="control">Control / Tempo</option>
                    <option value="disruption">Disruption</option>
                    <option value="mental">Mental / Magic</option>
                    <option value="defence">Defence Break</option>
                  </select>
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Duration: How many turns this trait lasts. Leave blank for infinite (∞).">Duration (turns)</label>
                  <input class="form-control" v-model.number="model.trait.duration" type="number" min="1" placeholder="Leave blank for ∞ infinite">
                </div>
                <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                  <i class="bi-check-lg"></i> {{ model.creating ? 'Create Trait' : 'Save Trait' }}
                </button>
              </div>
            </div>
          </div>

          <div class="admin-table-wrapper quest-table-wrapper">
            <table class="admin-table quest-table">
              <thead>
                <tr>
                  <th class="th-name">Name</th>
                  <th class="th-rules">Description</th>
                  <th class="th-level">Category</th>
                  <th class="th-level">Duration</th>
                  <th class="th-level">ID</th>
                  <th class="th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="trait in model.traits" :key="trait.id">
                  <tr class="admin-table-row quest-row" v-on:click="edit(trait.id)">
                    <td class="td-name">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="trait-badge" :class="'trait-' + trait.id" style="margin-right:6px;">{{ trait.id }}</span>
                        <span class="admin-name quest-name">{{ trait.name }}</span>
                      </div>
                    </td>
                    <td class="td-rules">
                      <span class="admin-rules-text rules-text" :title="trait.description">{{ trait.description }}</span>
                    </td>
                    <td class="td-level">
                      <span class="trait-badge" :class="'trait-cat-' + trait.category">{{ trait.category }}</span>
                    </td>
                    <td class="td-level">{{ trait.durationDisplay }}</td>
                    <td class="td-level">
                      <code>{{ trait.id }}</code>
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(trait.id)" title="Edit">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  `,

  cardTypes: `
  <div data-component="card-types">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-tags"></i>
              <div>
                <h2>Types</h2>
                <p class="admin-subtitle quest-subtitle">Manage card types</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Type</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an card type so it can be used.">Active</label>
                <div class="form-check form-switch">
                  <input v-model="model.type.active" type="checkbox" class="form-check-input">
                </div>
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Card types name.">Name</label>
                <input class="form-control" v-model="model.type.name" type="text">
              </div>
              <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Type
              </button>
            </div>
          </div>
        </div>
        
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-level">Active</th>
                <th class="th-name">Name</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="type in model.types" :key="type.id">
                <tr class="admin-table-row quest-row" v-on:click="edit(type.id)">
                  <td class="td-level">
                    <i v-if="type.active == true" class="bi-check-lg"></i> 
                    <i v-if="type.active == false" class="bi-x-lg"></i>
                  </td>
                  <td class="td-name">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ type.name }}</span>
                    </div>
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(type.id)" title="Edit Type">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
  `,

  packs: `
  <div data-component="packs">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-box-seam"></i>
              <div>
                <h2>Packs/Chests</h2>
                <p class="admin-subtitle quest-subtitle">Manage card packs</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Pack</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12 scroll_sidebar">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables the pack so it can be unlocked.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The packs name. To allow it to be redeemed via channel points it's name must match the channel points name.">Name</label>
                    <input class="form-control" v-model="model.pack.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many cards the pack contains.">Size</label>
                    <input class="form-control" v-model="model.pack.size" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many times this pack can be redeemed.">Limit</label>
                    <input class="form-control" v-model="model.pack.limit" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Chance: What percentage chance that an ultra will be unlocked in this pack.">Ultra</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ultraChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Chance: What percentage chance that a legendary will be unlocked in this pack.">Legendary</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.legendaryChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate Chance: What percentage chance that an ultimate will be unlocked in this pack.">Ultimate</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ultimateChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Bone Card Chance: What percentage chance that a bone card will be unlocked in this pack.">Bone Card</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.boneCardChance">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                    <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ascension Card Chance: What percentage chance that a ascension card will be unlocked in this pack.">Ascension Card</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ascChance">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delta Card Chance: What percentage chance that a delta card will be unlocked in this pack.">Delta Card</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.deltaChance">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Variant Card Chance: What percentage chance that a variant card will be unlocked in this pack.">Variant Card</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.variantChance">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables the pack so it can be unlocked.">Is Chest</label>
                    <div class="form-check form-switch">
                    <input v-model="model.pack.chest_active" @change="chestIsActive" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div v-if="model.pack.chest_active">
                      <hr>
                       <h4>Chest Rewards</h4>
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the store works.">XP value</label>
                        <input class="form-control" v-model="model.pack.xp" type="number">
                      </div>
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Barks Value</label>
                        <input class="form-control" v-model="model.pack.barks" type="number">
                      </div>
                      <div>
                      <div>
                        <button data-button><i class="bi bi-plus" v-on:click="incrementPack" :disabled="false"></i></button>
                      </div>
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the store works.">Select Packs</label>
                        <select class="form-select" v-model="model.pack.givePack[0].packId">
                          <option value=""></option>
                          <option v-for="(value, key) in model.packs" v-bind:value="key">
                            {{ value.name }}
                          </option>
                        </select>
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Packs Quantity: Quantity of the packs that will be given.">Quantity</label>
                          <input class="form-control" v-model="model.pack.givePack[0].packs_quantity" type="number">
                        </div>
                      </div>
                      <div v-if="model.pack.packs_amount > 0">
                          <div v-for="(pack, index) in model.pack.givePack.slice(1)" :key="index + 1">
                            <div>
                             <button data-button  class="remove_button" @click="removePack(index + 1)" :disabled="model.pack.packs_amount === 0"><i class="bi bi-dash"></i></button>
                              <div>
                                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Packs.">Select Packs</label>
                                <select class="form-select" v-model="pack.packId">
                                  <option v-for="(value, key) in model.packs" :value="key" :key="key">
                                    {{ value.name }}
                                  </option>
                                </select>
                              </div>
                              <div>
                                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Packs Quantity: Quantity of the packs that will be given.">Quantity</label>
                                <input class="form-control" v-model="pack.packs_quantity" type="number">
                              </div>
                            </div>
                          </div>
                       </div>
                       <div>
                        <button data-button><i class="bi bi-plus" v-on:click="incrementRandomCards" :disabled="false"></i></button>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Select Random Card</label>
                        <select class="form-select" v-model="model.pack.randomCard[0].randomCard">
                            <option v-for="(value, key) in model.randomcard" v-bind:value="key">
                              {{ value.name }}
                            </option>
                        </select>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Random Card Amount</label>
                        <input class="form-control" v-model="model.pack.randomCard[0].random_amount" type="number">
                      </div>
                      <div v-if="model.pack.random_amount > 0">
                        <div v-for="(random, index) in model.pack.randomCard.slice(1)" :key="index + 1">
                          <div>
                            <button data-button  class="remove_button" @click="removeRandomCard(index + 1)"><i class="bi bi-dash"></i></button>
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Select Random Card</label>
                            <select class="form-select" v-model="random.randomCard">
                              <option v-for="(value, key) in model.randomcard" v-bind:value="key">
                                {{ value.name }}
                              </option>
                            </select>
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Random Card Amount</label>
                            <input class="form-control" v-model="random.random_amount" type="number">
                          </div>
                        </div>
                      </div>

                      <!-- Reward Frames/Backgrounds Section -->
                      <div>
                          <hr>
                          <h5>Reward Frames/Backgrounds</h5>
                          <div>
                              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select reward type: single frame, single background, or multiple items">Reward Type</label>
                              <select class="form-select" v-model="model.pack.rewardFrameMode">
                                  <option value="single-frame">Single Frame</option>
                                  <option value="single-background">Single Background</option>
                                  <option value="multiple">Multiple Items</option>
                              </select>
                          </div>

                          <!-- Selection Dropdown -->
                          <div v-if="model.pack.rewardFrameMode === 'multiple'">
                              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Hold Ctrl/Cmd to select multiple items">Select Frames/Backgrounds</label>
                              <select
                                  class="form-select"
                                  multiple
                                  size="8"
                                  v-model="model.pack.rewardFrames"
                                  style="min-height: 200px;">
                                  <optgroup label="Frames" v-if="Object.keys(model.frames).length > 0">
                                      <option
                                          v-for="(frame, key) in model.frames"
                                          :value="{id: key, type: 'frame'}"
                                          :key="'f-'+key">
                                          {{ frame.name }} [Frame]
                                      </option>
                                  </optgroup>
                                  <optgroup label="Backgrounds" v-if="Object.keys(model.backgrounds).length > 0">
                                      <option
                                          v-for="(bg, key) in model.backgrounds"
                                          :value="{id: key, type: 'background'}"
                                          :key="'b-'+key">
                                          {{ bg.name }} [Background]
                                      </option>
                                  </optgroup>
                              </select>
                              <small class="form-text text-muted">Hold Ctrl (Windows) or Cmd (Mac) to select multiple items</small>
                          </div>

                          <!-- Single Selection Dropdown -->
                          <div v-else>
                              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select a frame or background">Select Item</label>
                              <select class="form-select" v-model="model.pack.rewardFrames[0]">
                                  <option value="">-- Select {{ model.pack.rewardFrameMode === 'single-frame' ? 'Frame' : 'Background' }} --</option>
                                  <optgroup v-if="model.pack.rewardFrameMode === 'single-frame'" label="Frames">
                                      <option
                                          v-for="(frame, key) in model.frames"
                                          :value="{id: key, type: 'frame'}"
                                          :key="key">
                                          {{ frame.name }}
                                      </option>
                                  </optgroup>
                                  <optgroup v-if="model.pack.rewardFrameMode === 'single-background'" label="Backgrounds">
                                      <option
                                          v-for="(bg, key) in model.backgrounds"
                                          :value="{id: key, type: 'background'}"
                                          :key="key">
                                          {{ bg.name }}
                                      </option>
                                  </optgroup>
                              </select>
                          </div>

                          <!-- Preview Section -->
                          <div v-if="model.pack.rewardFrames && model.pack.rewardFrames.length > 0" style="margin-top: 15px;">
                              <label>Selected Items Preview:</label>
                              <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; margin-top: 10px;">
                                  <div
                                      v-for="(item, index) in model.pack.rewardFrames"
                                      :key="item.id"
                                      style="border: 1px solid #ddd; border-radius: 4px; padding: 8px; text-align: center; position: relative;">
                                      <button
                                          type="button"
                                          @click="model.pack.rewardFrames.splice(index, 1)"
                                          style="position: absolute; top: 5px; right: 5px; background: #dc3545; color: white; border: none; border-radius: 50%; width: 20px; height: 20px; cursor: pointer; font-size: 12px; line-height: 1;"
                                          title="Remove">
                                          &times;
                                      </button>
                                      <img
                                          :src="item.type === 'background' ?
                                              (model.backgrounds[item.id] && model.backgrounds[item.id].extension ?
                                                  root + '/images/backgrounds/' + item.id + '/' + item.id + '.' + model.backgrounds[item.id].extension + '?t=' + Date.now() : '') :
                                              (model.frames[item.id] && model.frames[item.id].extension ?
                                                  root + '/images/frames/' + item.id + '/' + item.id + '.' + model.frames[item.id].extension + '?t=' + Date.now() : '')"
                                          :alt="item.type === 'background' ?
                                              (model.backgrounds[item.id] ? model.backgrounds[item.id].name : '') :
                                              (model.frames[item.id] ? model.frames[item.id].name : '')"
                                          style="width: 100%; height: 100px; object-fit: cover; border-radius: 4px; margin-bottom: 5px;">
                                      <div style="font-size: 12px; font-weight: bold;">
                                          {{ item.type === 'background' ?
                                              (model.backgrounds[item.id] ? model.backgrounds[item.id].name : '') :
                                              (model.frames[item.id] ? model.frames[item.id].name : '') }}
                                      </div>
                                      <div style="font-size: 10px; color: #666;">{{ item.type === 'frame' ? '[Frame]' : '[Background]' }}</div>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <!-- Card Backs Section -->
                      <div v-if="Object.keys(model.cardBacks).length > 0">
                          <hr>
                          <h5>Reward Card Backs</h5>
                          <div>
                              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select card backs to reward. Hold Ctrl/Cmd to select multiple.">Select Card Backs</label>
                              <select
                                  class="form-select"
                                  multiple
                                  size="6"
                                  v-model="model.pack.rewardCardBacks"
                                  style="min-height: 150px;">
                                  <option
                                      v-for="(back, key) in model.cardBacks"
                                      :value="key"
                                      :key="'cb-'+key">
                                      {{ back.name }}
                                  </option>
                              </select>
                              <small class="form-text text-muted">Hold Ctrl (Windows) or Cmd (Mac) to select multiple</small>
                          </div>

                          <!-- Preview -->
                          <div v-if="model.pack.rewardCardBacks && model.pack.rewardCardBacks.length > 0" style="margin-top: 15px;">
                              <label>Selected Card Backs:</label>
                              <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 10px; margin-top: 10px;">
                                  <div
                                      v-for="(id, index) in model.pack.rewardCardBacks"
                                      :key="id"
                                      style="border: 1px solid #ddd; border-radius: 4px; padding: 8px; text-align: center; position: relative;">
                                      <button
                                          type="button"
                                          @click="model.pack.rewardCardBacks.splice(index, 1)"
                                          style="position: absolute; top: 5px; right: 5px; background: #dc3545; color: white; border: none; border-radius: 50%; width: 20px; height: 20px; cursor: pointer; font-size: 12px; line-height: 1;"
                                          title="Remove">
                                          &times;
                                      </button>
                                      <img
                                          :src="root + '/images/card-backs/' + id + '.png'"
                                          :alt="model.cardBacks[id] ? model.cardBacks[id].name : id"
                                          style="width: 100%; height: 100px; object-fit: contain; border-radius: 4px; margin-bottom: 5px;"
                                          @error="$event.target.style.display='none'">
                                      <div style="font-size: 12px; font-weight: bold;">{{ model.cardBacks[id] ? model.cardBacks[id].name : id }}</div>
                                      <div style="font-size: 10px; color: #666;">[Card Back]</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables the pack so it can be unlocked.">Show for streamers</label>
                    <div class="form-check form-switch">
                    <input v-model="model.pack.streamerShow" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Guaranteed: Guarantees an ultra will be unlocked in this pack.">Ultra Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.ultraGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Guaranteed: Guarantees a legendary will be unlocked in this pack.">Legendary Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.legendaryGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Guaranteed: Guarantees a legendary will be unlocked in this pack.">Bone Card Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.boneCardGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delta Card Guaranteed: Guarantees a delta card will be unlocked in this pack.">Delta Card Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.deltaGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Variant Card Guaranteed: Guarantees a variant card will be unlocked in this pack.">Variant Card Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.variantGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                    <i class="bi-check-lg"></i> Save Pack
                  </button>
                    <div v-if="model.pack.id" class="upload-section">
                    <file-upload
                      :multiple="false"
                      :upload-type="model.pack.chest_active ? 'chest' : 'packs'"
                      :upload-id="model.pack.id"
                      accepted-types="image/*"
                      :max-size="5 * 1024 * 1024"
                      :existing-images="model.pack.images"
                      :allow-remove-existing="true"
                      :image-base-url="getPacksUrl()"
                      @upload-success="handleMediaUpload">
                    </file-upload>
                  </div>
                </div>
              </div>
            </div>
            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Name</th>
                    <th class="th-name">Image</th>
                    <th class="th-level">Size</th>
                    <th class="th-level">Limit</th>
                    <th class="th-level">Ultra</th>
                    <th class="th-level">Legendary</th>
                    <th class="th-level">Ultimate</th>
                    <th class="th-level">Bone Card</th>
                    <th class="th-level">Ascension</th>
                    <th class="th-level">Delta</th>
                    <th class="th-level">Variant</th>
                    <th class="th-level">ULT GTD</th>
                    <th class="th-level">LGY GTD</th>
                    <th class="th-level">DLT GTD</th>
                    <th class="th-level">VAR GTD</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="pack in model.packs" :key="pack.id">
                    <tr class="admin-table-row quest-row" v-on:click="edit(pack.id)">
                      <td class="td-level">
                        <i v-if="pack.active == true" class="bi-check-lg"></i> 
                        <i v-if="pack.active == false" class="bi-x-lg"></i> 
                      </td>
                      <td class="td-name">
                        <div class="admin-name-cell quest-name-cell">
                          <span class="admin-name quest-name" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="pack.name">{{ pack.name }}</span>
                        </div>
                      </td>
                      <td class="td-name">
                        <div v-if="pack.images && Object.keys(pack.images).length > 0" style="display: flex; gap: 4px; flex-wrap: wrap;">
                          <img v-for="(imgUrl, idx) in getPackImages(pack)" :key="idx" :src="imgUrl" :alt="pack.name + ' image ' + (idx + 1)" style="width: 40px; height: 50px; object-fit: cover; border-radius: 4px; border: 1px solid #ddd;" @click.stop @error="$event.target.style.display='none'" />
                        </div>
                        <span v-else style="color: #999;">No image</span>
                      </td>
                      <td class="td-level">
                        {{ pack.size }}
                      </td>
                      <td class="td-level">
                        {{ pack.limit }}
                      </td>
                      <td class="td-level">
                        {{ pack.ultraChance }}%
                      </td>
                      <td class="td-level">
                        {{ pack.legendaryChance }}%
                      </td>
                      <td class="td-level">
                        {{ pack.ultimateChance }}%
                      </td>
                      <td class="td-level">
                        {{ pack.boneCardChance }}%
                      </td>
                      <td class="td-level">
                        {{ pack.ascChance }}%
                      </td>
                      <td class="td-level">
                        {{ pack.deltaChance }}%
                      </td>
                      <td class="td-level">
                        {{ pack.variantChance }}%
                      </td>
                      <td class="td-level">
                        <i v-if="pack.ultraGuaranteed == true" class="bi-check-lg"></i>
                        <i v-if="pack.ultraGuaranteed == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-level">
                        <i v-if="pack.legendaryGuaranteed == true" class="bi-check-lg"></i>
                        <i v-if="pack.legendaryGuaranteed == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-level">
                        <i v-if="pack.deltaGuaranteed == true" class="bi-check-lg"></i>
                        <i v-if="pack.deltaGuaranteed == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-level">
                        <i v-if="pack.variantGuaranteed == true" class="bi-check-lg"></i>
                        <i v-if="pack.variantGuaranteed == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-actions">
                        <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(pack.id)" title="Edit Pack">
                          <i class="bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  cards: `
  <div data-component="cards">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-card-image"></i>
              <div>
                <h2>Cards</h2>
                <p class="admin-subtitle quest-subtitle">Manage game cards</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Card</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                    <select class="form-select" v-model="model.card.type">
                      <option v-for="(value, key) in model.types" v-bind:value="key">
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ability: The card's ability.">Ability</label>
                    <select class="form-select" v-model="model.card.ability">
                      <option value="">No Ability Selected</option>
                      <option v-for="(value, key) in model.abilities" v-bind:value="key">
                      {{ value.name }} - {{ value.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Innate Trait: A trait the card inflicts on the enemy each time its ability fires.">Innate Trait</label>
                    <select class="form-select" v-model="model.card.trait">
                      <option value="">No Trait</option>
                      <option v-for="trait in model.traits" :key="trait.id" :value="trait.id">
                        {{ trait.name }} — {{ trait.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="HP: The card's hit points.">HP</label>
                    <input class="form-control" v-model="model.card.hp" type="number">
                  </div>

                  <h6 style="margin-top: 15px; color: #888; border-bottom: 1px solid #444; padding-bottom: 5px;">Legacy Stats (kept for compatibility)</h6>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Attack: Legacy attack stat (use P-ATK instead).">Attack (Legacy)</label>
                    <input class="form-control" v-model="model.card.attack" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Defence: Legacy defence stat (use Armor instead).">Defence (Legacy)</label>
                    <input class="form-control" v-model="model.card.defence" type="number">
                  </div>

                  <h6 style="margin-top: 15px; color: #ffc107; border-bottom: 1px solid #ffc107; padding-bottom: 5px;">Battle Stats</h6>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="P-ATK: Physical attack damage.">P-ATK (Physical Attack)</label>
                    <input class="form-control" v-model="model.card.pAtk" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="M-ATK: Magic attack damage.">M-ATK (Magic Attack)</label>
                    <input class="form-control" v-model="model.card.mAtk" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Armor: Reduces incoming physical damage.">Armor (Physical Defense)</label>
                    <input class="form-control" v-model="model.card.armor" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ward: Reduces incoming magic damage.">Ward (Magic Defense)</label>
                    <input class="form-control" v-model="model.card.ward" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Accuracy: The card's attack accuracy (0-100).">Accuracy</label>
                    <input class="form-control" v-model="model.card.accuracy" type="number" min="0" max="100">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Speed: Turn order and action frequency.">Speed</label>
                    <input class="form-control" v-model="model.card.speed" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Crit Chance: Percent chance for critical hit (0-100).">Crit Chance (%)</label>
                    <input class="form-control" v-model="model.card.critChance" type="number" min="0" max="100">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Crit Damage: Extra damage on critical (150 = 1.5x).">Crit Damage (%)</label>
                    <input class="form-control" v-model="model.card.critDamage" type="number" min="100" max="500">
                  </div>

                  <h6 style="margin-top: 15px; color: #17a2b8; border-bottom: 1px solid #17a2b8; padding-bottom: 5px;">Resources</h6>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Stamina: Physical energy pool for attacks. Both Stamina and Mana regenerate after each attack.">Stamina</label>
                    <input class="form-control" v-model="model.card.stamina" type="number" min="1">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Mana: Magic energy pool for attacks. Both Stamina and Mana regenerate after each attack.">Mana</label>
                    <input class="form-control" v-model="model.card.mana" type="number" min="1">
                  </div>

                  <h6 style="margin-top: 15px; color: #888; border-bottom: 1px solid #444; padding-bottom: 5px;">Card Settings</h6>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate: If the card is an ultimate.">Ultimate</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.ultimate" type="checkbox" class="form-check-input" @change="selectCardFlag('ultimate')">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Variant: If the card is a variant of another card.">Variant</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.variant" type="checkbox" class="form-check-input" @change="selectCardFlag('variant')">
                    </div>
                  </div>
                  <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                    <i class="bi-check-lg"></i> Save Card
                  </button>
                  <div v-if="model.card.id" class="upload-section">
                    <file-upload
                      :multiple="false"
                      upload-type="cards"
                      :upload-id="model.card.id"
                      accepted-types="image/*"
                      :max-size="5 * 1024 * 1024"
                      :existing-images="model.card.image"
                      :allow-remove-existing="true"
                      :image-base-url="getCardUrl()"
                      @upload-success="handleCardImageUpload">
                    </file-upload>
                  </div>
                  <div v-if="model.card.id" class="upload-section">
                    <h6 style="margin-top: 15px; color: #888; border-bottom: 1px solid #444; padding-bottom: 5px;">Card VFX</h6>
                    <file-upload
                      :multiple="false"
                      upload-type="vfx"
                      :upload-id="model.card.id"
                      accepted-types="video/*,image/gif"
                      :max-size="20 * 1024 * 1024"
                      :existing-images="model.card.vfx"
                      :allow-remove-existing="true"
                      :image-base-url="getVfxUrl()"
                      @upload-success="handleCardVfxUpload">
                    </file-upload>
                  </div>
                </div>
              </div>
            </div>

            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Name</th>
                    <th class="th-name">Image</th>
                    <th class="th-level">HP</th>
                    <th class="th-level">Attack</th>
                    <th class="th-level">Defence</th>
                    <th class="th-level">Speed</th>
                    <th class="th-level">Accuracy</th>
                    <th class="th-level">P-ATK</th>
                    <th class="th-level">M-ATK</th>
                    <th class="th-level">Armor</th>
                    <th class="th-level">Ward</th>
                    <th class="th-level">Crit%</th>
                    <th class="th-level">Crit Dmg</th>
                    <th class="th-level">Stamina</th>
                    <th class="th-level">Mana</th>
                    <th class="th-name">Type</th>
                    <th class="th-name">Ability</th>
                    <th class="th-name">Traits</th>
                    <th class="th-level">Ultimate</th>
                    <th class="th-level">Variant</th>
                    <th class="th-level">Delta</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="card in model.cards" :key="card.id">
                    <tr class="admin-table-row quest-row" v-on:click="edit(card.id)">
                      <td class="td-level">
                        <i v-if="card.active == true" class="bi-check-lg"></i>
                        <i v-if="card.active == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-name">
                        <div class="admin-name-cell quest-name-cell">
                          <span class="admin-name quest-name" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">{{ card.name }}</span>
                        </div>
                      </td>
                      <td class="td-name">
                        <img v-if="card.image && card.image[0]" :src="getCardUrl() + card.image[0]" :alt="card.name + ' image'" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer;" @click.stop @error="$event.target.style.display='none'" />
                        <span v-else style="color: #999;">No image</span>
                      </td>
                      <td class="td-level">
                        {{ card.hp }}
                      </td>
                      <td class="td-level">
                        {{ card.attack }}
                      </td>
                      <td class="td-level">
                        {{ card.defence }}
                      </td>
                      <td class="td-level">
                        {{ card.speed }}
                      </td>
                      <td class="td-level">
                        {{ card.accuracy }}
                      </td>
                      <td class="td-level">
                        {{ card.pAtk || card.attack || 0 }}
                      </td>
                      <td class="td-level">
                        {{ card.mAtk || 0 }}
                      </td>
                      <td class="td-level">
                        {{ card.armor || card.defence || 0 }}
                      </td>
                      <td class="td-level">
                        {{ card.ward || 0 }}
                      </td>
                      <td class="td-level">
                        {{ card.critChance || 5 }}%
                      </td>
                      <td class="td-level">
                        {{ card.critDamage || 150 }}%
                      </td>
                      <td class="td-level">
                        {{ card.stamina || 100 }}
                      </td>
                      <td class="td-level">
                        {{ card.mana || 100 }}
                      </td>
                      <td class="td-name">
                        <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="card.type" :title="card.type">{{ card.type }}</span>
                      </td>
                      <td class="td-name">
                        <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="card.ability" :title="card.ability">{{ card.ability }}</span>
                      </td>
                      <td class="td-level">
                        {{ card.trait }}
                      </td>
                      <td class="td-level">
                        <i v-if="card.ultimate == true" class="bi-check-lg"></i>
                        <i v-if="card.ultimate == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-level">
                        <i v-if="card.variant == true" class="bi-check-lg"></i>
                        <i v-if="card.variant == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-level">
                        <i v-if="card.delta == true" class="bi-check-lg"></i>
                        <i v-if="card.delta == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-actions">
                        <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(card.id)" title="Edit Card">
                          <i class="bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  temporaryCards: `
  <div data-component="temporary-cards">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-calendar-event"></i>
              <div>
                <h2>Event Cards</h2>
                <p class="admin-subtitle quest-subtitle">Manage temporary event cards</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                    <select class="form-select" v-model="model.card.type">
                      <option v-for="(value, key) in model.types" v-bind:value="key">
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ability: The card's ability.">Ability</label>
                    <select class="form-select" v-model="model.card.ability">
                      <option value="">No Ability Selected</option>
                      <option v-for="(value, key) in model.abilities" v-bind:value="key">
                      {{ value.name }} - {{ value.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Innate Trait: A trait the card inflicts on the enemy each time its ability fires.">Innate Trait</label>
                    <select class="form-select" v-model="model.card.trait">
                      <option value="">No Trait</option>
                      <option v-for="trait in model.traits" :key="trait.id" :value="trait.id">
                        {{ trait.name }} — {{ trait.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="HP: The card's hit points.">HP</label>
                    <input class="form-control" v-model="model.card.hp" type="number">
                  </div>

                  <h6 style="margin-top: 15px; color: #ffc107; border-bottom: 1px solid #ffc107; padding-bottom: 5px;">Battle Stats</h6>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="P-ATK: Physical attack damage.">P-ATK (Physical Attack)</label>
                    <input class="form-control" v-model="model.card.pAtk" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="M-ATK: Magic attack damage.">M-ATK (Magic Attack)</label>
                    <input class="form-control" v-model="model.card.mAtk" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Armor: Reduces incoming physical damage.">Armor (Physical Defense)</label>
                    <input class="form-control" v-model="model.card.armor" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ward: Reduces incoming magic damage.">Ward (Magic Defense)</label>
                    <input class="form-control" v-model="model.card.ward" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Accuracy: The card's attack accuracy (0-100).">Accuracy</label>
                    <input class="form-control" v-model="model.card.accuracy" type="number" min="0" max="100">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Speed: Turn order and action frequency.">Speed</label>
                    <input class="form-control" v-model="model.card.speed" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Crit Chance: Percent chance for critical hit (0-100).">Crit Chance (%)</label>
                    <input class="form-control" v-model="model.card.critChance" type="number" min="0" max="100">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Crit Damage: Extra damage on critical (150 = 1.5x).">Crit Damage (%)</label>
                    <input class="form-control" v-model="model.card.critDamage" type="number" min="100" max="500">
                  </div>

                  <h6 style="margin-top: 15px; color: #17a2b8; border-bottom: 1px solid #17a2b8; padding-bottom: 5px;">Resources</h6>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Stamina: Physical energy pool for attacks.">Stamina</label>
                    <input class="form-control" v-model="model.card.stamina" type="number" min="1">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Mana: Magic energy pool for attacks.">Mana</label>
                    <input class="form-control" v-model="model.card.mana" type="number" min="1">
                  </div>

                  <h6 style="margin-top: 15px; color: #888; border-bottom: 1px solid #444; padding-bottom: 5px;">Card Settings</h6>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate: If the card is an ultimate.">Ultimate</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.ultimate" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tier: Card Tier.">Tier</label>
                    <input v-model="model.card.tier" type="number" class="form-control">
                  </div>
                  <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                    <i class="bi-check-lg"></i> Save Card
                  </button>
                  <div v-if="model.card.id && model.card.is_modified_existing || model.card.baseCardId === ''" class="upload-section">
                    <file-upload
                      :multiple="false"
                      upload-type="temp_cards"
                      :upload-id="model.card.id"
                      accepted-types="image/*"
                      :max-size="5 * 1024 * 1024"
                      :existing-images="model.card.image"
                      :allow-remove-existing="true"
                      :image-base-url="getCardUrl()"
                      @upload-success="handleCardImageUpload">
                    </file-upload>
                  </div>
                </div>
              </div>
            </div>

            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Event Name</th>
                    <th class="th-name">Name</th>
                    <th class="th-name">Image</th>
                    <th class="th-level">HP</th>
                    <th class="th-level">P-ATK</th>
                    <th class="th-level">M-ATK</th>
                    <th class="th-level">Armor</th>
                    <th class="th-level">Ward</th>
                    <th class="th-level">Speed</th>
                    <th class="th-level">Accuracy</th>
                    <th class="th-level">Crit%</th>
                    <th class="th-level">Crit Dmg</th>
                    <th class="th-level">Stamina</th>
                    <th class="th-level">Mana</th>
                    <th class="th-name">Type</th>
                    <th class="th-name">Ability</th>
                    <th class="th-name">Trait</th>
                    <th class="th-level">Ultimate</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="card in model.cards" :key="card.id">
                    <tr class="admin-table-row quest-row" v-on:click="edit(card.id)">
                      <td class="td-level">
                        <i v-if="card.active == true" class="bi-check-lg"></i> 
                        <i v-if="card.active == false" class="bi-x-lg"></i> 
                      </td>
                      <td class="td-name">
                        <span data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.event">{{ card.event }}</span>
                      </td>
                      <td class="td-name">
                        <div class="admin-name-cell quest-name-cell">
                          <span class="admin-name quest-name" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">{{ card.name }}</span>
                        </div>
                      </td>
                      <td class="td-name">
                        <img v-if="card.image && card.image[0]" :src="getCardUrl() + card.image[0]" :alt="card.name + ' image'" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer;" @click.stop @error="$event.target.style.display='none'" />
                        <span v-else style="color: #999;">No image</span>
                      </td>
                      <td class="td-level">{{ card.hp }}</td>
                      <td class="td-level">{{ card.pAtk }}</td>
                      <td class="td-level">{{ card.mAtk }}</td>
                      <td class="td-level">{{ card.armor }}</td>
                      <td class="td-level">{{ card.ward }}</td>
                      <td class="td-level">{{ card.speed }}</td>
                      <td class="td-level">{{ card.accuracy }}</td>
                      <td class="td-level">{{ card.critChance }}</td>
                      <td class="td-level">{{ card.critDamage }}</td>
                      <td class="td-level">{{ card.stamina }}</td>
                      <td class="td-level">{{ card.mana }}</td>
                      <td class="td-name">
                        <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="model.types[card.type]" :title="model.types[card.type].name">{{ model.types[card.type].name }}</span>
                      </td>
                      <td class="td-name">
                        <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="model.abilities[card.ability]" :title="model.abilities[card.ability].description">{{ model.abilities[card.ability].name }}</span>
                      </td>
                      <td class="td-name">
                        <span v-if="card.trait">{{ (model.traits.find(t => t.id == card.trait) || {}).name }}</span>
                      </td>
                      <td class="td-level">
                        <i v-if="card.ultimate == true" class="bi-check-lg"></i>
                        <i v-if="card.ultimate == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-actions">
                        <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(card.id)" title="Edit Card">
                          <i class="bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  specialCards: `
  <div data-component="special-cards">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-star"></i>
              <div>
                <h2>Special Cards</h2>
                <p class="admin-subtitle quest-subtitle">Manage special cards</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Special Card</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: card usage limit.">Limit</label>
                    <input class="form-control" v-model="model.card.userLimit" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="XP Multiplier: card xp multiplier.">XP Multiplier</label>
                    <input class="form-control" v-model="model.card.xpMultiplier" type="number" step="any">
                  </div>
  
                  <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                    <i class="bi-check-lg"></i> Save Special Card
                  </button>
                  
                </div>
              </div>
            </div>

            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Name</th>
                    <th class="th-level">Limit</th>
                    <th class="th-level">XP Multiplier</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="card in model.cards" :key="card.id">
                    <tr class="admin-table-row quest-row" v-on:click="edit(card.id)">
                      <td class="td-level">
                        <i v-if="card.active == true" class="bi-check-lg"></i> 
                        <i v-if="card.active == false" class="bi-x-lg"></i> 
                      </td>
                      <td class="td-name">
                        <div class="admin-name-cell quest-name-cell">
                          <span class="admin-name quest-name" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">{{ card.name }}</span>
                        </div>
                      </td>
                      <td class="td-level">
                        {{ card.userLimit }}
                      </td>
                      <td class="td-level">
                        {{ card.xpMultiplier }}
                      </td>
                      <td class="td-actions">
                        <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(card.id)" title="Edit Special Card">
                          <i class="bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  boneCards: `
  <div data-component="bone-cards">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-bone"></i>
              <div>
                <h2>Bone Cards</h2>
                <p class="admin-subtitle quest-subtitle">Manage bone cards</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Bone Card</span>
            </button>
          </div>
        </div>
        
         <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: card usage limit.">Description</label>
        
                     <textarea name="w3review" rows="4" cols="50" class="form-control" v-model="model.card.description"></textarea>
                  </div>
                       <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Value: value of the bone card.">Value</label>
                    <input class="form-control" v-model="model.card.value" type="number">
                  </div>
  
                  <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                    <i class="bi-check-lg"></i> Save Bone Card
                  </button>
                  
                </div>
              </div>
            </div>

            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Name</th>
                    <th class="th-rules">Description</th>
                    <th class="th-level">Value</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="card in model.cards" :key="card.id">
                    <tr class="admin-table-row quest-row" v-on:click="edit(card.id)">
                      <td class="td-level">
                        <i v-if="card.active == true" class="bi-check-lg"></i> 
                        <i v-if="card.active == false" class="bi-x-lg"></i> 
                      </td>
                      <td class="td-name">
                        <div class="admin-name-cell quest-name-cell">
                          <span class="admin-name quest-name" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">{{ card.name }}</span>
                        </div>
                      </td>
                      <td class="td-rules">
                        <span class="admin-rules-text rules-text" :title="card.description">{{ card.description }}</span>
                      </td>
                      <td class="td-level">
                        {{ card.value }}
                      </td>
                      <td class="td-actions">
                        <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(card.id)" title="Edit Bone Card">
                          <i class="bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  adminKeys: `
    <div data-component="admin-keys">
      <section class="quest-line-section">
        <div class="quest-line-container">
          <div class="admin-header-panel quest-header-panel">
            <div class="admin-header-content quest-header-content">
              <div class="admin-header-title quest-header-title">
                <i class="bi-key"></i>
                <div>
                  <h2>Keys</h2>
                  <p class="admin-subtitle quest-subtitle">Manage unlock keys</p>
                </div>
              </div>
              <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
                <i class="bi-plus-lg"></i>
                <span>Add Key</span>
              </button>
            </div>
          </div>

          <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
            <div>
              <i class="bi-x-lg close" v-on:click="reset()"></i> 
              <div class="col-12 scroll_sidebar">
                <div> 
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an key so it can be used.">Active</label>
                  <div class="form-check form-switch">
                    <input v-model="model.key.active" type="checkbox" class="form-check-input">
                  </div>
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Key name.">Name</label>
                  <input class="form-control" v-model="model.key.name" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the key works.">Description</label>
                  <input class="form-control" v-model="model.key.description" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Uses: How many times the key can be used. 0 equals infiniate.">Uses</label>
                  <input class="form-control" v-model="model.key.uses" type="number">
                </div>
                <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                  <i class="bi-check-lg"></i> Save Key
                </button>
                <div v-if="model.key.id"  class="upload">
                  <button data-button="upload">Upload</button>
                  <input type="file" id="file" ref="file" @change="upload"/>
                </div>
              </div>
            </div>
          </div>
          
          <div class="admin-table-wrapper quest-table-wrapper">
            <table class="admin-table quest-table">
              <thead>
                <tr>
                  <th class="th-level">Active</th>
                  <th class="th-name">Name</th>
                  <th class="th-rules">Description</th>
                  <th class="th-level">Uses</th>
                  <th class="th-name">Image</th>
                  <th class="th-name">Video</th>
                  <th class="th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="key in model.keys" :key="key.id">
                  <tr class="admin-table-row quest-row" v-on:click="edit(key.id)">
                    <td class="td-level">
                      <i v-if="key.active == true" class="bi-check-lg"></i> 
                      <i v-if="key.active == false" class="bi-x-lg"></i> 
                    </td>
                    <td class="td-name">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="admin-name quest-name">{{ key.name }}</span>
                      </div>
                    </td>
                    <td class="td-rules">
                      <span class="admin-rules-text rules-text" :title="key.description">{{ key.description }}</span>
                    </td>
                    <td class="td-level">
                      {{ key.uses }}
                    </td>
                    <td class="td-name">
                      <img v-if="key.image" :src="key.image" :alt="key.name + ' image'" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer;" @click.stop @error="$event.target.style.display='none'" />
                      <span v-else style="color: #999;">No image</span>
                    </td>
                    <td class="td-name">
                      <video v-if="key.video" :src="key.video" style="max-width: 150px; max-height: 100px; object-fit: contain; cursor: pointer;" controls @click.stop @error="$event.target.style.display='none'"></video>
                      <span v-else style="color: #999;">No video</span>
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(key.id)" title="Edit Key">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  `,

  adminFrames: `
    <div data-component="admin-frames">
      <section class="quest-line-section">
        <div class="quest-line-container">
          
          <!-- Header Panel -->
          <div class="admin-header-panel quest-header-panel">
            <div class="admin-header-content quest-header-content">
              <div class="admin-header-title quest-header-title">
                <i class="bi-images"></i>
                <div>
                  <h2>Profile Frames & Backgrounds</h2>
                  <p class="admin-subtitle quest-subtitle">Manage frame overlays and background images</p>
                </div>
              </div>
            </div>

            <!-- Tab Navigation -->
            <div class="admin-tabs">
              <button
                class="admin-tab-button"
                :class="{ active: activeTab === 'backgrounds' }"
                v-on:click="switchTab('backgrounds')">
                <i class="bi-image-fill"></i> Backgrounds
              </button>
              <button
                class="admin-tab-button"
                :class="{ active: activeTab === 'frames' }"
                v-on:click="switchTab('frames')">
                <i class="bi-file-earmark-image"></i> Frame Overlays
              </button>
            </div>
          </div>

          <!-- BACKGROUNDS TAB -->
          <div v-show="activeTab === 'backgrounds'" class="tab-content">
            <!-- Background Header -->
            <div class="admin-header-content quest-header-content" style="padding: 20px 32px; border-bottom: 1px solid rgba(255, 255, 255, 0.1);">
              <button class="admin-add-btn quest-add-btn" data-button="submit" v-on:click="addBackground()">
                <i class="bi-plus-lg"></i>
                <span>Add New Background</span>
              </button>
            </div>

            <!-- Background Edit Form -->
            <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit && activeTab === 'backgrounds' }">
              <div>
                <i class="bi-x-lg close" v-on:click="resetBackground()"></i>
                <div class="col-12 scroll_sidebar">
                  <div>
                    <label>Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.background.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label>Name</label>
                    <input class="form-control" v-model="model.background.name" type="text" placeholder="e.g., Epic Battle Background">
                  </div>
                  <div>
                    <label>Description</label>
                    <input class="form-control" v-model="model.background.description" type="text" placeholder="e.g., High-quality battle scene background">
                  </div>
                  <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="saveBackground()">
                    <i class="bi-check-lg"></i> Save Background
                  </button>

                      <!-- Background Upload Section -->
                      <div v-if="model.background.id" class="frame-upload-section" style="margin-top: 30px;">
                        <div class="frame-upload-instructions">
                          <strong>Background Image:</strong>
                          <ul>
                            <li>Recommended: 1920x1080 resolution</li>
                            <li>Format: PNG, JPG, or WebP</li>
                            <li>Max Size: 10MB</li>
                            <li>This will sit INSIDE the frame border</li>
                          </ul>
                        </div>

                        <!-- Background Preview -->
                        <div class="admin-frame-preview" v-if="model.backgrounds[model.background.id] && model.backgrounds[model.background.id].backgroundImage">
                          <img :src="model.backgrounds[model.background.id].backgroundImage" class="frame-background" alt="Background Preview">
                          <div class="frame-content">
                            <div style="text-align: center; color: white; text-shadow: 2px 2px 4px rgba(0,0,0,0.8);">
                              <h3 style="margin: 0;">{{ model.background.name }}</h3>
                              <p style="margin: 5px 0;">Background Preview</p>
                            </div>
                          </div>
                        </div>

                        <!-- Background Upload -->
                        <frame-upload
                          :frame-id="model.background.id"
                          upload-type="background">
                        </frame-upload>
                      </div>
                    </div>
                  </div>
                </div>

            <!-- Backgrounds List -->
            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Image</th>
                    <th class="th-name">Name</th>
                    <th class="th-rules">Description</th>
                    <th class="th-level">Resolution</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="Object.keys(model.backgrounds).length === 0">
                    <td colspan="6" class="empty-table-state">
                      <div class="empty-content">
                        <i class="bi-inbox"></i>
                        <p>No backgrounds yet. Click "Add New Background" to create one.</p>
                      </div>
                    </td>
                  </tr>
                  <tr class="admin-table-row quest-row" v-for="background in model.backgrounds" :key="background.id">
                    <td class="td-level">
                      <i v-if="background.active" class="bi-check-lg" style="color: #4CAF50;"></i>
                      <i v-else class="bi-x-lg" style="color: #f44336;"></i>
                    </td>
                    <td class="td-name">
                      <div class="catalog-image-wrapper">
                        <img v-if="background.backgroundImage" :src="background.backgroundImage" :alt="background.name" class="catalog-item-image" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
                        <div v-if="!background.backgroundImage" class="catalog-image-placeholder">
                          <i class="bi-image"></i>
                        </div>
                      </div>
                    </td>
                    <td class="td-name">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="admin-name quest-name">{{ background.name }}</span>
                      </div>
                    </td>
                    <td class="td-rules">
                      <span class="admin-rules-text rules-text" v-if="background.description">{{ background.description }}</span>
                      <span v-else>-</span>
                    </td>
                    <td class="td-level">
                      <span class="admin-badge-level level-badge">{{ background.resolution || '1920x1080' }}</span>
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="editBackground(background.id)" title="Edit Background">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- FRAMES TAB -->
          <div v-show="activeTab === 'frames'" class="tab-content">
            <!-- Frame Header -->
            <div class="admin-header-content quest-header-content" style="padding: 20px 32px; border-bottom: 1px solid rgba(255, 255, 255, 0.1);">
              <button class="admin-add-btn quest-add-btn" data-button="submit" v-on:click="addFrame()">
                <i class="bi-plus-lg"></i>
                <span>Add New Frame</span>
              </button>
            </div>

            <!-- Frame Edit Form -->
            <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit && activeTab === 'frames' }">
              <div>
                <i class="bi-x-lg close" v-on:click="resetFrame()"></i>
                <div class="col-12 scroll_sidebar">
                  <div>
                    <label>Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.frame.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label>Name</label>
                    <input class="form-control" v-model="model.frame.name" type="text" placeholder="e.g., Thor Frame">
                  </div>
                  <div>
                    <label>Description</label>
                    <input class="form-control" v-model="model.frame.description" type="text" placeholder="e.g., Epic Thor-themed decorative frame">
                  </div>
                  <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="saveFrame()">
                    <i class="bi-check-lg"></i> Save Frame
                  </button>

                      <!-- Frame Upload Section -->
                      <div v-if="model.frame.id" class="frame-upload-section" style="margin-top: 30px;">
                        <div class="frame-upload-instructions">
                          <strong>Frame Overlay (Decorative Border):</strong>
                          <ul>
                            <li>Use transparent PNG for best results</li>
                            <li>Format: PNG (recommended), JPG, or WebP</li>
                            <li>Max Size: 10MB</li>
                            <li>This overlays ON TOP of the background</li>
                          </ul>
                        </div>

                        <!-- Frame Preview -->
                        <div class="admin-frame-preview" v-if="model.frames[model.frame.id] && model.frames[model.frame.id].frameImage">
                          <div class="frame-content">
                            <div style="text-align: center; color: white; text-shadow: 2px 2px 4px rgba(0,0,0,0.8);">
                              <h3 style="margin: 0;">{{ model.frame.name }}</h3>
                              <p style="margin: 5px 0;">Frame Overlay</p>
                            </div>
                          </div>
                          <img :src="model.frames[model.frame.id].frameImage" class="frame-overlay" alt="Frame Preview">
                        </div>

                        <!-- Frame Upload -->
                        <frame-upload
                          :frame-id="model.frame.id"
                          upload-type="frame">
                        </frame-upload>
                      </div>
                    </div>
                  </div>
                </div>

            <!-- Frames List -->
            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Image</th>
                    <th class="th-name">Name</th>
                    <th class="th-rules">Description</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="Object.keys(model.frames).length === 0">
                    <td colspan="5" class="empty-table-state">
                      <div class="empty-content">
                        <i class="bi-inbox"></i>
                        <p>No frames yet. Click "Add New Frame" to create one.</p>
                      </div>
                    </td>
                  </tr>
                  <tr class="admin-table-row quest-row" v-for="frame in model.frames" :key="frame.id">
                    <td class="td-level">
                      <i v-if="frame.active" class="bi-check-lg" style="color: #4CAF50;"></i>
                      <i v-else class="bi-x-lg" style="color: #f44336;"></i>
                    </td>
                    <td class="td-name">
                      <div class="catalog-image-wrapper">
                        <img v-if="frame.frameImage" :src="frame.frameImage" :alt="frame.name" class="catalog-item-image" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
                        <div v-if="!frame.frameImage" class="catalog-image-placeholder">
                          <i class="bi-image"></i>
                        </div>
                      </div>
                    </td>
                    <td class="td-name">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="admin-name quest-name">{{ frame.name }}</span>
                      </div>
                    </td>
                    <td class="td-rules">
                      <span class="admin-rules-text rules-text" v-if="frame.description">{{ frame.description }}</span>
                      <span v-else>-</span>
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="editFrame(frame.id)" title="Edit Frame">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </section>
    </div>
  `,

  adminMedals:`
    <div data-component="admin-medals">
      <section class="quest-line-section">
        <div class="quest-line-container">
          <div class="admin-header-panel quest-header-panel">
            <div class="admin-header-content quest-header-content">
              <div class="admin-header-title quest-header-title">
                <i class="bi-trophy"></i>
                <div>
                  <h2>Achievements</h2>
                  <p class="admin-subtitle quest-subtitle">Manage achievement medals</p>
                </div>
              </div>
              <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
                <i class="bi-plus-lg"></i>
                <span>Add Achievement</span>
              </button>
            </div>
          </div>

          <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
            <div>
              <i class="bi-x-lg close" v-on:click="reset()"></i> 
              <div class="col-12 scroll_sidebar">
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an medal so it can be used.">Active</label>
                  <div class="form-check form-switch">
                    <input v-model="model.medal.active" type="checkbox" class="form-check-input">
                  </div>
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Medal name.">Name</label>
                  <input class="form-control" v-model="model.medal.name" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the medal works.">Description</label>
                  <input class="form-control" v-model="model.medal.description" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User level.">Level</label>
                  <input class="form-control" v-model="model.medal.level" type="number">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Wins: total victory.">Wins</label>
                  <input class="form-control" v-model="model.medal.wins" type="text">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Card Option</label>
                  <div class="form-check form-switch">
                    <input v-model="model.medal.isCardActive" type="checkbox" class="form-check-input">
                  </div>
                </div>
                <!-- Cards Section -->
                <div v-if="model.medal.isCardActive">
                
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                    <select class="form-select" v-model="model.medal.type">
                     <option value=""></option>
                      <option v-for="(value, key) in model.types" v-bind:value="value.name">
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                    <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Mode: Select win/defeat condition">Mode</label>
                        <div class="radio-input">
                            <label>
                                <input type="radio" class="input" name="options" value="to_win"
                                      v-model="model.medal.selectedMode">
                                To win
                            </label>
                            <label>
                                <input type="radio" class="input" name="options" value="to_defeat"
                                      v-model="model.medal.selectedMode">
                                To defeat
                            </label>
                            <label>
                                <input type="radio" class="input" name="options" value="any"
                                      v-model="model.medal.selectedMode">
                                Both
                            </label>
                        </div>
                    </div>
                    <div class="header-with-button">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards: Select cards for this medal">Cards</label>
                        <button data-button type="button" @click="incrementCards">
                            <i class="bi bi-plus"></i> Add Card
                        </button>
                    </div>
                    <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Card">Card 1</label>
                        <select class="form-select" :value="model.cards && model.cards[0] ? model.cards[0].cardId : ''" @change="updateCard(0, 'cardId', $event.target.value)">
                            <option value="">Select a card</option>
                            <option v-for="(value, key) in cards" :value="key" :key="key">
                                {{ value.name }}
                            </option>
                        </select>
                    </div>
                    <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Card Tier: Specify the tier level">Card Tier</label>
                           <select class="form-select" :value="model.cards && model.cards[0] ? model.cards[0].tier : 0" @change="updateCard(0, 'tier', $event.target.value)">
                                <option v-for="(type, index) in model.cardType" :value="index" :key="index">
                                    {{ type.name }}
                                </option>
                            </select>
                    </div>
                </div>
                
                <!-- Additional Cards -->
                <div v-if="model.medal.isCardActive && model.cardAmount >= 1">
                    <div v-for="(card, index) in (model.cards || []).slice(1)" :key="index + 1">
                        <div>
                            <div class="card-header-with-remove">
                                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Card">Card {{ index + 2 }}</label>
                                <button data-button type="button" class="remove_button" @click="removeCard(index + 1)">
                                    <i class="bi bi-dash"></i> Remove
                                </button>
                            </div>
                            <select class="form-select" :value="card.cardId" @change="updateCard(index + 1, 'cardId', $event.target.value)">
                                <option value="">Select a card</option>
                                <option v-for="(value, key) in cards" :value="key" :key="key">
                                    {{ value.name }}
                                </option>
                            </select>
                        </div>
                        <div>
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Card Tier: Specify the tier level">Card Tier</label>
                            <select class="form-select" :value="card.tier" @change="updateCard(index + 1, 'tier', $event.target.value)">
                                <option v-for="(type, index) in model.cardType" :value="index" :key="index">
                                    {{ type.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                  <i class="bi-check-lg"></i> Save Achievement
                </button>
                <div v-if="model.medal.id" class="upload">
                  <file-upload
                    :multiple="true"
                    upload-type="medals"
                    :upload-id="model.medal.id"
                    accepted-types="image/*,video/*"
                    :max-size="20 * 1024 * 1024"
                    :existing-images="model.medal.images"
                    :allow-remove-existing="true"
                    :image-base-url="getMedalsUrl()"
                    @upload-success="handleMediaUpload">
                </div>
              </div>
            </div>
          </div>
          
          <div class="admin-table-wrapper quest-table-wrapper">
            <table class="admin-table quest-table">
              <thead>
                <tr>
                  <th class="th-level">Active</th>
                  <th class="th-name">Name</th>
                  <th class="th-rules">Description</th>
                  <th class="th-name">Image</th>
                  <th class="th-name">Video</th>
                  <th class="th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="medal in model.medals" :key="medal.id">
                  <tr class="admin-table-row quest-row" v-on:click="edit(medal.id)">
                    <td class="td-level">
                      <i v-if="medal.active == true" class="bi-check-lg"></i>
                      <i v-if="medal.active == false" class="bi-x-lg"></i>
                    </td>
                    <td class="td-name">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="admin-name quest-name">{{ medal.name }}</span>
                      </div>
                    </td>
                    <td class="td-rules">
                      <span class="admin-rules-text rules-text" :title="medal.description">{{ medal.description }}</span>
                    </td>
                    <td class="td-name">
                      <img v-if="medal.image" :src="medal.image" :alt="medal.name + ' image'" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer;" @click.stop @error="$event.target.style.display='none'" />
                      <span v-else style="color: #999;">No image</span>
                    </td>
                    <td class="td-name">
                      <video v-if="medal.video" :src="medal.video" style="max-width: 150px; max-height: 100px; object-fit: contain; cursor: pointer;" controls @click.stop @error="$event.target.style.display='none'"></video>
                      <span v-else style="color: #999;">No video</span>
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(medal.id)" title="Edit Achievement">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  `,

  adminRewardFrames: `
    <div data-component="admin-reward-frames">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="header">
                <h4>Reward Frames - Assign to Quests, Events, Shop & Chests</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add New Reward</button>
              </div>

              <!-- Filter Tabs -->
              <div class="admin-tabs">
                <button class="admin-tab-button" :class="{ active: model.filterType === 'all' }" v-on:click="model.filterType = 'all'">
                  All Rewards
                </button>
                <button class="admin-tab-button" :class="{ active: model.filterType === 'quest' }" v-on:click="model.filterType = 'quest'">
                  Quests
                </button>
                <button class="admin-tab-button" :class="{ active: model.filterType === 'event' }" v-on:click="model.filterType = 'event'">
                  Events
                </button>
                <button class="admin-tab-button" :class="{ active: model.filterType === 'shop' }" v-on:click="model.filterType = 'shop'">
                  Shop
                </button>
                <button class="admin-tab-button" :class="{ active: model.filterType === 'chest' }" v-on:click="model.filterType = 'chest'">
                  Chests
                </button>
              </div>

              <!-- Edit Form -->
              <div class="row form" v-bind:class="{ visible: model.edit }">
                <div>
                  <i class="bi-x-lg close" v-on:click="reset()"></i>
                  <div class="col-12 scroll_sidebar">

                    <!-- Basic Settings -->
                    <div>
                      <label>Active</label>
                      <div class="form-check form-switch">
                        <input v-model="model.rewardFrame.is_active" type="checkbox" class="form-check-input">
                      </div>
                    </div>

                    <div>
                      <label>Featured</label>
                      <div class="form-check form-switch">
                        <input v-model="model.rewardFrame.is_featured" type="checkbox" class="form-check-input">
                      </div>
                    </div>

                    <div>
                      <label>Reward Name *</label>
                      <input class="form-control" v-model="model.rewardFrame.reward_name" type="text" placeholder="e.g., Golden Frame">
                    </div>

                    <div>
                      <label>Description</label>
                      <textarea class="form-control" v-model="model.rewardFrame.description" placeholder="Describe this reward..."></textarea>
                    </div>

                    <!-- Unlock Type - SELECT THIS FIRST -->
                    <div style="background: #e8f4f8; padding: 15px; border-radius: 5px; border: 2px solid #4a9eff;">
                      <label style="font-weight: bold; color: #2563eb;">
                        <span style="background: #2563eb; color: white; padding: 2px 8px; border-radius: 3px; font-size: 10px; margin-right: 5px;">STEP 1</span>
                        What Gets Unlocked? *
                      </label>
                      <select class="form-control" v-model="model.rewardFrame.unlock_type" style="margin-top: 8px; border: 2px solid #4a9eff;">
                        <option v-for="type in unlockTypes" :key="type.value" :value="type.value">
                          {{ type.label }}
                        </option>
                      </select>
                      <p style="font-size: 11px; color: #1e40af; margin-top: 8px; margin-bottom: 0;">
                        • <strong>Frame Only:</strong> User gets just the frame overlay (border)<br>
                        • <strong>Background Only:</strong> User gets just the background image<br>
                        • <strong>Select Multiple:</strong> Choose any combination of frames and/or backgrounds
                      </p>
                    </div>

                    <!-- Frame Selection - FILTERED BASED ON STEP 1 -->
                    <div style="margin-top: 15px;">
                      <label>
                        <span style="background: #2563eb; color: white; padding: 2px 8px; border-radius: 3px; font-size: 10px; margin-right: 5px;">STEP 2</span>
                        Select Frame/Background *
                      </label>
                      <p style="font-size: 12px; color: #666; margin: 5px 0;">
                        <span v-if="model.rewardFrame.unlock_type === 'frame'">
                          Showing <strong>frames only</strong>
                        </span>
                        <span v-else-if="model.rewardFrame.unlock_type === 'background'">
                          Showing <strong>backgrounds only</strong>
                        </span>
                        <span v-else-if="model.rewardFrame.unlock_type === 'multiple'">
                          Showing <strong>all frames and backgrounds</strong> - you can select multiple items
                        </span>
                      </p>

                      <!-- Single Select for Frame Only or Background Only -->
                      <select v-if="model.rewardFrame.unlock_type !== 'multiple'" class="form-control" v-model="model.rewardFrame.frame_id" v-on:change="selectFrame(model.rewardFrame.frame_id)">
                        <option value="">-- Select Frame/Background --</option>
                        <option v-for="frame in availableFrames" :key="frame.id" :value="frame.id">
                          {{ frame.displayName }}
                        </option>
                      </select>

                      <!-- Multiple Select for Select Multiple -->
                      <select v-else multiple class="form-control" v-model="model.rewardFrame.frame_ids" v-on:change="selectFrames()" style="min-height: 150px;">
                        <option v-for="frame in availableFrames" :key="frame.id" :value="frame.id">
                          {{ frame.displayName }}
                        </option>
                      </select>
                      <p v-if="model.rewardFrame.unlock_type === 'multiple'" style="font-size: 11px; color: #2563eb; margin-top: 5px; font-weight: bold;">
                        💡 Select any combination of frames and/or backgrounds
                      </p>
                      <p v-if="model.rewardFrame.unlock_type === 'multiple'" style="font-size: 11px; color: #666; margin-top: 3px; font-style: italic;">
                        💡 Tip: Hold Ctrl (Windows) or Cmd (Mac) to select multiple items
                      </p>

                      <p v-if="availableFrames.length === 0" style="font-size: 12px; color: #dc2626; margin-top: 5px;">
                        ⚠️ No frames available for "{{ model.rewardFrame.unlock_type }}" unlock type.
                        Please upload frames/backgrounds in Battle Frames admin first.
                      </p>
                    </div>

                    <!-- Frame Preview - Single Selection -->
                    <div v-if="model.selectedFrame && model.rewardFrame.unlock_type !== 'multiple'" style="margin: 15px 0; padding: 15px; border: 1px solid #ddd; border-radius: 5px; background: #f9f9f9;">
                      <strong style="display: block; margin-bottom: 10px;">✓ Selected: {{ model.selectedFrame.name }}</strong>
                      <p style="font-size: 12px; color: #666; margin: 5px 0 10px 0;">{{ model.selectedFrame.description }}</p>

                      <!-- Frame Image Preview -->
                      <div v-if="model.selectedFrame.frameImage" style="text-align: center; margin-top: 10px;">
                        <img :src="model.selectedFrame.frameImage" alt="Frame Preview" style="max-width: 200px; max-height: 200px; border: 2px solid #4a9eff; border-radius: 5px;">
                        <p style="font-size: 11px; color: #666; margin-top: 5px;">Frame Overlay</p>
                      </div>

                      <!-- Background Image Preview -->
                      <div v-if="model.selectedFrame.backgroundImage" style="text-align: center; margin-top: 10px;">
                        <img :src="model.selectedFrame.backgroundImage" alt="Background Preview" style="max-width: 200px; max-height: 200px; border: 2px solid #4a9eff; border-radius: 5px;">
                        <p style="font-size: 11px; color: #666; margin-top: 5px;">Background Image</p>
                      </div>
                    </div>

                    <!-- Frame Preview - Multiple Selection -->
                    <div v-if="model.selectedFrames.length > 0 && model.rewardFrame.unlock_type === 'multiple'" style="margin: 15px 0; padding: 15px; border: 1px solid #ddd; border-radius: 5px; background: #f9f9f9;">
                      <strong style="display: block; margin-bottom: 10px;">✓ Selected {{ model.selectedFrames.length }} items:</strong>

                      <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; margin-top: 10px;">
                        <div v-for="frame in model.selectedFrames" :key="frame.id" style="border: 1px solid #ccc; border-radius: 5px; padding: 8px; background: white; text-align: center;">
                          <div style="font-size: 11px; font-weight: bold; margin-bottom: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" :title="frame.name">
                            {{ frame.name }}
                          </div>

                          <!-- Frame Image Thumbnail -->
                          <img v-if="frame.frameImage" :src="frame.frameImage" :alt="frame.name" style="width: 100%; max-height: 100px; object-fit: contain; border: 1px solid #ddd; border-radius: 3px; margin-bottom: 3px;">

                          <!-- Background Image Thumbnail -->
                          <img v-if="frame.backgroundImage" :src="frame.backgroundImage" :alt="frame.name" style="width: 100%; max-height: 100px; object-fit: contain; border: 1px solid #ddd; border-radius: 3px; margin-bottom: 3px;">

                          <div style="font-size: 10px; color: #666; margin-top: 3px;">
                            {{ frame.frameImage ? 'Frame' : 'Background' }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Reward Type -->
                    <div>
                      <label>Reward Type *</label>
                      <select class="form-control" v-model="model.rewardFrame.reward_type">
                        <option v-for="type in rewardTypes" :key="type.value" :value="type.value">
                          {{ type.label }}
                        </option>
                      </select>
                    </div>

                    <!-- Universal Level Requirement -->
                    <div>
                      <label>Level Required</label>
                      <input class="form-control" v-model.number="model.rewardFrame.required_level" type="number" min="0" placeholder="0">
                      <small class="form-text text-muted">User must be at this level or higher to unlock this reward (0 = no level requirement)</small>
                    </div>

                    <hr>

                    <!-- Shop Fields -->
                    <div v-if="showShopFields">
                      <h5>Shop Item Settings</h5>

                      <div>
                        <label>Currency Type</label>
                        <select class="form-control" v-model="model.rewardFrame.currency_type">
                          <option v-for="curr in currencyTypes" :key="curr.value" :value="curr.value">
                            {{ curr.label }}
                          </option>
                        </select>
                      </div>

                      <div>
                        <label>Price *</label>
                        <input class="form-control" v-model.number="model.rewardFrame.currency_amount" type="number" placeholder="0">
                      </div>
                    </div>

                    <!-- Quest Fields -->
                    <div v-if="showQuestFields">
                      <h5>Quest Reward Settings</h5>

                      <div>
                        <label>Quest *</label>
                        <select class="form-control" v-model="model.rewardFrame.quest_id">
                          <option value="">-- Select Quest --</option>
                          <option v-for="quest in model.quests" :key="quest.id" :value="quest.id">
                            {{ quest.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Event Fields -->
                    <div v-if="showEventFields">
                      <h5>Event Reward Settings</h5>

                      <div>
                        <label>Event *</label>
                        <select class="form-control" v-model="model.rewardFrame.event_id">
                          <option value="">-- Select Event --</option>
                          <option v-for="event in model.events" :key="event.id" :value="event.id">
                            {{ event.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Chest Fields -->
                    <div v-if="showChestFields">
                      <h5>Chest Drop Settings</h5>

                      <div>
                        <label>Chest Type *</label>
                        <select class="form-control" v-model="model.rewardFrame.chest_type">
                          <option value="">-- Select Chest --</option>
                          <option v-for="chest in model.chests" :key="chest.id" :value="chest.id">
                            {{ chest.name }}
                          </option>
                        </select>
                      </div>

                      <div>
                        <label>Guaranteed Drop</label>
                        <div class="form-check form-switch">
                          <input v-model="model.rewardFrame.is_guaranteed" type="checkbox" class="form-check-input">
                        </div>
                      </div>

                      <div v-if="!model.rewardFrame.is_guaranteed">
                        <label>Drop Rate % *</label>
                        <input class="form-control" v-model.number="model.rewardFrame.drop_rate" type="number" step="0.01" placeholder="e.g., 5.5">
                      </div>
                    </div>

                    <hr>

                    <!-- Optional Settings -->
                    <h5>Optional Settings</h5>

                    <div>
                      <label>Start Date (leave empty for immediate)</label>
                      <input class="form-control" v-model="model.rewardFrame.start_date" type="datetime-local">
                    </div>

                    <div>
                      <label>End Date (leave empty for permanent)</label>
                      <input class="form-control" v-model="model.rewardFrame.end_date" type="datetime-local">
                    </div>

                    <div>
                      <label>Max Claims (leave empty for unlimited)</label>
                      <input class="form-control" v-model.number="model.rewardFrame.max_claims" type="number" placeholder="e.g., 100">
                    </div>

                    <div>
                      <label>Sort Order</label>
                      <input class="form-control" v-model.number="model.rewardFrame.sort_order" type="number" placeholder="0">
                    </div>

                    <button class="top-margin" data-button="submit" v-on:click="save()">
                      {{ model.rewardFrame.id ? 'Update' : 'Create' }} Reward
                    </button>
                  </div>
                </div>
              </div>

              <!-- Rewards List -->
              <div class="body">
                <table>
                  <thead>
                    <tr>
                      <th>Active</th>
                      <th>Image</th>
                      <th>Frame/Background</th>
                      <th>Reward Name</th>
                      <th>Reward Description</th>
                      <th>Type</th>
                      <th>Details</th>
                      <th>Unlocks</th>
                      <th>Claims</th>
                      <th>Featured</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="Object.keys(filteredRewards).length === 0">
                      <td colspan="11" style="text-align: center;">No reward frames assigned yet</td>
                    </tr>
                    <tr v-for="reward in filteredRewards" :key="reward.id">
                      <td>
                        <div class="form-check form-switch">
                          <input type="checkbox" :checked="reward.is_active" v-on:change="toggleActive(reward.id, reward._type)" class="form-check-input">
                        </div>
                      </td>
                      <td>
                        <div class="reward-image-wrapper">
                          <img v-if="reward._type === 'frame' && model.frames[reward.frame_id] && model.frames[reward.frame_id].frameImage" :src="model.frames[reward.frame_id].frameImage" :alt="reward.frame_name" class="reward-item-image" @error="$event.target.style.display='none'">
                          <img v-else-if="reward._type === 'background' && model.backgrounds[reward.background_id] && model.backgrounds[reward.background_id].backgroundImage" :src="model.backgrounds[reward.background_id].backgroundImage" :alt="reward.background_name" class="reward-item-image" @error="$event.target.style.display='none'">
                          <div v-else class="reward-image-placeholder">
                            <i class="bi-image"></i>
                          </div>
                        </div>
                      </td>
                      <td>
                        {{ reward.frame_name || reward.background_name || 'N/A' }}
                        <span v-if="reward._type === 'background'" style="font-size: 10px; color: #666;">[BG]</span>
                      </td>
                      <td>
                        {{ reward.description}}
                        <span v-if="reward._type === 'background'" style="font-size: 10px; color: #666;">[BG]</span>
                      </td>
                      <td>{{ reward.reward_name }}</td>
                      <td><span class="badge reward-frames">{{ getRewardTypeLabel(reward.reward_type) }}</span></td>
                      <td>
                        <span v-if="reward.reward_type === 'shop'">{{ reward.currency_amount }}</span>
                        <span v-else-if="reward.reward_type === 'rank'">{{ reward.required_rank }}</span>
                        <span v-else-if="reward.reward_type === 'quest'">Quest: {{ getQuestName(reward.quest_id) }}</span>
                        <span v-else-if="reward.reward_type === 'event'">Event: {{ getEventName(reward.event_id) }}</span>
                        <span v-else-if="reward.reward_type === 'chest'">{{ getChestDisplay(reward) }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>{{ getUnlockTypeLabel(reward.unlock_type || reward._type) }}</td>
                      <td>{{ reward.current_claims || 0 }} / {{ reward.max_claims || '∞' }}</td>
                      <td>
                        <span v-if="reward.is_featured">⭐</span>
                      </td>
                      <td>
                        <button class="btn-small" v-on:click="edit(reward.id, reward._type)">Edit</button>
                        <button class="btn-small btn-danger" v-on:click="deleteReward(reward.id, reward._type)">Delete</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  adminStore:`
  <div data-component="admin-store">
    <section class="quest-line-section">
      <div class="quest-line-container">
        
        <!-- Header Panel -->
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-shop"></i>
              <div>
                <h2>Store Manager</h2>
                <p class="admin-subtitle quest-subtitle">Configure and manage store items</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>New Store Item</span>
            </button>
          </div>
        </div>

        <!-- Edit Form Sidebar -->
        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
              
              <!-- Store Form Fields -->
              <div class="quest-form-section">
                <div class="quest-form-section-header">
                  <i class="bi-info-circle"></i>
                  <h3>Store Details</h3>
                </div>
                <div class="quest-form-group">
                  <label>Name</label>
                  <input class="form-control" v-model="model.store.name" type="text" placeholder="Enter store name">
                </div>
                <div class="quest-form-group">
                  <label>Description</label>
                  <input class="form-control" v-model="model.store.description" type="text" placeholder="Enter description">
                </div>
                <div class="quest-form-row">
                  <div class="quest-form-group">
                    <label>Price</label>
                    <input class="form-control" v-model="model.store.price" type="number" placeholder="0">
                  </div>
                  <div class="quest-form-group">
                    <label>Prefix</label>
                    <input class="form-control" v-model="model.store.prefix" type="text" placeholder="e.g. sf">
                  </div>
                </div>
                <div class="quest-form-group">
                  <label>Tier</label>
                  <input class="form-control" v-model="model.store.tier" type="number" max="3" placeholder="1-3">
                </div>
              </div>

              <!-- Cooldown Section -->
              <div class="quest-form-section">
                <div class="quest-form-section-header">
                  <i class="bi-clock-history"></i>
                  <h3>Cooldown Settings</h3>
                </div>
                <div class="quest-form-group">
                  <label>Enable Cooldown</label>
                  <div class="form-check form-switch">
                    <input type="checkbox" v-model="model.cooldownEnabled" @change="!model.cooldownEnabled && (model.store.item_cooldown = 0)" class="form-check-input">
                  </div>
                </div>
                <div class="quest-form-group" v-if="model.cooldownEnabled">
                  <label>Cooldown Time (in hours)</label>
                  <input class="form-control" v-model="model.store.item_cooldown" type="number" placeholder="Hours">
                </div>
              </div>

              <!-- Card Sacrifice Section -->
              <div class="quest-form-section" v-if="model.store.tier > 1">
                <div class="quest-form-section-header">
                  <i class="bi-collection"></i>
                  <h3>Card Sacrifice</h3>
                </div>
                <div class="quest-form-group">
                  <label>Card Tier</label>
                  <select class="form-select" v-model="model.store.cardTier" v-on:change="selectedTier">
                    <option value="">Select Card Tier</option>
                    <option v-for="tier in model.cardTier" :value="tier">{{ tier.name }}</option>
                  </select>
                </div>
                <div class="quest-form-group">
                  <label>Cards Sacrifice Count</label>
                  <input class="form-control" v-model="model.store.dumpCard" type="number" placeholder="0">
                </div>
              </div>

              <!-- Special Fusion Section -->
              <div class="quest-form-section" v-if="model.store.prefix === 'sf'">
                <div class="quest-form-section-header">
                  <i class="bi-stars"></i>
                  <h3>Special Fusion Values</h3>
                </div>
                <div class="quest-form-row">
                  <div class="quest-form-group">
                    <label>Standard</label>
                    <input class="form-control" v-model="model.store.standard" type="number" placeholder="0">
                  </div>
                  <div class="quest-form-group">
                    <label>Ultra</label>
                    <input class="form-control" v-model="model.store.ultra" type="number" placeholder="0">
                  </div>
                </div>
                <div class="quest-form-row">
                  <div class="quest-form-group">
                    <label>Legendary</label>
                    <input class="form-control" v-model="model.store.legendary" type="number" placeholder="0">
                  </div>
                  <div class="quest-form-group">
                    <label>Ultimate</label>
                    <input class="form-control" v-model="model.store.ultimate" type="number" placeholder="0">
                  </div>
                </div>
              </div>

              <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Store Item
              </button>

              <!-- Image Upload (only available after item is saved) -->
              <div class="quest-form-section" v-if="model.store.id">
                <div class="quest-form-section-header">
                  <i class="bi-image"></i>
                  <h3>Item Image</h3>
                </div>
                <div v-if="model.store.image" class="store-admin-img-preview">
                  <img :src="\`\${root}\${model.store.image}\`" :alt="model.store.name">
                </div>
                <file-upload
                  upload-type="store"
                  :upload-id="model.store.id"
                  accepted-types="image/png,image/jpeg,image/webp"
                  :multiple="false"
                  :auto-upload="true"
                  @upload-success="handleImageUpload">
                </file-upload>
              </div>
              <p v-else class="store-upload-hint"><i class="bi-info-circle"></i> Save the item first to enable image upload.</p>

            </div>
          </div>
        </div>

        <!-- Store Table -->
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-name">Name</th>
                <th class="th-rules">Description</th>
                <th class="th-level">Price</th>
                <th class="th-mode">Prefix</th>
                <th class="th-wins">Cooldown</th>
                <th class="th-level">Tier</th>
                <th class="th-mode">Card Sacrifice</th>
                <th class="th-wins">Sacrifice Count</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(store, index) in model.stores" :key="index">
                <!-- Main Store Row -->
                <tr class="admin-table-row quest-row">
                  <td class="td-name">
                    <div class="admin-name-cell quest-name-cell">
                      <img v-if="store.image" :src="\`\${root}\${store.image}\`" :alt="store.name" class="store-table-thumb">
                      <span class="admin-name quest-name">{{ store.name }}</span>
                    </div>
                  </td>
                  <td class="td-rules">
                    <span class="admin-rules-text rules-text" :title="store.description">{{ store.description }}</span>
                  </td>
                  <td class="td-level">
                    <span class="admin-badge-level level-badge">{{ store.price }}</span>
                  </td>
                  <td class="td-mode">
                    <span class="admin-badge-mode mode-badge">{{ store.prefix }}</span>
                  </td>
                  <td class="td-wins">
                    <span class="admin-badge-wins wins-badge" v-if="store.item_cooldown">{{ store.item_cooldown }}h</span>
                    <span class="admin-badge-wins wins-badge empty" v-else>—</span>
                  </td>
                  <td class="td-level">
                    <span class="tier-badge">T{{ store.tier }}</span>
                  </td>
                  <td class="td-mode">
                    <span class="admin-badge-mode mode-badge" v-if="store.cardTier && store.cardTier.name">{{ store.cardTier.name }}</span>
                    <span class="admin-badge-mode mode-badge empty" v-else>—</span>
                  </td>
                  <td class="td-wins">
                    <span class="admin-badge-wins wins-badge" v-if="store.dumpCard">{{ store.dumpCard }}</span>
                    <span class="admin-badge-wins wins-badge empty" v-else>—</span>
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(store.id)" title="Edit Store Item">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
              </template>
              
              <!-- Empty State -->
              <tr v-if="Object.keys(model.stores).length === 0">
                <td colspan="9" class="empty-table-state">
                  <div class="empty-content">
                    <i class="bi-inbox"></i>
                    <p>No store items created yet</p>
                    <button class="admin-add-btn quest-add-btn small" v-on:click="add()">
                      <i class="bi-plus-lg"></i> Create First Store Item
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>
  `,

  adminSeason: `
  <div data-component="seasonal">
      <section class="quest-line-section">
        <div class="quest-line-container">
          <div class="admin-header-panel quest-header-panel">
            <div class="admin-header-content quest-header-content">
              <div class="admin-header-title quest-header-title">
                <i class="bi-calendar-event"></i>
                <div>
                  <h2>Season Settings</h2>
                  <p class="admin-subtitle quest-subtitle">Manage season configurations</p>
                </div>
              </div>
              <button class="admin-add-btn quest-add-btn top-margin" v-bind:class="{ remove_button: model.seasonStarted}" data-button="submit" v-on:click="handleClick()">{{model.seasonStarted ? 'End Season' : 'Start Season'}}</button>
            </div>
          </div>

          <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
            <div>
              <i class="bi-x-lg close" v-on:click="reset()"></i> 
              <div class="col-12 scroll_sidebar">
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Store Price.">Start Date</label>
                  <input class="form-control" v-model="model.season.startDate" type="date">
                </div>
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="End Season">Season End</label>
                  <input class="form-control" v-model="model.season.endDate" type="date">
                </div>
             
                <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">Save</button>
                <button class="top-margin" data-button="submit" v-on:click="pause(false)" v-if="!model.season.active">Resume Season</button>
                <button class="top-margin" data-button="submit" v-on:click="pause(true)" v-if="model.season.active">Pause Season</button>
              </div>
            </div>
          </div>
          
          <div class="admin-table-wrapper quest-table-wrapper">
            <table class="admin-table quest-table">
              <thead>
                <tr>
                  <th class="th-level">Active</th>
                  <th class="th-name">Season</th>
                  <th class="th-date">Season Start</th>
                  <th class="th-date">Season End</th>
                  <th class="th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="season in model.seasons" :key="season.id">
                  <tr class="admin-table-row quest-row" v-on:click="edit(season.id)">
                    <td class="td-level">
                      <i v-if="season.active == true" class="bi-check-lg"></i> 
                      <i v-if="season.active == false" class="bi-x-lg"></i> 
                    </td>
                    <td class="td-name">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="admin-name quest-name">Season {{season.id}}</span>
                      </div>
                    </td>
                    <td class="td-date">
                      {{season.startDate}}
                    </td>
                    <td class="td-date">
                      {{season.endDate}}
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(season.id)" title="Edit Season">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
`,

adminFaction: `
  <div data-component="admin-faction">
    <section class="quest-line-section">
      <div class="quest-line-container">
        
        <!-- Header Panel -->
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-people"></i>
              <div>
                <h2>Faction Settings</h2>
                <p class="admin-subtitle quest-subtitle">Create and manage factions</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>New Faction</span>
            </button>
          </div>
        </div>

        <!-- Edit Form Sidebar -->
        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Faction Name.">Faction Name</label>
                <input class="form-control" v-model="model.faction.name" type="text">
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description.">Description</label>
                <input class="form-control" v-model="model.faction.description" type="text">
              </div>
              <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Faction
              </button>
              <div v-if="model.faction.id" class="upload-section">
                <file-upload
                  :multiple="false"
                  upload-type="faction"
                  :upload-id="model.faction.id"
                  accepted-types="image/*,video/*"
                  :max-size="50 * 1024 * 1024"
                  :existing-images="model.faction.image"
                  :allow-remove-existing="true"
                  :image-base-url="getFactionUrl()"
                  @upload-success="handleFactionImageUpload">
                </file-upload>
              </div>
            </div>
          </div>
        </div>

        <!-- Faction Table -->
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-toggle">
                  <i class="bi-eye"></i>
                </th>
                <th class="th-name">Faction Name</th>
                <th class="th-rules">Description</th>
                <th class="th-date">Image/Video</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(faction, index) in model.factions" :key="index">
                <!-- Main Faction Row -->
                <tr class="admin-table-row quest-row" :class="{ 'expanded': model.expandedRow === index }">
                  <td class="td-toggle" @click="toggleDetails(index)">
                    <button class="admin-toggle-btn toggle-btn" :class="{ 'active': model.expandedRow === index }">
                      <i v-if="model.expandedRow === index" class="bi-eye-fill"></i>
                      <i v-else class="bi-eye-slash"></i>
                    </button>
                  </td>
                  <td class="td-name" @click="toggleDetails(index)">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ faction.name }}</span>
                    </div>
                  </td>
                  <td class="td-rules" @click="toggleDetails(index)">
                    <span class="admin-rules-text rules-text" :title="faction.description">{{ faction.description }}</span>
                  </td>
                  <td class="td-date" @click="toggleDetails(index)">
                    <div class="faction-media-column">
                      <div v-if="faction.image && Array.isArray(faction.image) && faction.image.length > 0" class="media-item" v-for="(img, imgIndex) in faction.image" :key="'img-' + imgIndex">
                        <img :src="getFactionImageUrl(faction.id, img)" class="faction-media-preview" @error="handleImageError($event, faction.id, 'image')" />
                      </div>
                      <div v-else-if="faction.image && !Array.isArray(faction.image)" class="media-item">
                        <img :src="getFactionImageUrl(faction.id, faction.image)" class="faction-media-preview" @error="handleImageError($event, faction.id, 'image')" />
                      </div>
                      <div v-if="hasValidVideo(faction) && Array.isArray(faction.video) && faction.video.length > 0" class="media-item" v-for="(vid, vidIndex) in faction.video" :key="'vid-' + vidIndex" v-show="vid && vid.trim() !== '' && getFactionVideoUrl(faction.id, vid)">
                        <div class="video-container">
                          <video v-if="getFactionVideoUrl(faction.id, vid)" :src="getFactionVideoUrl(faction.id, vid)" class="faction-media-preview" controls @error="handleVideoError($event, faction.id, 'video')" @loadeddata="handleVideoLoaded($event, faction.id, vid)"></video>
                          <div v-else class="video-placeholder">
                            <i class="bi-play-circle"></i>
                            <span>Video unavailable</span>
                          </div>
                          <div class="video-placeholder" style="display: none;">
                            <i class="bi-play-circle"></i>
                            <span>Video unavailable</span>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="hasValidVideo(faction) && !Array.isArray(faction.video) && getFactionVideoUrl(faction.id, faction.video)" class="media-item">
                        <div class="video-container">
                          <video :src="getFactionVideoUrl(faction.id, faction.video)" class="faction-media-preview" controls @error="handleVideoError($event, faction.id, 'video')" @loadeddata="handleVideoLoaded($event, faction.id, faction.video)"></video>
                          <div class="video-placeholder" style="display: none;">
                            <i class="bi-play-circle"></i>
                            <span>Video unavailable</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="(!faction.image || (Array.isArray(faction.image) && faction.image.length === 0)) && !hasValidVideo(faction)" class="media-empty">
                        <i class="bi-image"></i>
                        <span>No media</span>
                      </div>
                    </div>
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(faction.id)" title="Edit Faction">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
                
                <!-- Expanded Details Row -->
                <tr class="admin-details-row quest-details-row" v-show="model.expandedRow === index">
                  <td colspan="5">
                    <div class="admin-details-panel quest-details-panel">
                      <div class="faction-members-section">
                        <!-- Members Section -->
                        <div class="detail-card members-card">
                          <div class="detail-card-header">
                            <div class="members-header-content">
                              <div class="members-header-title">
                                <i class="bi-people"></i>
                                <h4>{{ faction.name }} - Members</h4>
                              </div>
                              <input type="text" class="search-bar" v-model="model.searchTerm" placeholder="Search members..." aria-label="Search">
                            </div>
                          </div>
                          <div class="detail-card-body">
                            <table class="faction-members-table">
                              <thead>
                                <tr>
                                  <th class="th-avatar">Avatar</th>
                                  <th class="th-twitch-id">Twitch ID</th>
                                  <th class="th-username">Username</th>
                                  <th class="th-action">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(member, memberIndex) in filteredMembers" :key="memberIndex" class="member-row">
                                  <td class="td-avatar">
                                    <div class="avatar-container">
                                      <img :src="member.twitchProfileImage" class="faction-member-avatar" :alt="member.twitchDisplayName || 'Member'">
                                    </div>
                                  </td>
                                  <td class="td-twitch-id">
                                    <span class="twitch-id-value">{{ member.twitchId }}</span>
                                  </td>
                                  <td class="td-username">
                                    <span class="username-value">{{ member.twitchDisplayName }}</span>
                                  </td>
                                  <td class="td-action">
                                    <button class="remove-member-btn" @click="removeUser(member.id, faction.id, member.twitchDisplayName, faction.name)" title="Remove member">
                                      <i class="bi bi-x-circle"></i>
                                      <span>Remove</span>
                                    </button>
                                  </td>
                                </tr>
                                <tr v-if="!filteredMembers || filteredMembers.length === 0" class="empty-members-row">
                                  <td colspan="4" class="empty-state">
                                    <div class="empty-members-content">
                                      <i class="bi-people"></i>
                                      <p>No members found</p>
                                      <span v-if="model.searchTerm">Try adjusting your search</span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              
              <!-- Empty State -->
              <tr v-if="Object.keys(model.factions).length === 0">
                <td colspan="5" class="empty-table-state">
                  <div class="empty-content">
                    <i class="bi-inbox"></i>
                    <p>No factions created yet</p>
                    <button class="quest-add-btn small" v-on:click="add()">
                      <i class="bi-plus-lg"></i> Create First Faction
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>
`,

adminQuestLine:`
  <div data-component="admin-quest-line">
    <section class="quest-line-section">
      <div class="quest-line-container">
        
        <!-- Header Panel -->
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-trophy"></i>
              <div>
                <h2>Quest Builder</h2>
                <p class="admin-subtitle quest-subtitle">Create and manage quest campaigns</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>New Quest</span>
            </button>
          </div>
        </div>

        <!-- Edit Form Sidebar -->
        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
              <QuestForm 
                :model="model.quest"
                :cards="model.cards"
                :packs="model.packs"
                :randomcard="model.randomcard"
                @input-changed="handleQuestChange"
              />
              <RewardsComponent
                :rewards="model.quest.rewards"
                :packs="model.packs"
                :randomcard="model.randomcard"
                :selectedCards="model.cards"
                :frames="model.frames"
                :backgrounds="model.backgrounds"
                :cardBacks="model.cardBacks"
                @reward-changed="handleRewardChange"
              />
              <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Quest
              </button>
              <file-upload
                :multiple="false"
                upload-type="quest"
                :upload-id="model.quest.id"
                accepted-types="image/*"
                :max-size="5 * 1024 * 1024"
                :existing-images="model.quest.image"
                :allow-remove-existing="true"
                :image-base-url="getQuestUrl()"
                @upload-success="handleCardImageUpload">
              </file-upload>
            </div>
          </div>
        </div>

        <!-- Quest Table -->
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-toggle">
                  <i class="bi-eye"></i>
                </th>
                <th class="th-name">Quest Name</th>
                <th class="th-rules">Rules</th>
                <th class="th-date">Schedule</th>
                <th class="th-level">Level</th>
                <th class="th-mode">Mode</th>
                <th class="th-wins">Wins</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(quest, index) in model.quests" :key="index">
                <!-- Main Quest Row -->
                <tr class="admin-table-row quest-row" :class="{ 'expanded': model.expandedRow === index }">
                  <td class="td-toggle" @click="toggleDetails(index)">
                    <button class="admin-toggle-btn toggle-btn" :class="{ 'active': model.expandedRow === index }">
                      <i v-if="model.expandedRow === index" class="bi-eye-fill"></i>
                      <i v-else class="bi-eye-slash"></i>
                    </button>
                  </td>
                  <td class="td-name" @click="toggleDetails(index)">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ quest.name }}</span>
                    </div>
                  </td>
                  <td class="td-rules" @click="toggleDetails(index)">
                    <span class="admin-rules-text rules-text" :title="quest.description">{{ quest.description }}</span>
                  </td>
                  <td class="td-date" @click="toggleDetails(index)">
                    <div class="date-cell">
                      <span class="date-value">{{ formattedDate(quest.date) }}</span>
                      <span class="time-value">{{ quest.time }}</span>
                    </div>
                  </td>
                  <td class="td-level" @click="toggleDetails(index)">
                    <span class="admin-badge-level level-badge">Lv. {{ quest.level }}</span>
                  </td>
                  <td class="td-mode" @click="toggleDetails(index)">
                    <span class="admin-badge-mode mode-badge" :class="quest.selectedMode">
                      {{ quest.selectedMode === 'any' ? 'Both' : quest.selectedMode }}
                    </span>
                  </td>
                  <td class="td-wins" @click="toggleDetails(index)">
                    <span class="admin-badge-wins wins-badge">{{ quest.wins }}</span>
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(quest.id)" title="Edit Quest">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
                
                <!-- Expanded Details Row -->
                <tr class="admin-details-row quest-details-row" v-show="model.expandedRow === index">
                  <td colspan="8">
                    <div class="admin-details-panel quest-details-panel">
                      <div class="details-grid">
                        
                        <!-- Cards Section -->
                        <div class="detail-card">
                          <div class="detail-card-header">
                            <i class="bi-collection"></i>
                            <h4>Required Cards</h4>
                          </div>
                          <div class="detail-card-body">
                            <table class="mini-table">
                              <thead>
                                <tr>
                                  <th>Card Name</th>
                                  <th>Tier</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="card in quest.cards" :key="card.cardId">
                                  <td>{{ card.name || 'Unknown' }}</td>
                                  <td><span class="tier-badge">T{{ card.tier }}</span></td>
                                </tr>
                                <tr v-if="!quest.cards || quest.cards.length === 0">
                                  <td colspan="2" class="empty-state">No cards required</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <!-- Rewards Section -->
                        <div class="detail-card">
                          <div class="detail-card-header">
                            <i class="bi-gift"></i>
                            <h4>Rewards</h4>
                          </div>
                          <div class="detail-card-body">
                            <div class="rewards-grid">
                              <div class="reward-item">
                                <span class="reward-label">Wins Needed</span>
                                <span class="reward-value">{{ quest.wins }}</span>
                              </div>
                              <div class="reward-item">
                                <span class="reward-label">Barks</span>
                                <span class="reward-value" v-if="(quest.rewards ? quest.rewards.barks : quest.barks) > 0">
                                  {{ quest.rewards ? quest.rewards.barks : quest.barks }}
                                </span>
                                <span class="reward-value empty" v-else>—</span>
                              </div>
                              <div class="reward-item">
                                <span class="reward-label">XP Amount</span>
                                <span class="reward-value" v-if="(quest.rewards ? quest.rewards.xp : quest.xp) > 0">
                                  {{ quest.rewards ? quest.rewards.xp : quest.xp }}
                                </span>
                                <span class="reward-value empty" v-else>—</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Packs/Chest Section -->
                        <div class="detail-card">
                          <div class="detail-card-header">
                            <i class="bi-box-seam"></i>
                            <h4>Packs / Chests</h4>
                          </div>
                          <div class="detail-card-body">
                            <table class="mini-table">
                              <thead>
                                <tr>
                                  <th>Pack Name</th>
                                  <th>Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="(quest.rewards ? quest.rewards.givePack : quest.packs) && (quest.rewards ? quest.rewards.givePack : quest.packs).length > 0">
                                  <tr v-for="pack in (quest.rewards ? quest.rewards.givePack : quest.packs)" :key="pack.packId">
                                    <td>{{ pack.name || 'Unknown Pack' }}</td>
                                    <td><span class="qty-badge">x{{ pack.packs_quantity }}</span></td>
                                  </tr>
                                </template>
                                <tr v-else>
                                  <td colspan="2" class="empty-state">No packs assigned</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <!-- Random Cards Section -->
                        <div class="detail-card">
                          <div class="detail-card-header">
                            <i class="bi-shuffle"></i>
                            <h4>Random Cards</h4>
                          </div>
                          <div class="detail-card-body">
                            <table class="mini-table">
                              <thead>
                                <tr>
                                  <th>Card Tier</th>
                                  <th>Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="quest.rewards && quest.rewards.randomCard && quest.rewards.randomCard.length > 0">
                                  <tr v-for="randomCards in quest.rewards.randomCard" :key="randomCards.randomCard">
                                    <td>
                                      <span v-if="randomCards.randomCard === 1" class="card-tier standard">Standard</span>
                                      <span v-else-if="randomCards.randomCard === 2" class="card-tier ultra">Ultra</span>
                                      <span v-else-if="randomCards.randomCard === 3" class="card-tier legendary">Legendary</span>
                                      <span v-else-if="randomCards.randomCard === 4" class="card-tier ultimate">Ultimate</span>
                                      <span v-else-if="randomCards.randomCard === 5" class="card-tier bone">Bone</span>
                                      <span v-else-if="randomCards.randomCard === 6" class="card-tier ascension">Ascension</span>
                                      <span v-else class="card-tier none">None</span>
                                    </td>
                                    <td>
                                      <span v-if="randomCards.random_amount > 0" class="qty-badge">x{{ randomCards.random_amount }}</span>
                                      <span v-else class="qty-badge empty">—</span>
                                    </td>
                                  </tr>
                                </template>
                                <tr v-else>
                                  <td colspan="2" class="empty-state">No random cards</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              
              <!-- Empty State -->
              <tr v-if="Object.keys(model.quests).length === 0">
                <td colspan="8" class="empty-table-state">
                  <div class="empty-content">
                    <i class="bi-inbox"></i>
                    <p>No quests created yet</p>
                    <button class="quest-add-btn small" v-on:click="add()">
                      <i class="bi-plus-lg"></i> Create First Quest
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>
`,


  login: `
    <div data-component="login">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xs-12 col-md-6">
            <div class="card">
              <div class="row justify-content-md-center inputs">
                <div class="col-md-12">
                    <div>
                      <label>Email *</label>
                      <input v-model="model.email" type="email" @keyup.enter="login"/>
                    </div>
                    <div>
                      <label>Password *</label>
                      <input v-model="model.password" type="password" @keyup.enter="login"/>
                    </div>
                </div>
              </div>
              <div class="row submit">
                <div class="col-md-12">
                  <p v-if="model.error" class="error">Incorrect Email/Password Combination</p>
                  <button v-on:click="login" data-button="login">
                      <span v-if="!model.submitting">Log In</span>
                      <div v-if="model.submitting" class="show-spinner is-loading" data-loader="circle-side"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  stats: `
    <div class="row">
      <div class="col-4 col-md-2" v-for="stat in model.stats">
        <div class="card stats" v-bind:class="stat.type">
          <div class="icon">
            <i :class="stat.icon"></i>
          </div>
          <div class="stat">
            <h3 :title="stat.value">{{ stat.value }}</h3>
            <p :title="stat.type">{{ stat.type }}</p>
          </div>
        </div>
      </div>
    </div>
  `,

  cardLibrary: `
    <div data-component="cards-library">
      <div data-page="yours" v-if="model.activeTab === 'yours'">

        <nav v-if="model.page.cards.length">
          <ul class="pagination justify-content-center" v-if="model.page.count > 1">
            <li class="page-item pagination-prev" v-bind:class="{ disabled: model.page.current == 1 }"><a class="page-link" v-on:click="previousPage">Previous</a></li>
            <li class="page-item" v-bind:class="{ active: index == model.page.current }" v-for="index in model.page.count" :key="index"><a class="page-link" v-on:click="setPage(index)">{{index}}</a></li>
            <li class="page-item pagination-next" v-bind:class="{ disabled: model.page.current == model.page.count }"><a class="page-link" v-on:click="nextPage">Next</a></li>
          </ul>
        </nav>

        <div>
          <div class="card-grid">
            <playing-card v-bind:card="card" class="asd"  v-if="model.page.cards.length && card.active" v-bind:show="true" v-for="card in model.page.cards"></playing-card>
          </div>
         
          <h4 class="no-unlocks" v-if="!model.page.cards.length">No Cards Unlocked</h4>
        </div>

        <nav v-if="model.page.cards.length">
          <ul class="pagination justify-content-center" v-if="model.page.count > 1">
            <li class="page-item pagination-prev" v-bind:class="{ disabled: model.page.current == 1 }"><a class="page-link" v-on:click="previousPage">Previous</a></li>
            <li class="page-item" v-bind:class="{ active: index == model.page.current }" v-for="index in model.page.count" :key="index"><a class="page-link" v-on:click="setPage(index)">{{index}}</a></li>
            <li class="page-item pagination-next" v-bind:class="{ disabled: model.page.current == model.page.count }"><a class="page-link" v-on:click="nextPage">Next</a></li>
          </ul>
        </nav>
      </div>

      <div data-page="normal" v-if="model.activeTab === 'normal'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards.normal"></playing-card>
        </div>
      </div>

      <div data-page="legendary" v-if="model.activeTab === 'legendary'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards.legendary"></playing-card>
        </div>
      </div>

      <div data-page="ultras" v-if="model.activeTab === 'ultras'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards.ultra"></playing-card>
        </div>
      </div>

      <div data-page="ultimates" v-if="model.activeTab === 'ultimates'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards.ultimate"></playing-card>
        </div>
      </div>

      <div data-page="favorites" v-if="model.activeTab === 'favorites'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="true" v-for="card in model.cards.favorites"></playing-card>
        </div>
      </div>

      <div data-page="bone_cards" v-if="model.activeTab === 'bone_cards'">
        <div class="card-grid">
          <special-card v-bind:card="card" v-bind:show="true" v-for="card in model.cards.special_bone"></special-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.special_bone.length">No Bone Cards Available</h4>
      </div>

      <div data-page="ascension_cards" v-if="model.activeTab === 'ascension_cards'">
        <div class="card-grid">
          <special-card v-bind:card="card" v-bind:show="true" v-for="card in model.cards.ascension"></special-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.ascension.length">No Ascension Cards Available</h4>
      </div>

      <div data-page="variants" v-if="model.activeTab === 'variants'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards.variant" :key="card.cardNumber"></playing-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.variant.length">No Variant Cards Available</h4>
      </div>

      <div data-page="variant_cards" v-if="model.activeTab === 'variant_cards'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="true" v-for="card in model.cards.variant_user" :key="card.cardNumber"></playing-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.variant_user.length">No Variant Cards Available</h4>
      </div>

      <div data-page="delta_cards" v-if="model.activeTab === 'delta_cards'">
        <div class="card-grid">
          <special-card v-bind:card="card" v-bind:show="true" v-for="card in model.cards.delta_cards" :key="card.id"></special-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.delta_cards.length">No Delta Cards Available</h4>
      </div>

      <div data-page="delta" v-if="model.activeTab === 'delta'">
        <div class="card-grid">
          <special-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards.delta" :key="card.id"></special-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.delta.length">No Delta Cards Available</h4>
      </div>

      <div data-page="exotic_cards" v-if="model.activeTab === 'exotic_cards'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards.exotic"></playing-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.exotic.length">No Exotic Cards Available</h4>
      </div>

      <div data-page="exotic" v-if="model.activeTab === 'exotic'">
        <div class="card-grid">
          <playing-card v-bind:card="card" v-bind:show="true" v-for="card in model.cards.exotic_cards"></playing-card>
        </div>
        <h4 class="no-unlocks" v-if="!model.cards.exotic_cards.length">No Exotic Cards Available</h4>
      </div>

      <div data-page="legacy" v-if="model.activeTab === 'legacy'">
        <div v-if="model.legacyPage.isLoading" class="loading-state">
          <p>Loading legacy cards...</p>
        </div>
        <div v-if="!model.legacyPage.isLoading && model.cards.legacy && model.cards.legacy.length > 0">
          <nav v-if="model.legacyPage.count > 1">
            <ul class="pagination justify-content-center">
              <li class="page-item pagination-prev" v-bind:class="{ disabled: model.legacyPage.current == 1 }"><a class="page-link" v-on:click="previousPageLegacy">Previous</a></li>
              <li class="page-item" v-bind:class="{ active: index == model.legacyPage.current }" v-for="index in model.legacyPage.count" :key="'legacy-' + index"><a class="page-link" v-on:click="setPageLegacy(index)">{{index}}</a></li>
              <li class="page-item pagination-next" v-bind:class="{ disabled: model.legacyPage.current == model.legacyPage.count }"><a class="page-link" v-on:click="nextPageLegacy">Next</a></li>
            </ul>
          </nav>
          <div class="card-grid">
            <component
              v-for="card in model.cards.legacy"
              :key="card.id"
              :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
              :card="card"
              :show="true"
            ></component>
          </div>
          <nav v-if="model.legacyPage.count > 1">
            <ul class="pagination justify-content-center">
              <li class="page-item pagination-prev" v-bind:class="{ disabled: model.legacyPage.current == 1 }"><a class="page-link" v-on:click="previousPageLegacy">Previous</a></li>
              <li class="page-item" v-bind:class="{ active: index == model.legacyPage.current }" v-for="index in model.legacyPage.count" :key="'legacy-' + index"><a class="page-link" v-on:click="setPageLegacy(index)">{{index}}</a></li>
              <li class="page-item pagination-next" v-bind:class="{ disabled: model.legacyPage.current == model.legacyPage.count }"><a class="page-link" v-on:click="nextPageLegacy">Next</a></li>
            </ul>
          </nav>
        </div>
        <h4 class="no-unlocks" v-if="!model.legacyPage.isLoading && (!model.cards.legacy || model.cards.legacy.length === 0)">No Legacy Cards Available</h4>
      </div>

      <div class="view-card"><div></div></div>
    </div>
  `,

  viewerMedals: `
   
    <div data-component="viewer-medals">
      <div v-if="model.medals.length" v-for="medal in model.medals" class="medal" :data-id="medal.id">
        <div>
          <img :src="medal.image">
        </div>
        <p :title="medal.name">{{ medal.name }}</p>
        <p :title="medal.description" class="description">{{ medal.description }}</p>
        <p>Unlocked: {{ medal.count }}</p>
      </div>
      <h4 class="no-unlocks" v-if="!model.medals.length">No Achievements Unlocked</h4>

      <div class="view-element"><div></div></div>
    </div>
  `,

  viewerKeys: `
    <div data-component="viewer-keys">
      <div v-if="model.keys.length" v-for="key in model.keys" class="key" :data-id="key.id">
        <div>
          <img :src="key.image">
        </div>
        <p :title="key.name">{{ key.name }}</p>
        <p :title="key.description" class="description">{{ key.description }}</p>
        <p>Uses: {{ key.uses }}</p>
        <p class="bold">Key ID: #{{ key.keyNumber }}</p>
      </div>
      <h4 class="no-unlocks" v-if="!model.keys.length">No Keys Unlocked</h4>

      <div class="view-element"><div></div></div>
    </div>
  `,

  dogTags: `
    <div data-component="dog-tags">
      <div v-if="model.tags.length" class="dogtag-container">
        <div v-for="tag in model.tags" class="dogtag">
          <div class="information">  
            <p class="name" :title="tag.twitchDisplayName">{{ tag.twitchDisplayName }}</p>
          </div>
        </div>
      </div>
      <h4 class="no-unlocks" v-if="!model.tags.length">No Dog Tags</h4>
    </div>
  `,

  battleHelper: `
    <div data-component="battle-helper" v-bind:class="{ 'is-open': model.open }">
      <h4 v-on:click="open()">Battle Helper <button v-bind:class="{ 'is-open': model.open }"><i class="bi-arrow-down-square"></i></button></h4>
      <p>1. Choose the battle command type.</p>
      <p>2. Enter the Twitch display name of the users you want to battle.</p>
      <!--<p>3. Ctrl+click or press and hold on the cards you would like to use in the battle. Select at least <strong>{{model.counts.min}}</strong> cards to battle and a max of <strong>{{model.counts.max}}</strong>.</p>-->
      <p>3. Select a team, Ctrl+click or press and hold on the cards you would like to use in the battle. Select <strong>{{model.counts.min}}</strong> cards to battle with.</p>
      <div class="count">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Cards Selected: {{ model.battle.count }}</label>
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Command Type: Are you challenging a user or accepting a challenge?">Command Type <i class="bi-info-circle"></i></label>
        <select class="form-select" v-model="model.battle.action" @change="generateCommand">
          <option value="challenge">Challenge</option>
          <option value="accept">Accept</option>
        </select>
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Twitch Display Name: Enter the users display name you would like to challenge.">Twitch Display Name <i class="bi-info-circle"></i></label>
        <input class="form-control search" v-model="model.battle.displayName" v-on:keyup="generateCommand()" type="text">
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Your Teams: Select one of your team of cards?">Your Teams <i class="bi-info-circle"></i></label>
        <select class="form-select" v-model="model.battle.team" v-on:change="selectTeam">
          <option value="">Select Team</option>
          <option v-for="team in model.battle.teams" :value="team">{{ team.name }}</option>
        </select>
      </div>
      <div class="command" v-bind:class="{ enabled: model.battle.enabled }">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Enter the users display name you would like to challenge.">Your Command</label>
        <textarea id="command" readonly class="form-control">{{ model.battle.command }}</textarea>
      </div>
      <button type="button" data-button="copy" v-on:click="copyCommand()" v-bind:class="{ 'is-disabled': !model.battle.enabled }"><i class="bi-clipboard-plus"></i> Copy</button>
      <p class="info">Copy and paste this command into SGTWoofy's stream chat.</p>

      <div class="teams">
        <p>4. Save this team to reuse the group of cards again.</p>
        <div v-bind:class="{ 'is-disabled': model.battle.cards.length != 4 }">
          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name: Set a unique name for this team of cards.">Team Name <i class="bi-info-circle"></i></label>
          <input class="form-control" v-model="model.battle.teamName" v-on:keyup="cleanName" type="text">

        </div>
        <button type="button" data-button="save" v-on:click="saveTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }"><i class="bi-save2"></i> Save Team</button>
        <button type="button" data-button="delete" v-on:click="deleteTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }"><i class="bi-trash"></i> Delete Team</button>
        <br>
       
        <p class="info">You update the name or cards of any team by selecting it and saving your changes.</p>
      </div>
    </div>
  `,

  visibilitySettings: `
    <div data-component="visibility-settings" v-bind:class="{ 'is-open': model.isPanelOpen }">
      <h4 v-on:click="togglePanel()">
        Content Visibility
        <button v-bind:class="{ 'is-open': model.isPanelOpen }">
          <i class="bi-arrow-down-square"></i>
        </button>
      </h4>

      <div v-if="model.isPanelOpen" class="visibility-settings-panel">
        <!-- Battle Visibility Section -->
        <div class="visibility-section">
          <h4>Battle Visibility</h4>
          <p class="visibility-description">Control which battles you see</p>

          <div class="visibility-options">
            <label class="visibility-option">
              <input
                type="radio"
                v-model="model.battleVisibility"
                value="all"
              >
              <span class="option-label">
                <strong>Show All Battles</strong>
                <small>See every battle happening on stream</small>
              </span>
            </label>

            <label class="visibility-option">
              <input
                type="radio"
                v-model="model.battleVisibility"
                value="own"
              >
              <span class="option-label">
                <strong>Show Only My Battles</strong>
                <small>See only battles you're involved in</small>
              </span>
            </label>

            <label class="visibility-option">
              <input
                type="radio"
                v-model="model.battleVisibility"
                value="none"
              >
              <span class="option-label">
                <strong>Hide All Battles</strong>
                <small>No battles are shown</small>
              </span>
            </label>
          </div>
        </div>

        <!-- Pack Opening Visibility Section -->
        <div class="visibility-section">
          <h4>Card Pack Opening Visibility</h4>
          <p class="visibility-description">Control which pack openings you see</p>

          <div class="visibility-options">
            <label class="visibility-option">
              <input
                type="radio"
                v-model="model.packVisibility"
                value="all"
              >
              <span class="option-label">
                <strong>Show All Pack Openings</strong>
                <small>See all pack openings from all players</small>
              </span>
            </label>

            <label class="visibility-option">
              <input
                type="radio"
                v-model="model.packVisibility"
                value="own"
              >
              <span class="option-label">
                <strong>Show Only My Pack Openings</strong>
                <small>See only your own pack openings</small>
              </span>
            </label>

            <label class="visibility-option">
              <input
                type="radio"
                v-model="model.packVisibility"
                value="none"
              >
              <span class="option-label">
                <strong>Hide All Pack Openings</strong>
                <small>No pack openings are shown</small>
              </span>
            </label>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="visibility-actions">
          <button @click="saveSettings" class="save-btn">
            <i class="bi-check-circle"></i> Save
          </button>
          <button @click="resetSettings" class="reset-btn">
            <i class="bi-arrow-clockwise"></i> Reset
          </button>
        </div>

        <!-- Save Confirmation Message -->
        <div v-if="model.showSaveConfirmation" class="visibility-confirmation">
          <i class="bi-check-circle-fill"></i> Settings saved!
        </div>
      </div>

      <!-- Summary Display -->
      <div v-if="!model.isPanelOpen" class="visibility-summary">
        <span>Battles: {{ formatMode(model.battleVisibility) }}</span>
        <span>Packs: {{ formatMode(model.packVisibility) }}</span>
      </div>
    </div>
  `,

  themeSwitch: `
    <div data-component="theme-switch">
      <div class="row">
        <div class="col-7 col-lg-4">
          <h4>Theme</h4>
        </div>
        <div class="col-2 col-lg-3">
          Light
        </div>
        <div class="col-1 col-lg-2">
          <div class="form-check form-switch">
            <input v-model="model.theme" type="checkbox" class="form-check-input" @change="save()">
          </div>
        </div>
        <div class="col-2 col-lg-3">
          Dark
        </div>
      </div>
    </div>
  `,

hqBot: `
  <div data-component="hq-bot">

    <!-- Landscape-required overlay — shown via CSS when width < 768px or portrait -->
    <div class="portrait-required-notice">
      <div class="portrait-notice-icon">&#8635;</div>
      <p class="portrait-notice-text">ROTATE TO LANDSCAPE</p>
      <p class="portrait-notice-sub">Battle requires landscape orientation on a wider screen</p>
    </div>

    <section>
      <div class="col-12">

            <!-- ── Futuristic Header ── -->
            <div class="header" v-if="!model.prepareBattle">
              <div class="bot-title-wrapper">
                <span class="bot-sys-tag">&#9654; SYS.AI</span>
                <h4 class="bot-title">COMBAT PROTOCOL</h4>
                <span class="bot-status-tag">&#9711; ONLINE</span>
              </div>
              <p class="bot-subtitle">SELECT DIFFICULTY TIER</p>
            </div>

            <!-- ── Tier Selection ── -->
            <div class="grid-container-bot" v-if="!model.prepareBattle">

              <!-- STANDARD -->
              <div class="grid-item standard" v-bind:class="{'show': model.standard, 'is-disabled': model.settings.botstandard.value > model.userLevel || !model.standard}">
                <div class="tier-header">
                  <span class="tier-code">T-01</span>
                  <h4>Standard</h4>
                  <span class="tier-badge standard-badge">&#9650;</span>
                </div>
                <div class="tier-data-row">
                  <div class="data-stat"><span class="data-key">THREAT</span><span class="data-val">LOW</span></div>
                  <div class="data-stat"><span class="data-key">DECK</span><span class="data-val">TIER 1</span></div>
                </div>
                <div class="difficulty-info">
                  <div class="bot-card-container">
                    <div class="bot-card-scaled">
                      <div data-component="playing-card" class="playing-card-container">
                        <div class="playing-card-wrapper">
                          <div class="playing-card flipped">
                            <div class="playing-card-face playing-card-backing"></div>
                            <div data-tier="1" class="playing-card-face playing-card-front">
                              <div class="playing-card-front-frame">
                                <div class="top">
                                <div class="bottom is-hidden"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button @click="prepareBattle('standard')" class="center-button">
                  <span class="btn-icon">&#9658;</span>{{ model.botMode == 'standard' ? 'SELECTED' : 'ENGAGE' }}
                </button>
              </div>

              <!-- ULTRA -->
              <div class="grid-item ultra" v-bind:class="{'show': model.ultra, 'is-disabled': model.settings.botultra.value > model.userLevel || !model.ultra}">
                <div class="tier-header">
                  <span class="tier-code">T-02</span>
                  <h4>Ultra</h4>
                  <span class="tier-badge ultra-badge">&#9670;</span>
                </div>
                <div class="tier-data-row">
                  <div class="data-stat"><span class="data-key">THREAT</span><span class="data-val">HIGH</span></div>
                  <div class="data-stat"><span class="data-key">DECK</span><span class="data-val">TIER 2</span></div>
                </div>
                <div class="difficulty-info">
                  <div class="bot-card-container">
                    <div class="bot-card-scaled">
                      <div data-component="playing-card" class="playing-card-container">
                        <div class="playing-card-wrapper">
                          <div class="playing-card flipped">
                            <div class="playing-card-face playing-card-backing"></div>
                            <div data-tier="2" class="playing-card-face playing-card-front">
                              <div class="playing-card-front-frame">
                                <div class="top">
                                <div class="bottom is-hidden"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button @click="prepareBattle('ultra')" class="center-button">
                  <span class="btn-icon">&#9658;</span>{{ model.botMode == 'ultra' ? 'SELECTED' : 'ENGAGE' }}
                </button>
              </div>

              <!-- LEGENDARY -->
              <div class="grid-item legendary" v-bind:class="{'show': model.legendary, 'is-disabled': model.settings.legendarybot.value > model.userLevel || !model.legendary}">
                <div class="tier-header">
                  <span class="tier-code">T-03</span>
                  <h4>Legendary</h4>
                  <span class="tier-badge legendary-badge">&#9733;</span>
                </div>
                <div class="tier-data-row">
                  <div class="data-stat"><span class="data-key">THREAT</span><span class="data-val">EXTREME</span></div>
                  <div class="data-stat"><span class="data-key">DECK</span><span class="data-val">TIER 3</span></div>
                </div>
                <div class="difficulty-info">
                  <div class="bot-card-container">
                    <div class="bot-card-scaled">
                      <div data-component="playing-card" class="playing-card-container">
                        <div class="playing-card-wrapper">
                          <div class="playing-card flipped">
                            <div class="playing-card-face playing-card-backing"></div>
                            <div data-tier="3" class="playing-card-face playing-card-front">
                              <div class="playing-card-front-frame">
                                <div class="top">
                                <div class="bottom is-hidden"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button @click="prepareBattle('legendary')" class="center-button">
                  <span class="btn-icon">&#9658;</span>{{ model.botMode == 'legendary' ? 'SELECTED' : 'ENGAGE' }}
                </button>
              </div>

            </div><!-- /grid-container-bot -->

            <!-- ── Battle Arena ── -->
            <div v-else>
              <div data-component="battle-arena" class="always-display">
                <button @click="backToMenu" class="battle-exit-btn" title="Exit Battle">✕</button>
                <div id="singleMode">
                  <div class="content">
                    <div class="arena" v-bind:class="{ show: model.show.cards }">
                      <div class="arena-row">
                        <div class="cards-side cards-left cards-1">
                          <div class="card-stack">
                            <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards1"></playing-card>
                          </div>
                        </div>
                        <div class="log-panel log" v-bind:class="{ show: model.show.logs }">
                          <div class="log-title">Battle Log</div>
                          <div v-for="log in model.logs" class="log-entry" :class="['log-' + log.type, log.tier ? 'tier-' + log.tier : '', log.tier === 1 ? 'tier-prime' : '', log.tier === 2 ? 'tier-ultra' : '', log.tier === 3 ? 'tier-legendary' : '']">
                            <div class="log-message">{{ log.message }}</div>
                            <div v-if="log.type === 'attack' && log.meta" class="log-details">
                              <span v-if="log.meta.physicalDamage > 0" class="damage-physical">
                                ⚔️ {{ log.meta.physicalDamage }} ({{ log.meta.pAtk }}-{{ log.meta.armor }})
                              </span>
                              <span v-if="log.meta.magicDamage > 0" class="damage-magic">
                                ✨ {{ log.meta.magicDamage }} ({{ log.meta.mAtk }}-{{ log.meta.ward }})
                              </span>
                              <span v-if="log.meta.critical" class="damage-critical">💥 CRIT!</span>
                            </div>
                          </div>
                        </div>
                        <div class="cards-side cards-right cards-2">
                          <div class="card-stack">
                            <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.cards2"></playing-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="winner" v-bind:class="{ show: model.show.winner }">
                    <button @click="backToMenu" class="bot-overlay-close" title="Cancel">&#10005;</button>
                    <div v-if="model.teamSelectMode">
                      <h3 class="bot-select-team-title">&#10022; SELECT TEAM &#10022;</h3>
                      <div>
                        <select class="form-select mb-6 bot-team-select" v-model="model.team" @change="selectTeam(model.team.cards)">
                          <option v-for="team in model.teams" :value="team">{{ team.name }}</option>
                        </select>
                        <div v-if="model.battle.team" class="row">
                          <div class="bot-teamcards-grid" :style="gridStyle">
                            <div class="bot-grid-item" v-for="(card, cardIndex) in model.battle.team" :key="'random-' + cardIndex">
                              <div class="bot-team-scaled">
                                <playing-card
                                  :card="card"
                                  :show="true"
                                  :class="card.name">
                                </playing-card>
                              </div>
                            </div>
                          </div>
                          <div class="bot-battle-actions">
                            <button @click="startBotBattle" class="center-button battle-start-btn">&#9889; INITIATE BATTLE</button>
                            <button @click="backToMenu" class="center-button back-btn">&#8592; BACK</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="winner-user"></div>
                      <div class="result-message"></div>
                      <button @click="backToMenu" class="center-button back-btn">&#8592; BACK TO MENU</button>
                    </div>
                  </div>
                </div>
              </div>
            </div><!-- /v-else battle arena -->

          </div>
    </section>
  </div>
`,

hqStore: `
  <div data-component="hq-store">
      <!-- Store Packs Section -->
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="header">
                <h4>Store</h4>
              </div>

              <div class="store-pack-grid">
                <div class="pack-card" v-if="store.tier < 2" :id="store.id" v-for="store in model.stores">
                  <div class="pack-image store-pack-image">
                    <img v-if="store.image" :src="\`\${root}\${store.image}\`" :alt="store.name" class="store-item-img">
                    <div v-else class="pack-emoji">🎴</div>
                  </div>
                  <div class="store-pack-info">
                    <h2 class="store-pack-name">{{ store.name }}</h2>
                    <p>Remaining Time: </p>
                    <div class="pack-cooldown">
                      <span class="clock-icon">?</span>
                      <span class="cooldown-time">{{ formatTime(store.cooldown) === '0:00' ? 'Available now' : formatTime(store.cooldown) }}</span>
                    </div>
                    <p class="pack-description">{{ store.description }}</p>
                    <button class="buy-button" @click="buy(store)" :class="{activated: store.usertier >= store.tier || store.tier > 1}">
                      <div v-if="store.usertier > store.tier">ACTIVE</div>
                      <div v-else-if="store.tier > 1">INACTIVE</div>
                      <div v-else>Buy <i class="bi bi-currency-dollar"></i>{{ store.price }}</div>
                    </button>
                  </div>
                </div>
                <div class="pack-card" :id="frame.id" v-for="frame in barksFrameItems" :key="frame.id" :class="{ 'locked-item': !frame.is_claimed && frame.required_level > 0 && model.userLevel < frame.required_level, 'claimed-item': frame.is_claimed }">
                  <div class="pack-image">
                    <img v-if="frame.frame_image_url" :src="frame.image" :alt="frame.frame_name" style="width: 100%; object-fit: contain;">
                    <div v-else class="pack-emoji">🖼️</div>
                    <div v-if="frame.is_claimed" class="claimed-badge">
                      <i class="bi bi-check-circle-fill"></i>
                      <span>Owned</span>
                    </div>
                    <div v-else-if="frame.required_level > 0 && model.userLevel < frame.required_level" class="level-lock-overlay">
                      <i class="bi bi-lock-fill"></i>
                      <span>Level {{ frame.required_level }}</span>
                    </div>
                  </div>
                  <div class="store-pack-info">
                    <h2 class="store-pack-name">{{ frame.frame_name || frame.reward_name }}</h2>
                    <p class="pack-description">{{ frame.frame_description || frame.description }}</p>
                    <p v-if="frame.required_level > 0 && !frame.is_claimed" class="level-requirement">
                      <i class="bi bi-star-fill"></i> Level {{ frame.required_level }} Required
                    </p>
                    <button class="buy-button" @click="buyFrame(frame)" :disabled="frame.is_claimed || (frame.required_level > 0 && model.userLevel < frame.required_level)" :class="{ 'locked': !frame.is_claimed && frame.required_level > 0 && model.userLevel < frame.required_level, 'claimed': frame.is_claimed }">
                      <span v-if="frame.is_claimed">
                        <i class="bi bi-check-circle-fill"></i> Owned
                      </span>
                      <span v-else-if="frame.required_level > 0 && model.userLevel < frame.required_level">
                        <i class="bi bi-lock-fill"></i> Locked
                      </span>
                      <span v-else>
                        Buy 🪙 {{ frame.currency_amount }}
                      </span>
                    </button>
                  </div>
                </div>
                
                <div class="pack-card" :id="bg.id" v-for="bg in barksBackgroundItems" :key="bg.id" :class="{ 'locked-item': !bg.is_claimed && bg.required_level > 0 && model.userLevel < bg.required_level, 'claimed-item': bg.is_claimed }">
                  <div class="pack-image">
                    <img v-if="bg.background_image_url" :src="bg.image" :alt="bg.background_name" style="width: 100%; object-fit: contain;">
                    <div v-else class="pack-emoji">🌄</div>
                    <div v-if="bg.is_claimed" class="claimed-badge">
                      <i class="bi bi-check-circle-fill"></i>
                      <span>Owned</span>
                    </div>
                    <div v-else-if="bg.required_level > 0 && model.userLevel < bg.required_level" class="level-lock-overlay">
                      <i class="bi bi-lock-fill"></i>
                      <span>Level {{ bg.required_level }}</span>
                    </div>
                  </div>
                  <div class="store-pack-info">
                    <h2 class="store-pack-name">{{ bg.background_name || bg.reward_name }}</h2>
                    <p class="pack-description">{{ bg.background_description || bg.description }}</p>
                    <p v-if="bg.required_level > 0 && !bg.is_claimed" class="level-requirement">
                      <i class="bi bi-star-fill"></i> Level {{ bg.required_level }} Required
                    </p>
                    <button class="buy-button" @click="buyBackground(bg)" :disabled="bg.is_claimed || (bg.required_level > 0 && model.userLevel < bg.required_level)" :class="{ 'locked': !bg.is_claimed && bg.required_level > 0 && model.userLevel < bg.required_level, 'claimed': bg.is_claimed }">
                      <span v-if="bg.is_claimed">
                        <i class="bi bi-check-circle-fill"></i> Owned
                      </span>
                      <span v-else-if="bg.required_level > 0 && model.userLevel < bg.required_level">
                        <i class="bi bi-lock-fill"></i> Locked
                      </span>
                      <span v-else>
                        Buy 🪙 {{ bg.currency_amount }}
                      </span>
                    </button>
                  </div>
                </div>

                <div class="pack-card" :id="backing.id" v-for="backing in barksBackingItems" :key="backing.id" :class="{ 'claimed-item': backing.is_claimed }">
                  <div class="pack-image">
                    <img :src="\`\${root}/images/card-backs/\${backing.id}.png\`" :alt="backing.name" style="width: 110px; heihgt: 250px; object-fit: contain;" @error="$event.target.style.display='none'">
                    <div v-if="backing.is_claimed" class="claimed-badge">
                      <i class="bi bi-check-circle-fill"></i>
                      <span>Owned</span>
                    </div>
                  </div>
                  <div class="store-pack-info">
                    <h2 class="store-pack-name">{{ backing.name }}</h2>
                    <span class="card-back-rarity-badge" :class="'rarity-' + backing.rarity">{{ backing.rarity }}</span>
                    <p class="pack-description">{{ backing.description }}</p>
                    <button class="buy-button" @click="buyBacking(backing)" :disabled="backing.is_claimed" :class="{ 'claimed': backing.is_claimed }">
                      <span v-if="backing.is_claimed">
                        <i class="bi bi-check-circle-fill"></i> Owned
                      </span>
                      <span v-else>
                        Buy 🪙 {{ backing.point_cost }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

  </div>
`,

hqOpenPack: `
  <div data-component="hq-open-pack">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h1>Open Pack Queue</h1>
                <p>Open your packs and discover amazing cards</p>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <HQunlockQueue></HQunlockQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>
  </div>
`,


hqCardManagement: `
<div data-component="card-management">
     <div class="tabs">
            <div class="tab-list">
                <button class="hq-tab-item" v-bind:class="{ active: model.tab == 'tab1'}" @click="showTab('tab1')">Team Stats</button>
                <button class="hq-tab-item" v-bind:class="{ active: model.tab == 'tab2'}" @click="showTab('tab2')">Inventory</button>
            </div>
      </div>

      <!-- Tab Content -->
          <div id="tab1" class="stats-section  tab" v-bind:class="{ active: model.tab == 'tab1'}">
                   <div class="drop-area" id="team-drop-area" @dragover.prevent="onDragOver" @drop="onDrop">
                        <div class="drop-placeholder remove_me">Drag cards here to build your team</div>
                        <div class="card-grid" :style="gridStyle">
                          <playing-card v-bind:card="card" class="custom-class hq-select" v-for="card in model.battle.cards"></playing-card>
                        </div>
                    </div>

                    <div class="team-stats-collapsible">
                      <button class="team-stats-toggle" @click="toggleStats()">
                        <span>Team Stats</span>
                        <span class="team-stats-badge" v-if="teamType" :class="teamType.toLowerCase()">{{ teamType }}</span>
                        <i class="bi" :class="model.statsOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                      </button>
                      <div class="team-stats-body" v-show="model.statsOpen">
                        <div class="team-stats-grid">
                          <div class="team-stat-row"><span class="team-stat-label">Phys ATK</span><span class="team-stat-value">{{model.stats.total_patk}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Mag ATK</span><span class="team-stat-value">{{model.stats.total_matk}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Armor</span><span class="team-stat-value">{{model.stats.total_armor}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Ward</span><span class="team-stat-value">{{model.stats.total_ward}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Accuracy</span><span class="team-stat-value">{{model.stats.total_acc}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Speed</span><span class="team-stat-value">{{model.stats.total_spd}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">HP</span><span class="team-stat-value">{{model.stats.total_hp}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Crit Chance</span><span class="team-stat-value">{{model.stats.total_crit_chance}}%</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Crit DMG</span><span class="team-stat-value">{{model.stats.total_crit_dmg}}%</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Stamina</span><span class="team-stat-value">{{model.stats.total_stamina}}</span></div>
                          <div class="team-stat-row"><span class="team-stat-label">Mana</span><span class="team-stat-value">{{model.stats.total_mana}}</span></div>
                        </div>
                      </div>
                    </div>
                <!--<div class="drop-area content-center" @dragover.prevent="onDragOver" @drop="onDrop">  
                  <div class="overflow-y-scroll h-screen">
                      <h1 class="text-center remove_me"> drag cards here</h1>
                      <playing-card v-bind:card="card" class="custom-class hq-select" v-for="card in model.battle.cards"></playing-card>
                  </div>-->
            </div>
            
          <div id="tab2" class="tab" v-bind:class="{ active: model.tab == 'tab2'}">
          
                   <div class="chamber-bg" v-if="model.chamber.open">
                      <div class="stats-header">
                          <div class="ascension-stat-item">
                              Ascension: <span class="ascension-stat-value">1</span>
                          </div>
                          <div class="ascension-stat-item">
                              Prime Card: <span class="ascension-stat-value">{{model.chamber.count}}</span>
                          </div>
                      </div>
                      <div class="drop-area" @dragover.prevent="chamberDragOver" @drop="chamberDrop">
                        <div class="card-grid">
                            <special-card v-bind:card="card" class="custom-class ascension-card" v-for="card in model.chamber.ascensionCard"></special-card>
                            <playing-card v-bind:card="card" class="custom-class chamber-select" v-for="card in model.chamber.cards"></playing-card>
                            <div class="playing-card-box ascension playing-card-container " v-for="index in model.chamber.total_ascension"></div>
                            <div class="playing-card-box playing-card-container" v-for="index in model.chamber.count"> </div>
                        </div>
                      </div>
                  </div>

                  <div class="chamber-bg exalted-chamber-bg" v-else-if="model.exaltedChamber.open">
                    <button class="close-button" @click="closeExaltedChamber">X</button>
                    <div class="stats-header exalted-stats-header">
                      <div class="exalted-stat-item exalted-main-stat">
                        <span class="exalted-stat-label">Level 100 Card</span>
                        <span class="exalted-stat-value">{{ model.exaltedChamber.mainCard ? '✓' : '0 / 1' }}</span>
                      </div>
                      <div class="exalted-stat-item exalted-prime-stat">
                        <span class="exalted-stat-label">Prime</span>
                        <span class="exalted-stat-value">{{ model.exaltedChamber.primeCard ? '✓' : '0 / 1' }}</span>
                      </div>
                      <div class="exalted-stat-item exalted-ultra-stat">
                        <span class="exalted-stat-label">Ultra</span>
                        <span class="exalted-stat-value">{{ model.exaltedChamber.ultraCard ? '✓' : '0 / 1' }}</span>
                      </div>
                      <div class="exalted-stat-item exalted-legendary-stat">
                        <span class="exalted-stat-label">Legendary</span>
                        <span class="exalted-stat-value">{{ model.exaltedChamber.legendaryCard ? '✓' : '0 / 1' }}</span>
                      </div>
                    </div>

                    <div class="exalted-drop-area">
                        <div class="exalted-slot exalted-slot-main" @dragover.prevent="exaltedDragOver" @drop="exaltedDropMain">
                            <div class="exalted-slot-label">
                                <span class="slot-name">Main Card</span>
                                <span class="slot-tier">Tier 3 — Legendary</span>
                            </div>
                            <playing-card v-if="model.exaltedChamber.mainCard" v-bind:card="model.exaltedChamber.mainCard" class="custom-class chamber-select"></playing-card>
                            <div v-else class="playing-card-box playing-card-container exalted-placeholder"></div>
                        </div>
                        <div class="exalted-slot exalted-slot-prime" @dragover.prevent="exaltedDragOver" @drop="exaltedDropSacrifice($event, 1)">
                            <div class="exalted-slot-label">
                                <span class="slot-name">Sacrifice</span>
                                <span class="slot-tier">Tier 1 — Prime</span>
                            </div>
                            <playing-card v-if="model.exaltedChamber.primeCard" v-bind:card="model.exaltedChamber.primeCard" class="custom-class chamber-select"></playing-card>
                            <div v-else class="playing-card-box playing-card-container exalted-placeholder exalted-placeholder-prime"></div>
                        </div>
                        <div class="exalted-slot exalted-slot-ultra" @dragover.prevent="exaltedDragOver" @drop="exaltedDropSacrifice($event, 2)">
                            <div class="exalted-slot-label">
                                <span class="slot-name">Sacrifice</span>
                                <span class="slot-tier">Tier 2 — Ultra</span>
                            </div>
                            <playing-card v-if="model.exaltedChamber.ultraCard" v-bind:card="model.exaltedChamber.ultraCard" class="custom-class chamber-select"></playing-card>
                            <div v-else class="playing-card-box playing-card-container exalted-placeholder exalted-placeholder-ultra"></div>
                        </div>
                        <div class="exalted-slot exalted-slot-legendary" @dragover.prevent="exaltedDragOver" @drop="exaltedDropSacrifice($event, 3)">
                            <div class="exalted-slot-label">
                                <span class="slot-name">Sacrifice</span>
                                <span class="slot-tier">Tier 3 — Legendary</span>
                            </div>
                            <playing-card v-if="model.exaltedChamber.legendaryCard" v-bind:card="model.exaltedChamber.legendaryCard" class="custom-class chamber-select"></playing-card>
                            <div v-else class="playing-card-box playing-card-container exalted-placeholder exalted-placeholder-legendary"></div>
                        </div>
                      </div>
                  </div>
                  <div v-else>
                  <div class="inventory-scroll-wrapper">
                  <div class="inventory-drop-area">
                     <div class="grid-container">
                       <user-inventory :key="model.inventoryKey" v-bind:inventory="inventory" v-for="inventory in model.inventory" :sounds="model.audio"></user-inventory>

                       <!-- Exclusive Cards Section -->
                       <div v-if="model.exclusiveCards.length > 0" class="exclusive-cards-section">
                         <div class="exclusive-header">
                           <h3>🎴 Exclusive Streamer Cards</h3>
                         </div>
                         <div class="exclusive-cards-grid">
                           <div v-for="card in model.exclusiveCards" :key="card.id" class="exclusive-card-item" :title="card.name">
                             <component
                               :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
                               :card="card"
                               :show="false"
                               class="custom-class exclusive-card"
                             ></component>
                             <div class="exclusive-badge">Exclusive</div>
                             <div v-if="card.tier" class="tier-badge" :class="'tier-' + card.tier">Tier {{ card.tier }}</div>
                           </div>
                         </div>
                       </div>


                        <div class="dump dumps" id="dump2"  @dragover.prevent @drop="dumpCard($event)" >
                            <button class="close-button" @click="closeDump">X</button>
                            <h2>Dump Cards</h2>
                             <component
                                v-for="card in model.dump.dumpCards"
                                :key="card.id"
                                :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
                                :card="card"
                                :show="'false'"
                                class="custom-class dump-remove"
                              ></component>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>

            <div class="exalted-reveal-overlay" v-if="model.exaltedReveal" @click="closeExaltedReveal">
              <div class="exalted-reveal-card">
                <playing-card :card="model.exaltedReveal" :show="true"></playing-card>
                <p class="exalted-reveal-label">Exalted</p>
                <p class="exalted-reveal-dismiss">Tap to dismiss</p>
              </div>
            </div>

            <div class="forge-card">
                <special-card v-bind:card="model.bone_card" class="blind_card"></special-card>
            </div>
            <div class="ascension-chamber">
                <playing-card v-bind:card="model.ascension_chamber_card" class="asc"></playing-card>
            </div>
            <!--<div class="packs-reward">
              <playing-card class="pulse pack-reward" :class="model.pack.name" v-bind:card="model.card" v-bind:show="'true'"></playing-card>
            </div>-->
            <div class="reward-modal">
              
                
                <div class="reward-modal-content">
                <img :src="\`\${root}/images/sgt-woofy-logo-200.png\`" alt="Logo" class="center-logo" />

                <rewards-claim
                  :rewards="{
                    otherRewards: model.chestRewards,
                    userCards: model.userCards,
                    userPacks: model.userPacks,
                    frameDrops: model.frameDrops,
                    backgroundDrops: model.backgroundDrops,
                    rewardCount: model.rewardCount
                  }"
                  :barks-image-url="\`\${root}/images/coin-sample.png\`"
                />
                </div>
              
            </div>
      </div>
      </div>

      
</div>
`,


teamDrawer: `
  <div data-component="team-drawer">
    <div class="drawer-overlay" v-if="isOpen" @click.self="closeDrawer">
      <div class="drawer is-open" ref="drawer">
        <div class="drawer-content">

          <!-- Mode Toggle Tabs -->
          <div class="drawer-mode-toggles">
            <button
              type="button"
              @click="switchMode('current')"
              class="drawer-mode-btn"
              :class="{ active: model.mode === 'current' }">
              <span class="mode-checkbox" :class="{ checked: model.mode === 'current' }"></span>
              Current Season
            </button>
            <button
              type="button"
              @click="switchMode('legacy')"
              class="drawer-mode-btn"
              :class="{ active: model.mode === 'legacy' }">
              <span class="mode-checkbox" :class="{ checked: model.mode === 'legacy' }"></span>
              Legacy Teams
            </button>
          </div>

          <!-- Team Select -->
          <div class="drawer-section">
            <select class="drawer-select" v-model="model.battle.team" v-on:change="selectTeam">
              <option value="">Select Team</option>
              <option v-for="team in model.battle.teams" :value="team">{{ team.name }}</option>
            </select>
          </div>

          <!-- Card Backing -->
          <div class="drawer-section drawer-backing-section" v-if="model.battle.team">
            <div class="drawer-backing-label">
              <i class="bi bi-layers"></i> Card Backing
              <span v-if="model.teamBacking" class="drawer-backing-active-name">{{ model.teamBacking.name }}</span>
              <span v-else class="drawer-backing-active-name">Default</span>
            </div>
            <div class="drawer-backing-grid">
              <!-- Default / none option -->
              <div
                class="drawer-backing-item"
                :class="{ 'is-selected': !model.teamBacking }"
                @click="equipTeamBacking(null)"
                title="Default">
                <div class="drawer-backing-thumb drawer-backing-default">
                  <i class="bi bi-x-lg"></i>
                </div>
                <span class="drawer-backing-item-name">Default</span>
              </div>
              <!-- Owned backings -->
              <div
                v-for="backing in model.userBackings"
                :key="backing.id"
                class="drawer-backing-item"
                :class="{ 'is-selected': model.teamBacking && model.teamBacking.backing_id === backing.id }"
                @click="equipTeamBacking(backing)"
                :title="backing.name">
                <div class="drawer-backing-thumb">
                  <img :src="root + '/images/card-backs/' + backing.id + '.png'" :alt="backing.name" />
                </div>
                <span class="drawer-backing-item-name">{{ backing.name }}</span>
              </div>
              <!-- Empty state -->
              <div v-if="!model.userBackings.length" class="drawer-backing-empty">
                No backings owned
              </div>
            </div>
          </div>

          <!-- Team Name Input -->
          <div class="drawer-section" v-bind:class="{ 'is-disabled': !model.battle.cards.length }">
            <input class="drawer-input" v-model="model.battle.teamName" v-on:keyup="cleanName" type="text" placeholder="Team name...">
          </div>

          <!-- Action Buttons -->
          <div class="drawer-section drawer-actions">
            <button type="button" data-button="save" v-on:click="saveTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }" class="drawer-btn-save w-full">
              <i class="bi-save2"></i> {{ model.mode === 'legacy' ? 'Save Legacy Team' : 'Save' }}
            </button>
            <button type="button" class="drawer-btn-delete w-full" v-on:click="deleteTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }">
              <i class="bi-trash"></i> {{ model.mode === 'legacy' ? 'Delete Legacy Team' : 'Delete' }}
            </button>

            <!-- Legacy Battle Button -->
            <div v-if="model.mode === 'legacy'">
              <button type="button" v-on:click="startBattle()" class="play-bot w-full" v-bind:class="{ 'is-disabled': !model.battle.cards.length }">
                <i class="bi-lightning-charge"></i> Start Legacy Battle
              </button>
            </div>
            <!-- Current Season Battle Button -->
            <div v-else>
              <div v-if="model.botLoaded">
                <button type="button" v-on:click="practiceBot()" class="play-bot w-full" v-bind:class="{ 'is-disabled': !model.battle.cards.length }">
                  <i class="bi-lightning-charge"></i> Start Battle
                </button>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="drawer-footer">
            <a href="/privacy.php">Privacy</a>
          </div>

        </div>
       </div>

  </div>

  <div class="toggle-arrow" @click="toggleDrawer">
        <i v-if="!model.isOpen" class="bi bi-arrow-right"></i>
  </div>

`,

announcementDrawer: `
  <div data-component="announcement-drawer">

    <div class="announcement-overlay" :class="[model.isOpen ? 'is-above' : '', model.isOpen ? 'is-visible' : '']">
      <div class="announcement-box full">
          <div v-for="(slide, index) in model.slides" :key="index" class="mySlides image-fade" :style="{ display: index + 1 === model.slideIndex ? 'block' : 'none' }">
            <img v-if="slide.type === 'image'" :src="slide.src" alt="Announcement Image" class="overlay-image-full"  />
            <video v-if="slide.type === 'video'":src="slide.src" controls autoplay muted loop preload="metadata" playsinline style="max-width: 100%; border-radius: 12px;" class="overlay-image-full"></video>
          </div>
          
          <div class="slideshow-container">
            <a @click.prevent="plusSlides(-1)" style="position:absolute;top:50%;left:5px;cursor:pointer;color:#0ef;font-weight:bold;font-size:28px;user-select:none;z-index:10;">&#10094;</a>
            <a @click.prevent="plusSlides(1)" style="position:absolute;top:50%;right:5px;cursor:pointer;color:#0ef;font-weight:bold;font-size:28px;user-select:none;z-index:10;">&#10095;</a>
          </div>
        
             
               <div class="content-overlay" :style="overlayStyle">
                <div class="announcement-timer">⏳ {{model.timer}}</div>
                <h1 class="announcement-title" :style="titleStyle">
                  {{  model.announcement.name }}
                </h1>
                <p class="announcement-description" :style="descriptionStyle">
                  {{ model.announcement.description }}
                </p>
              </div>
             
           <div class="slider-dots">
            <span v-for="(slide, index) in model.slides" :key="index" class="dot" :class="{ active: model.slideIndex === index + 1 }" @click="currentSlide(index + 1)"></span>
          </div>
         <button type="button" data-button="copy"  @click="closeDrawer" class="announcement-button-ok"><i class="bi bi-hand-thumbs-up"></i> OK</button>
      </div>
      </div>
     

  </div>

`,
questDrawer: `
  <div data-component="quest-drawer">

    <div class="drawer-overlay quest-drawer" v-if="model.isOpen" @click.self="closeDrawer">
      <div class="drawer is-open" ref="drawer">

        <div class="drawer-header stats-user">
          <h1>Battledogs Quest</h1>
        </div>

        <div class="drawer-content main-quest">
          <user-quest :quest="quest" :activeIndex="model.activeIndex" v-bind:index="index" class="quest-list" v-for="(quest, index) in model.questReward"></user-quest>
        </div>

      </div>
    </div>

    <div class="quest-right-overlay" v-if="model.isRightOpen" @click.self="closeRightDrawer"></div>
      <div class="drawer right-drawer" :class="{ 'is-open': model.isRightOpen }" ref="rightDrawer">
        <div class="drawer-header stats-user">
          <h1>Track Quest</h1>
      
        </div>
        <div class="drawer-right-content">
          <div class="card-status-container" :class="'cards-count-' + (model.selectedQuest.cardsMatches ? Math.min(model.selectedQuest.cardsMatches.length, 3) : 0)">
           <div class="cards-container" v-for="(card,index) in model.selectedQuest.cardsMatches">
           <div class="card-visual">
                    
                  <playing-card
                    v-bind:card="{
                        ...card.card,
                        image: \`\${root}/images/cards/\${card.card.id}.png\`
                    }"
                    v-bind:show="true">
                  </playing-card>
            </div>
              <div class="tier-indicator">Tier {{card.tier}}</div>
              <div class="card-status">
                  <div class="status-item wins" v-if="model.selectedQuest.questMode === 'to_win' || model.selectedQuest.questMode === 'any'">
                      Wins: {{card.win_count}}
                  </div>
                  <div class="status-item defeats"  v-if="model.selectedQuest.questMode === 'to_defeat' || model.selectedQuest.questMode === 'any'">
                      Defeated: {{card.defeat_count}}
                  </div>
              </div>
            </div>
          </div>
        </div>
    </div>


     <div class="toggle-arrow" @click="toggleDrawer">
          <i v-if="!model.isOpen" class="bi bi-arrow-right"></i>
    </div>
     <div class="toggle-arrow arrow-right" @click="toggleRightDrawer ">
          <i class="bi bi-arrow-left"></i>
    </div>
</div>

`,

questInfo : `
  <div data-component="quests-info">
    <section>
      <div class="row">
        <div class="col-12">

              <div class="quest-area" v-if="model.questReward">
                <h1 class="quest-name">{{model.questReward.questName}}</h1>

                <div class="quest-description" v-if="model.questReward.description">
                  <p>{{model.questReward.description}}</p>
                </div>

                <div class="quest-mode" v-if="model.questReward != null">
                  <div class="quest-meta-chip">
                    <span class="quest-meta-icon">&#9876;</span>
                    <span class="quest-meta-label">Mode</span>
                    <span class="quest-meta-value">{{ model.questReward.questMode === 'to_win' ? 'To Win' : (model.questReward.questMode === 'to_defeat' ? 'To Defeat' : 'Win &amp; Defeat') }}</span>
                  </div>
                  <div class="quest-meta-chip">
                    <span class="quest-meta-icon">&#9812;</span>
                    <span class="quest-meta-label">Wins Needed</span>
                    <span class="quest-meta-value">{{ model.questReward.questWins }}</span>
                  </div>
                </div>

                <div class="top-team">
                      <div class="stats-playing-card-container" v-for="(cardMatch, index) in model.questReward.cardsMatches" :key="cardMatch.card.id || index">
                        <div class="stats-playing-card">
                           <playing-card
                        v-bind:card="{ ...cardMatch.card, image: \`\${root}/images/cards/\${cardMatch.card.id}.png\` }"
                        v-bind:show="true">
                      </playing-card>
                        </div>
                      </div>
                </div>


                <div class="rewards-section" v-if="model.questReward != null">
                  <div class="rewards-header">
                      <h2 class="rewards-title">Rewards</h2>
                  </div>
            
                  <div class="rewards-container" >
                    <reward-display 
                        :rewards="model.questReward.rewards || {}" 
                        display-type="default">
                    </reward-display>
                  
                  </div>

                   <button class="claim-button" :id="rewardButtonWithIndex(model.questReward.questId)" :disabled="!model.isButtonDisabled" @click="claimReward">{{model.questReward.active === true ? 'REWARD CLAIMED' : 'CLAIM REWARDS'}} </button>
                </div>

                 <!--<div class="reward-grid-container" :style="rewardGridStyle">
                    <div class="reward-grid-item" :key="index" v-for="(reward, index) in model.rewards">
                        <div :id="getRewardId(index)" v-if="reward.barks > 0">
                          <div class="reward-cards">
                            <div class="reward-barks cover">
                              <div class="barks" :style="barksStyle"></div>
                              <div class="reward-value">{{reward.barks}}x</div>
                            </div>
                          </div>
                        </div>
                        <div :id="getRewardId(index)" v-else-if="reward.xp > 0">
                          <div class="reward-cards">
                            <div class="reward-xp cover" >
                              <div class="fire xp-reward">XP</div>
                              <div class="reward-value">{{reward.xp}}x</div>
                            </div>
                    
                          </div>
                        </div>
                        <div :id="getRewardId(index)" v-else-if="reward.randomCard > 0">
                          <div class="reward-cards">
                            <div>
                                <playing-card 
                                    v-if="reward.randomCard >= 1 && reward.randomCard <= 6"
                                    v-bind:card="{
                                        ...reward.card,
                                        tier: Number(reward.randomCard),
                                    }" 
                                    class="randomCard-reward cover" 
                                    v-bind:show="true">
                                </playing-card>

                            </div>
                            <div class="random-reward"  v-if="model.rewards.length > 0">{{reward.random_amount}}X</div>
                          </div>
                       
                        </div>
                        <div :id="getRewardId(index)" v-else-if="reward.name">
                          <div class="reward-cards">
                            <playing-card  
                              id="cover" 
                              class="cover"
                              v-bind:show="{
                                  unflip: true
                              }" 
                              :class="reward.name" 
                              v-bind:show="false"
                              >
                            </playing-card>
                            <div class="random-reward">{{reward.packs_quantity}}X</div>
                          </div>
                        </div>
                    </div>
                  </div>-->
                 <!-- <div class="reward-button" v-if="model.rewards.length > 0"><button ></button></div> -->
              </div>  

               <div class="reward-fireworks">
                <div v-if="model.hasOpen" class="quest-reward-container">
                  <div class="victory-banner">QUEST COMPLETE</div>
                  <div data-component="open-pack-hq" class="always-display">
                    <button class="hq-close-btn" v-on:click="reset()">&#10005;</button>
                    <div class="content">
                      <div class="open-pack-wrapper-hq" v-bind:class="{ show: model.packLoaded }">
                        <div class="open-pack-container collapsed">
                          <div id="opened-cards" class="opened-cards-wrapper">
                            <div class="opened-cards">

                                <div class="reward-card-component playing-card-container scaled" v-for="(others, index) in model.userOthersReward">
                                  <div class="playing-card-wrapper">
                                    <div class="playing-card">
                                      <div class="playing-card-face playing-card-backing"></div>
                                      <div class="playing-card-face playing-card-front other-reward-container">
                                        <div v-if="others.name === 'xp'">
                                          <div class="fire give-reward">{{others.name}}</div>
                                          <div class="reward-value-show">{{others.value}}x</div>
                                        </div>
                                        <div v-else-if="others.type === 'frame'">
                                          <div class="frame-reward">
                                            <div class="reward-type-badge">Frame</div>
                                            <div class="reward-visual-container">
                                              <img :src="others.image_url" class="frame-reward-img"/>
                                            </div>
                                            <div class="reward-label">{{others.name}}</div>
                                          </div>
                                        </div>
                                        <div v-else-if="others.type === 'background'">
                                          <div class="background-reward">
                                            <div class="reward-type-badge">Background</div>
                                            <div class="reward-visual-container">
                                              <img :src="others.image_url" class="reward-background-img"/>
                                            </div>
                                            <div class="reward-label">{{others.name}}</div>
                                          </div>
                                        </div>
                                        <div v-else>
                                          <div class="give-reward spinning-slow" :style="barksStyle"></div>
                                          <div class="reward-value-show">{{others.value}}x</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <component
                                  v-for="card in model.userCards"
                                  class="scaled"
                                  :key="card.id"
                                  v-bind:card="card"
                                  :is="card.tier === 8 || card.tier === 10 ? 'special-card' : (card.tier >= 4 && card.tier !== 9 ? 'special-card' : 'playing-card')"
                                  :card="card"
                                  :show="false"
                                ></component>

                                <div class="reward-card-component playing-card-container scaled" v-for="backing in model.userCardBacks" :key="backing.id">
                                  <div class="playing-card-wrapper">
                                    <div class="playing-card">
                                      <div class="playing-card-face playing-card-backing"></div>
                                      <div class="playing-card-face playing-card-front other-reward-container">
                                            <img :src="getCardBack(backing)" class="back-reward-img"/>
                                          <div class="reward-value-show">{{backing.name}}</div>
                                  
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="reward-card-component playing-card-container scaled" v-for="pack in model.userPacks">
                                  <div class="playing-card-wrapper">
                                    <div class="playing-card">
                                      <div class="playing-card-face playing-card-backing"></div>
                                      <div class="playing-card-face playing-card-front other-reward-container">
                                        <div class="pack-reward">
                                          <div class="reward-type-badge">Pack</div>
                                          <div class="reward-visual-container">
                                            <img :src="getPackImageUrl(pack)" class="pack-reward-img" :class="{'is-reward-chest': pack.isChest}"/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="firework1"></div>
                <div class="firework2"></div>
                <div class="firework3"></div>
                <div class="firework4"></div>
                <div class="firework5"></div>
                <div class="firework6"></div>
            </div>

        </div>
       



          </div>
      </div>
    </section>
  </div>
`,

deepStats: `
<div data-component="deepstats">
  <section>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="row columns">

                <!-- ── Best Performing Team ── -->
                <div class="col-6 top">
                  <div class="stats-user panel-best">
                    <div class="stat-panel-label"><span class="stat-label-dot best-dot">&#9679;</span> REC.TEAM</div>
                    <h1>Best Performing Team</h1>
                    <div class="title">
                      <p v-if="model.bestTeam && model.bestTeam.name">{{ model.bestTeam.name }}</p>
                      <p v-else class="no-data">&#8212; NO RECORDS &#8212;</p>
                    </div>
                    <div class="top-team">
                      <div class="stats-playing-card-container" v-for="(card, index) in (model.bestTeam.highestTeamCards || [])" v-if="model.bestTeam.highestTeamCards && model.bestTeam.highestTeamCards.length">
                        <div class="stats-playing-card">
                          <playing-card
                            v-bind:card="card"
                            v-bind:card="{
                              ...card,
                              image: \`\${root}/images/cards/\${card.cardId}.png\`,
                              cardNumber: getCardNumber(index, 'best')
                            }"
                            v-bind:show="'true'"
                          ></playing-card>
                        </div>
                      </div>
                    </div>
                    <div class="table">
                      <div class="table-row">
                        <div class="table-cell left-cell win">WIN</div>
                        <div class="table-cell right-cell win">{{ model.bestTeam.highestTeamWinCount || 0 }}</div>
                      </div>
                      <div class="table-row">
                        <div class="table-cell left-cell loss">LOSS</div>
                        <div class="table-cell right-cell loss">{{ model.bestTeam.highestTeamLoseCount || 0 }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── Worst Performing Team ── -->
                <div class="col-6 top">
                  <div class="stats-user panel-worst">
                    <div class="stat-panel-label"><span class="stat-label-dot worst-dot">&#9679;</span> REC.TEAM</div>
                    <h1>Worst Performing Team</h1>
                    <div class="title">
                      <p v-if="model.worstTeam && model.worstTeam.lowestTeamWin">{{ model.worstTeam.lowestTeamWin }}</p>
                      <p v-else class="no-data">&#8212; NO RECORDS &#8212;</p>
                    </div>
                    <div class="info">
                      <div class="top-team">
                        <div class="stats-playing-card-container" v-for="(card, index) in (model.worstTeam.lowestTeamCards || [])" v-if="model.worstTeam.lowestTeamCards && model.worstTeam.lowestTeamCards.length">
                          <div class="stats-playing-card">
                            <playing-card
                              v-bind:card="card"
                              v-bind:show="'true'"
                              v-bind:card="{
                                ...card,
                                image: \`\${root}/images/cards/\${card.cardId}.png\`,
                                cardNumber: getCardNumber(index, 'worst')
                              }"
                            ></playing-card>
                          </div>
                        </div>
                      </div>
                      <div class="top-stats">
                        <div></div>
                        <div class="second-column">
                          <div class="table">
                            <div class="table-row">
                              <div class="table-cell left-cell win">WIN</div>
                              <div class="table-cell right-cell win">{{ model.worstTeam.lowestTeamWinCount || 0 }}</div>
                            </div>
                            <div class="table-row">
                              <div class="table-cell left-cell loss">LOSS</div>
                              <div class="table-cell right-cell loss">{{ model.worstTeam.lowestTeamLoseCount || 0 }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── Top Performing Card ── -->
                <div class="col-6 top">
                  <div class="stats-user panel-top">
                    <div class="stat-panel-label"><span class="stat-label-dot top-dot">&#9679;</span> REC.CARD</div>
                    <h1>Top Performing Card</h1>
                    <div class="title">
                      <p v-if="model.topCard && model.topCard.highestCardWin && model.topCard.highestCardWin.length">{{ model.topCard.highestCardWin[0].name }}</p>
                      <p v-else class="no-data">&#8212; NO RECORDS &#8212;</p>
                    </div>
                    <div class="info">
                      <div class="top-card">
                        <div class="stats-playing-card-container" v-for="card in (model.topCard.highestCardWin || [])" v-if="model.topCard.highestCardWin && model.topCard.highestCardWin.length">
                          <div class="stats-playing-card">
                            <playing-card
                              v-bind:card="card"
                              v-bind:show="'true'"
                              v-bind:card="{
                                ...card,
                                image: \`\${root}/images/cards/\${card.cardId}.png\`
                              }"
                            ></playing-card>
                          </div>
                        </div>
                      </div>
                      <div class="top-stats">
                        <div></div>
                        <div class="second-column">
                          <div class="table">
                            <div class="table-row">
                              <div class="table-cell left-cell win">WIN</div>
                              <div class="table-cell right-cell win">{{ model.topCard.highestCardWinCount || 0 }}</div>
                            </div>
                            <div class="table-row">
                              <div class="table-cell left-cell loss">LOSS</div>
                              <div class="table-cell right-cell loss">{{ model.topCard.highestCardLoseCount || 0 }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── Worst Performing Card ── -->
                <div class="col-6 top">
                  <div class="stats-user panel-low">
                    <div class="stat-panel-label"><span class="stat-label-dot low-dot">&#9679;</span> REC.CARD</div>
                    <h1>Worst Performing Card</h1>
                    <div class="title">
                      <p v-if="model.lowestCard && model.lowestCard.lowestCardWin && model.lowestCard.lowestCardWin.length">{{ model.lowestCard.lowestCardWin[0].name }}</p>
                      <p v-else class="no-data">&#8212; NO RECORDS &#8212;</p>
                    </div>
                    <div class="info">
                      <div class="top-card">
                        <div class="stats-playing-card-container" v-for="card in (model.lowestCard.lowestCardWin || [])" v-if="model.lowestCard.lowestCardWin && model.lowestCard.lowestCardWin.length">
                          <div class="stats-playing-card">
                            <playing-card
                              v-bind:card="card"
                              v-bind:show="'true'"
                              v-bind:card="{
                                ...card,
                                image: \`\${root}/images/cards/\${card.cardId}.png\`
                              }"
                            ></playing-card>
                          </div>
                        </div>
                      </div>
                      <div class="top-stats">
                        <div></div>
                        <div class="second-column">
                          <div class="table">
                            <div class="table-row">
                              <div class="table-cell left-cell loss">LOSS</div>
                              <div class="table-cell right-cell win">{{ model.lowestCard.lowestCardLoseCount || 0 }}</div>
                            </div>
                            <div class="table-row">
                              <div class="table-cell left-cell win">WIN</div>
                              <div class="table-cell right-cell loss">{{ model.lowestCard.lowestCardWinCount || 0 }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── Most Wins Against Player ── -->
                <div class="col-4 top">
                  <div class="stats-user panel-wins">
                    <div class="stat-panel-label"><span class="stat-label-dot wins-dot">&#9679;</span> OPP.WINS</div>
                    <h1>Most Wins Against Player</h1>
                    <div class="title">
                      <p v-if="model.mostWinOnPlayer && model.mostWinOnPlayer.highestOnOpponent">{{ model.mostWinOnPlayer.highestOnOpponent }}</p>
                      <p v-else class="no-data">&#8212; NO RECORDS &#8212;</p>
                    </div>
                    <div class="info">
                      <div class="second-column">
                        <div class="table">
                          <div class="table-row">
                            <div class="table-cell win">WIN</div>
                            <div class="table-cell win">{{ model.mostWinOnPlayer.highestWinOnOpponentCount || 0 }}</div>
                          </div>
                          <div class="table-row">
                            <div class="table-cell loss">LOSS</div>
                            <div class="table-cell loss">{{ model.mostWinOnPlayer.lossOnOpponentCount || 0 }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="second-column">
                        <img class="profile-img" :src="model.mostWinOnPlayer.profile" v-if="model.mostWinOnPlayer && model.mostWinOnPlayer.profile" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── Most Loss Against Player ── -->
                <div class="col-4 top">
                  <div class="stats-user panel-losses">
                    <div class="stat-panel-label"><span class="stat-label-dot losses-dot">&#9679;</span> OPP.LOSS</div>
                    <h1>Most Loss Against Player</h1>
                    <div class="title">
                      <p v-if="model.mostLossOnPlayer && model.mostLossOnPlayer.lowestWinOpponent">{{ model.mostLossOnPlayer.lowestWinOpponent }}</p>
                      <p v-else class="no-data">&#8212; NO RECORDS &#8212;</p>
                    </div>
                    <div class="info">
                      <div class="top-stats">
                        <div class="second-column">
                          <div class="table">
                            <div class="table-row">
                              <div class="table-cell win">LOSS</div>
                              <div class="table-cell win">{{ model.mostLossOnPlayer.lowestLossOnOpponentCount || 0 }}</div>
                            </div>
                            <div class="table-row">
                              <div class="table-cell loss">WIN</div>
                              <div class="table-cell loss">{{ model.mostLossOnPlayer.lowestWinOnOpponentCount || 0 }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="second-column">
                          <img class="profile-img" :src="model.mostLossOnPlayer && model.mostLossOnPlayer.profile" v-if="model.mostLossOnPlayer && model.mostLossOnPlayer.profile" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── History Tabs ── -->
                <div class="stats-user panel-history">
                  <div class="tab-container">
                    <div class="tab-button title" v-bind:class="{ active: model.tab == 'tab1'}" @click="showTab('tab1')">&#9776; Player History</div>
                    <div class="tab-button title" v-bind:class="{ active: model.tab == 'tab2'}" @click="showTab('tab2')">&#9781; Battle Log</div>
                  </div>

                  <div id="stats-tab" class="stats-content" v-bind:class="{ active: model.tab == 'tab1'}">
                    <h1>Record Against Player History</h1>
                    <table class="history-table">
                      <thead>
                        <tr>
                          <th>Player 1</th>
                          <th>Player 2</th>
                          <th>Wins</th>
                          <th>Loses</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in (model.opponentHistory || [])" v-if="model.opponentHistory && model.opponentHistory.length">
                          <td data-label="Player 1">
                            <div class="player-info">
                              <img :src="user.player1_image" class="player_history_image" />
                              <span class="text-white" :title="user.user1">{{ user.user1 }}</span>
                            </div>
                          </td>
                          <td data-label="Player 2">
                            <div class="player-info">
                              <img :src="user.player2_image" class="player_history_image" />
                              <span class="text-white" :title="user.opponent">{{ user.opponent }}</span>
                            </div>
                          </td>
                          <td data-label="Wins" class="win">{{ user.opponent_wins }}</td>
                          <td data-label="Loses" class="loss">{{ user.opponent_loss }}</td>
                        </tr>
                        <tr v-else>
                          <td colspan="4" class="no-data" style="text-align:center;padding:20px;letter-spacing:3px;">&#8212; NO RECORDS YET &#8212;</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div id="hist-tab" class="stats-content" v-bind:class="{ active: model.tab == 'tab2'}">
                    <h1>Battle History</h1>
                    <table class="history-table">
                      <thead>
                        <tr>
                          <th>Opponent</th>
                          <th>Opp. Cards</th>
                          <th>Your Cards</th>
                          <th>Status</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in (model.playerHistory || [])" v-if="model.playerHistory && model.playerHistory.length">
                          <td data-label="Opponent">
                            <div class="player-info">
                              <img :src="user.profile" class="player_history_image" />
                              <span :title="user.user1" class="text-white">{{ user.opponent }}</span>
                            </div>
                          </td>
                          <td data-label="Opponent Cards">
                            <p class="text-white" :title="user.opponentCards.map(card => card.name).join(', ')">{{ user.opponentCards.map(card => card.name).join(', ') }}</p>
                          </td>
                          <td data-label="Cards">
                            <p class="text-white" :title="user.Cards.map(card => card.name).join(', ')">{{ user.Cards.map(card => card.name).join(', ') }}</p>
                          </td>
                          <td data-label="Battle Status">
                            <p :class="user.BattleStatus === 'Winner' ? 'win' : 'loss'">{{ user.BattleStatus }}</p>
                          </td>
                          <td data-label="Date">
                            <p class="text-white">{{ user.dateUpdated }}</p>
                          </td>
                        </tr>
                        <tr v-else>
                          <td colspan="5" class="no-data" style="text-align:center;padding:20px;letter-spacing:3px;">&#8212; NO RECORDS YET &#8212;</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div><!-- /panel-history -->

              </div><!-- /row columns -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-component="view-medal">
      <div class="view-element"><div></div></div>
    </div>
  </section>
</div>
`,

adminTournament: `
  <div data-component="admin-tournament">
    <section class="quest-line-section">
      <div class="quest-line-container">
        
        <!-- Header Panel -->
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-trophy"></i>
              <div>
                <h2>Tournaments</h2>
                <p class="admin-subtitle quest-subtitle">Manage tournament configurations</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>New Tournament</span>
            </button>
          </div>
        </div>

        <!-- Edit Form Sidebar -->
        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: enable a tournament battle.">Active</label>
                <div class="form-check form-switch">
                  <input v-model="model.tournament.active" type="checkbox" class="form-check-input">
                </div>
              </div>
              <TournamentForm
                :model="model.tournament"
                :players="model.players"
                :options="model.option"
                :battleOptions="model.battle_options"
                @input-changed="handleInputChange"
              />
              <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Tournament
              </button>
            </div>
          </div>
        </div>

        <!-- Tournament Table -->
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-name">Name</th>
                <th class="th-rules">Description</th>
                <th class="th-level">Players</th>
                <th class="th-mode">Battle Option</th>
                <th class="th-mode">Selected Option</th>
                <th class="th-level">Is Active</th>
                <th class="th-date">Created At</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="model.isLoading">
                <tr>
                  <td colspan="8" class="empty-table-state">
                    <div class="empty-content">
                      <div class="loader1"></div>
                      <p>please wait...</p>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else-if="!model.hasResult">
                <tr>
                  <td colspan="8" class="empty-table-state">
                    <div class="empty-content">
                      <i class="bi-inbox"></i>
                      <p>No records found</p>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="admin-table-row quest-row" v-for="tournament in model.tournaments" :key="tournament.id" v-on:click="edit(tournament.id)">
                  <td class="td-name">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ tournament.name }}</span>
                    </div>
                  </td>
                  <td class="td-rules">
                    <span class="admin-rules-text rules-text" :title="tournament.description">{{ tournament.description }}</span>
                  </td>
                  <td class="td-level">
                    <span class="admin-badge-level level-badge">{{ tournament.bracket }}</span>
                  </td>
                  <td class="td-mode">
                    <span class="admin-badge-mode mode-badge">{{ tournament.battleOption }}</span>
                  </td>
                  <td class="td-mode">
                    <span class="admin-badge-mode mode-badge">{{ tournament.selectedOption }}</span>
                  </td>
                  <td class="td-level">
                    <i v-if="tournament.isActive == true" class="bi-check-lg"></i> 
                    <i v-if="tournament.isActive == false" class="bi-x-lg"></i> 
                  </td>
                  <td class="td-date">
                    {{ tournament.created_at }}
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(tournament.id)" title="Edit Tournament">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>
`,

confirmModal : `
    <div data-component="confirm-modal class="always-display"">
          <div class="modal" >
            <div class="modal-content">
                <div v-if="model.deltaInfo" class="delta-info-panel">
                  <div class="delta-panel-layout">
                    <div v-if="model.deltaInfo" class="delta-panel-card-preview">
                      <special-card :card="equippedDeltaCard" :show="true" class="delta-preview"></special-card>
                    </div>
                    <div class="delta-panel-info">
                      <h4 class="delta-info-title">{{ model.deltaInfo.deltaCard }}</h4>
                      <p class="delta-description">{{ model.deltaInfo.deltaCardDescription }}</p>
                      <p class="delta-effect"><strong>Effect:</strong> {{ model.deltaInfo.deltaCardEffect }}</p>
                      <div class="delta-info-actions">
                        <button type="button" class="btn-unequip" v-on:click="model.confirmUnequip = true; confirm()">Unequip</button>
                        <button type="button" v-on:click="cancel()">Close</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="model.card">
                    <h4>{{model.message}}</h4>
                  </div>
                  <button type="button" data-button="save" v-on:click="confirm()">Yes</button>
                  <button type="button" class="delete_team" v-on:click="cancel()">Cancel</button>
                </div>
            </div>
          </div>
    </div>
`,
userFaction : `
 <div data-component="user-faction">
      <section>
        <div class="row mt-2">
          <div class="col-12">
            <div class="card">

            <div class="header-container">
             <div>
                <img v-if="model.id" :src="\`\${root}/images/faction/\${model.id}.png\`" alt="Faction Image" :style="{ width: '50px', height: '50px' }"><h4>{{model.factionName}}</h4>
              </div>
              <div><i class="bi bi-box-arrow-left leave-faction" @click="leaveFaction" title="Leave Faction" v-if="model.id"></i></div>
            </div>
             

              <div class="row">
                    <div v-if="model.hasFaction" class="main-content">
                              <div class="left-section">
                                <div class="stats-grid">
                                  <div class="stat-card stats-user"><div class="icon"></div><h3 title="0">{{model.factionStats.totalFactionPoints}}</h3> <h1 title="achievements">Faction Points</h1></div>
                                  <div class="stat-card stats-user"><div class="icon"></div><h3 title="0">{{model.factionStats.winRate}}%</h3> <h1 title="achievements">Faction Win Rate</h1></div>
                                  <div class="stat-card stats-user"><div class="icon"></i></div><h3 title="0">{{model.factionStats.userTotalFactionPoints}}</h3> <h1 title="achievements">Your Points</h1></div>
                                  <div class="stat-card stats-user"><div class="icon"></div><h3 title="0">{{model.factionStats.userWinRate}}%</h3> <h1 title="achievements">Your Win Rate</h1></div>
                                </div>
                                <div class="profile-section stats-user">
                                  <div class="section-title"><h1>Faction Members</h1></div>
                                  <div class="profile-list">
                                    <div class="profile-item" v-for="user in model.factionMembers">
                                        <img :src="user.twitchProfileImage" class="profile-avatar"/>
                                        <div class="profile-info">
                                            <div class="username">{{user.twitchDisplayName}}</div>
                                            <div class="profile-stats">{{user.points}} pts   {{user.winRate}} % WR</div>
                                        </div>
                                        <div class="profile-rank">Leader</div>
                                    </div>
                                  </div>
                               
                                </div>
                                </div>
                                <div class="history-section stats-user">
                                    <h1>Match History</h1>
                                    <div v-if="model.userFactionHistory.length > 0">
                                      <div class="history-item" v-for="user in model.userFactionHistory">
                                          <div class="history-field">
                                              <div class="history-label">Opponent</div>
                                              <div class="history-value">{{ model.userTwitchInfo[user.opponent]?.twitchDisplayName || '...' }}</p></div>
                                          </div>
                                          <div class="history-field">
                                              <div class="history-label">Faction</div>
                                              <div class="history-value">{{user.name}}</div>
                                          </div>
                                          <div class="history-field">
                                              <div class="history-label">Points</div>
                                              <div class="history-value">{{user.value}}</div>
                                          </div>
                                          <div class="history-field">
                                              <div class="history-label">Status</div>
                                              <div class="history-value" v-bind:class="{'status-loss': user.value < 0,  'status-win': user.value > 0}">{{ user.value < 0 ? 'Defeat' : 'Win'}}</div>
                                          </div>
                                      </div>
                                    </div>
                               
                                    <div v-else class="empty-state">No match history available</div>
                                </div>
                              
                               
                      </div>
                      <div v-else>
                          <div class="faction-container">
                            <div class="faction-item" :key="faction.id" v-for="faction in model.factions" >
                              <img :src="faction.image" @click.stop="selectedFaction(faction.id)"  v-bind:class="{'grayscale' : faction.userLevel < model.settings.factionlevel.value}">
                              <!--<div class="faction-label" @click.stop="selectedFaction(faction.id)"></div>-->
                              <div class="faction-label" v-bind:class="{'join': faction.userLevel >= model.settings.factionlevel.value}" @click.stop="selectedFaction(faction.id)">{{faction.userLevel < model.settings.factionlevel.value ? '' : faction.name}}</div>
                              
                            </div>
                            <div class="center-label" v-if="model.userLevel < model.settings.factionlevel.value">Required Level  {{model.settings.factionlevel.value}}</div>
                          </div>
                      </div>

                  
                  </div>
                </div>
              </div>

          </div>
        </div>
      </section>
  </div>
`,

modLogs: `
  <div data-component="mod-logs">
    <section class="quest-line-section">
      <div class="quest-line-container">
        
        <!-- Header Panel -->
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-journal-text"></i>
              <div>
                <h2>Transaction Logs</h2>
                <p class="admin-subtitle quest-subtitle">Track and monitor user transactions and activities</p>
              </div>
            </div>
            <div class="admin-header-actions" style="display: flex; align-items: center; gap: 15px;">
              <div style="display: flex; align-items: center; gap: 8px;">
                <label style="margin: 0; font-size: 14px; color: #b8b8b8;">Show:</label>
                <select class="form-control" v-model="model.page.limit" @change="selectedOption" style="width: auto; min-width: 80px; padding: 8px 12px;">
                  <option v-for="(value, key) in model.option" v-bind:value="value.value" :key="key">
                    {{ value.name }}
                  </option>
                </select>
              </div>
              <div style="font-size: 14px; color: #b8b8b8;">
                <span v-if="model.page.count > 0">Total: {{ model.page.count }} records</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Logs Table -->
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-date" style="width: 180px;">
                  <i class="bi-clock"></i>
                  Date & Time
                </th>
                <th class="th-name" style="width: 120px;">
                  <i class="bi-tag"></i>
                  Type
                </th>
                <th class="th-rules">
                  <i class="bi-info-circle"></i>
                  Transaction Details
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="!model.isLoading">
                <tr>
                  <td colspan="3" class="empty-table-state">
                    <div class="empty-content">
                      <div class="loader1"></div>
                      <p>Loading transaction logs...</p>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else-if="!model.hasResult">
                <tr>
                  <td colspan="3" class="empty-table-state">
                    <div class="empty-content">
                      <i class="bi-inbox" style="font-size: 48px; color: #555; margin-bottom: 15px;"></i>
                      <p style="font-size: 16px; color: #888;">No transaction logs available</p>
                      <p style="font-size: 14px; color: #666; margin-top: 5px;">Transaction logs will appear here once activities are recorded</p>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr 
                  class="admin-table-row quest-row mod-log-row" 
                  v-for="(log, index) in model.logs" 
                  :key="log.id || index"
                  :class="getLogTypeClass(log)"
                >
                  <td class="td-date">
                    <div style="display: flex; flex-direction: column; gap: 4px;">
                      <span style="font-weight: 600; color: #fff;">{{ formatDate(log.dateCreated) }}</span>
                      <span style="font-size: 12px; color: #888;">{{ formatTime(log.dateCreated) }}</span>
                    </div>
                  </td>
                  <td class="td-name">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <i :class="getLogIcon(log)" style="font-size: 18px;"></i>
                      <span class="log-type-badge" :class="getLogTypeBadgeClass(log)">
                        {{ getLogTypeLabel(log) }}
                      </span>
                    </div>
                  </td>
                  <td class="td-rules">
                    <div class="log-details">
                      <span class="admin-rules-text rules-text" :title="log.log">{{ log.log }}</span>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="mod-logs-pagination" v-if="model.hasResult && model.page.max > 1">
          <div class="pagination-info">
            <span>Showing page {{ model.page.current }} of {{ model.page.max }}</span>
            <span style="color: #888; margin-left: 10px;">({{ model.page.count }} total records)</span>
          </div>
          <div class="pagination-controls">
            <button 
              class="pagination-btn" 
              @click="prevPage" 
              :disabled="model.page.current === 1"
              :class="{ disabled: model.page.current === 1 }"
            >
              <i class="bi-chevron-left"></i>
              Previous
            </button>
            <div class="pagination-numbers">
              <button 
                v-for="page in getVisiblePages()" 
                :key="page"
                @click="goToPage(page)" 
                class="pagination-number"
                :class="{ active: model.page.current === page, ellipsis: page === '...' }"
                :disabled="page === '...'"
              >
                {{ page }}
              </button>
            </div>
            <button 
              class="pagination-btn" 
              @click="nextPage" 
              :disabled="model.page.current === model.page.max"
              :class="{ disabled: model.page.current === model.page.max }"
            >
              Next
              <i class="bi-chevron-right"></i>
            </button>
          </div>
        </div>

      </div>
    </section>
  </div>
  `,
  adminSubscription:`
  <div data-component="admin-subscription">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Subscription Management</h4>
            </div>

            <!-- Edit Form -->
            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close subs-reset" v-on:click="reset()"></i>
                <div class="col-12 scroll_sidebar">
                  <div>
                    <label>Subscription Name</label>
                    <input type="text" class="form-control" v-model="model.subscription.name">
                  </div>
                  <div>
                    <label>Subscription Price</label>
                    <input type="number" class="form-control" v-model="model.subscription.price">
                  </div>
                  <div>
                    <label>Standard Pack</label>
                    <input type="number" class="form-control" v-model="model.subscription.standard">
                  </div>
                  <div>
                    <label>Ultra Pack</label>
                    <input type="number" class="form-control" v-model="model.subscription.ultra">
                  </div>
                  <div>
                    <label>Legendary Pack</label>
                    <input type="number" class="form-control" v-model="model.subscription.legendary">
                  </div>
                  <div>
                    <label>Prime Chest</label>
                    <input type="number" class="form-control" v-model="model.subscription.primeChest">
                  </div>
                  <div>
                    <label>Ultra Chest</label>
                    <input type="number" class="form-control" v-model="model.subscription.ultraChest">
                  </div>
                  <div>
                    <label>Legendary Chest</label>
                    <input type="number" class="form-control" v-model="model.subscription.legendaryChest">
                  </div>
                  <div style="margin-bottom: 15px;">
                    <div style="display: flex; align-items: center; margin-bottom: 5px;">
                      <input type="checkbox" class="form-check-input" v-model="model.subscription.tournament" id="tournament" style="margin-right: 10px;">
                      <label for="tournament" style="margin: 0;">Tournament</label>
                    </div>
                  </div>
                  <div style="margin-bottom: 15px;">
                    <div style="display: flex; align-items: center; margin-bottom: 5px;">
                      <input type="checkbox" class="form-check-input" v-model="model.subscription.streamerTournament" id="streamerTournament" style="margin-right: 10px;">
                      <label for="streamerTournament" style="margin: 0;">Streamer Tournament</label>
                    </div>
                  </div>
                  <div style="margin-bottom: 15px;">
                    <div style="display: flex; align-items: center; margin-bottom: 5px;">
                      <input type="checkbox" class="form-check-input" v-model="model.subscription.communityRewards" id="communityRewards" style="margin-right: 10px;">
                      <label for="communityRewards" style="margin: 0;">Community Challenge Rewards</label>
                    </div>
                  </div>
                  <div style="margin-bottom: 15px;">
                    <div style="display: flex; align-items: center; margin-bottom: 5px;">
                      <input type="checkbox" class="form-check-input" v-model="model.subscription.exclusiveEvents" id="exclusiveEvents" style="margin-right: 10px;">
                      <label for="exclusiveEvents" style="margin: 0;">Exclusive Events</label>
                    </div>
                  </div>
                </div>
                <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
              </div>
            </div>

            <!-- Subscriptions Table -->
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Standard</th>
                    <th>Ultra</th>
                    <th>Legendary</th>
                    <th>Prime Chest</th>
                    <th>Ultra Chest</th>
                    <th>Legendary Chest</th>
                    <th>Stripe</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="model.subscriptions.length === 0">
                    <td colspan="10" style="text-align: center;">No subscriptions found.</td>
                  </tr>
                  <tr v-for="(subscription, index) in model.subscriptions" :key="subscription.id">
                    <td><strong>{{ subscription.subsName }}</strong></td>
                    <td>\${{ subscription.subsPrice }}</td>
                    <td>{{ subscription.standard }}</td>
                    <td>{{ subscription.ultra }}</td>
                    <td>{{ subscription.legendary }}</td>
                    <td>{{ subscription.primeChest }}</td>
                    <td>{{ subscription.ultraChest }}</td>
                    <td>{{ subscription.legendaryChest }}</td>
                    <td>
                      <span v-if="subscription.subsPrice > 0" :style="{ color: subscription.stripePriceId ? '#4caf50' : '#f44336', fontSize: '12px' }">
                        {{ subscription.stripePriceId ? '✓ Synced' : '✗ Not synced' }}
                      </span>
                      <span v-else style="color: #999; font-size: 12px;">Free</span>
                    </td>
                    <td>
                      <button class="btn-small" v-on:click="edit(index)">Edit</button>
                      <button v-if="subscription.subsPrice > 0" class="btn-small" v-on:click="syncStripeProduct(subscription.id, subscription.subsName, subscription.subsPrice)" style="margin-left: 4px;">Sync Stripe</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      <!-- Promotional Banner Section -->
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Promotional Banner</h4>
            </div>

            <!-- Banner Editor -->
            <div class="body">
              
              <!-- Controls Header -->
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px solid #333;">
                <div style="display: flex; align-items: center; gap: 15px;">
                  <div style="display: flex; align-items: center;">
                    <label style="margin-right: 10px;">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.banner.active" type="checkbox" class="form-check-input" @change="saveBanner()">
                    </div>
                  </div>
                </div>
                <button data-button="submit" v-on:click="saveBanner()">Save Banner</button>
              </div>
                
              <!-- Live Preview (Sticky) -->
              <div style="position: sticky; top: 20px; z-index: 100; margin-bottom: 30px; width: 100%; background: #1a1a2e; padding: 15px; border-radius: 10px; box-shadow: 0 4px 15px rgba(0,0,0,0.3);">
                <h5 style="margin-bottom: 15px;">Live Preview</h5>
                <div class="banner-preview-container" :style="bannerPreviewContainerStyle" style="width: 100%;">
                  <div class="banner-preview" :style="bannerPreviewStyle" style="width: 100%;">
                    <img v-if="model.banner.displayImage" :src="model.banner.displayImage" :style="bannerDisplayImageStyle" class="banner-display-image">
                    <div class="banner-content" :style="bannerContentStyle">
                      <h3 :style="bannerTitleStyle">{{ model.banner.title || 'Banner Title' }}</h3>
                      <p :style="bannerDescriptionStyle">{{ model.banner.description || 'Banner description goes here' }}</p>
                      <span v-if="model.banner.discountText" :style="bannerDiscountStyle">{{ model.banner.discountText }}</span>
                      <button v-if="model.banner.buttonText" :style="bannerButtonStyle">{{ model.banner.buttonText }}</button>
                    </div>
                  </div>
                </div>
              </div>

              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                
                <!-- Content Settings -->
                <div class="card" style="padding: 15px;">
                  <h5 style="margin-bottom: 15px; border-bottom: 1px solid #333; padding-bottom: 10px;">Content</h5>
                  <div>
                    <label>Title *</label>
                    <input type="text" class="form-control" v-model="model.banner.title" placeholder="e.g., Holiday Sale!">
                  </div>
                  <div>
                    <label>Description</label>
                    <textarea class="form-control" v-model="model.banner.description" rows="2" placeholder="e.g., Get 50% off all subscriptions this holiday season!"></textarea>
                  </div>
                  <div>
                    <label>Discount Text</label>
                    <input type="text" class="form-control" v-model="model.banner.discountText" placeholder="e.g., 50% OFF">
                  </div>
                  <div>
                    <label>Button Text</label>
                    <input type="text" class="form-control" v-model="model.banner.buttonText" placeholder="e.g., Subscribe Now">
                  </div>
                  <div>
                    <label>Button Link</label>
                    <input type="text" class="form-control" v-model="model.banner.buttonLink" placeholder="e.g., #subscriptions">
                  </div>
                </div>

                <!-- Layout Settings -->
                <div class="card" style="padding: 15px;">
                  <h5 style="margin-bottom: 15px; border-bottom: 1px solid #333; padding-bottom: 10px;">Layout</h5>
                  <div>
                    <label>Content Position</label>
                    <select class="form-control" v-model="model.banner.contentPosition">
                      <option value="left">Left</option>
                      <option value="center">Center</option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                  <div>
                    <label>Content Alignment</label>
                    <select class="form-control" v-model="model.banner.contentAlignment">
                      <option value="left">Left</option>
                      <option value="center">Center</option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                  <div>
                    <label>Banner Height (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.height" placeholder="200">
                  </div>
                  <div>
                    <label>Border Radius (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.borderRadius" placeholder="10">
                  </div>
                  <div>
                    <label>Padding (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.padding" placeholder="30">
                  </div>
                </div>

                <!-- Background Settings -->
                <div class="card" style="padding: 15px;">
                  <h5 style="margin-bottom: 15px; border-bottom: 1px solid #333; padding-bottom: 10px;">Background</h5>
                  <div>
                    <label>Background Type</label>
                    <select class="form-control" v-model="model.banner.backgroundType">
                      <option value="color">Solid Color</option>
                      <option value="gradient">Gradient</option>
                      <option value="image">Image</option>
                    </select>
                  </div>
                  <div v-if="model.banner.backgroundType === 'color'">
                    <label>Background Color</label>
                    <input type="color" class="form-control" v-model="model.banner.backgroundColor" style="height: 40px;">
                  </div>
                  <div v-if="model.banner.backgroundType === 'gradient'">
                    <label>Gradient Start Color</label>
                    <input type="color" class="form-control" v-model="model.banner.gradientStart" style="height: 40px;">
                  </div>
                  <div v-if="model.banner.backgroundType === 'gradient'">
                    <label>Gradient End Color</label>
                    <input type="color" class="form-control" v-model="model.banner.gradientEnd" style="height: 40px;">
                  </div>
                  <div v-if="model.banner.backgroundType === 'gradient'">
                    <label>Gradient Direction</label>
                    <select class="form-control" v-model="model.banner.gradientDirection">
                      <option value="to right">Left to Right</option>
                      <option value="to left">Right to Left</option>
                      <option value="to bottom">Top to Bottom</option>
                      <option value="to top">Bottom to Top</option>
                      <option value="to bottom right">Diagonal (Top-Left to Bottom-Right)</option>
                      <option value="to bottom left">Diagonal (Top-Right to Bottom-Left)</option>
                    </select>
                  </div>
                  <div v-if="model.banner.backgroundType === 'image'">
                    <label>Background Image URL</label>
                    <input type="text" class="form-control" v-model="model.banner.backgroundImage" placeholder="https://...">
                  </div>
                  <div v-if="model.banner.backgroundType === 'image'">
                    <label>Background Size</label>
                    <select class="form-control" v-model="model.banner.backgroundSize">
                      <option value="cover">Cover</option>
                      <option value="contain">Contain</option>
                      <option value="auto">Auto</option>
                    </select>
                  </div>
                  <div v-if="model.banner.backgroundType === 'image'">
                    <label>Background Overlay Color</label>
                    <input type="color" class="form-control" v-model="model.banner.overlayColor" style="height: 40px;">
                  </div>
                  <div v-if="model.banner.backgroundType === 'image'">
                    <label>Overlay Opacity (0-1)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.overlayOpacity" step="0.1" min="0" max="1" placeholder="0.5">
                  </div>
                </div>

                <!-- Display Image Settings -->
                <div class="card" style="padding: 15px;">
                  <h5 style="margin-bottom: 15px; border-bottom: 1px solid #333; padding-bottom: 10px;">Display Image</h5>
                  <div>
                    <label>Display Image URL</label>
                    <input type="text" class="form-control" v-model="model.banner.displayImage" placeholder="https://... (optional promotional image)">
                  </div>
                  <div v-if="model.banner.displayImage">
                    <label>Image Position</label>
                    <select class="form-control" v-model="model.banner.imagePosition">
                      <option value="left">Left</option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                  <div v-if="model.banner.displayImage">
                    <label>Image Width (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.imageWidth" placeholder="150">
                  </div>
                  <div v-if="model.banner.displayImage">
                    <label>Image Height (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.imageHeight" placeholder="150">
                  </div>
                </div>

                <!-- Typography Settings -->
                <div class="card" style="padding: 15px;">
                  <h5 style="margin-bottom: 15px; border-bottom: 1px solid #333; padding-bottom: 10px;">Typography</h5>
                  <div>
                    <label>Title Color</label>
                    <input type="color" class="form-control" v-model="model.banner.titleColor" style="height: 40px;">
                  </div>
                  <div>
                    <label>Title Size (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.titleSize" placeholder="28">
                  </div>
                  <div>
                    <label>Description Color</label>
                    <input type="color" class="form-control" v-model="model.banner.descriptionColor" style="height: 40px;">
                  </div>
                  <div>
                    <label>Description Size (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.descriptionSize" placeholder="16">
                  </div>
                  <div>
                    <label>Discount Badge Color</label>
                    <input type="color" class="form-control" v-model="model.banner.discountBgColor" style="height: 40px;">
                  </div>
                  <div>
                    <label>Discount Text Color</label>
                    <input type="color" class="form-control" v-model="model.banner.discountTextColor" style="height: 40px;">
                  </div>
                </div>

                <!-- Button Settings -->
                <div class="card" style="padding: 15px;">
                  <h5 style="margin-bottom: 15px; border-bottom: 1px solid #333; padding-bottom: 10px;">Button</h5>
                  <div>
                    <label>Button Background Color</label>
                    <input type="color" class="form-control" v-model="model.banner.buttonBgColor" style="height: 40px;">
                  </div>
                  <div>
                    <label>Button Text Color</label>
                    <input type="color" class="form-control" v-model="model.banner.buttonTextColor" style="height: 40px;">
                  </div>
                  <div>
                    <label>Button Border Radius (px)</label>
                    <input type="number" class="form-control" v-model.number="model.banner.buttonBorderRadius" placeholder="5">
                  </div>
                  <div>
                    <label>Button Padding (px)</label>
                    <input type="text" class="form-control" v-model="model.banner.buttonPadding" placeholder="e.g., 10 20">
                  </div>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

    </section>
  </div>
`,

promotionalAds: `
 <transition name="promo-fade" appear>
   <div class="always-display promo-banner-wrapper">
     <div v-html="model.compiledHTML"  v-if="model.compiledHTML"></div>
   </div>
 </transition>
`,
subscriptionTiers: `
  <section class="always-display subscriptions" id="subscriptions">
    <div class="container">
      <h2 class="section-title">Choose Your Battle Tier</h2>

        <div class="tiers-grid">
            <div v-for="(subscription, index) in model.subscriptions" :key="subscription.id" class="tier-card" :class="{ popular: index === 2 }">
                <h3 class="tier-name">{{ subscription.subsName }}</h3>
                <div class="tier-price">
                    {{ subscription.isActivePromotion ? subscription.subsPriceAfter : subscription.subsPrice }}$
                </div>
                <div v-if="subscription.isActivePromotion" class="tier-price after">
                    {{ subscription.subsPrice }}$
                </div>
                <ul class="tier-features">
                    <li v-if="index === 0">{{ subscription.prime }} Prime Packs</li>
                    <li v-if="index === 1">Full Access to Game</li>
                    <li v-if="index === 1">{{ subscription.prime }} Prime Packs</li>
                    <li v-if="index === 1">{{ subscription.ultra }} Ultra Packs</li>
                    <li v-if="index === 1">{{ subscription.legendary }} Legendary Pack</li>
                    <li v-if="index === 1">{{ subscription.chest }} Chest</li>
                    <li v-if="index === 1">BattleDogs Discord Access</li>
                    <li v-if="index === 1">Streamer Role</li>
                    <li v-if="index === 1">Streamer Tournaments</li>
                    <li v-if="index === 2">Everything in Prime</li>
                    <li v-if="index === 2">{{ subscription.prime }} Prime Packs</li>
                    <li v-if="index === 2">{{ subscription.ultra }} Ultra Packs</li>
                    <li v-if="index === 2">{{ subscription.legendary }} Legendary Pack</li>
                    <li v-if="index === 2">{{ subscription.chest }} Chest</li>
                    <li v-if="index === 2">Exclusive Streamer Tournaments</li>
                    <li v-if="index === 2">Tournament Management Channel</li>
                    <li v-if="index === 2">Spotlight Features</li>
                    <li v-if="index === 3">Everything in Ultra</li>
                    <li v-if="index === 3">{{ subscription.prime }} Prime Packs</li>
                    <li v-if="index === 3">{{ subscription.ultra }} Ultra Packs</li>
                    <li v-if="index === 3">{{ subscription.legendary }} Legendary Pack</li>
                    <li v-if="index === 3">{{ subscription.chest }} Chest</li>
                    <li v-if="index === 3">Exclusive Events</li>
                    <li v-if="index === 3">Community Challenge Rewards</li>
                    <li v-if="index === 3">And Much More!</li>
                </ul>
                <button v-if="!model.isSubscribed" class="tier-button" v-on:click="selectTier(subscription.id)" :disabled="model.isSubscribed">
                  Get {{ subscription.subsName }}
                </button>
                <button v-if="subscription.cancelable && model.subscription.status !== 'canceling'" class="tier-button text-secondary" v-on:click="cancel()">Cancel</button>
                <button v-if="subscription.cancelable && model.subscription.status === 'canceling'" class="tier-button tier-button-reactivate" v-on:click="reactivate()">Reactivate</button>
            </div>
        </div>

        <div class="season-pass"> 
            <div class="season-pass-content"> 
                <h3>🎁 Gift Subscription Pass</h3> 
                <p>Surprise your friends and family with the ultimate gaming experience! 
                    The Gift Subscription Pass grants access to all tiers for an entire season, 
                    ensuring that your loved ones enjoy exclusive bonuses, limited-time rewards, and VIP tournament access.
                </p> 
                <p>With this pass, recipients can:</p> 
                <ul> 
                    <li>Unlock premium content and features across all game tiers.</li> 
                    <li>Participate in exclusive events and tournaments designed for VIP members.</li> 
                    <li>Receive special in-game rewards and bonuses that enhance their gaming experience.</li> 
                </ul>
                <button class="season-pass-button" v-on:click="selectGift()">Send Gift</button>
            </div> 
        </div>
    </div>
  </section>
`,
adminUserSubscriptions:`
  <div data-component="admin-user-subscription">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header-container">
              <h4>Payment Logs</h4>
               <input type="text" class="search-bar" v-model="model.searchTerm" placeholder="Search..." aria-label="Search">
            </div>

             <div class="row form" v-bind:class="{ visible: model.edit }">
            <div>
              <i class="bi-x-lg close subs-reset" v-on:click="reset()"></i> 
              <div class="col-12">
                <div>
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom">Status</label>
                  <select v-model="model.updateUser.status">
                    <option v-for="status in model.status" :key="status.value" :value="status.value">
                      {{ status.name }}
                    </option>
                  </select>
                </div>
               
              </div>
                <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                <button class="red top-margin" data-button="submit" v-on:click="cancel()">Cancel</button>
            </div>
          </div>
              
            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-3">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom">Date/Time</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom">TwitchId</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom">TwitchDisplayName</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Logs">Is Paid</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Logs">Subcription</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Logs">Status</label>
                  </div>
                  <div class="col-1 edit">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record." >Edit</label>
                </div>
                </div>
              </div>
            </div>
            <div v-if="!model.isLoading" class="loading">
              <div class="loader1"></div>
              <p>please wait...</p>
            </div>
            <div v-else>
              <div v-if="!model.hasResult" class="loading">
                <p>No Subscriptions Found</p>
              </div>
            </div>
             <div class="table">
                <div class="row data" v-bind:class="{ approved: data.status === 'approved', pending: data.status === 'pending', denied:  data.status === 'declined', cancelled:  data.status === 'cancelled'}" v-for="data in filteredMembers" v-on:click="edit(data.id)">
                  <div class="col-3">
                    <p>{{ data.created_at }}</p>
                  </div>
                  <div class="col-2">
                    <p>{{ data.twitchDisplayName[0].twitchId }}</p>
                  </div>
                  <div class="col-2">
                    <p>{{ data.twitchDisplayName[0].twitchDisplayName }}</p>
                  </div>
                  <div class="col-1">
                    <i v-if=" data.isPaid == true" class="bi-check-lg"></i> 
                      <i v-if="data.isPaid == false"class="bi-x-lg"></i> 
                  </div>
                  <div class="col-2">
                     <p>{{ data.subscription[0].subsName }}</p>
                  </div>
                  <div class="col-1 d-md-block">
                    <p>{{ data.status }}</p>
                  </div>
                  <div class="col-1 edit">
                    <i class="bi-pencil"></i> 
                  </div>
                </div>
              </div>
            
        </div>
      </div>
    </section>
  </div>

`,

adminFeaturedStreamers: `
  <div data-component="admin-featured-streamers">
    <section class="admin-section">
      <div class="admin-header-panel">
        <div class="admin-header-content">
          <div class="admin-header-title">
            <i class="bi-star-fill featured-icon"></i>
            <div>
              <h2>Featured Streamers</h2>
              <p class="admin-subtitle">
                {{ currentFeaturedCount }}/3 featured
              </p>
            </div>
          </div>
          <button class="admin-refresh-btn" @click="loadEligibleStreamers()">
            <i class="bi-arrow-clockwise"></i> Refresh
          </button>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="model.isLoading" class="text-center p-4">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Error State -->
      <div v-else-if="model.error" class="alert alert-danger">
        {{ model.error }}
        <button class="btn btn-sm btn-outline-danger ms-2" @click="loadEligibleStreamers()">Retry</button>
      </div>

      <template v-else>
        <!-- Currently Featured -->
        <div v-if="model.featuredStreamers.length > 0" class="featured-current-section">
          <h3><i class="bi-star-fill"></i> Currently Featured</h3>
          <div class="table-responsive">
            <table class="table admin-table">
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Streamer</th>
                  <th>Recent Activity</th>
                  <th>Featured Until</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="streamer in sortedFeaturedStreamers" :key="'featured-' + streamer.twitchId">
                  <td>
                    <select
                      :value="streamer.featuredOrder"
                      @change="updateOrder(streamer, $event.target.value)"
                      class="form-select form-select-sm order-select"
                    >
                      <option v-for="n in 3" :value="n">{{ n }}</option>
                    </select>
                  </td>
                  <td>
                    <div class="streamer-cell" @click="openTwitchChannel(streamer)">
                      <img :src="streamer.twitchProfileImage" class="streamer-avatar-sm" />
                      <span>{{ streamer.twitchDisplayName }}</span>
                    </div>
                  </td>
                  <td>
                    <span class="badge bg-info me-1">{{ streamer.recentBattles }} battles</span>
                    <span class="badge bg-secondary">{{ streamer.recentEvents }} events</span>
                  </td>
                  <td>{{ formatDate(streamer.featuredUntil) }}</td>
                  <td>
                    <button
                      class="btn btn-danger btn-sm"
                      @click="unfeatureStreamer(streamer)"
                    >
                      <i class="bi-x-lg"></i> Remove
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else class="no-featured-message">
          <i class="bi-star"></i>
          <p>No streamers are currently featured. Select from eligible streamers below.</p>
        </div>

        <!-- Eligible Streamers -->
        <div class="eligible-section mt-4">
          <h3><i class="bi-people"></i> Eligible Streamers</h3>
          <p class="text-muted">
            Streamers with active subscription and recent activity (last 30 days)
          </p>

          <div class="eligible-controls mb-3">
            <div class="search-control">
              <i class="bi-search"></i>
              <input
                type="text"
                v-model="model.searchTerm"
                class="form-control"
                placeholder="Search streamers..."
              />
            </div>
            <div class="expiry-control">
              <label class="form-label">Featured Until (optional)</label>
              <input
                type="datetime-local"
                v-model="model.featuredUntil"
                class="form-control"
              />
            </div>
          </div>

          <div v-if="filteredEligible.length === 0" class="no-eligible-message">
            <p v-if="model.searchTerm">No streamers match your search.</p>
            <p v-else>No eligible streamers found. Streamers need an active subscription and recent battle/event activity.</p>
          </div>

          <div class="table-responsive" v-else>
            <table class="table admin-table">
              <thead>
                <tr>
                  <th>Streamer</th>
                  <th>Battles (30d)</th>
                  <th>Events (30d)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="streamer in filteredEligible" :key="'eligible-' + streamer.twitchId">
                  <td>
                    <div class="streamer-cell" @click="openTwitchChannel(streamer)">
                      <img :src="streamer.twitchProfileImage" class="streamer-avatar-sm" />
                      <span>{{ streamer.twitchDisplayName }}</span>
                    </div>
                  </td>
                  <td>{{ streamer.recentBattles }}</td>
                  <td>{{ streamer.recentEvents }}</td>
                  <td>
                    <button
                      class="btn btn-primary btn-sm"
                      @click="featureStreamer(streamer)"
                      :disabled="!canAddMore"
                    >
                      <i class="bi-star"></i> Feature
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </section>
  </div>
`,

homeFeaturedStreamers: `
  <div class="home-featured-section" v-if="model.featuredStreamers.length > 0">
    <div class="home-featured-container">
      <h2 class="home-featured-title">
        <i class="bi-star-fill"></i> Featured Streamers
      </h2>
      <div class="home-featured-grid">
        <div
          v-for="streamer in sortedFeaturedStreamers"
          :key="streamer.id"
          class="home-featured-card"
          :class="{ 'is-live': streamer.isLive }"
          @click="openChannel(streamer)"
        >
          <div class="home-featured-avatar">
            <img
              :src="streamer.twitchProfileImage"
              :alt="streamer.twitchDisplayName"
              @error="$event.target.src='/images/default-avatar.png'"
            />
            <span v-if="streamer.isLive" class="live-indicator">
              <i class="bi-broadcast"></i> LIVE
            </span>
          </div>
          <div class="home-featured-info">
            <h3>{{ streamer.twitchDisplayName }}</h3>
            <p v-if="streamer.isLive" class="viewer-count">
              <i class="bi-eye"></i> {{ streamer.viewerCount }}
            </p>
            <p v-else class="offline-status">Offline</p>
          </div>
        </div>
      </div>
    </div>
  </div>
`,

userPayment: `
<div class="always-display margin-top-30">
  <div v-if="!model.isPayed">
  <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header ">
              <h4>Battledogs Checkout</h4>
            </div>

            <div class="checkout-container">

              <!-- Gift Subscription Flow -->
              <div v-if="model.isGift" class="gift-flow-container">
                  <div class="gift-flow-card">

                      <!-- Gift Header -->
                      <div class="gift-header">
                          <div class="gift-icon">
                              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                  <polyline points="20 12 20 22 4 22 4 12"></polyline>
                                  <rect x="2" y="7" width="20" height="5"></rect>
                                  <line x1="12" y1="22" x2="12" y2="7"></line>
                                  <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                                  <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
                              </svg>
                          </div>
                          <h2 class="gift-heading">Gift a Premium Subscription</h2>
                          <p class="gift-subheading">Give the gift of BattleDogs premium access</p>
                      </div>

                      <!-- Gift Form -->
                      <div class="gift-form">

                          <!-- Recipient Email -->
                          <div class="gift-input-group">
                              <label class="gift-input-label">
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                      <polyline points="22,6 12,13 2,6"></polyline>
                                  </svg>
                                  Recipient's Email
                              </label>
                              <input
                                  v-model="model.reciever"
                                  type="email"
                                  class="gift-input"
                                  :class="{ 'gift-input--valid': model.recipientVerified, 'gift-input--error': model.recipientError }"
                                  placeholder="friend@example.com"
                                  required
                                  @input="model.recipientVerified = false; model.recipientError = ''; model.recipientDisplayName = ''"
                                  @blur="verifyRecipient()"
                              >
                              <div v-if="model.recipientVerifying" class="gift-recipient-status gift-recipient-status--checking">
                                  Checking...
                              </div>
                              <div v-else-if="model.recipientVerified" class="gift-recipient-status gift-recipient-status--valid">
                                  &#10003; {{ model.recipientDisplayName }} is registered on BattleDogs
                              </div>
                              <div v-else-if="model.recipientError" class="gift-recipient-status gift-recipient-status--error">
                                  &#10007; {{ model.recipientError }}
                              </div>
                          </div>

                          <!-- Plan Selection -->
                          <div class="gift-input-group">
                              <label class="gift-input-label">
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                      <polyline points="2 17 12 22 22 17"></polyline>
                                      <polyline points="2 12 12 17 22 12"></polyline>
                                  </svg>
                                  Choose Subscription Tier
                              </label>
                              <div class="gift-plan-options">
                                  <div
                                      v-for="(subscription) in model.subscriptions"
                                      :key="subscription.id"
                                      @click="model.subscription = subscription; selectedTier()"
                                      class="gift-plan-option"
                                      :class="{ 'active': model.subscription.id === subscription.id }"
                                  >
                                      <div class="gift-plan-name">{{ subscription.subsName }}</div>
                                      <div class="gift-plan-price">\${{ subscription.subsPrice }}<span>/month</span></div>
                                  </div>
                              </div>
                          </div>

                          <!-- Gift Summary -->
                          <div class="gift-summary">
                              <div class="gift-summary-row">
                                  <span>Subscription Tier</span>
                                  <strong>{{ model.subscription.subsName }}</strong>
                              </div>
                              <div class="gift-summary-row">
                                  <span>Recipient</span>
                                  <strong>{{ model.reciever || 'Not entered' }}</strong>
                              </div>
                              <div class="gift-summary-divider"></div>
                              <div class="gift-summary-row gift-summary-total">
                                  <span>Total</span>
                                  <strong class="gift-price">\${{ model.subscription.subsPrice }}</strong>
                              </div>
                              <div class="gift-billing-note">
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <path d="M12 16v-4M12 8h.01"></path>
                                  </svg>
                                  <span>Recipient will be billed monthly after the first month</span>
                              </div>
                          </div>

                          <!-- Purchase Button -->
                          <button class="gift-purchase-btn" v-on:click="submitPayment">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                  <polyline points="20 12 20 22 4 22 4 12"></polyline>
                                  <rect x="2" y="7" width="20" height="5"></rect>
                                  <line x1="12" y1="22" x2="12" y2="7"></line>
                              </svg>
                              <span>Complete Gift Purchase</span>
                          </button>

                          <div class="gift-secure-badge">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                  <path d="M7 11V7a5 5 0 0110 0v4"></path>
                              </svg>
                              Secure payment powered by Stripe
                          </div>
                      </div>

                  </div>
              </div>

              <!-- Regular Checkout - Two Column Layout -->
              <div v-else class="checkout-grid">

                  <!-- Left Column - Plan Details -->
                  <div class="checkout-plan-section">
                      <div class="plan-card">
                          <div class="plan-header">
                              <h3 class="plan-title">{{ model.subscription.subsName }} Plan</h3>
                              <div class="plan-badge">Monthly Subscription</div>
                          </div>

                          <div class="plan-details">
                              <div class="plan-detail-row">
                                  <div class="detail-icon">
                                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                          <path d="M9 11l3 3L22 4"></path>
                                          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
                                      </svg>
                                  </div>
                                  <div class="detail-content">
                                      <span class="detail-label">Subscription Tier</span>
                                      <span class="detail-value">{{ model.subscription.subsName }}</span>
                                  </div>
                              </div>

                              <div class="plan-detail-row">
                                  <div class="detail-icon">
                                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                          <circle cx="12" cy="12" r="10"></circle>
                                          <polyline points="12 6 12 12 16 14"></polyline>
                                      </svg>
                                  </div>
                                  <div class="detail-content">
                                      <span class="detail-label">Billing Cycle</span>
                                      <span class="detail-value">Monthly recurring</span>
                                  </div>
                              </div>

                              <div class="plan-detail-row">
                                  <div class="detail-icon">
                                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                          <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"></path>
                                      </svg>
                                  </div>
                                  <div class="detail-content">
                                      <span class="detail-label">Monthly Price</span>
                                      <span class="detail-value price-highlight">\${{ model.subscription.subsPrice }}</span>
                                  </div>
                              </div>
                          </div>

                          <div class="plan-info">
                              <p class="info-text">Your subscription will automatically renew each month. Cancel anytime from your account settings.</p>
                          </div>
                      </div>
                  </div>

                  <!-- Right Column - Order Summary -->
                  <div class="checkout-summary-section">
                      <div class="summary-card">
                          <h3 class="summary-title">Order Summary</h3>

                          <div class="summary-rows">
                              <div class="summary-row">
                                  <span class="summary-label">{{ model.subscription.subsName }} Subscription</span>
                                  <span class="summary-value">\${{ model.subscription.subsPrice }}</span>
                              </div>

                              <div class="summary-divider"></div>

                              <div class="summary-row summary-total">
                                  <span class="summary-label">Total Due Today</span>
                                  <span class="summary-value total-amount">\${{ model.subscription.subsPrice }}</span>
                              </div>

                              <div class="summary-recurring">
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <path d="M12 6v6l4 2"></path>
                                  </svg>
                                  <span>Recurring monthly charge of \${{ model.subscription.subsPrice }}</span>
                              </div>
                          </div>

                          <button class="checkout-purchase-btn" v-on:click="submitPayment">
                              <span class="btn-text">Complete Purchase</span>
                              <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                              </svg>
                          </button>

                          <div class="secure-notice">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                  <path d="M7 11V7a5 5 0 0110 0v4"></path>
                              </svg>
                              <span>Secure payment powered by Stripe</span>
                          </div>
                      </div>
                  </div>

              </div>
            </div>


            
          </div>
        </div>
      </div>
  </section>  
  </div>
  <div class="payment-container" v-else>
    <div class="payment-card">
      <div class="card-header">
          <h2>Payment Processing</h2>
          <p>Please wait while we process your payment</p>
      </div>

      <div class="card-body">
          <!-- Processing State -->
          <div class="payment-status " v-bind:class="{processing: !model.paymentSuccess, success: model.paymentSuccess}" v-if="!model.paymentError">
              <div class="status-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                  </svg>
              </div>
              <div class="status-text">
                  <h3>Processing Payment</h3>
                  <p>Your payment is being processed. Please wait...</p>
              </div>
          </div>
          <div class="payment-status " v-bind:class="{processing: !model.paymentSuccess, success: model.paymentSuccess}" v-else>
              <div class="status-icon">
                <i class="bi bi-x-lg"></i>
              </div>
              <div class="status-text">
                  <h3>Processing Error</h3>
                  <p>Your payment has been failed.</p>
                  <p>{{model.errorMessage}}</p>
              </div>
              <button type="button" class="delete_team" @click="backToHomePage">Back</button>
          </div>

          <div v-if="!model.paymentError">

            <div class="progress-bar">
              <div class="progress" id="progress"></div>
            </div>

            <!-- Success State (hidden initially) -->
            <div class="payment-status" v-bind:class="{success: !model.paymentSuccess}">
                <div class="status-icon">
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                    </svg>
                </div>
                <div class="status-text">
                    <h3>Payment Successful!</h3>
                    <p>Your payment has been processed successfully.</p>
                </div>
            </div>

            <div class="payment-details" v-if="model.paymentSuccess">
                <div class="detail-row">
                    <span>Amount</span>
                    <span v-if="model.paymentSuccess">$ {{model.payment.amount}}</span>
                </div>
                <div class="detail-row">
                    <span>Date</span>
                    <span id="current-date">{{model.payment.date}}</span>
                </div>
                <div class="detail-row">
                    <span>Transaction ID</span>
                    <span>{{model.payment.transactionId}}</span>
                </div>
            </div>
          
          </div>
          
        <div class="text text-primary" style="margin: 20px;" v-if="model.redirect">
         <span>Redirecting to homepage in <span class="red">{{model.countDownTimer}}</span> seconds...</span>
        </div>
      </div>
    </div>
  </div>
</div>
`,
adminEvents:`
  <div data-component="admin-events">
    <section class="quest-line-section">
      <div class="quest-line-container">
        
        <!-- Header Panel -->
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-calendar-event"></i>
              <div>
                <h2>Events Builder</h2>
                <p class="admin-subtitle quest-subtitle">Create and manage event campaigns</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>New Event</span>
            </button>
          </div>
        </div>

        <!-- Edit Form Sidebar -->
        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i> 
            <div class="col-12 scroll_sidebar">
                    <div>
                      <h5>Broadcast Event</h5>
                      <hr>
                      <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="users: select users.">Select Users</label>
                          <select class="form-select" v-model="model.event.selectedUser" @change="selectUsers">
                          <option  v-for="userOption in model.userOptions" :key="userOption.value" :value="userOption.value">
                            {{ userOption.name }}
                          </option>
                        </select>
                      </div>
                      <div v-if="model.event.selectedUser == 'all' ">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="tier: select user tier.">Select Tier</label>
                        <select class="form-select" v-model="model.event.userTier" @change="selectUsers">
                          <option  v-for="userTier in model.userTiers" :key="userTier.value" :value="userTier.value">
                            {{ userTier.name }}
                          </option>
                        </select>
                      </div>
                      <div v-if="model.event.selectedUser != 'specificuser'">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Level: required level.">Level Required</label>
                          <select class="form-select" v-model="model.event.levelOption" @change="levelRequired">
                            <option  v-for="levelOption in model.levelOptions" :key="levelOption.value" :value="levelOption.value">
                              {{ levelOption.name }}
                            </option>
                          </select>
                          <div v-if="model.event.levelOption != 'all'" >
                            <input class="form-control" v-model="model.event.level" type="number">
                          </div>
                      </div>
                      <div v-else>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                        <input class="form-control search" name="unlock-user" v-on:keyup="searchStreamers()" type="text">
                        <div class="admin-event">
                          <label v-for="(selectedUser, index) in model.event.selectedUsers">{{selectedUser}} <i class="bi bi-x" @click="removeSelectedUser(index)"></i></label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: event name.">Event Name</label>
                      <input class="form-control" v-model="model.event.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: event description.">Event Description</label>
                      <textarea cols="50" type="text" class="form-control" v-model="model.event.description"></textarea>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tournament Description">From</label>
                      <input rows="4" cols="50" type="datetime-local" class="form-control" v-model="model.event.from"></input>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tournament Description">To</label>
                      <input rows="4" cols="50" type="datetime-local" class="form-control" v-model="model.event.to"></input>
                    </div>
                    <div>
                      <h5>Option</h5>
                      <hr>
                      <div class="radio-input">
                        <label>
                          <input type="radio" class="input" name="options" @change="inputValue('tournament')">
                          Tournament
                        </label>
                        <label>
                          <input type="radio" class="input" name="options" @change="inputValue('quest')">
                          Quest
                        </label>
                        <label>
                          <input type="radio" class="input" checked name="options"  @change="inputValue('others')">
                          Custom
                        </label>
                      </div>
                    </div>
                    
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Enable Keys</label>
                        <div class="form-check form-switch">
                          <input @change="enableKey" v-model="model.event.keyEnabled" type="checkbox" class="form-check-input">
                        </div>
                        <div v-if="model.event.keyEnabled">
                          <div>
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Select Keys</label>
                            <select class="form-select" v-model="model.event.keyId" @change="selectedKey(value)">
                                <option v-for="(value, key) in model.keys" v-bind:value="key">
                                  {{ value.name }}
                                </option>
                            </select>
                            <div>
                              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Keys amount to be given away">Keys Amount</label>
                              <input class="form-control" v-model="model.event.keys_amount" type="Number">
                            </div>
                          </div>
                          <div>
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Select Custom Tier</label>
                            <div class="form-check form-switch">
                              <input @change="selectCustomTier(model.event.tierKey)" v-model="model.event.tierKey" type="checkbox" class="form-check-input">
                            </div>
                            <div v-if="model.event.tierKey">
                               <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="tier: select user tier.">Select Tier</label>
                              <select class="form-select" v-model="model.event.keyTier" @change="selectUsers">
                                <option  v-for="userTier in filteredUserTiers" :key="userTier.value" :value="userTier.value">
                                  {{ userTier.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    <div v-if="model.isTournamentEnabled">
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="select a tournament.">Select Existing Tournament</label>
                        <div class="form-check form-switch">
                          <input v-model="model.existingTournament" @change="tournamentEnabled" type="checkbox" class="form-check-input">
                        </div>
                      </div>
                      <div v-if="model.existingTournament">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="select existing tournament.">Select Tournament</label>
                        <select class="form-select" v-model="model.event.tournamentId" @change="selectUsers">
                          <option  v-for="tournament in model.tournaments" :key="tournament.id" :value="tournament.id">
                            {{ tournament.name }}
                          </option>
                        </select>
                      </div>
                      <div v-else>
                        <TournamentForm
                          :model="model.event.tournament"
                          :players="model.players"
                          :options="model.option"
                          :battleOptions="model.battle_options"
                          @input-changed="handleInputChange"
                        />
                      </div>
                    </div>
                    <div v-if="model.isQuestEnabled">
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Select Existing Quest</label>
                        <div class="form-check form-switch">
                          <input v-model="model.existingQuest" @change="questEnabled" type="checkbox" class="form-check-input">
                        </div>
                      </div>
                      <div v-if="model.existingQuest">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="select existing quest.">Select Quest</label>
                        <select class="form-select" v-model="model.event.questId" @change="selectUsers">
                          <option  v-for="quest in model.quests" :key="quest.id" :value="quest.id">
                            {{ quest.name }}
                          </option>
                        </select>
                      </div>
                      <QuestForm v-else
                        :model="model.event.quest"
                        :cards="model.cards"
                        :packs="model.packs"
                        :randomcard="model.randomcard"
                        @input-changed="handleQuestChange"
                      />
                    </div>
                    <div v-if="!model.hasData">
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Select Login Options</label>
                        <div class="form-check form-switch">
                          <input @change="loginSelected" v-model="model.loginSelected" type="checkbox" class="form-check-input">
                        </div>
                        <div v-if="model.loginSelected">
                          <div>
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Enable Login Streak</label>
                            <div class="form-check form-switch">
                              <input @change="loginstreak" v-model="model.event.loginStreak" type="checkbox" class="form-check-input">
                            </div>
                          </div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Login days count</label>
                          <input class="form-control" v-model="model.event.loginCount" type="Number">
                        </div>
                      </div>
                    </div>
                    <div v-if="model.isCustomEnabled && model.event.custom">
                      <h5>Rules</h5>
                      <hr>
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Choose bracket.">Battle Options</label>
                        <select class="form-select" v-model="model.event.custom.battleOption" @change="selectedBattleOptions">
                            <option  v-for="battleOption in model.battle_options" :key="battleOption.value" :value="battleOption.value">
                              {{ battleOption.name }}
                            </option>
                          </select>
                      </div>
                      <div>
                        <div class="radio-input">
                          <label>
                            <input type="radio" class="input" name="options" value="to_win" v-model="model.event.custom.selectedMode">
                            To win
                          </label>
                          <label>
                            <input type="radio" class="input" name="options" value="to_defeat" v-model="model.event.custom.selectedMode">
                            To defeat
                          </label>
                          <label>
                            <input type="radio" class="input" name="options" value="any" v-model="model.event.custom.selectedMode">
                            Both
                          </label>
                          <label>
                            <input type="radio" class="input" name="options" value="battle" v-model="model.event.custom.selectedMode">
                            Battle
                          </label>
                        </div>
                      </div>
                      <div>
                        <h6>Card Configuration</h6>
                          <hr>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Create Team</label>
                          <div class="form-check form-switch">
                            <input v-model="model.event.custom.cardTeam" @change="generateCardTeam(model.event.custom.cardTeam)" type="checkbox" class="form-check-input">
                          </div>
                          <div v-if="model.event.custom.cardTeam">
                            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Team Name</label>
                              <input class="form-control" v-model="model.event.custom.teamName" type="text">
                          </div>
                          <event-card-manager
                            :event-cards="model.event.custom.cards"
                            :temporary-cards="model.event.custom.temporaryCards"
                            :available-cards="model.cards"
                            :abilities="model.abilities"
                            :types="model.types"
                            :traits="model.traits"
                            :mode="model.event.custom.cardManagementMode"
                            :is-team-enabled="model.event.custom.cardTeam"
                            :battle-type="model.event.custom.battleOption"
                            @mode-changed="handleCardModeChange"
                            @cards-updated="handleExistingCardsUpdate"
                            @temporary-cards-updated="handleTemporaryCardsUpdate"
                            @card-selected="handleCardSelection"
                          />
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Wins: how many wins needed to finish the event">Wins needed</label>
                          <input class="form-control" v-model="model.event.custom.wins" type="number">
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Attempt count">Attempt Count</label>
                          <input class="form-control" v-model="model.event.custom.attempt" type="number">
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Retry count">Retry Count</label>
                          <input class="form-control" v-model="model.event.custom.retry" type="number">
                        </div>

                      </div>
                    </div>
                    
                    <h5>Rewards</h5>
                    <hr>
                    <!-- Rewards -->
                    <RewardsComponent
                        :rewards="model.event.rewards"
                        :packs="model.packs"
                        :randomcard="model.randomcard"
                        :selectedCards="model.cards"
                        :eventCards="model.activeEventCards"
                        :frames="model.frames"
                        :backgrounds="model.backgrounds"
                        :cardBacks="model.cardBacks"
                        :exotic-cards="model.exoticCards"
                        @reward-changed="handleRewardChange"
                    />
              
              <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Event
              </button>
            </div>
          </div>
        </div>

        <!-- Events Table -->
        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-toggle">
                  <i class="bi-eye"></i>
                </th>
                <th class="th-name">Event Name</th>
                <th class="th-rules">Description</th>
                <th class="th-date">Start Date</th>
                <th class="th-date">End Date</th>
                <th class="th-mode">Type</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(event, index) in model.events" :key="index">
                <!-- Main Event Row -->
                <tr class="admin-table-row quest-row" :class="{ 'expanded': model.expandedRow === index }">
                  <td class="td-toggle" @click="toggleDetails(index)">
                    <button class="admin-toggle-btn toggle-btn" :class="{ 'active': model.expandedRow === index }">
                      <i v-if="model.expandedRow === index" class="bi-eye-fill"></i>
                      <i v-else class="bi-eye-slash"></i>
                    </button>
                  </td>
                  <td class="td-name" @click="toggleDetails(index)">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ event.name }}</span>
                    </div>
                  </td>
                  <td class="td-rules" @click="toggleDetails(index)">
                    <span class="admin-rules-text rules-text" :title="event.description">{{ event.description }}</span>
                  </td>
                  <td class="td-date" @click="toggleDetails(index)">
                    <div class="date-cell">
                      <span class="date-value">{{ formattedDate(event.from) }}</span>
                    </div>
                  </td>
                  <td class="td-date" @click="toggleDetails(index)">
                    <div class="date-cell">
                      <span class="date-value">{{ formattedDate(event.to) }}</span>
                    </div>
                  </td>
                  <td class="td-mode" @click="toggleDetails(index)">
                    <span class="admin-badge-mode mode-badge" :class="getEventType(event).toLowerCase()">
                      {{ getEventType(event) }}
                    </span>
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(event.id)" title="Edit Event">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
                
                <!-- Expanded Details Row -->
                <tr class="admin-details-row quest-details-row" v-show="model.expandedRow === index">
                  <td colspan="7">
                    <div class="admin-details-panel quest-details-panel">
                      <div class="details-grid">

                        
                        <!-- Custom Event Details -->
                        <template v-if="event.custom">
                          <!-- Custom Event Rules -->
                          <div class="detail-card">
                            <div class="detail-card-header">
                              <i class="bi-gear"></i>
                              <h4>Custom Event Rules</h4>
                            </div>
                            <div class="detail-card-body">
                              <div class="rewards-grid">
                                <div class="reward-item">
                                  <span class="reward-label">Battle Rules</span>
                                  <span class="reward-value">{{ battleRules(event.custom.selectedMode) }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Battle Mode</span>
                                  <span class="reward-value">{{ event.custom.battleOption }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Wins Needed</span>
                                  <span class="reward-value">{{ event.custom.wins }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Retry Count</span>
                                  <span class="reward-value">{{ event.custom.retry }}</span>
                                </div>
                                <div class="reward-item" v-if="event.custom.key">
                                  <span class="reward-label">Key</span>
                                  <span class="reward-value">{{ event.custom.key[0] ? event.custom.key[0].name : 'n/a' }}</span>
                                </div>
                                <div class="reward-item" v-if="event.custom.keys_amount">
                                  <span class="reward-label">Key Amount</span>
                                  <span class="reward-value">{{ event.custom.keys_amount }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Custom Event Cards -->
                          <div class="detail-card">
                            <div class="detail-card-header">
                              <i class="bi-collection"></i>
                              <h4>Required Cards</h4>
                            </div>
                            <div class="detail-card-body">
                              <table class="mini-table">
                                <thead>
                                  <tr>
                                    <th>Card Name</th>
                                    <th>Tier</th>
                                    <th>Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="card in event.custom.cards" :key="card.cardId" v-if="event.custom.cards && event.custom.cards.length > 0">
                                    <td>{{ card.name || 'Unknown' }}</td>
                                    <td><span class="tier-badge">T{{ card.tier }}</span></td>
                                    <td><span class="type-badge">Existing</span></td>
                                  </tr>
                                  <tr v-for="card in event.custom.temporaryCards" :key="card.id" v-if="event.custom.temporaryCards && event.custom.temporaryCards.length > 0">
                                    <td>{{ card.name }} {{ card.baseCardId === '' ? '(Event Card)' : '(Custom Card)' }}</td>
                                    <td><span class="tier-badge">T{{ card.tier }}</span></td>
                                    <td><span class="type-badge custom">Custom</span></td>
                                  </tr>
                                  <tr v-if="(!event.custom.cards || event.custom.cards.length === 0) && (!event.custom.temporaryCards || event.custom.temporaryCards.length === 0)">
                                    <td colspan="3" class="empty-state">No cards required</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </template>
                        <!-- Tournament Event Details -->
                        <template v-if="event.tournament">
                          <div class="detail-card">
                            <div class="detail-card-header">
                              <i class="bi-trophy"></i>
                              <h4>Tournament Details</h4>
                            </div>
                            <div class="detail-card-body">
                              <div class="rewards-grid">
                                <div class="reward-item">
                                  <span class="reward-label">Name</span>
                                  <span class="reward-value">{{ event.tournament.name }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Description</span>
                                  <span class="reward-value">{{ event.tournament.description }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Players</span>
                                  <span class="reward-value">{{ event.tournament.players }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Rounds</span>
                                  <span class="reward-value">{{ event.tournament.round }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Battle Option</span>
                                  <span class="reward-value">{{ event.tournament.battleOption }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Selected Option</span>
                                  <span class="reward-value">{{ event.tournament.selectedOptions }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Status</span>
                                  <span class="reward-value" :class="event.tournament.isActive ? 'status-active' : 'status-inactive'">
                                    {{ event.tournament.isActive ? 'Active' : 'Inactive' }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>

                        <!-- Quest Event Details -->
                        <template v-if="event.quest">
                          <div class="detail-card">
                            <div class="detail-card-header">
                              <i class="bi-list-task"></i>
                              <h4>Quest Details</h4>
                            </div>
                            <div class="detail-card-body">
                              <div class="rewards-grid">
                                <div class="reward-item">
                                  <span class="reward-label">Quest Name</span>
                                  <span class="reward-value">{{ event.quest.name }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Description</span>
                                  <span class="reward-value">{{ event.quest.description }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Start Date/Time</span>
                                  <span class="reward-value">{{ formattedDate(event.quest.date) }} {{ event.quest.time }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Level Required</span>
                                  <span class="reward-value">Lv. {{ event.quest.level }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Mode</span>
                                  <span class="reward-value">{{ event.quest.selectedMode === 'any' ? 'Both' : event.quest.selectedMode }}</span>
                                </div>
                                <div class="reward-item">
                                  <span class="reward-label">Wins Needed</span>
                                  <span class="reward-value">{{ event.quest.wins }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Quest Cards -->
                          <div class="detail-card" v-if="event.quest.cards && event.quest.cards.length > 0">
                            <div class="detail-card-header">
                              <i class="bi-collection"></i>
                              <h4>Required Cards</h4>
                            </div>
                            <div class="detail-card-body">
                              <table class="mini-table">
                                <thead>
                                  <tr>
                                    <th>Card Name</th>
                                    <th>Tier</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="card in event.quest.cards" :key="card.cardId">
                                    <td>{{ card.name || 'Unknown' }}</td>
                                    <td><span class="tier-badge">T{{ card.tier }}</span></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </template>
                        <!-- Tasks Section -->
                        <div class="detail-card" v-if="event.task && event.task.length > 0">
                          <div class="detail-card-header">
                            <i class="bi-list-check"></i>
                            <h4>Tasks ({{ getTotalTaskCount(event) }})</h4>
                            <button class="detail-card-action" @click="addTaskToEvent(event, index)">
                              <i class="bi-plus-lg"></i> Add Task
                            </button>
                          </div>
                          <div class="detail-card-body">
                            <taskComponent
                              v-for="(task, taskIndex) in event.task"
                              :key="task.id"
                              :id="task.id"
                              :index="index"
                              :taskIndex="taskIndex"
                              :existingTask="task"
                              :packs="model.packs"
                              :cards="model.cards"
                              :temporaryCards="model.eventCards"
                              :randomcard="model.randomcard" 
                              @update-task="updateTask($event, taskIndex, index)"
                              @remove-task="removeTask(taskIndex, index)"
                              @input-changed="updateTaskData($event, taskIndex, index)"
                              @save-task="saveTask"
                              @reorder-tasks="reorderTasks"
                            />
                          </div>
                        </div>

                        <!-- Rewards Section -->
                        <div class="detail-card" v-if="event.rewards">
                          <div class="detail-card-header">
                            <i class="bi-gift"></i>
                            <h4>Rewards</h4>
                          </div>
                          <div class="detail-card-body">
                            <div class="rewards-grid">
                              <div class="reward-item">
                                <span class="reward-label">Barks</span>
                                <span class="reward-value" v-if="event.rewards.barks > 0">{{ event.rewards.barks }}</span>
                                <span class="reward-value empty" v-else>—</span>
                              </div>
                              <div class="reward-item">
                                <span class="reward-label">XP Amount</span>
                                <span class="reward-value" v-if="event.rewards.xp > 0">{{ event.rewards.xp }}</span>
                                <span class="reward-value empty" v-else>—</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Packs/Chest Section -->
                        <div class="detail-card" v-if="event.rewards && event.rewards.givePack && event.rewards.givePack.length > 0">
                          <div class="detail-card-header">
                            <i class="bi-box-seam"></i>
                            <h4>Packs / Chests</h4>
                          </div>
                          <div class="detail-card-body">
                            <table class="mini-table">
                              <thead>
                                <tr>
                                  <th>Pack Name</th>
                                  <th>Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="pack in event.rewards.givePack" :key="pack.packId">
                                  <td>{{ pack.name || 'Unknown Pack' }}</td>
                                  <td><span class="qty-badge">x{{ pack.packs_quantity }}</span></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <!-- Random Cards Section -->
                        <div class="detail-card" v-if="event.rewards && event.rewards.randomCard && event.rewards.randomCard.length > 0">
                          <div class="detail-card-header">
                            <i class="bi-shuffle"></i>
                            <h4>Random Cards</h4>
                          </div>
                          <div class="detail-card-body">
                            <table class="mini-table">
                              <thead>
                                <tr>
                                  <th>Card Tier</th>
                                  <th>Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="randomCards in event.rewards.randomCard" :key="randomCards.randomCard">
                                  <td>
                                    <span v-if="randomCards.randomCard === 1" class="card-tier standard">Standard</span>
                                    <span v-else-if="randomCards.randomCard === 2" class="card-tier ultra">Ultra</span>
                                    <span v-else-if="randomCards.randomCard === 3" class="card-tier legendary">Legendary</span>
                                    <span v-else-if="randomCards.randomCard === 4" class="card-tier ultimate">Ultimate</span>
                                    <span v-else-if="randomCards.randomCard === 5" class="card-tier bone">Bone</span>
                                    <span v-else-if="randomCards.randomCard === 6" class="card-tier ascension">Ascension</span>
                                    <span v-else class="card-tier none">None</span>
                                  </td>
                                  <td>
                                    <span v-if="randomCards.random_amount > 0" class="qty-badge">x{{ randomCards.random_amount }}</span>
                                    <span v-else class="qty-badge empty">—</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              
              <!-- Empty State -->
              <tr v-if="Object.keys(model.events).length === 0">
                <td colspan="7" class="empty-table-state">
                  <div class="empty-content">
                    <i class="bi-inbox"></i>
                    <p>No events created yet</p>
                    <button class="quest-add-btn small" v-on:click="add()">
                      <i class="bi-plus-lg"></i> Create First Event
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>
`,

eventCardManager:`
  <div class="event-card-manager">
    <div class="card-type-selector mb-3">
      <div>
          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Create New Temporary Cards</label>
          <div class="form-check form-switch">
            <input @change="setCardMode(selectCardMode)" v-model="selectCardMode" type="checkbox" class="form-check-input">
          </div>
        </button>
      </div>
    </div>

    <!-- Existing Cards Mode -->
    <div v-if="cardMode === 'existing'">
      <div v-for="(card, index) in eventCards" :key="'existing-' + index" class="">
        <div class="row">
          <div class="col-6">
            <label>Select Card</label>
            <select class="form-select" v-model="card.cardId" @change="loadCardStats(card, index)">
              <option value="">-- Select Card --</option>
              <option v-for="(cardData, cardId) in availableCards" :key="cardId" :value="cardId">
                {{ cardData.name }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Tier</label>
            <input class="form-control" v-model.number="card.tier" type="number" min="1">
          </div>
          <div class="col-md-2">
            <button class="remove_button" @click="removeCard(index)" v-if="index > 0" :disabled="isTeamEnabled">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    
      <button data-button type="button" @click="addExistingCard" :disabled="isTeamEnabled">
        <i class="bi bi-plus"></i>
      </button>
    </div>

    <!-- Temporary Cards Mode -->
    <div v-if="cardMode === 'temporary'">
      <button data-button type="button" @click="addTemporaryCard" :disabled="isTeamEnabled">
        <i class="bi bi-plus"></i> Add Temporary Card
      </button>
      <div v-for="(card, index) in temporaryCards" :key="'temp-' + index" class="">
        <div class="row mb-2">
          <div class="col-md-8">
            <div class="form-check">
              <input 
                class="form-check-input" 
                type="checkbox" 
                :id="'modify-existing-' + index"
                v-model="card.isModified"
                @change="toggleModifyMode(card, index)"
              >
              <label class="form-check-label" :for="'modify-existing-' + index">
                Modify existing card
              </label>
            </div>
          </div>
          <div class="">
            <button class="remove_button" @click="removeTemporaryCard(index)" v-if="index > 0" :disabled="isTeamEnabled">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>

        <!-- Base Card Selection (if modifying) -->
        <div v-if="card.isModified" class="row mb-3">
          <div class="col-md-12">
            <label>Base Card</label>
            <select class="form-select" v-model="card.baseCardId" @change="loadBaseCardForModification(card)">
              <option value="">-- Select Base Card --</option>
              <option v-for="(cardData, cardId) in availableCards" :key="cardId" :value="cardId">
                {{ cardData.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Card Details -->
        <div class="row">
          <div>
            <label>Card Name</label>
            <input
              class="form-control"
              v-model="card.name"
              type="text"
              :readonly="card.isModified && card.baseCardId"
              placeholder="Enter card name"
            >
          </div>
          <div>
            <label>Tier</label>
            <input class="form-control" v-model.number="card.tier" type="number" min="1">
          </div>
          <div>
            <label>Type</label>
            <select class="form-select" v-model="card.type">
              <option v-for="(type, id) in types" :key="id" :value="id">
                {{ type.name }}
              </option>
            </select>
          </div>
          <div>
            <label>Ability</label>
            <select class="form-select" v-model="card.ability">
              <option value="">No Ability Selected</option>
              <option v-for="(ability, id) in abilities" :key="id" :value="id">
                {{ ability.name }}
              </option>
            </select>
          </div>
          <div>
            <label>Innate Trait</label>
            <select class="form-select" v-model="card.trait">
              <option value="">No Trait</option>
              <option v-for="trait in traits" :key="trait.id" :value="trait.id">
                {{ trait.name }} — {{ trait.description }}
              </option>
            </select>
          </div>
          <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active cards are available for giveaway rewards.">Active</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" v-model="card.active" :true-value="1" :false-value="0" @change="$emit('temporary-cards-updated', temporaryCards)">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="">
            <label>HP</label>
            <input class="form-control" v-model.number="card.hp" type="number" min="0">
          </div>
        </div>

        <h6 style="margin-top: 15px; color: #ffc107; border-bottom: 1px solid #ffc107; padding-bottom: 5px;">Battle Stats</h6>
        <div class="row">
          <div class="">
            <label>P-ATK (Physical Attack)</label>
            <input class="form-control" v-model.number="card.pAtk" type="number" min="0">
          </div>
          <div class="">
            <label>M-ATK (Magic Attack)</label>
            <input class="form-control" v-model.number="card.mAtk" type="number" min="0">
          </div>
          <div class="">
            <label>Armor (Physical Defense)</label>
            <input class="form-control" v-model.number="card.armor" type="number" min="0">
          </div>
          <div class="">
            <label>Ward (Magic Defense)</label>
            <input class="form-control" v-model.number="card.ward" type="number" min="0">
          </div>
          <div class="">
            <label>Accuracy</label>
            <input class="form-control" v-model.number="card.accuracy" type="number" min="0" max="100">
          </div>
          <div class="">
            <label>Speed</label>
            <input class="form-control" v-model.number="card.speed" type="number" min="0">
          </div>
          <div class="">
            <label>Crit Chance (%)</label>
            <input class="form-control" v-model.number="card.critChance" type="number" min="0" max="100">
          </div>
          <div class="">
            <label>Crit Damage (%)</label>
            <input class="form-control" v-model.number="card.critDamage" type="number" min="100" max="500">
          </div>
        </div>

        <h6 style="margin-top: 15px; color: #17a2b8; border-bottom: 1px solid #17a2b8; padding-bottom: 5px;">Resources</h6>
        <div class="row">
          <div class="">
            <label>Stamina</label>
            <input class="form-control" v-model.number="card.stamina" type="number" min="1">
          </div>
          <div class="">
            <label>Mana</label>
            <input class="form-control" v-model.number="card.mana" type="number" min="1">
          </div>
        </div>

        <!-- Show original vs modified stats if modifying -->
        <div v-if="card.isModified && card.originalStats" class="mt-2">
          <small class="text-muted">
            Original: HP:{{ card.originalStats.hp }} P-ATK:{{ card.originalStats.pAtk }}
            M-ATK:{{ card.originalStats.mAtk }} Armor:{{ card.originalStats.armor }}
            Ward:{{ card.originalStats.ward }} SPD:{{ card.originalStats.speed }}
            ACC:{{ card.originalStats.accuracy }}
          </small>
        </div>
      </div>
    </div>
  </div>
`, 

adminRewardPoints: `
  <div data-component="admin-reward-points">
   <section>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <!-- Points Configuration Section -->
            <div class="row" style="margin-top: 40px;">
              <div class="col-12">
                <div class="card">
                  <div class="header">
                    <h4>Points Configuration</h4>
                    <button class="top-margin" data-button="submit" @click="addPointsConfig()">Add Configuration</button>
                  </div>

                  <!-- Edit Form -->
                  <div class="row form" v-bind:class="{ visible: model.config_edit }">
                    <div>
                      <i class="bi-x-lg close" @click="resetPointsConfigForm()"></i>
                      <div class="col-12">
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Activity Type">Activity Type</label>
                          <input class="form-control" v-model="model.points_config_form.activity_type" type="text" placeholder="e.g., battle, subscription">
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Activity Name">Activity Name</label>
                          <input class="form-control" v-model="model.points_config_form.activity_name" type="text" placeholder="e.g., Battle Participation">
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Points Value">Points Value</label>
                          <input class="form-control" v-model.number="model.points_config_form.points_value" type="number" min="0">
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description">Description</label>
                          <textarea class="form-control" v-model="model.points_config_form.description" rows="3" placeholder="Optional description"></textarea>
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active Status">
                            <input type="checkbox" :checked="model.points_config_form.active" @change="model.points_config_form.active = $event.target.checked ? 1 : 0"> Active
                          </label>
                        </div>
                      </div>
                      <button class="top-margin" data-button="submit" @click="savePointsConfig()">Save</button>
                    </div>
                  </div>

                  <!-- Configuration Table -->
                  <div class="row">
                    <div class="col-12">
                      <div class="row columns">
                        <div class="col-2">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Activity Type</label>
                        </div>
                        <div class="col-3">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Activity Name</label>
                        </div>
                        <div class="col-2">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Points</label>
                        </div>
                        <div class="col-2">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Status</label>
                        </div>
                        <div class="col-2">
                        </div>
                      </div>
                      <div class="table">
                        <div class="row data" v-for="config in model.points_config" :key="config.id">
                          <div class="col-2">
                            <p>{{ config.activity_type }}</p>
                          </div>
                          <div class="col-3">
                            <p>{{ config.activity_name }}</p>
                          </div>
                          <div class="col-2">
                            <p><strong>{{ config.points_value }}</strong></p>
                          </div>
                          <div class="col-2">
                            <p>
                              <span v-if="config.active" class="badge bg-success redemption">Active</span>
                              <span v-else class="badge bg-danger">Inactive</span>
                            </p>
                          </div>
                          <div class="col-2 edit">
                            <i class="bi-pencil" @click="editPointsConfig(config)" :title="config.description || 'No description'" style="cursor: pointer;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            </div>

          </div>
        </div>
    </section>
  </div>

`,

sideButtons: `
  <div class="always-display">
     <!-- Floating Buttons -->
    <div class="floating-group" aria-hidden="false">

      <button class="fab events" @click="openEvents" title="Events" aria-label="Events">
        <!-- simple calendar icon (svg) -->
        <svg width="35" height="35" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 11h5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" opacity="0.95"/>
          <rect x="3" y="5" width="18" height="16" rx="2" stroke="white" stroke-width="1.6" fill="none" opacity="0.95"/>
          <path d="M16 3v4M8 3v4" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
        <span class="fab-label">Events</span>
        <span class="sparkle"></span>
      </button>

      <button class="fab notifications" @click="openAnnouncement" title="Announcements" aria-label="Announcements">
        <!-- bell icon -->
        <svg width="35" height="35" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0 1 18 14.158V11c0-3.07-1.64-5.64-4.5-6.32V4a1.5 1.5 0 1 0-3 0v.68C7.64 5.36 6 7.92 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="fab-label">Announcements</span>
        <span class="sparkle"></span>
        <span class="badge" id="notifBadge">3</span>
      </button>
    </div>
  </div>
`,
TournamentForm: `
    <div>
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tournament name">Tournament Name</label>
            <input class="form-control" 
                   :value="tournament.name || ''" 
                   @input="updateField('name', $event.target.value)" 
                   type="text">
        </div>
        
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tournament Description">Description</label>
            <textarea rows="4" cols="50" 
                      class="form-control" 
                      :value="tournament.description || ''" 
                      @input="updateField('description', $event.target.value)">
            </textarea>
        </div>
        
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Choose How many players.">Players</label>
            <select class="form-select" 
                    :value="tournament.players || ''" 
                    @change="updateField('players', $event.target.value)">
                <option value="">Select Number of Players</option>
                <option v-for="player in players" :key="player.value" :value="player.value">
                    {{ player.name }}
                </option>
            </select>
        </div>
        
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Choose Option.">Options</label>
            <select class="form-select" 
                    :value="tournament.selectedOption || ''" 
                    @change="updateField('selectedOption', $event.target.value)">
                <option v-for="(value, key) in options" :key="key" :value="key">
                    {{ value.name }}
                </option>
            </select>
        </div>
        
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Choose bracket.">Battle Options</label>
            <select class="form-select" 
                    :value="tournament.battleOption || ''" 
                    @change="updateField('battleOption', $event.target.value)">
                <option value="">Select Battle Option</option>
                <option v-for="battleOption in battleOptions" :key="battleOption.value" :value="battleOption.value">
                    {{ battleOption.name }}
                </option>
            </select>
        </div>
        
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: enable autobattle.">Auto Battle</label>
            <div class="form-check form-switch">
                <input :checked="tournament.autobattle || false" 
                       type="checkbox" 
                       class="form-check-input" 
                       @change="updateField('autobattle', $event.target.checked)">
            </div>
        </div>
        
        <div v-if="tournament.battleOption === 'single'">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Multiple Battle">Multiple Battle</label>
            <div class="form-check form-switch">
                <input :checked="tournament.multipleBattle || false" 
                       type="checkbox" 
                       class="form-check-input" 
                       @change="updateField('multipleBattle', $event.target.checked)">
            </div>
        </div>
        
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: enable faction only.">Faction Only</label>
            <div class="form-check form-switch">
                <input :checked="tournament.faction || false" 
                       type="checkbox" 
                       class="form-check-input" 
                       @change="handleFactionChange($event.target.checked)">
            </div>
        </div>
        
        <div v-if="tournament.faction">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Faction Wars">Faction Wars</label>
            <div class="form-check form-switch">
                <input :checked="tournament.universalFaction || false" 
                       type="checkbox" 
                       class="form-check-input" 
                       @change="handleUniversalFactionChange($event.target.checked)">
            </div>
        </div>
        
        <div v-if="tournament.faction">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Inner Faction Wars">Inner Faction Wars</label>
            <div class="form-check form-switch">
                <input :checked="tournament.innerFaction || false" 
                       type="checkbox" 
                       class="form-check-input" 
                       @change="handleInnerFactionChange($event.target.checked)">
            </div>
        </div>
`,
QuestForm: `
   <div>
    <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Level: required level.">Level Required</label>
        <input class="form-control" :value="model.level" @input="updateField('level', $event.target.value)" type="number">
    </div>
    
    <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Quest name.">Quest Name</label>
        <input class="form-control" :value="model.name" @input="updateField('name', $event.target.value)" type="text">
    </div>
    
    <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Quest rule.">Quest Rules</label>
        <textarea class="form-control" :value="model.description" @input="updateField('description', $event.target.value)"></textarea>
    </div>
     
    <!-- Date and Time -->
    <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Data: when will the quest start">Date</label>
        <input class="form-control" :value="model.date" @input="updateField('date', $event.target.value)" type="date">
    </div>
    
    <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Time: when will the quest start">Time</label>
        <input class="form-control" :value="model.time" @input="updateField('time', $event.target.value)" type="time">
    </div>
    
    <div>
        <div class="radio-input">
            <label>
                <input type="radio" class="input" name="options" value="to_win" 
                       :checked="model.selectedMode === 'to_win'"
                       @change="updateField('selectedMode', $event.target.value)">
                To win
            </label>
            <label>
                <input type="radio" class="input" name="options" value="to_defeat"
                       :checked="model.selectedMode === 'to_defeat'" 
                       @change="updateField('selectedMode', $event.target.value)">
                To defeat
            </label>
            <label>
                <input type="radio" class="input" name="options" value="any"
                       :checked="model.selectedMode === 'any'" 
                       @change="updateField('selectedMode', $event.target.value)">
                Both
            </label>
        </div>
    </div>
    
    <!-- Cards Section -->
    <div>
        <button data-button type="button" @click="incrementCards">
            <i class="bi bi-plus"></i>
        </button>
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Card">Card</label>
            <select class="form-select" :value="model.cards && model.cards[0] ? model.cards[0].cardId : ''" 
                    @change="updateCard(0, 'cardId', $event.target.value)">
                <option v-for="(value, key) in cards" :value="key" :key="key">
                    {{ value.name }}
                </option>
            </select>
        </div>
        <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom">Card Tier</label>
            <input class="form-control" :value="model.cards && model.cards[0] ? model.cards[0].tier : ''" 
                   @input="updateCard(0, 'tier', $event.target.value)" type="number">
        </div>
    </div>
    
    <!-- Additional Cards -->
    <div v-if="cardAmount >= 1">
        <div v-for="(card, index) in (model.cards || []).slice(1)" :key="index + 1">
            <div>
                <button data-button type="button" class="remove_button" @click="removeCard(index + 1)">
                  <i class="bi bi-dash"></i>
                </button>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Achievement: Select a medal you want to give to a user.">Card</label>
                <select class="form-select" :value="card.cardId" @change="updateCard(index + 1, 'cardId', $event.target.value)">
                    <option v-for="(value, key) in cards" :value="key" :key="key">
                        {{ value.name }}
                    </option>
                </select>
            </div>
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Achievement: Select a medal you want to give to a user.">Card Tier</label>
                <input class="form-control" :value="card.tier" @input="updateCard(index + 1, 'tier', $event.target.value)" type="number">
            </div>
        </div>
    </div>

    <div>
      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Wins: how many wins needed to finish the quest">Wins needed</label>
      <input class="form-control" :value="model.wins" @input="updateField('wins', $event.target.value)" type="number">
    </div>

</div>
`,

StreamerRewardsComponent: `
<div class="streamer-rewards-component">
    <!-- XP Reward -->
    <div class="reward-section">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="XP value to reward viewers">XP Reward</label>
        <input class="form-control" :value="safeRewards.xp || 0" @input="updateField('xp', $event.target.value)" type="number" min="0">
    </div>

    <!-- Barks Reward -->
    <div class="reward-section">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Barks (currency) to reward viewers">Barks Reward</label>
        <input class="form-control" :value="safeRewards.barks || 0" @input="updateField('barks', $event.target.value)" type="number" min="0">
    </div>

    <!-- Pack Rewards Section -->
    <div class="reward-section" v-if="hasAvailablePacks">
        <div class="reward-header">
            <button data-button type="button" @click="incrementPack" class="btn-add">
                <i class="bi bi-plus"></i>
            </button>
            <label>Add Pack Reward</label>
            <small class="text-muted">(From your inventory)</small>
        </div>

        <!-- First Pack -->
        <div class="reward-item">
            <div class="reward-row">
                <div class="reward-field">
                    <label>Select Pack</label>
                    <select class="form-select" :value="getPackValue(0, 'packId')" @change="updatePack(0, 'packId', $event.target.value)">
                        <option value="">-- Select Pack --</option>
                        <option v-for="(pack, key) in availablePacks" :value="key" :key="key">
                            {{ pack.name }} ({{ pack.availableQuantity }} available)
                        </option>
                    </select>
                </div>
                <div class="reward-field quantity-field">
                    <label>Quantity</label>
                    <input class="form-control"
                        :value="getPackValue(0, 'packs_quantity')"
                        @input="updatePack(0, 'packs_quantity', $event.target.value)"
                        type="number"
                        min="0"
                        :max="getMaxPackQuantity(getPackValue(0, 'packId'))">
                </div>
            </div>
        </div>

        <!-- Additional Packs -->
        <div v-if="packsAmount > 0">
            <div v-for="(pack, index) in additionalPacks" :key="'pack-' + (index + 1)" class="reward-item">
                <div class="reward-row">
                    <button data-button type="button" class="btn-remove" @click="removePack(index + 1)">
                        <i class="bi bi-dash"></i>
                    </button>
                    <div class="reward-field">
                        <label>Select Pack</label>
                        <select class="form-select" :value="getPackValue(index + 1, 'packId')" @change="updatePack(index + 1, 'packId', $event.target.value)">
                            <option value="">-- Select Pack --</option>
                            <option v-for="(packOption, key) in availablePacks" :value="key" :key="key">
                                {{ packOption.name }} ({{ packOption.availableQuantity }} available)
                            </option>
                        </select>
                    </div>
                    <div class="reward-field quantity-field">
                        <label>Quantity</label>
                        <input class="form-control"
                            :value="getPackValue(index + 1, 'packs_quantity')"
                            @input="updatePack(index + 1, 'packs_quantity', $event.target.value)"
                            type="number"
                            min="0">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="reward-section text-muted">
        <i class="bi bi-info-circle"></i> No packs available in your inventory to give as rewards.
    </div>


    <!-- Chest Rewards Section -->
    <div class="reward-section" v-if="canGiveChests">
        <div class="reward-header">
            <button data-button type="button" @click="incrementChest" class="btn-add">
                <i class="bi bi-plus"></i>
            </button>
            <label>Add Chest Reward</label>
            <small class="text-muted">({{ effectiveInventory.chest }} available)</small>
        </div>

        <!-- First Chest -->
        <div class="reward-item">
            <div class="reward-row">
                <div class="reward-field">
                    <label>Select Chest</label>
                    <select class="form-select" :value="getChestValue(0, 'chestId')" @change="updateChest(0, 'chestId', $event.target.value)">
                        <option value="">-- Select Chest --</option>
                        <option v-for="(chest, key) in chests" :value="key" :key="key">
                            {{ chest.name }} ({{ chest.availableQuantity }} available)
                        </option>
                    </select>
                </div>
                <div class="reward-field quantity-field">
                    <label>Quantity</label>
                    <input class="form-control"
                        :value="getChestValue(0, 'chest_quantity')"
                        @input="updateChest(0, 'chest_quantity', $event.target.value)"
                        type="number"
                        min="0"
                        :max="getMaxChestQuantity(getChestValue(0, 'chestId'))">
                </div>
            </div>
        </div>

        <!-- Additional Chests -->
        <div v-if="chestsAmount > 0">
            <div v-for="(chest, index) in additionalChests" :key="'chest-' + (index + 1)" class="reward-item">
                <div class="reward-row">
                    <button data-button type="button" class="btn-remove" @click="removeChest(index + 1)">
                        <i class="bi bi-dash"></i>
                    </button>
                    <div class="reward-field">
                        <label>Select Chest</label>
                        <select class="form-select" :value="getChestValue(index + 1, 'chestId')" @change="updateChest(index + 1, 'chestId', $event.target.value)">
                            <option value="">-- Select Chest --</option>
                            <option v-for="(chestOption, key) in chests" :value="key" :key="key">
                                {{ chestOption.name }} ({{ chestOption.availableQuantity }} available)
                            </option>
                        </select>
                    </div>
                    <div class="reward-field quantity-field">
                        <label>Quantity</label>
                        <input class="form-control"
                            :value="getChestValue(index + 1, 'chest_quantity')"
                            @input="updateChest(index + 1, 'chest_quantity', $event.target.value)"
                            type="number"
                            min="0">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="reward-section text-muted">
        <i class="bi bi-info-circle"></i> No chests available in your inventory to give as rewards.
    </div>

    <!-- Exclusive Card Rewards Section -->
    <div class="reward-section" v-if="hasOwnedExclusiveCards">
        <div class="reward-header">
            <button data-button type="button" @click="incrementExclusiveCard" class="btn-add">
                <i class="bi bi-plus"></i>
            </button>
            <label>Add Exclusive Card Reward</label>
            <small class="text-muted">(From your reward shop purchases)</small>
        </div>

        <!-- First Exclusive Card -->
        <div class="reward-item">
            <div class="reward-row">
                <div class="reward-field">
                    <label>Select Card</label>
                    <select class="form-select" :value="getExclusiveCardValue(0, 'cardId')" @change="updateExclusiveCard(0, 'cardId', $event.target.value)">
                        <option value="">-- Select Card --</option>
                        <option v-for="(card, key) in ownedExclusiveCards" :value="key" :key="key">
                            {{ card.name }} (x{{ card.quantity || 1 }} available)
                        </option>
                    </select>
                </div>
                <div class="reward-field quantity-field">
                    <label>Quantity</label>
                    <input class="form-control"
                        :value="getExclusiveCardValue(0, 'card_quantity')"
                        @input="updateExclusiveCard(0, 'card_quantity', $event.target.value)"
                        type="number"
                        min="0"
                        :max="getMaxExclusiveCardQuantity(getExclusiveCardValue(0, 'cardId')) + (parseInt(getExclusiveCardValue(0, 'card_quantity')) || 0)">
                </div>
            </div>
        </div>

        <!-- Additional Exclusive Cards -->
        <div v-if="exclusiveCardsAmount > 0">
            <div v-for="(card, index) in additionalExclusiveCards" :key="'exclusive-' + (index + 1)" class="reward-item">
                <div class="reward-row">
                    <button data-button type="button" class="btn-remove" @click="removeExclusiveCard(index + 1)">
                        <i class="bi bi-dash"></i>
                    </button>
                    <div class="reward-field">
                        <label>Select Card</label>
                        <select class="form-select" :value="getExclusiveCardValue(index + 1, 'cardId')" @change="updateExclusiveCard(index + 1, 'cardId', $event.target.value)">
                            <option value="">-- Select Card --</option>
                            <option v-for="(cardOption, key) in ownedExclusiveCards" :value="key" :key="key">
                                {{ cardOption.name }} (x{{ cardOption.quantity || 1 }} available)
                            </option>
                        </select>
                    </div>
                    <div class="reward-field quantity-field">
                        <label>Quantity</label>
                        <input class="form-control"
                            :value="getExclusiveCardValue(index + 1, 'card_quantity')"
                            @input="updateExclusiveCard(index + 1, 'card_quantity', $event.target.value)"
                            type="number"
                            min="0"
                            :max="getMaxExclusiveCardQuantity(getExclusiveCardValue(index + 1, 'cardId')) + (parseInt(getExclusiveCardValue(index + 1, 'card_quantity')) || 0)">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="reward-section text-muted">
        <i class="bi bi-info-circle"></i> No exclusive cards available. Purchase cards from the reward points shop first.
    </div>

    <!-- Owned Shop Items Section -->
    <div class="reward-section" v-if="canGiveShopItems">
        <div class="reward-header">
            <button data-button type="button" @click="incrementShopItem" class="btn-add">
                <i class="bi bi-plus"></i>
            </button>
            <label>Add Owned Shop Item Reward</label>
            <small class="text-muted">(Items you've purchased)</small>
        </div>

        <!-- First Shop Item -->
        <div class="reward-item">
            <div class="reward-row">
                <div class="reward-field full-width">
                    <label>Select Owned Item</label>
                    <select class="form-select" :value="getShopItemValue(0, 'itemId')" @change="updateShopItemSelection(0, $event.target.value)">
                        <option value="">-- Select Item --</option>
                        <option v-for="item in ownedShopItems" :value="item.id" :key="item.id">
                            {{ item.displayName }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!-- Additional Shop Items -->
        <div v-if="shopItemsAmount > 0">
            <div v-for="(item, index) in additionalShopItems" :key="'shopitem-' + (index + 1)" class="reward-item">
                <div class="reward-row">
                    <button data-button type="button" class="btn-remove" @click="removeShopItem(index + 1)">
                        <i class="bi bi-dash"></i>
                    </button>
                    <div class="reward-field full-width">
                        <label>Select Owned Item</label>
                        <select class="form-select" :value="getShopItemValue(index + 1, 'itemId')" @change="updateShopItemSelection(index + 1, $event.target.value)">
                            <option value="">-- Select Item --</option>
                            <option v-for="itemOption in ownedShopItems" :value="itemOption.id" :key="itemOption.id">
                                {{ itemOption.displayName }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`,

RewardsComponent: `
    <div>
        <!-- XP and Barks -->
        <div v-if="hasXp">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="XP value to be rewarded.">XP Value</label>
            <input class="form-control" :value="rewards.xp || 0" @input="updateField('xp', $event.target.value)" type="number">
        </div>
        <div v-if="hasBarks">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of barks to be rewarded.">Barks Value</label>
            <input class="form-control" :value="rewards.barks || 0" @input="updateField('barks', $event.target.value)" type="number">
        </div>
        
        <!-- Packs Section -->
        <div v-if="hasGivePack">
            <div>
                <button data-button type="button" @click="incrementPack">
                    <i class="bi bi-plus"></i>
                </button>
                <label>Add Pack Reward</label>
            </div>
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select packs to reward.">Select Packs</label>
                <select class="form-select" :value="getPackValue(0, 'packId')" @change="updatePack(0, 'packId', $event.target.value)">
                    <option value="">-- Select Pack --</option>
                    <option v-for="(pack, key) in packs" :value="key" :key="key">
                        {{ pack.name }}
                    </option>
                </select>
            </div>
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Quantity of packs to give.">Quantity</label>
                <input class="form-control" :value="getPackValue(0, 'packs_quantity')" @input="updatePack(0, 'packs_quantity', $event.target.value)" type="number">
            </div>
        </div>
        
        <!-- Additional Packs -->
        <div v-if="packsAmount > 0">
            <div v-for="(pack, index) in additionalPacks" :key="'pack-' + (index + 1)">
                <div>
                    <button data-button type="button" class="remove_button" @click="removePack(index + 1)">
                        <i class="bi bi-dash"></i>
                    </button>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select packs to reward.">Select Packs</label>
                    <select class="form-select" :value="getPackValue(index + 1, 'packId')" @change="updatePack(index + 1, 'packId', $event.target.value)">
                        <option value="">-- Select Pack --</option>
                        <option v-for="(packOption, key) in packs" :value="key" :key="key">
                            {{ packOption.name }}
                        </option>
                    </select>
                </div>
                <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Quantity of packs to give.">Quantity</label>
                    <input class="form-control" :value="getPackValue(index + 1, 'packs_quantity')" @input="updatePack(index + 1, 'packs_quantity', $event.target.value)" type="number">
                </div>
            </div>
        </div>
        
        <!-- Random Cards Section -->
        <div v-if="hasRandomCard">
          <div>
            <button data-button type="button" @click="incrementRandomCards">
                <i class="bi bi-plus"></i>
            </button>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add random card reward.">Add Random Card Reward</label>
          </div>
          <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select random card tier.">Select Random Card</label>
            <select class="form-select" :value="getRandomCardValue(0, 'randomCard')" @change="updateRandomCard(0, 'randomCard', $event.target.value)">
                <option value="">-- Select Card Type --</option>
                <option v-for="(card, key) in randomcard" :value="key" :key="key" v-if="card.name">
                    {{ card.name }}
                </option>
            </select>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of random cards to give.">Random Card Amount</label>
            <input class="form-control" :value="getRandomCardValue(0, 'random_amount')" @input="updateRandomCard(0, 'random_amount', $event.target.value)" type="number">
          </div>

          <!-- Additional Random Cards -->
          <div v-if="randomAmount > 0">
              <div v-for="(random, index) in additionalRandomCards" :key="'random-' + (index + 1)">
                  <div>
                      <button data-button type="button" class="remove_button" @click="removeRandomCard(index + 1)">
                          <i class="bi bi-dash"></i>
                      </button>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select random card tier.">Select Random Card</label>
                      <select class="form-select" :value="getRandomCardValue(index + 1, 'randomCard')" @change="updateRandomCard(index + 1, 'randomCard', $event.target.value)">
                          <option value="">-- Select Card Type --</option>
                          <option v-for="(cardOption, key) in randomcard" :value="key" :key="key" v-if="cardOption.name">
                              {{ cardOption.name }}
                          </option>
                      </select>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of random cards to give.">Random Card Amount</label>
                      <input class="form-control" :value="getRandomCardValue(index + 1, 'random_amount')" @input="updateRandomCard(index + 1, 'random_amount', $event.target.value)" type="number">
                  </div>
              </div>
          </div>
        </div>

        <!-- Selected Cards -->
        <div v-if="hasSelectedCard">
          <div>
            <button data-button type="button" @click="incrementSelectedCards">
                <i class="bi bi-plus"></i>
            </button>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="select card reward.">Add Card Reward</label>
          </div>
          <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select card.">Select Card</label>
            <select class="form-select" :value="getSelectedCardValue(0, 'cardId')" @change="updateSelectedCard(0, 'cardId', $event.target.value)">
                <option value="">-- Select Card --</option>
                <option v-for="(card, key) in selectedCards" :value="key" :key="key" v-if="card.name">
                    {{ card.name }}
                </option>
            </select>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Amount</label>
            <input class="form-control" :value="getSelectedCardValue(0, 'card_amount')" @input="updateSelectedCard(0, 'card_amount', $event.target.value)" type="number">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Tier</label>
            <input class="form-control" :value="getSelectedCardValue(0, 'card_tier')" @input="updateSelectedCard(0, 'card_tier', $event.target.value)" type="number">
          </div>

          <!-- Additional Selected Cards -->
          <div v-if="cardAmount > 0">
              <div v-for="(cards, index) in additionalSelectedCards" :key="'cards-' + (index + 1)">
                  <div>
                      <button data-button type="button" class="remove_button" @click="removeSelectedCard(index + 1)">
                          <i class="bi bi-dash"></i>
                      </button>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select card.">Select Card</label>
                      <select class="form-select" :value="getSelectedCardValue(index + 1, 'cardId')" @change="updateSelectedCard(index + 1, 'cardId', $event.target.value)">
                          <option value="">-- Select Card --</option>
                          <option v-for="(cardOption, key) in selectedCards" :value="key" :key="key" v-if="cardOption.name">
                              {{ cardOption.name }}
                          </option>
                      </select>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Amount</label>
                      <input class="form-control" :value="getSelectedCardValue(index + 1, 'card_amount')" @input="updateSelectedCard(index + 1, 'card_amount', $event.target.value)" type="number">
                     
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Tier</label>
                      <input class="form-control" :value="getSelectedCardValue(index + 1, 'card_tier')" @input="updateSelectedCard(index + 1, 'card_tier', $event.target.value)" type="number">
                  </div>
              </div>
          </div>
        </div>

        <!-- EVent Cards -->
        <div v-if="hasEventCard">
          <div>
            <button data-button type="button" @click="incrementEventCards">
                <i class="bi bi-plus"></i>
            </button>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="select card reward.">Add Event Card Reward</label>
          </div>
          <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select card.">Select Card</label>
            <select class="form-select" :value="getEventCardValue(0, 'id')" @change="updateEventCard(0, 'id', $event.target.value)">
                <option value="">-- Select Card --</option>
                <option v-for="(card, key) in eventCards" :value="card.id" :key="key" v-if="card.name">
                    {{ card.name }}
                </option>
            </select>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Amount</label>
            <input class="form-control" :value="getEventCardValue(0, 'card_amount')" @input="updateEventCard(0, 'card_amount', $event.target.value)" type="number">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Tier</label>
            <input class="form-control" :value="getEventCardValue(0, 'card_tier')" @input="updateEventCard(0, 'card_tier', $event.target.value)" type="number">
          </div>

          <!-- Additional Selected Cards -->
          <div v-if="eventCardAmount > 0">
              <div v-for="(cards, index) in additionalEventCards" :key="'event-cards-' + (index + 1)">
                  <div>
                      <button data-button type="button" class="remove_button" @click="removeEventCard(index + 1)">
                          <i class="bi bi-dash"></i>
                      </button>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select card.">Select Card</label>
                      <select class="form-select" :value="getEventCardValue(index + 1, 'id')" @change="updateEventCard(index + 1, 'id', $event.target.value)">
                          <option value="">-- Select Card --</option>
                          <option v-for="(cardOption, key, i) in eventCards" :value="cardOption.id" :key="key" v-if="cardOption.name">
                              {{ cardOption.name }}
                          </option>
                      </select>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Amount</label>
                      <input class="form-control" :value="getEventCardValue(index + 1, 'card_amount')" @input="updateEventCard(index + 1, 'card_amount', $event.target.value)" type="number">
                     
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of cards to give.">Card Tier</label>
                      <input class="form-control" :value="getEventCardValue(index + 1, 'card_tier')" @input="updateEventCard(index + 1, 'card_tier', $event.target.value)" type="number">
                  </div>
              </div>
          </div>
        </div>

        <!-- Variant Cards -->
        <div v-if="hasVariantCard">
          <div>
            <button data-button type="button" @click="incrementVariantCards">
                <i class="bi bi-plus"></i>
            </button>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add variant card reward.">Add Variant Card Reward</label>
          </div>
          <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select variant card.">Select Variant Card</label>
            <select class="form-select" :value="getVariantCardValue(0, 'cardId')" @change="updateVariantCard(0, 'cardId', $event.target.value)">
                <option value="">-- Select Variant Card --</option>
                <option v-for="card in variantCards" :value="card.id" :key="card.id">
                    {{ card.name }}
                </option>
            </select>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of variant cards to give.">Card Amount</label>
            <input class="form-control" :value="getVariantCardValue(0, 'card_amount')" @input="updateVariantCard(0, 'card_amount', $event.target.value)" type="number">
          </div>

          <!-- Additional Variant Cards -->
          <div v-if="variantCardAmount > 0">
              <div v-for="(cards, index) in additionalVariantCards" :key="'variant-cards-' + (index + 1)">
                  <div>
                      <button data-button type="button" class="remove_button" @click="removeVariantCard(index + 1)">
                          <i class="bi bi-dash"></i>
                      </button>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select variant card.">Select Variant Card</label>
                      <select class="form-select" :value="getVariantCardValue(index + 1, 'cardId')" @change="updateVariantCard(index + 1, 'cardId', $event.target.value)">
                          <option value="">-- Select Variant Card --</option>
                          <option v-for="card in variantCards" :value="card.id" :key="card.id">
                              {{ card.name }}
                          </option>
                      </select>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of variant cards to give.">Card Amount</label>
                      <input class="form-control" :value="getVariantCardValue(index + 1, 'card_amount')" @input="updateVariantCard(index + 1, 'card_amount', $event.target.value)" type="number">
                  </div>
              </div>
          </div>
        </div>

        <!-- Delta Cards -->
        <div v-if="hasDeltaCard">
          <div>
            <button data-button type="button" @click="incrementDeltaCards">
                <i class="bi bi-plus"></i>
            </button>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add delta card reward.">Add Delta Card Reward</label>
          </div>
          <div>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select delta card.">Select Delta Card</label>
            <select class="form-select" :value="getDeltaCardValue(0, 'deltaCardId')" @change="updateDeltaCard(0, 'deltaCardId', $event.target.value)">
                <option value="">-- Select Delta Card --</option>
                <option v-for="card in deltaCards" :value="card.id" :key="card.id">
                    {{ card.name }} — {{ card.category }}
                </option>
            </select>
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of delta cards to give.">Amount</label>
            <input class="form-control" :value="getDeltaCardValue(0, 'card_amount')" @input="updateDeltaCard(0, 'card_amount', $event.target.value)" type="number">
          </div>

          <!-- Additional Delta Cards -->
          <div v-if="deltaCardAmount > 0">
              <div v-for="(cards, index) in additionalDeltaCards" :key="'delta-cards-' + (index + 1)">
                  <div>
                      <button data-button type="button" class="remove_button" @click="removeDeltaCard(index + 1)">
                          <i class="bi bi-dash"></i>
                      </button>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select delta card.">Select Delta Card</label>
                      <select class="form-select" :value="getDeltaCardValue(index + 1, 'deltaCardId')" @change="updateDeltaCard(index + 1, 'deltaCardId', $event.target.value)">
                          <option value="">-- Select Delta Card --</option>
                          <option v-for="card in deltaCards" :value="card.id" :key="card.id">
                              {{ card.name }} — {{ card.category }}
                          </option>
                      </select>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Amount of delta cards to give.">Amount</label>
                      <input class="form-control" :value="getDeltaCardValue(index + 1, 'card_amount')" @input="updateDeltaCard(index + 1, 'card_amount', $event.target.value)" type="number">
                  </div>
              </div>
          </div>
        </div>

        <!-- Exotic Card Prize (1-of-a-Kind) -->
        <div v-if="hasExoticCard">
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select an exotic card as the exclusive 1-of-a-kind event prize.">
                    <i class="bi-gem"></i> Exotic Card Prize
                </label>
                <select class="form-select" :value="getExoticCardValue(0, 'cardId')" @change="updateExoticCard(0, 'cardId', $event.target.value)">
                    <option value="">-- No Exotic Prize --</option>
                    <option v-for="(card, key) in exoticCards" :value="key" :key="key" v-if="card.name">
                        {{ card.name }}
                    </option>
                </select>
            </div>
        </div>

        <!-- Reward Frames/Backgrounds Section -->
        <div v-if="hasRewardFrames">
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select reward type: single frame, single background, or multiple items">Reward Type</label>
                <select class="form-select" :value="rewardFrameMode" @change="updateRewardFrameMode($event.target.value)">
                    <option value="single-frame">Single Frame</option>
                    <option value="single-background">Single Background</option>
                    <option value="multiple">Multiple Items</option>
                </select>
            </div>

            <!-- Selection Dropdown -->
            <div v-if="rewardFrameMode === 'multiple'">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Hold Ctrl/Cmd to select multiple items">Select Frames/Backgrounds</label>
                <select
                    class="form-select"
                    multiple
                    size="8"
                    v-model="rewardFramesSelectedIds"
                    style="min-height: 200px;">
                    <optgroup label="Frames" v-if="Object.keys(frames).length > 0">
                        <option
                            v-for="(frame, key) in frames"
                            :value="key"
                            :key="'f-'+key">
                            {{ frame.name }} [Frame]
                        </option>
                    </optgroup>
                    <optgroup label="Backgrounds" v-if="Object.keys(backgrounds).length > 0">
                        <option
                            v-for="(bg, key) in backgrounds"
                            :value="key"
                            :key="'b-'+key">
                            {{ bg.name }} [Background]
                        </option>
                    </optgroup>
                </select>
                <small class="form-text text-muted">Hold Ctrl (Windows) or Cmd (Mac) to select multiple items</small>
            </div>

            <!-- Single Selection Dropdown -->
            <div v-else>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select a frame or background">Select Item</label>
                <select
                    class="form-select"
                    :value="selectedRewardItems.length > 0 ? selectedRewardItems[0].id : ''"
                    @change="updateRewardFramesSelection([$event.target.value])">
                    <option value="">-- Select {{ rewardFrameMode === 'single-frame' ? 'Frame' : 'Background' }} --</option>
                    <option
                        v-for="item in availableRewardItems"
                        :value="item.id"
                        :key="item.id">
                        {{ item.displayName }}
                    </option>
                </select>
            </div>

            <!-- Preview Section -->
            <div v-if="selectedRewardItemsPreview.length > 0" style="margin-top: 15px;">
                <label>Selected Items Preview:</label>
                <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; margin-top: 10px;">
                    <div
                        v-for="item in selectedRewardItemsPreview"
                        :key="item.id"
                        style="border: 1px solid #ddd; border-radius: 4px; padding: 8px; text-align: center; position: relative;">
                        <button
                            type="button"
                            @click="removeRewardItem(item.id)"
                            style="position: absolute; top: 5px; right: 5px; background: #dc3545; color: white; border: none; border-radius: 50%; width: 20px; height: 20px; cursor: pointer; font-size: 12px; line-height: 1;"
                            title="Remove">
                            &times;
                        </button>
                        <img
                            :src="getRewardItemImage(item)"
                            :alt="item.name"
                            style="width: 100%; height: 100px; object-fit: cover; border-radius: 4px; margin-bottom: 5px;">
                        <div style="font-size: 12px; font-weight: bold;">{{ item.name }}</div>
                        <div style="font-size: 10px; color: #666;">{{ item.type === 'frame' ? '[Frame]' : '[Background]' }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Card Backs Section -->
        <div v-if="hasRewardCardBacks">
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select card backing rewards. Hold Ctrl/Cmd to select multiple.">Select Card Back Rewards</label>
                <select
                    class="form-select"
                    multiple
                    size="6"
                    v-model="cardBacksSelectedIds"
                    style="min-height: 150px;">
                    <option
                        v-for="(back, key) in cardBacks"
                        :value="key"
                        :key="'cb-' + key">
                        {{ back.name }}
                    </option>
                </select>
                <small class="form-text text-muted">Hold Ctrl (Windows) or Cmd (Mac) to select multiple</small>
            </div>

            <!-- Preview -->
            <div v-if="selectedCardBacksPreview.length > 0" style="margin-top: 15px;">
                <label>Selected Card Backs:</label>
                <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 10px; margin-top: 10px;">
                    <div
                        v-for="back in selectedCardBacksPreview"
                        :key="back.id"
                        style="border: 1px solid #ddd; border-radius: 4px; padding: 8px; text-align: center; position: relative;">
                        <button
                            type="button"
                            @click="removeCardBackItem(back.id)"
                            style="position: absolute; top: 5px; right: 5px; background: #dc3545; color: white; border: none; border-radius: 50%; width: 20px; height: 20px; cursor: pointer; font-size: 12px; line-height: 1;"
                            title="Remove">
                            &times;
                        </button>
                        <img
                            :src="\`\${root}/images/card-backs/\${back.id}.png\`"
                            :alt="back.name"
                            style="width: 100%; height: 100px; object-fit: contain; border-radius: 4px; margin-bottom: 5px;"
                            @error="$event.target.style.display='none'">
                        <div style="font-size: 12px; font-weight: bold;">{{ back.name }}</div>
                        <div style="font-size: 10px; color: #666;">[Card Back]</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Chest Rewards Section -->
        <div v-if="hasGiveChest">
            <div>
                <button data-button type="button" @click="incrementChest">
                    <i class="bi bi-plus"></i>
                </button>
                <label>Add Chest Reward</label>
            </div>
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select chest to reward.">Select Chest</label>
                <select class="form-select" :value="getChestValue(0, 'chestId')" @change="updateChest(0, 'chestId', $event.target.value)">
                    <option value="">-- Select Chest --</option>
                    <option v-for="(chest, key) in chests" :value="key" :key="key">
                        {{ chest.name }}
                    </option>
                </select>
            </div>
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Quantity of chests to give.">Quantity</label>
                <input class="form-control" :value="getChestValue(0, 'chest_quantity')" @input="updateChest(0, 'chest_quantity', $event.target.value)" type="number" min="0">
            </div>

            <!-- Additional Chests -->
            <div v-if="chestsAmount > 0">
                <div v-for="(chest, index) in additionalChests" :key="'chest-' + (index + 1)">
                    <div>
                        <button data-button type="button" class="remove_button" @click="removeChest(index + 1)">
                            <i class="bi bi-dash"></i>
                        </button>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select chest to reward.">Select Chest</label>
                        <select class="form-select" :value="getChestValue(index + 1, 'chestId')" @change="updateChest(index + 1, 'chestId', $event.target.value)">
                            <option value="">-- Select Chest --</option>
                            <option v-for="(chestOption, key) in chests" :value="key" :key="key">
                                {{ chestOption.name }} ({{ chestOption.availableQuantity }} available)
                            </option>
                        </select>
                    </div>
                    <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Quantity of chests to give.">Quantity</label>
                        <input class="form-control" :value="getChestValue(index + 1, 'chest_quantity')" @input="updateChest(index + 1, 'chest_quantity', $event.target.value)" type="number" min="0">
                    </div>
                </div>
            </div>
        </div>

        <!-- Owned Shop Items Rewards Section -->
        <div v-if="hasGiveShopItem">
            <div>
                <button data-button type="button" @click="incrementShopItem">
                    <i class="bi bi-plus"></i>
                </button>
                <label>Add Owned Shop Item Reward</label>
            </div>
            <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select an owned shop item to reward.">Select Owned Item</label>
                <select class="form-select" :value="getShopItemValue(0, 'itemId')" @change="updateShopItemSelection(0, $event.target.value)">
                    <option value="">-- Select Item --</option>
                    <option v-for="item in ownedShopItems" :value="item.id" :key="item.id">
                        {{ item.displayName }}
                    </option>
                </select>
                <small class="text-muted" v-if="ownedShopItems.length === 0">No owned shop items available. Purchase items from the shop first.</small>
            </div>

            <!-- Additional Shop Items -->
            <div v-if="shopItemsAmount > 0">
                <div v-for="(item, index) in additionalShopItems" :key="'shopitem-' + (index + 1)">
                    <div>
                        <button data-button type="button" class="remove_button" @click="removeShopItem(index + 1)">
                            <i class="bi bi-dash"></i>
                        </button>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select an owned shop item to reward.">Select Owned Item</label>
                        <select class="form-select" :value="getShopItemValue(index + 1, 'itemId')" @change="updateShopItemSelection(index + 1, $event.target.value)">
                            <option value="">-- Select Item --</option>
                            <option v-for="itemOption in ownedShopItems" :value="itemOption.id" :key="itemOption.id">
                                {{ itemOption.displayName }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

    </div>
`,

taskComponent: `
  <div class="row task-item" 
     :key="id" 
     :id="id"
     draggable="true"
     @dragstart="onDragStart($event)"
     @dragover="onDragOver($event)"
     @drop="onDrop($event)"
     @dragend="onDragEnd($event)"
     :class="{ 'dragging': isDragging }"
    >
    <div class="drag-handle">
      <i class="bi-grip-vertical"></i>
    </div>
    <div class="col-5">
      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Task #{{ taskIndex + 1 }}</label>
      <input class="form-control" type="text" v-model="model.task" @input="updateField('task', $event.target.value)">
    </div>
    <div class="col-5">
      <div @click="openRewardsModule(taskIndex)">
        <span>
          {{ [
            model.barks ? 'Barks' : null,
            model.xp ? 'XP' : null,
            model.randomCard ? 'Random Cards' : null,
            model.selectedCard ? 'Selected Cards' : null,
            model.give_pack ? 'Packs' : null,
            model.eventCard ? 'Event Card' : null,
          ].filter(Boolean).join(', ') || '?Select Rewards?' }}
        </span>
      </div>
    </div>
    <div class="col-2">
      <i class="bi-check-lg" title="save task" @click="saveTask( index, taskIndex)"></i>
      <i class="bi-x-lg" title="remove task" @click="removeTask(index, taskIndex)"></i>
    </div>
      <div class="menu-container">
      <div class="submenu-pointer" :class="model.eventIndex === taskIndex ? 'task-reward' : ''"></div>
        <div class="submenu" :class="model.eventIndex === taskIndex ? 'task-reward' : ''">
          <div class="submenu-content">
            <div class="options-column">
                <div class="option-group">
                  <div class="option-item">
                      <input type="checkbox" v-model="model.barks" @click="selectReward('barks')">
                      <label >Barks</label>
                  </div>
                  <div class="option-item">
                      <input type="checkbox" v-model="model.xp" @click="selectReward('xp')">
                      <label >XP</label>
                  </div>
                  <div class="option-item">
                      <input type="checkbox" v-model="model.randomCard" @click="selectReward('randomcard')">
                      <label>Random Cards</label>
                  </div>
                  <div class="option-item">
                      <input type="checkbox" v-model="model.selectedCard" @click="selectReward('card')">
                      <label>Select Cards</label>
                  </div>
                  <div class="option-item">
                    <input type="checkbox" v-model="model.eventCard" @click="selectReward('event_card')">
                    <label>Select Event Cards</label>
                  </div>
                  <div class="option-item">
                      <input type="checkbox" v-model="model.give_pack" @click="selectReward('pack')">
                      <label>Packs</label>
                  </div>
                  <div class="option-item">
                      <input type="checkbox" v-model="model.frames" @click="selectReward('frames')">
                      <label>Frames</label>
                  </div>
              </div>       
            </div>
            <div class="input-column">
                <div class="input-item">
                      <RewardsComponent
                        :rewards="model.rewards"
                        :packs="model.packs"
                        :randomcard="model.randomcard"
                        :selectedCards="model.cards"
                        :eventCards="model.event_cards"
                        :frames="model.frames"
                        :backgrounds="model.backgrounds"
                        :cardBacks="model.cardBacks"
                        @reward-changed="handleRewardChange"
                    />
                </div>
            </div>
          </div>
      </div>
      </div>
  </div>
    <!---
    <div class="col-1">
      
    </div> -->
`,

userEvents: `
<div data-component="user-events">

  <section class="ue-section">

    <!-- Atmospheric background layer -->
    <div class="ue-bg-layer" aria-hidden="true">
      <div class="ue-grid-overlay"></div>
      <div class="ue-orb uo1"></div>
      <div class="ue-orb uo2"></div>
      <div class="ue-particle p1"></div>
      <div class="ue-particle p2"></div>
      <div class="ue-particle p3"></div>
      <div class="ue-particle p4"></div>
      <div class="ue-particle p5"></div>
      <div class="ue-particle p6"></div>
    </div>

    <div class="events-bg">

      <!-- ── NO EVENT STATE ───────────────────────────────────── -->
      <div v-if="!model.hasEvent">
        <div class="coming-soon ue-coming-soon" v-if="!model.eventOpen">
          <div class="ue-cs-inner">
            <div class="ue-radar"></div>
            <h1 class="ue-cs-title">Coming Soon</h1>
            <p class="ue-cs-sub">New events are being prepared for deployment</p>
          </div>
        </div>
        <div v-else>
          <div data-component="battle-arena" class="always-display">
            <button @click="backToEvent" class="battle-exit-btn" title="Exit Battle" :disabled="model.battle.saving" :class="{'is-disabled': model.battle.saving}">&#10005;</button>
            <div id="singleMode">
              <div class="content">
                <div class="arena" v-bind:class="{ show: model.battle.show.cards }">
                  <div class="arena-row">
                    <div class="cards-side cards-left cards-1">
                      <div class="card-stack">
                        <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.battle.cards1"></playing-card>
                      </div>
                    </div>
                    <div class="log-panel log" v-bind:class="{ show: model.battle.show.logs }">
                      <div class="log-title">Battle Log</div>
                      <div v-for="log in model.battle.logs" class="log-entry" :class="['log-' + log.type, log.tier ? 'tier-' + log.tier : '', log.tier === 1 ? 'tier-prime' : '', log.tier === 2 ? 'tier-ultra' : '', log.tier === 3 ? 'tier-legendary' : '']">
                        <div class="log-message">{{ log.message }}</div>
                        <div v-if="log.type === 'attack' && log.meta" class="log-details">
                          <span v-if="log.meta.physicalDamage > 0" class="damage-physical">
                            ⚔️ {{ log.meta.physicalDamage }} ({{ log.meta.pAtk }}-{{ log.meta.armor }})
                          </span>
                          <span v-if="log.meta.magicDamage > 0" class="damage-magic">
                            ✨ {{ log.meta.magicDamage }} ({{ log.meta.mAtk }}-{{ log.meta.ward }})
                          </span>
                          <span v-if="log.meta.critical" class="damage-critical">💥 CRIT!</span>
                        </div>
                      </div>
                    </div>
                    <div class="cards-side cards-right cards-2">
                      <div class="card-stack">
                        <playing-card v-bind:card="card" v-bind:show="false" v-for="card in model.battle.cards2"></playing-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="winner" v-bind:class="{ show: model.battle.show.winner }">
                <button @click="backToEvent" class="bot-overlay-close" title="Cancel" :disabled="model.battle.saving" :class="{'is-disabled': model.battle.saving}">&#10005;</button>
                <div v-if="model.prepareBattle">
                  <h3 class="bot-select-team-title">&#10022; {{model.selectedEvent.name}} &#10022;</h3>
                  <div v-if="model.battle.team" class="row">
                    <div class="bot-teamcards-grid" :style="gridStyle">
                      <div class="bot-grid-item" v-for="(card, cardIndex) in model.battle.team" :key="'random-' + cardIndex">
                        <div class="bot-team-scaled">
                          <playing-card
                            v-bind:card="{
                              ...card,
                              image: \`\${root}/images/cards/\${card.cardId}.png\`
                            }"
                            :show="true">
                          </playing-card>
                        </div>
                      </div>
                    </div>
                    <div class="bot-battle-actions">
                      <button @click="startEventBattle" class="center-button battle-start-btn">&#9889; INITIATE BATTLE</button>
                      <button @click="backToEvent" class="center-button back-btn" :disabled="model.battle.saving" :class="{'is-disabled': model.battle.saving}">&#8592; BACK</button>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="winner-user"></div>
                  <div class="result-message">
                    <h2 class="white" v-if="model.battle.result === 'win'">Event Success!</h2>
                    <h2 class="white" v-if="model.battle.result === 'lose'">Event Failed!</h2>
                  </div>
                  <button @click="backToEvent" class="center-button back-btn" :disabled="model.battle.saving" :class="{'is-disabled': model.battle.saving}">&#8592; BACK TO MENU</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── HAS EVENTS STATE ─────────────────────────────────── -->
      <div v-else class="events-container">
        <div class="events-grid">

          <!-- Sidebar: Mission Select -->
          <div class="sidebar ue-sidebar">
            <div class="ue-sidebar-header">
              <span class="ue-sh-icon">&#9672;</span>
              <span class="ue-sh-label">Active Events</span>
            </div>
            <ul class="events-menu">
              <li class="events-menu-item"
                  :class="{active: model.eventName == events.id}"
                  @click="selectedEvent(events.id, events, index)"
                  v-for="(events, index) in model.events"
                  :key="events.id">
                <span class="ue-mi-dot"></span>
                <span class="ue-mi-text">{{events.name}}</span>
              </li>
            </ul>
            <div class="scroll-indicator" v-if="isScrollable && !isScrolledToBottom">&#9660;</div>
          </div>

          <!-- Main content panel -->
          <div class="events-main-content ue-main-panel">

            <!-- Event name header -->
            <div class="ue-event-header" v-if="model.selectedEvent && model.selectedEvent.name">
              <div class="ue-event-title-bar">
                <span class="ue-event-status-dot"></span>
                <h2 class="ue-event-name">{{model.selectedEvent.name}}</h2>
                <span class="ue-event-live-badge">LIVE</span>
              </div>
            </div>

            <!-- Tab navigation -->
            <div class="events-tabs">
              <div class="events-tab"
                  v-if="model.selectedEvent && model.selectedEvent.isLogin"
                  v-bind:class="{ active: model.tabs == 'daily_login' }"
                  @click="tabs('daily_login')">
                {{model.selectedEvent.loginCount}} Days Login
              </div>
              <div class="events-tab"
                  v-if="model.selectedEvent && model.selectedEvent.selectedMode === 'battle'"
                  v-bind:class="{ active: model.tabs == 'battle'}"
                  @click="tabs('battle')">
                Battle
              </div>
              <div class="events-tab"
                  v-if="model.selectedEvent && model.selectedEvent.tournament"
                  v-bind:class="{ active: model.tabs == 'tournament' }"
                  @click="tabs('tournament')">
                Tournaments
              </div>
              <div class="events-tab"
                  v-if="model.selectedEvent && model.selectedEvent.quest"
                  v-bind:class="{ active: model.tabs == 'quest' }"
                  @click="tabs('quest')">
                Quest Challenge
              </div>
              <div class="events-tab"
                  v-if="model.selectedEvent && model.selectedEvent.tasks && model.selectedEvent.tasks.length > 0 && !model.selectedEvent.isLogin"
                  v-bind:class="{ active: model.tabs == 'task' }"
                  @click="tabs('task')">
                Challenge Task
              </div>
              <div class="events-tab" v-bind:class="{ active: model.tabs == 'info' }"
                  @click="tabs('info')">
                Info
              </div>
            </div>

            <!-- Tab: All except Info -->
            <div class="events-tab-content" :class="{active: model.tabs != 'info'}">
              <div class="events-description">
                <p>{{model.selectedEvent.description}}</p>

                <div class="key-required ue-key-badge" v-if="model.selectedEvent.key">
                  <img :src="\`\${root}/images/keys/\${model.selectedEvent.key[0].id}.png\`"
                      alt="key image"
                      :style="{ width: '20px', height: '20px' }">
                  <span>{{model.selectedEvent.key[0].name}} required</span>
                </div>

                <p v-if="model.selectedEvent.eventcode" class="ue-event-code">Event Code: @{{model.selectedEvent.eventcode}}</p>

                <div class="ue-timer-block">
                  <div class="ue-timer-row">
                    <span class="ue-timer-icon">&#8987;</span>
                    <span class="ue-timer-text events-date-range">{{model.timer}}</span>
                  </div>
                  <div class="events-date-range ue-date-range">{{formattedDateFrom}} &mdash; {{formattedDateTo}}</div>
                </div>

                <button class="streamers-toggle ue-streamers-btn"
                  v-if="model.selectedEvent.streamers"
                  title="View participating streamers"
                  @click="toggleModal"
                  @mouseenter="showModal = true"
                  @mouseleave="showModal = false">
                  <span>&#9432;</span>
                  <span>View Streamers</span>
                </button>

                <div class="streamers-list" v-bind:class="{ show: model.showModal }" id="streamers-list">
                  <transition name="fade">
                    <div v-if="model.showModal && model.selectedEvent.streamers" class="toolbar" :style="toolbarStyle" @mouseenter="showModal = true" @mouseleave="showModal = false">
                      <ul>
                        <li v-for="(streamer, index) in model.selectedEvent.streamers" :key="index">{{ streamer.twitchDisplayName }}</li>
                      </ul>
                    </div>
                  </transition>
                </div>
              </div>

              <!-- Task panel (non-task tabs) -->
              <div v-if="model.tabs != 'task'">
                <event-task-panel
                  :event-type="currentEventType"
                  :tasks="model.selectedEvent.tasks || []"
                  :rewards="model.selectedEvent.rewards || {}"
                  :quest-cards="model.selectedEvent.quest?.cards || []"
                  :event-cards="model.selectedEvent.cards || []"
                  :temporary-cards="model.selectedEvent.temporaryCards || []"
                  :user-progress="model.selectedEvent.userProgress || []"
                  :event-tournament="model.selectedEvent.tournament || []"
                  :quest-mode-text="questModeText"
                  :team-name="model.selectedEvent.teamName || ''"
                  :can-start-quest="canStartQuest"
                  :can-start-battle="canStartBattle"
                  :can-claim-reward="canClaimReward"
                  :claim-reward="canClaimReward"
                  :reward-claimed="rewardClaimed"
                  @start-quest="openEventBattle"
                  @start-battle="openEventBattle">
                </event-task-panel>
              </div>

              <!-- Challenge Task tab -->
              <div v-else>
                <div class="mission-panel ue-mission-panel" v-for="(task, taskIndex) in model.selectedEvent.tasks" :key="taskIndex">
                  <div class="battle-header ue-mission-header">
                    <div class="mission-text ue-mission-name">{{task.taskName}}</div>
                    <div class="progress-counter ue-progress-chip">0/{{taskIndex + 1}}</div>
                  </div>
                  <div class="rewards-section">
                    <div class="rewards-header">
                      <h2 class="rewards-title">
                        <div v-if="task.rewards.length > 0">Reward{{task.rewards.length > 1 ? 's' : ''}}</div>
                      </h2>
                    </div>
                    <reward-display :rewards="task.rewards" display-type="default"></reward-display>
                  </div>
                  <button class="go-button ue-btn ue-btn-primary">Go</button>
                </div>
              </div>
            </div>

            <!-- Tab: Info -->
            <div class="events-tab-content" :class="{active: model.tabs == 'info'}">
              <div class="events-description ue-info-panel">
                <h3 class="ue-info-title">{{ model.selectedEvent.name }}</h3>
                <p>{{ model.selectedEvent.description }}</p>
                <div class="info-box ue-info-box">
                  <h4>How to Participate:</h4>
                  <ol>
                    <!-- Key requirement shown for any event type -->
                    <li v-if="model.selectedEvent.key">
                      Acquire the <strong>{{ model.selectedEvent.key[0].name }}</strong> key item &mdash; this is required to access this event
                    </li>

                    <!-- Streamers list shown for any event type that has streamers -->
                    <li v-if="model.selectedEvent.streamers">
                      Check the <strong>View Streamers</strong> list above to find a participating streamer's Twitch channel to join
                    </li>

                    <!-- Login event -->
                    <template v-if="currentEventType === 'login'">
                      <li>Log in to the site daily</li>
                      <li>Complete {{ model.selectedEvent.loginCount }} {{ model.selectedEvent.loginStreak ? 'consecutive ' : '' }}login{{ model.selectedEvent.loginCount > 1 ? 's' : '' }} to finish the event</li>
                      <li>Claim your rewards once all logins are recorded</li>
                    </template>

                    <!-- Battle event -->
                    <template v-if="currentEventType === 'battle'">
                      <li v-if="model.selectedEvent.teamName">Make sure your cards are tagged with <strong>#your-card-team-name</strong> &mdash; only cards on this team can join the event</li>
                      <li>In Twitch chat, type <strong>!eventchallenge @{{ model.selectedEvent.eventcode }}</strong> <strong>#your-cards-team-name</strong></li>
                      <li v-if="model.selectedEvent.battleOption && model.selectedEvent.battleOption !== 'single'">Assemble a {{ model.selectedEvent.battleOption }} team using your <span v-if="model.selectedEvent.teamName"><strong>#your-cards-team-name</strong></span> cards</li>
                      <li>Win {{ model.selectedEvent.wins }} battle{{ model.selectedEvent.wins != 1 ? 's' : '' }} to complete the event</li>
                      <li v-if="model.selectedEvent.attempt > 0">You have {{ model.selectedEvent.attempt }} attempt{{ model.selectedEvent.attempt != 1 ? 's' : '' }} total</li>
                      <li>Claim your rewards once the required wins are reached</li>
                    </template>

                    <!-- Tournament event -->
                    <template v-if="currentEventType === 'tournament'">
                      <li v-if="model.selectedEvent.teamName">Make sure your cards are tagged with <strong>#your-card-team-name</strong> &mdash; only cards on this team can join the event</li>
                      <li>In Twitch chat, type <strong>!eventchallenge @{{ model.selectedEvent.eventcode }}</strong> <strong>#your-cards-team-name</strong></li>
                      <li>Compete through the tournament bracket rounds</li>
                      <li>Win each round to advance and earn your rewards</li>
                    </template>

                    <!-- Quest event -->
                    <template v-if="currentEventType === 'quest'">
                      <li v-if="model.selectedEvent.teamName">Make sure your cards are tagged with <strong>#{{ model.selectedEvent.teamName }}</strong> &mdash; only cards on this team can join the event</li>
                      <li>Open the Quest tab to see required cards and objectives</li>
                      <li>{{ questModeText }}</li>
                      <li>Complete the quest requirements to earn your rewards</li>
                    </template>

                    <!-- Challenge Task event -->
                    <template v-if="currentEventType === 'task'">
                      <li>Open the Challenge Task tab to see all tasks</li>
                      <li>Complete each task to unlock staged rewards</li>
                      <li>Claim your rewards after completing the tasks</li>
                    </template>
                  </ol>
                </div>
              </div>
            </div>

          </div><!-- /ue-main-panel -->
        </div><!-- /events-grid -->
      </div><!-- /events-container -->

    </div><!-- /events-bg -->

    <!-- Reward modal -->
    <div class="reward-modal">
      <div class="reward-modal-content">
        <img :src="\`\${root}/images/sgt-woofy-logo-200.png\`" alt="Logo" class="center-logo" />
        <div>
          <rewards-claim
            :rewards="model.rewards"
            :barks-image-url="\`\${root}/images/coin-sample.png\`"
          />
        </div>
      </div>
    </div>

  </section>
</div>
`,

rewardDisplay: `
    <div class="rewards-container" >
        <button v-if="displayType != 'login'" class="scroll-arrow left" id="scrollLeft" @click="scrollLeft" disabled="">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
        </button>
        <button v-if="displayType != 'login'"  class="scroll-arrow right" id="scrollRight"  @click="scrollRight">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        </button>

        <div class="rewards-scroll" id="rewardsScroll">
            <div class="rewards-grid">
                     
                    <!-- XP Rewards -->
                    <div v-if="rewards.xp" class="reward-item" :class="[isRewardContainer, containerClass]">
                        <div class="reward-icon xp">XP</div>
                        <div class="reward-name">Experience</div>
                        <div class="reward-multiplier">×{{rewards.xp}}</div>
                    </div>

                    <!-- Barks Rewards -->
                    <div v-if="rewards.barks" class="reward-item" :class="[isRewardContainer, containerClass]">
                            <div class="reward-icon barks"><div class="give-reward spinning-slow" :style="barksStyle"></div></div>
                            <div class="reward-name">
                                <!--<div class="give-reward spinning-slow" :style="barksStyle"></div>-->
                                Barks
                            </div>
                            <div class="reward-multiplier">×{{rewards.barks}}</div>
                    </div>

                    <!-- Random Card Rewards -->
                    <div v-for="(card, cardIndex) in rewards.randomCard" 
                          class="reward-item"
                          :key="'random-' + cardIndex" 
                          v-if="rewards.randomCard"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon randomcard">
                              <div class="reward-scaled">
                                  <playing-card
                                      v-bind:card="{
                                          tier: Number(card.randomCard),
                                          name: 'Random',
                                          image: '',
                                          id: 'random-reward-' + cardIndex,
                                      }"
                                      class="randomCard-reward"
                                      :show="true">
                                  </playing-card>
                              </div>
                            </div>
                        </div>
                        <div class="reward-name">Random Card</div>
                        <div class="reward-multiplier">×{{card.random_amount || card.card_amount || 1}}</div>
                    </div>

                    <!-- Give Pack Rewards -->
                    <div v-for="(pack, packIndex) in rewards.givePack"
                          class="reward-item"
                          :key="'pack-' + packIndex"
                          v-if="rewards.givePack"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon pack">
                              <div class="reward-scaled">
                                  <playing-card
                                      v-if="!pack.isChest"
                                      id="cover"
                                      class="cover reward"
                                      :card="pack"
                                      :style="getPackImageStyle(pack)">
                                  </playing-card>
                                  <div class="is-chest" v-if="pack.isChest">
                                      <img :src="\`\${root}/images/chest/\${pack.packId}/1.png\`"
                                            :style="chestImageStyle">
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div class="reward-name">{{pack.name}}</div>
                        <div class="reward-multiplier">×{{pack.packs_quantity}}</div>
                    </div>

                    <!-- Selected Card Rewards -->
                    <div v-for="(card, cardIndex) in rewards.selectedCard"
                          class="reward-item"
                          :key="'selected-' + cardIndex"
                          v-if="rewards.selectedCard"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon selectedcard">
                              <div class="reward-scaled">
                                  <playing-card
                                      :show="true"
                                      v-bind:card="getCardData(card)"
                                        >
                                  </playing-card>
                              </div>
                            </div>
                        </div>
                        <div class="reward-name">{{card.name}}</div>
                        <div class="reward-multiplier">×{{card.card_amount}}</div>
                    </div>

                    <!-- Selected Card Rewards -->
                    <div v-for="(card, cardIndex) in rewards.eventCard"
                          class="reward-item"
                          :key="'event-card-' + cardIndex"
                          v-if="rewards.eventCard"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon eventcard">
                              <div class="reward-scaled">
                                  <playing-card
                                      :show="true"
                                      v-bind:card="getEventCardData(card)"
                                      >
                                  </playing-card>
                              </div>
                            </div>
                        </div>
                        <div class="reward-name">{{card.name}}</div>
                        <div class="reward-multiplier">×{{card.card_amount}}</div>
                    </div>

                    <!-- Frame Rewards -->
                    <div v-for="(frame, frameIndex) in rewards.rewardFrames"
                          class="reward-item"
                          :key="'frame-' + frameIndex"
                          v-if="rewards.rewardFrames && rewards.rewardFrames.length > 0"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon frame">
                              <div class="reward-frame-display">
                                  <img v-if="getFrameImageUrl(frame)"
                                       :src="getFrameImageUrl(frame)"
                                       :alt="frame.frame_name || frame.name"
                                       class="frame-reward-img" />
                              </div>
                            </div>
                        </div>
                        <div class="reward-name">{{frame.frame_name || frame.reward_name || frame.name}}</div>
                        <div class="reward-quantity">Frame</div>
                    </div>

                    <!-- Background Rewards -->
                    <div v-for="(bg, bgIndex) in rewards.rewardBackgrounds"
                          class="reward-item"
                          :key="'background-' + bgIndex"
                          v-if="rewards.rewardBackgrounds && rewards.rewardBackgrounds.length > 0"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon background">
                              <div class="reward-frame-display">
                                  <img v-if="getBackgroundImageUrl(bg)"
                                       :src="getBackgroundImageUrl(bg)"
                                       :alt="bg.background_name || bg.name"
                                       class="background-reward-img" />
                                  <div v-else class="background-placeholder">🌄</div>
                              </div>
                            </div>
                        </div>
                        <div class="reward-name">{{bg.background_name || bg.reward_name || bg.name}}</div>
                        <div class="reward-quantity">Background</div>
                    </div>

                    <!-- Card Back Rewards -->
                    <div v-for="(back, backIndex) in rewards.rewardCardBacks"
                          class="reward-item"
                          :key="'card-back-' + backIndex"
                          v-if="rewards.rewardCardBacks && rewards.rewardCardBacks.length > 0"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon card-back">
                              <div class="reward-scaled">
                                  <playing-card
                                      v-bind:card="{ backingId: back.id, name: '' }"
                                      v-bind:show="false">
                                  </playing-card>
                              </div>
                            </div>
                        </div>
                        <div class="reward-name">{{back.name}}</div>
                        <div class="reward-quantity">Card Back</div>
                    </div>

                    <!-- Exotic Card Rewards -->
                    <div v-for="(card, exoticIndex) in rewards.exoticCard"
                          class="reward-item"
                          :key="'exotic-' + exoticIndex"
                          v-if="rewards.exoticCard && rewards.exoticCard.length > 0 && card.cardId"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon exotic-card">
                                <div class="reward-scaled">
                                    <playing-card
                                        v-bind:card="getCardData(card)"
                                        v-bind:show="true">
                                    </playing-card>
                                </div>
                            </div>
                        </div>
                        <div class="reward-name">{{card.name}}</div>
                        <div class="reward-quantity">Exotic Card</div>
                    </div>

                    <!-- Variant Card Rewards -->
                    <div v-for="(card, variantIndex) in rewards.variantCard"
                          class="reward-item"
                          :key="'variant-' + variantIndex"
                          v-if="rewards.variantCard && rewards.variantCard.length > 0 && card.cardId"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon variant-card">
                                <div class="reward-scaled">
                                    <playing-card
                                        v-bind:card="getCardData(card)"
                                        v-bind:show="true">
                                    </playing-card>
                                </div>
                            </div>
                        </div>
                        <div class="reward-name">{{card.name}}</div>
                        <div class="reward-quantity variant-qty">Variant Card</div>
                        <div class="reward-multiplier variant-qty">×{{card.card_amount || 1}}</div>
                    </div>

                    <!-- Delta Card Rewards -->
                    <div v-for="(card, deltaIndex) in rewards.deltaCard"
                          class="reward-item"
                          :key="'delta-' + deltaIndex"
                          v-if="rewards.deltaCard && rewards.deltaCard.length > 0 && card.deltaCardId"
                          :class="[isRewardContainer, containerClass]">
                        <div :class="[iconClass, loginRewardClass]">
                            <div class="reward-icon delta-card">
                                <div class="reward-scaled">
                                    <playing-card
                                        v-bind:card="getDeltaCardData(card)"
                                        v-bind:show="true">
                                    </playing-card>
                                </div>
                            </div>
                        </div>
                        <div class="reward-name">{{card.name}}</div>
                        <div class="reward-quantity delta-qty">Delta Card</div>
                        <div class="reward-multiplier delta-qty">×{{card.card_amount || 1}}</div>
                    </div>

            </div>
        </div>
    </div>
`,

eventCardsDisplay: `

  <div class="cards-grid">
      <!-- Quest Cards -->
      <div class="events-card-item" 
            v-for="(card, cardIndex) in questCards" 
            :key="'quest-' + cardIndex" 
            v-if="questCards && questCards.length > 0">
          <div class="events-card-container event-battle">
              <div class="reward-circle"></div>
              <div class="reward-scaled-battle">
                  <playing-card  
                      :card="card"
                      :show="true" >
                  </playing-card>
              </div>
          </div>
      </div>

      <!-- Regular Event Cards -->
      <div class="events-card-item" 
            v-for="(card, cardIndex) in eventCards" 
            :key="'event-' + cardIndex" 
            v-if="eventCards && eventCards.length > 0">
          <div class="events-card-container event-battle">
              <div class="reward-circle"></div>
              <div class="reward-scaled-battle">
                  <playing-card  
                      :card="card"
                      :show="true" >
                  </playing-card>
              </div>
          </div>
      </div>

      <!-- Temporary Cards -->
      <div class="events-card-item" 
            v-for="(card, cardIndex) in temporaryCards" 
            :key="'temp-' + cardIndex" 
            v-if="temporaryCards && temporaryCards.length > 0">
          <div class="events-card-container event-battle">
              <div class="reward-circle"></div>
              <div class="reward-scaled-battle">
                  <playing-card  
                      :card="card"
                      :show="true" >
                  </playing-card>
              </div>
          </div>
      </div>
  </div>
`,

eventTaskPanel: `
  <div>
    <!-- Login Event Grid -->
    <div v-if="eventType === 'login'">
        <div class="grid">
          <div class="grid-item-events" v-for="(task, taskIndex) in tasks" :key="taskIndex">
              <div class="card-events">
                  <div class="corner-decoration top-left"></div>
                  <div class="corner-decoration top-right"></div>
                  <div class="corner-decoration bottom-left"></div>
                  <div class="corner-decoration bottom-right"></div>

                  <div class="card-events-inner">
                      <div class="day-number">{{task.taskName}}</div>
                      <reward-display 
                          :rewards="task.rewards" 
                          display-type="login" 
                          :show-overflow="false">
                      </reward-display>
                      <button class="claim-button" :disabled="task.completed" v-bind:class="{'is-disabled': !isClaimable(taskIndex) || task.completed }" @click="claimTaskReward(task)">{{task.completed ? 'Reward Claimed' : 'Claim Reward'}}</button>
                  </div>
              </div>
          </div>
        </div>
        <div class="battle-section">
            <div class="battle-header">
                <div class="mission-text">{{userProgress[0].required_logins}} Days Login Streak Reward</div>
                <div class="progress-counter">{{userProgress[0].progress_percentage}}%</div>
            </div>

            <div class="battle-header rewards">
                <div class="mission-text">Rewards</div>
            </div>
       
            <reward-display 
                :rewards="rewards" 
                display-type="default">
            </reward-display>
            <button class="go-button" @click="claimRewards" v-if="userProgress[0].progress_percentage === 100 && !userProgress[0].completed">
                CLAIM REWARD
            </button>
            <button class="play-bot" disabled v-if="userProgress[0].completed">
                REWARD CLAIMED
            </button>
        </div>
    </div>

    <!-- Tournament/Standard Mission Panels -->
    <div v-else-if="eventType === 'tournament'" >
     <div class="battle-section">
            <div class="battle-header">
                <div class="battle-title">{{eventTournament.name}}</div>
                <div class="progress-counter"></div>
            </div>
            
             <div class="mission-bottom" id="rewardContainer">
                <div class="event-tournament-col">
                    <tournament-arena class="tournament-arena-container" :tournament="eventTournament"></tournament-arena>
                    <div class="td-panel">
                      <div class="td-header">
                        <span class="td-header-icon">&#9670;</span>
                        <h5 class="td-title">Tournament Details</h5>
                        <div class="td-header-line"></div>
                      </div>

                      <p class="td-description">{{eventTournament.description}}</p>

                      <div class="td-stats">
                        <div class="td-stat">
                          <span class="td-stat-icon">&#9812;</span>
                          <span class="td-label">Teams Needed</span>
                          <span class="td-value">{{eventTournament.round}}</span>
                        </div>
                        <div class="td-stat">
                          <span class="td-stat-icon">&#9876;</span>
                          <span class="td-label">Players</span>
                          <span class="td-value">{{eventTournament.players}}</span>
                        </div>
                        <div class="td-stat">
                          <span class="td-stat-icon">&#9881;</span>
                          <span class="td-label">Rules</span>
                          <span class="td-value">{{eventTournament.selectedOptions}}</span>
                        </div>
                        <div class="td-stat">
                          <span class="td-stat-icon">&#9654;</span>
                          <span class="td-label">Mode</span>
                          <span class="td-value">{{eventTournament.battleOption}}</span>
                        </div>
                        <div class="td-stat">
                          <span class="td-stat-icon">&#9873;</span>
                          <span class="td-label">Faction Mode</span>
                          <span class="td-value">{{eventTournament.faction}}</span>
                        </div>
                      </div>

                      <div class="td-action">
                        <button class="td-btn td-btn-locked" disabled v-if="canStartBattle">
                          <span class="td-btn-icon">&#9203;</span> In Progress
                        </button>
                        <button class="td-btn td-btn-claim" @click="claimRewards" v-else-if="canClaimReward">
                          <span class="td-btn-icon">&#9733;</span> Claim Reward
                        </button>
                        <button class="td-btn td-btn-claimed" disabled v-else-if="rewardClaimed">
                          <span class="td-btn-icon">&#10003;</span> Reward Claimed
                        </button>
                        <button class="td-btn td-btn-locked" disabled v-else>
                          <span class="td-btn-icon">&#128274;</span> Unlock
                        </button>
                      </div>
                    </div>
                
                  </div>
                  
            </div> 
        </div>
        <div class="rewards-section">
          <div class="rewards-title">
              <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"></path>
              </svg>
              Rewards
          </div>
          <div class="rewards-section">
              <reward-display 
                  :rewards="rewards" 
                  display-type="default">
              </reward-display>
          </div>
        </div>
    </div>

    <!-- Quest Battle Panel -->
    <div v-else-if="eventType === 'quest'">
        <div class="battle-section">
            <div class="battle-header">
                <div class="mission-text">{{questModeText}}</div>
                <div class="progress-counter"></div>
            </div>
            
              <event-card-display
                  :quest-cards="questCards"
                  :event-cards="eventCards">
              </event-card-display>
                <button class="go-button" 
                      disabled
                      v-if="canStartBattle">
                    IN PROGRESS
              </button>
              <button class="go-button" 
                      @click="claimRewards"
                      v-else-if="canClaimReward">
                  CLAIM REWARD
              </button>
              <button class="play-bot" v-else-if="rewardClaimed" disabled>REWARD CLAIMED</button>
              <button class="play-bot" v-else disabled>UNLOCK</button>

        </div>
        
        <div class="rewards-section">
          <div class="rewards-title">
              <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"></path>
              </svg>
              Rewards
          </div>
          <div class="rewards-section">
              <reward-display 
                  :rewards="rewards" 
                  display-type="default">
              </reward-display>
          </div>
        
        </div>
    </div>

    <!-- Battle Event Panel -->
    <div v-else-if="eventType === 'battle'">
        <div class="battle-section">
            <div class="battle-header">
                <div class="battle-title">?? Battle with {{teamName}}</div>
                <div class="progress-counter"></div>
            </div>

            <event-card-display
                :temporary-cards="temporaryCards"
                :event-cards="eventCards">
            </event-card-display>
            <button class="go-button" 
                    @click="$emit('start-battle')" 
                    v-if="canStartBattle">
                  Go
            </button>
            <button class="go-button" 
                    @click="claimRewards"
                    v-else-if="canClaimReward">
                CLAIM REWARD
            </button>
            <button class="play-bot" v-else-if="rewardClaimed" disabled>REWARD CLAIMED</button>
            <button class="play-bot" v-else disabled>UNLOCK</button>
        </div>
        <div class="rewards-section">
              <div class="rewards-header">
                  <h2 class="rewards-title">
                    <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"></path>
                    </svg>
                    Rewards
                </h2>
              </div>
                  
              <reward-display 
                  :rewards="rewards" 
                  display-type="default">
              </reward-display>
        </div>
    </div>
  </div>
`,

uploadComponent: `
<div class="upload-component" :class="{ 'drag-over': dragOver }">
  <!-- Upload Progress -->
  <div v-if="uploadProgress.active" class="upload-progress">
    <div class="progress-bar">
      <div class="progress-fill" :style="{ width: uploadProgress.percent + '%' }"></div>
    </div>
    <div class="progress-text">{{ uploadProgress.text }} ({{ uploadProgress.percent }}%)</div>
  </div>

   <!-- Existing Images Section -->
  <div v-if="existingImages" class="existing-images">
    <h5>Current Image:</h5>
    <div class="file-list">
      <div v-for="(image, index) in existingImages" :key="'existing-' + index" class="file-item existing-file">
        <div class="file-preview">
          <img :src="getImageUrl(image)" :alt="image || 'Video'">
        </div>
        <div class="file-info">
          <div class="file-name">{{ image }}</div>
        </div>
        <button type="button" class="remove-file" @click="removeExistingImage(image, index)" v-if="allowRemoveExisting">
          <i class="bi-x-lg"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Drop Zone -->
  <div v-if="!uploadProgress.active" 
       class="drop-zone"
       @drop="handleFileDrop"
       @dragover="handleDragOver"
       @dragenter="handleDragEnter"
       @dragleave="handleDragLeave"
       @click="triggerFileInput">
    
    <div class="drop-zone-content">
      <i class="bi-cloud-arrow-up upload-icon"></i>
      <p class="drop-text">
        <span v-if="multiple">Drop files here or click to browse</span>
        <span v-else>Drop file here or click to browse</span>
      </p>
      <p class="drop-subtext">
        <span v-if="acceptedTypes">Accepted: {{ acceptedTypesText }}</span>
        <span v-if="maxSize">Max size: {{ formatFileSize(maxSize) }}</span>
      </p>
    </div>

    <!-- Hidden File Input -->
    <input 
      type="file" 
      ref="fileInput"
      :multiple="multiple"
      :accept="acceptedTypes"
      @change="handleFileSelect"
      style="display: none;">
  </div>

  <!-- Selected Files Preview -->
  <div v-if="selectedFiles.length > 0 && !uploadProgress.active" class="selected-files">
    <h5>Selected Files:</h5>
    <div class="file-list">
      <div v-for="(file, index) in selectedFiles" :key="index" class="file-item">
        <div class="file-preview">
          <img v-if="file.preview && isImage(file.file)" :src="file.preview" alt="Preview">
          <i v-else class="bi-file-earmark file-icon"></i>
        </div>
        <div class="file-info">
          <div class="file-name">{{ file.name }}</div>
          <div class="file-size">{{ formatFileSize(file.size) }}</div>
        </div>
        <button type="button" class="remove-file" @click="removeFile(index)">
          <i class="bi-x-lg"></i>
        </button>
      </div>
    </div>
    
    <!-- Upload Actions -->
    <div class="upload-actions">
      <button type="button" class="btn btn-primary" @click="uploadFiles" :disabled="!canUpload">
        <i class="bi-cloud-arrow-up"></i>
        Upload {{ selectedFiles.length }} {{ selectedFiles.length === 1 ? 'File' : 'Files' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="clearFiles">
        <i class="bi-trash"></i>
        Clear All
      </button>
    </div>
  </div>
</div>
`,
rewardsClaim: `
 <div class="reward-modal-wrapper" :style="dynamicHeight">
    <div class="chest-reward-grid-container" :style="rewardGridStyle">
      <!-- Other rewards (XP, Barks, etc.) -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(reward, index) in otherRewards"
        :key="'reward-' + index"
      >
        <div class="playing-card-wrapper">
          <div class="playing-card flipped">
            <div class="other-reward-container">
              
              <div v-if="reward.name === 'xp'">
                <div class="fire give-reward">{{reward.name}}</div>
                <div class="reward-value-show">{{reward.value}}x</div>
              </div>
              <div v-else-if="reward.type === 'frame'">
                <div class="playing-card-face playing-card-backing"></div>
                <div class="frame-reward">
                  <div class="reward-type-badge">Frame</div>
                  <div class="reward-visual-container">
                    <img :src="\`\${root}/\${reward.image_url}\`" :alt="reward.name" class="reward-frame-img" />
                  </div>
                  <div class="reward-label">{{reward.name}}</div>
                </div>
              </div>
              <div v-else-if="reward.type === 'background'">
                <div class="playing-card-face playing-card-backing"></div>
                <div class="background-reward">
                  <div class="reward-type-badge">Background</div>
                  <div class="reward-visual-container">
                    <img :src="\`\${root}/\${reward.image_url}\`" :alt="reward.name" class="reward-background-img" />
                  </div>
                  <div class="reward-label">{{reward.name}}</div>
                </div>
              </div>
              <div v-else>
                <div class="give-reward spinning-slow" :style="barksStyle"></div>
                <div class="reward-value-show">{{reward.value}}x</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Frame drops -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(frame, index) in frameDrops"
        :key="'frame-' + index"
      >
        <div class="playing-card-wrapper">
          <div class="playing-card frame-background">
            <div class="playing-card-face playing-card-backing"></div>
            <div class="other-reward-container">
              <div class="frame-reward">
                <div class="reward-type-badge">Frame</div>
                <div class="reward-visual-container">
                  <img v-if="frame.image_url" :src="frame.image_url" :alt="frame.name" class="reward-frame-img" />
                  <div v-else class="frame-reward-placeholder">🖼️</div>
                </div>
                <div class="reward-label">{{frame.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Background drops -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(bg, index) in backgroundDrops"
        :key="'background-' + index"
      >
        <div class="playing-card-wrapper">
          <div class="playing-card frame-background">
            <div class="playing-card-face playing-card-backing"></div>
            <div class="other-reward-container">
              <div class="background-reward">
                <div class="reward-type-badge">Background</div>
                <div class="reward-visual-container">
                  <img v-if="bg.image_url" :src="\`\${root}/\${bg.image_url}\`" :alt="bg.name" class="reward-background-img" />
                  <div v-else class="background-reward-placeholder">🌄</div>
                </div>
                <div class="reward-label">{{bg.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- User cards -->
      <component
        v-for="card in userCards"
        class="chest-card-reward"
        :key="card.id"
        :card="card"
        :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
        :show="true"
      />

      <!-- Event cards -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(card, index) in eventCards"
        :key="'event-card-' + index"
      >
        <component
          class="chest-card-reward"
          :card="card"
          :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
          :show="true"
        />
        <div class="reward-type-badge reward-badge-event">Event</div>
      </div>

      <!-- User packs -->
      <div class="reward-card-component playing-card-container scaled" v-for="pack in userPacks">
        <div class="playing-card-wrapper">
          <div class="playing-card reward-pack-flip">
            <div class="playing-card-face playing-card-backing"></div>
            <div class="playing-card-face playing-card-front other-reward-container">
              <div class="pack-reward">
                <div class="reward-type-badge">Pack</div>
                <div class="reward-visual-container">
                  <img :src="getPackImageStyle(pack)" class="pack-reward-img" :class="{'is-reward-chest': pack.isChest}"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card back rewards -->
      <div class="reward-card-component playing-card-container scaled" v-for="backing in rewardCardBacks" :key="backing.id">
        <div class="playing-card-wrapper">
          <div class="playing-card reward-card-back-flip">
            <div class="playing-card-face playing-card-backing"></div>
            <div class="playing-card-face playing-card-front other-reward-container">
                   <img v-if="backing.image_url" :src="backing.image_url" :alt="backing.name" class="reward-frame-img" />
                   <div v-else class="frame-reward-placeholder">&#127183;</div>
                <div class="reward-value-show">{{backing.name}}</div>

            </div>
          </div>
        </div>
      </div>

      <!-- Background rewards -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(bg, index) in rewardBackgrounds"
        :key="'reward-bg-' + index"
      >
        <div class="playing-card-wrapper">
          <div class="playing-card frame-background">
            <div class="playing-card-face playing-card-backing"></div>
            <div class="other-reward-container">
              <div class="background-reward">
                <div class="reward-type-badge">Background</div>
                <div class="reward-visual-container">
                  <img v-if="bg.image_url" :src="bg.image_url" :alt="bg.name" class="reward-background-img" />
                  <div v-else class="background-reward-placeholder">&#127756;</div>
                </div>
                <div class="reward-label">{{bg.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Frame rewards -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(frame, index) in rewardFrames"
        :key="'reward-frame-' + index"
      >
        <div class="playing-card-wrapper">
          <div class="playing-card frame-background">
            <div class="playing-card-face playing-card-backing"></div>
            <div class="other-reward-container">
              <div class="frame-reward">
                <div class="reward-type-badge">Frame</div>
                <div class="reward-visual-container">
                  <img v-if="frame.image_url" :src="frame.image_url" :alt="frame.name" class="reward-frame-img" />
                  <div v-else class="frame-reward-placeholder">&#128444;</div>
                </div>
                <div class="reward-label">{{frame.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Exotic cards -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(card, index) in exoticCards"
        :key="'exotic-card-' + index"
      >
        <playing-card
          :card="card"
          :show="false"
        />
        <div class="reward-type-badge reward-badge-exotic">Exotic</div>
      </div>

      <!-- Variant cards -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(card, index) in variantCards"
        :key="'variant-card-' + index"
      >
        <playing-card
          :card="card"
          :show="false"
        />
        <div class="reward-type-badge reward-badge-variant">Variant</div>
      </div>

      <!-- Delta cards -->
      <div
        class="reward-card-component playing-card-container scaled"
        v-for="(card, index) in deltaCards"
        :key="'delta-card-' + index"
      >
        <special-card
          :card="card"
          :show="false"
        />
        <div class="reward-type-badge reward-badge-delta">Delta</div>
      </div>
    </div>
  </div>
`,
frameUpload: `
  <div class="frame-upload-component">
    <div v-if="!uploadProgress.active" class="upload-dropzone"
         @drop="handleFileDrop"
         @dragover="handleDragOver"
         @dragenter="handleDragEnter"
         @dragleave="handleDragLeave"
         @click="triggerFileInput"
         :class="{ 'drag-over': dragOver, 'has-file': selectedFile }">

      <div v-if="!selectedFile" class="dropzone-content">
        <i class="bi-cloud-arrow-up" style="font-size: 32px; color: #999; margin-bottom: 10px;"></i>
        <p>Drop {{ uploadType }} image here or click to browse</p>
        <p style="font-size: 12px; color: #999;">PNG, JPG, or WebP (Max 10MB)</p>
      </div>

      <div v-else class="selected-file-preview">
        <img :src="previewUrl" :alt="uploadType" style="max-width: 100%; max-height: 200px; border-radius: 8px;">
        <button type="button" @click.stop="clearFile" class="remove-btn">
          <i class="bi-x-lg"></i> Remove
        </button>
      </div>

      <input type="file"
             ref="fileInput"
             accept="image/png,image/jpeg,image/jpg,image/webp"
             @change="handleFileSelect"
             style="display: none;">
    </div>

    <div v-if="uploadProgress.active" class="upload-progress-bar">
      <div class="progress-fill" :style="{ width: uploadProgress.percent + '%' }"></div>
      <div class="progress-text">{{ uploadProgress.percent }}% - Uploading {{ uploadType }}...</div>
    </div>

    <button v-if="selectedFile && !uploadProgress.active"
            @click="uploadFile"
            class="upload-btn"
            data-button="submit">
      <i class="bi-upload"></i> Upload {{ uploadType }}
    </button>

    <div v-if="validationMessage" class="aspect-ratio-warning">
      {{ validationMessage }}
    </div>
  </div>
`,

userProfile: `
  <div class="banner-wrapper">
  <div class="banner-container">
    <div class="stars"></div>
    <div class="nebula"></div>

    <!-- Background Wrapper (overflow: hidden to contain background) -->
    <div class="background-wrapper">
      <!-- Selected Background Image (Responsive) -->
      <picture v-if="selectedBackgroundUrl">
        <source media="(min-width: 1280px)" :srcset="selectedBackgroundUrl.desktop">
        <source media="(min-width: 768px)" :srcset="selectedBackgroundUrl.tablet">
        <source media="(max-width: 767px)" :srcset="selectedBackgroundUrl.mobile">
        <img :src="selectedBackgroundUrl.desktop || selectedBackgroundUrl"
             class="profile-background"
             alt="Profile Background">
      </picture>
    </div>

    <!-- Frame Image (Responsive - can overflow banner-container) -->
    <div class="frame">
      <picture v-if="selectedFrameUrl">
        <source media="(min-width: 1280px)" :srcset="selectedFrameUrl.desktop">
        <source media="(min-width: 768px)" :srcset="selectedFrameUrl.tablet">
        <source media="(max-width: 767px)" :srcset="selectedFrameUrl.mobile">
        <img :src="selectedFrameUrl.desktop || selectedFrameUrl"
             class="frame-image"
             alt="Profile Frame">
      </picture>
      <div class="inner-frame"></div>
    </div>

    <!-- Medals Display (Upper Right) -->
    <div class="profile-medals">
      <div v-if="selectedMedals.slot1" class="medal-badge gold" :title="selectedMedals.slot1.name">
        <img :src="selectedMedals.slot1.url" alt="Gold Medal">
      </div>
      <div v-if="selectedMedals.slot2" class="medal-badge silver" :title="selectedMedals.slot2.name">
        <img :src="selectedMedals.slot2.url" alt="Silver Medal">
      </div>
      <div v-if="selectedMedals.slot3" class="medal-badge bronze" :title="selectedMedals.slot3.name">
        <img :src="selectedMedals.slot3.url" alt="Bronze Medal">
      </div>
    </div>

    <!-- Faction Logo Icon (Dynamic Position) -->
    <div v-if="factionLogoUrl"
         class="logo-icon"
         :class="'logo-position-' + logoPosition"
         :style="{ backgroundImage: 'url(' + factionLogoUrl + ')' }"
         :title="'Faction Logo'">
    </div>

    <div class="content">
      <div class="username">{{ username }}</div>
      <div class="title">{{ userTitle }}</div>
    </div>

    <!-- Customize Button -->
    <button @click="openCustomizer" class="customize-profile-btn" title="Customize Your Profile">
      <i class="bi-gear-fill"></i> Customize
    </button>

    <!-- Profile Customizer Modal -->
    <profile-customizer
      v-if="showCustomizer"
      :visible="showCustomizer"
      :twitch-id="twitchId"
      :username="username"
      :user-title="userTitle"
      @close="closeCustomizer"
      @customization-saved="onCustomizationSaved">
    </profile-customizer>
  </div>
  </div>
`,

profileCustomizer: `
  <div class="profile-customizer-modal" v-show="visible">
    <div class="customizer-overlay" @click="close"></div>
    <div class="customizer-panel">

      <!-- Header -->
      <div class="customizer-header">
        <h2><i class="bi-palette-fill"></i> Customize Your Profile</h2>
        <button @click="close" class="close-btn" title="Close">&times;</button>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="customizer-loading">
        <div class="loader1"></div>
        <p>Loading customization options...</p>
      </div>

      <!-- Error State -->
      <div v-if="error" class="customizer-error">
        <i class="bi-exclamation-triangle-fill"></i>
        <p>{{ error }}</p>
        <button @click="loadData" class="btn-secondary">Retry</button>
      </div>

      <!-- Main Content -->
      <div v-if="!loading && !error" class="customizer-content">

        <!-- Live Preview Section -->
        <div class="preview-section">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
            <h3 style="margin: 0;"><i class="bi-eye-fill"></i> Live Preview</h3>
            <button v-if="factionLogoUrl"
                    @click="toggleLogoPosition"
                    class="logo-position-toggle"
                    :title="'Toggle Logo Position (Currently: ' + logoPosition + ')'">
              <i class="bi-arrow-left-right"></i> Faction Logo Position: {{ logoPosition === 'left' ? 'Left' : 'Right' }}
            </button>
          </div>
          <div class="preview-container">

            <!-- Background Wrapper (overflow: hidden to contain background) -->
            <div class="preview-background-wrapper">
              <img v-if="previewBackgroundUrl"
                   :src="previewBackgroundUrl"
                   class="preview-background"
                   alt="Background Preview">
            </div>

            <!-- Content layer -->
            <div class="preview-content">
              <div class="preview-username">{{ username }}</div>
              <div class="preview-title">{{ userTitle }}</div>
            </div>

            <!-- Frame overlay (110% size, overflows container) -->
            <div class="preview-frame-wrapper">
              <img v-if="previewFrameUrl"
                   :src="previewFrameUrl"
                   class="preview-frame"
                   alt="Frame Preview">
            </div>

            <!-- Medal badges (upper right) -->
            <div class="preview-medals">
              <div v-if="previewMedalUrls[0]" class="medal-badge gold">
                <img :src="previewMedalUrls[0]" alt="Gold Medal">
              </div>
              <div v-if="previewMedalUrls[1]" class="medal-badge silver">
                <img :src="previewMedalUrls[1]" alt="Silver Medal">
              </div>
              <div v-if="previewMedalUrls[2]" class="medal-badge bronze">
                <img :src="previewMedalUrls[2]" alt="Bronze Medal">
              </div>
            </div>

            <!-- Faction Logo (Dynamic Position) -->
            <div v-if="factionLogoUrl"
                 class="logo-icon"
                 :class="'logo-position-' + logoPosition"
                 :style="{ backgroundImage: 'url(' + factionLogoUrl + ')' }"
                 :title="'Faction Logo'">
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="customizer-tabs">
          <button @click="switchTab('frames')"
                  :class="{active: activeTab === 'frames'}"
                  class="customizer-tab-button">
            <i class="bi-file-earmark-image"></i> Frames
          </button>
          <button @click="switchTab('backgrounds')"
                  :class="{active: activeTab === 'backgrounds'}"
                  class="customizer-tab-button">
            <i class="bi-image-fill"></i> Backgrounds
          </button>
          <button @click="switchTab('medals')"
                  :class="{active: activeTab === 'medals'}"
                  class="customizer-tab-button">
            <i class="bi-trophy-fill"></i> Medals
          </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content-area">

          <!-- Frames Tab -->
          <div v-show="activeTab === 'frames'" class="gallery-tab">
            <p v-if="availableFrames.length === 0" class="no-items-message">
              <i class="bi-inbox"></i> No frames unlocked yet. Complete achievements to unlock frames!
            </p>
            <div v-else class="gallery-grid">
              <div v-for="frame in availableFrames"
                   :key="frame.id"
                   @click="selectFrame(frame.id)"
                   :class="['gallery-item', {selected: selectedFrameId === frame.id}]"
                   :title="frame.description">
                <img :src="\`\${root}/\${frame.thumbnailUrl}\`" class="gallery-thumbnail" :alt="frame.name">
                <div class="gallery-name">{{ frame.name }}</div>
                <div v-if="selectedFrameId === frame.id" class="selection-check">
                  <i class="bi-check-lg"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Backgrounds Tab -->
          <div v-show="activeTab === 'backgrounds'" class="gallery-tab">
            <p v-if="availableBackgrounds.length === 0" class="no-items-message">
              <i class="bi-inbox"></i> No backgrounds unlocked yet. Complete achievements to unlock backgrounds!
            </p>
            <div v-else class="gallery-grid">
              <div v-for="bg in availableBackgrounds"
                   :key="bg.id"
                   @click="selectBackground(bg.id)"
                   :class="['gallery-item', {selected: selectedBackgroundId === bg.id}]"
                   :title="bg.description">
                <img :src="\`\${root}/\${bg.thumbnailUrl}\`" class="gallery-thumbnail" :alt="bg.name">
                <div class="gallery-name">{{ bg.name }}</div>
                <div v-if="selectedBackgroundId === bg.id" class="selection-check">
                  <i class="bi-check-lg"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Medals Tab -->
          <div v-show="activeTab === 'medals'" class="medals-tab">
            <p v-if="availableMedals.length === 0" class="no-items-message">
              <i class="bi-inbox"></i> No medals earned yet. Win battles to earn medals!
            </p>
            <div v-else>

              <!-- Gold Slot -->
              <div class="medal-slot-section">
                <h4><i class="bi-trophy-fill" style="color: #FFD700"></i> Gold Slot (Left)</h4>
                <div class="gallery-grid medals-grid">
                  <div v-for="medal in availableMedals"
                       :key="'gold-' + medal.id"
                       @click="selectMedal(1, medal.id)"
                       :class="['gallery-item medal-item', {selected: selectedMedals.slot1 === medal.id}]"
                       :title="medal.description">
                    <img :src="\`\${root}/\${medal.imageUrl}\`" class="gallery-thumbnail medal-thumbnail" :alt="medal.name">
                    <div class="gallery-name">{{ medal.name }}</div>
                    <div v-if="selectedMedals.slot1 === medal.id" class="selection-check">
                      <i class="bi-check-lg"></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Silver Slot -->
              <div class="medal-slot-section">
                <h4><i class="bi-trophy-fill" style="color: #C0C0C0"></i> Silver Slot (Middle)</h4>
                <div class="gallery-grid medals-grid">
                  <div v-for="medal in availableMedals"
                       :key="'silver-' + medal.id"
                       @click="selectMedal(2, medal.id)"
                       :class="['gallery-item medal-item', {selected: selectedMedals.slot2 === medal.id}]"
                       :title="medal.description">
                    <img :src="\`\${root}/\${medal.imageUrl}\`" class="gallery-thumbnail medal-thumbnail" :alt="medal.name">
                    <div class="gallery-name">{{ medal.name }}</div>
                    <div v-if="selectedMedals.slot2 === medal.id" class="selection-check">
                      <i class="bi-check-lg"></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bronze Slot -->
              <div class="medal-slot-section">
                <h4><i class="bi-trophy-fill" style="color: #CD7F32"></i> Bronze Slot (Right)</h4>
                <div class="gallery-grid medals-grid">
                  <div v-for="medal in availableMedals"
                       :key="'bronze-' + medal.id"
                       @click="selectMedal(3, medal.id)"
                       :class="['gallery-item medal-item', {selected: selectedMedals.slot3 === medal.id}]"
                       :title="medal.description">
                    <img :src="\`\${root}/\${medal.imageUrl}\`" class="gallery-thumbnail medal-thumbnail" :alt="medal.name">
                    <div class="gallery-name">{{ medal.name }}</div>
                    <div v-if="selectedMedals.slot3 === medal.id" class="selection-check">
                      <i class="bi-check-lg"></i>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      <!-- Actions -->
      <div v-if="!loading && !error" class="customizer-actions">
        <button @click="cancelCustomization" class="btn-secondary" :disabled="saving">
          <i class="bi-x-circle"></i> Cancel
        </button>
        <button @click="saveCustomization" class="btn-primary" :disabled="saving">
          <i class="bi-check-circle"></i> {{ saving ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>

    </div>
  </div>
`,

  streamerRedemptionShop: `
  <div class="redemption-shop-container" data-component="streamer-redemption-shop">
    <!-- Header with Points Display -->
    <div class="shop-header">
      <div class="header-content">
        <h2 class="shop-title">
          <i class="bi-gem"></i> Reward Points Shop
        </h2>
        <div class="points-display">
          <div class="points-card">
            <div class="points-label">Available Points</div>
            <div class="points-value">{{ model.userPoints.total_points.toLocaleString() }}</div>
          </div>
          <div class="points-card lifetime">
            <div class="points-label">Lifetime Points</div>
            <div class="points-value">{{ model.userPoints.lifetime_points.toLocaleString() }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="model.loading" class="loading-state">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>

    <!-- Error State -->
    <div v-if="model.error" class="error-state">
      <i class="bi-exclamation-triangle"></i>
      <p>{{ model.error }}</p>
      <button @click="loadData" class="btn-primary">Retry</button>
    </div>

    <!-- Main Content -->
    <div v-if="!model.loading && !model.error" class="shop-content">

      <!-- Pending Requests Section -->
      <div v-if="pendingRequests.length > 0" class="pending-requests-section">
        <h3 class="section-title">
          <i class="bi-clock-history"></i> Pending Approval ({{ pendingRequests.length }})
        </h3>
        <div class="pending-requests-list">
          <div v-for="request in pendingRequests" :key="request.id" class="pending-request-card">
            <div class="request-info">
              <div class="request-item-name">{{ request.item_name }}</div>
              <div class="request-details">
                <span class="item-type-badge">{{ getItemTypeLabel(request.item_type) }}</span>
                <span class="point-cost">{{ request.point_cost }} points</span>
              </div>
              <div class="request-date">Requested: {{ formatDate(request.requested_at) }}</div>
            </div>
            <div class="request-status">
              <span :class="['status-badge', getStatusBadgeClass(request.status)]">
                <i class="bi-hourglass-split"></i> Pending
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Filter Tabs -->
      <div class="shop-filters">
        <button
          @click="setFilter('all')"
          :class="['filter-btn', { active: model.selectedFilter === 'all' }]">
          All Items
        </button>
        <button
          @click="setFilter('frame')"
          :class="['filter-btn', { active: model.selectedFilter === 'frame' }]">
          🖼️ Frames
        </button>
        <button
          @click="setFilter('background')"
          :class="['filter-btn', { active: model.selectedFilter === 'background' }]">
          🌄 Backgrounds
        </button>
        <button
          @click="setFilter('event_card')"
          :class="['filter-btn', { active: model.selectedFilter === 'event_card' }]">
          🃏 Event Cards
        </button>
        <button
          @click="setFilter('exclusive_card')"
          :class="['filter-btn', { active: model.selectedFilter === 'exclusive_card' }]">
          🎴 Exclusive Cards
        </button>
        <button
          @click="setFilter('subscription')"
          :class="['filter-btn', { active: model.selectedFilter === 'subscription' }]">
          ⭐ Subscriptions
        </button>
      </div>

      <!-- Catalog Grid -->
      <div class="catalog-grid">
        <div v-for="item in filteredCatalog" :key="item.id" class="catalog-item-card">
          <!-- Featured Badge -->
          <div v-if="item.is_featured" class="featured-badge">
            <i class="bi-star-fill"></i> Featured
          </div>

          <!-- Item Image / Card Preview -->
          <div class="item-image-container">
            <!-- Card Preview with Playing Card (Exclusive & Event Cards) -->
            <div v-if="['exclusive_card', 'event_card'].includes(item.item_type)" class="card-preview">
              <playing-card
                :card="getExclusiveCardData(item)"
                :show="true">
              </playing-card>
              <div v-else class="card-preview-placeholder">
                <span>{{ getPlaceholderIcon(item.item_type) }}</span>
              </div>
            </div>

            <!-- Regular Item Image -->
            <div v-else>
              <img
                :src="getItemImageUrl(item)"
                :alt="item.name"
                class="item-image"
                @error="(e) => e.target.style.display = 'none'">
              <div v-if="!item.item_image && !item.image_url" class="item-placeholder">
                {{ getPlaceholderIcon(item.item_type) }}
              </div>
            </div>
          </div>

          <!-- Item Info -->
          <div class="item-info">
            <h4 class="item-name">{{ item.name }}</h4>
            <p v-if="item.description" class="item-description">{{ item.description }}</p>

            <div class="item-meta">
              <span class="item-type-badge">{{ getItemTypeLabel(item.item_type) }}</span>
              <span v-if="item.subscription_duration_days" class="duration-badge">
                {{ item.subscription_duration_days }} days
              </span>
              <span v-if="item.item_type === 'exclusive_card' && item.tier" :class="['tier-badge', 'tier-' + item.tier]">
                {{ getTierName(item.tier) }}
              </span>
              <span v-if="item.item_type === 'exclusive_card' && item.exclusiveUntil" class="exclusivity-badge">
                Exclusive Until: {{ formatDate(item.exclusiveUntil) }}
              </span>
            </div>

            <!-- Exclusive Card Stats -->
            <div v-if="item.item_type === 'exclusive_card'" class="exclusive-card-stats">
              <div class="stats-row">
                <span class="stat">HP: {{ item.card.hp }}</span>
                <span class="stat">ATK: {{ item.card.attack }}</span>
              </div>
              <div class="stats-row">
                <span class="stat">DEF: {{ item.card.defence }}</span>
                <span class="stat">SPD: {{ item.card.speed }}</span>
              </div>
              <div class="stats-row">
                <span class="stat">ACC: {{ item.card.accuracy }}</span>
              </div>
              <div class="stats-row">
                <span class="stat">Exclusive Until: {{ item.card.exclusiveUntil }}</span>
              </div>
            </div>

            <!-- Stock Info -->
            <div v-if="item.stock_quantity !== null" class="stock-info">
              <span v-if="item.is_in_stock" class="in-stock">
                <i class="bi-check-circle"></i> {{ item.remaining_stock }} left
              </span>
              <span v-else class="out-of-stock">
                <i class="bi-x-circle"></i> Out of Stock
              </span>
            </div>

            <!-- Already Owned -->
            <div v-if="item.already_owned" class="owned-badge">
              <i class="bi-check2-circle"></i> Already Owned
            </div>
          </div>

          <!-- Item Footer -->
          <div class="item-footer">
            <div class="item-cost">
              <i class="bi-gem"></i>
              <span class="cost-value">{{ item.point_cost.toLocaleString() }}</span>
              <span class="cost-label">points</span>
            </div>
            <button
              @click="redeemItem(item)"
              :disabled="!isRedeemable(item) || !hasEnoughPoints(item) || model.loading"
              :title="!hasEnoughPoints(item) ? 'Need ' + (item.point_cost - model.userPoints.total_points) + ' more points' : ''"
              class="btn-redeem">
              <i class="bi-cart-plus"></i> Redeem
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div v-if="filteredCatalog.length === 0" class="empty-state">
          <i class="bi-inbox"></i>
          <p>No items available in this category</p>
        </div>
      </div>

      <!-- Recent Requests Section -->
      <div v-if="recentRequests.length > 0" class="recent-requests-section">
        <h3 class="section-title">
          <i class="bi-clock-history"></i> Recent Requests
        </h3>
        <div class="recent-requests-list">
          <div v-for="request in recentRequests" :key="request.id" class="recent-request-item">
            <div class="request-item-name">{{ request.item_name }}</div>
            <div class="request-date">{{ formatDate(request.reviewed_at || request.requested_at) }}</div>
            <span :class="['status-badge', getStatusBadgeClass(request.status)]">
              {{ request.status }}
            </span>
            <div v-if="request.rejection_reason" class="rejection-reason">
              <i class="bi-info-circle"></i> {{ request.rejection_reason }}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
`,

  adminRedemptionApproval: `
  <div class="admin-redemption-approval-container" data-component="admin-redemption-approval">
    <!-- Header -->
    <div class="approval-header">
      <h2 class="approval-title">
        <i class="bi-clipboard-check"></i> Redemption Approval Queue
      </h2>

      <!-- Stats Cards -->
      <div class="stats-cards">
        <div class="stat-card pending">
          <div class="stat-icon"><i class="bi-hourglass-split"></i></div>
          <div class="stat-content">
            <div class="stat-value">{{ pendingCount }}</div>
            <div class="stat-label">Pending</div>
          </div>
        </div>
        <div class="stat-card approved">
          <div class="stat-icon"><i class="bi-check-circle"></i></div>
          <div class="stat-content">
            <div class="stat-value">{{ approvedCount }}</div>
            <div class="stat-label">Approved</div>
          </div>
        </div>
        <div class="stat-card rejected">
          <div class="stat-icon"><i class="bi-x-circle"></i></div>
          <div class="stat-content">
            <div class="stat-value">{{ rejectedCount }}</div>
            <div class="stat-label">Rejected</div>
          </div>
        </div>
        <div class="stat-card total">
          <div class="stat-icon"><i class="bi-gem"></i></div>
          <div class="stat-content">
            <div class="stat-value">{{ model.stats.total_points_redeemed.toLocaleString() }}</div>
            <div class="stat-label">Points Redeemed</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="model.loading" class="loading-state">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>

    <!-- Error State -->
    <div v-if="model.error" class="error-state">
      <i class="bi-exclamation-triangle"></i>
      <p>{{ model.error }}</p>
      <button @click="loadData" class="btn-primary">Retry</button>
    </div>

    <!-- Pending Requests List -->
    <div v-if="!model.loading && !model.error" class="approval-content">
      <div v-if="pendingCount === 0" class="empty-state">
        <i class="bi-inbox"></i>
        <h3>No Pending Requests</h3>
        <p>All redemption requests have been processed</p>
      </div>

      <div v-else class="pending-requests-table">
        <div v-for="request in model.pendingRequests" :key="request.request_id" class="request-row">
          <!-- User Info -->
          <div class="request-user">
            <div class="user-avatar">
              <img :src="request.twitchProfileImage"  class="admin-approval-img" ></img>
            </div>
            <div class="user-details">
              <div class="username">{{ request.twitchDisplayName || request.username }}</div>
              <div class="twitch-id">{{ request.twitchId }}</div>
            </div>
          </div>

          <!-- Item Info -->
          <div class="request-item">
            <div class="item-icon">{{ getItemTypeIcon(request.item_type) }}</div>
            <div class="item-details">
              <div class="item-name">{{ request.item_name }}</div>
              <div class="item-type">{{ getItemTypeLabel(request.item_type) }}</div>
            </div>
          </div>

          <!-- Cost & Points -->
          <div class="request-cost">
            <div class="cost-display">
              <i class="bi-gem"></i>
              <span class="cost-value">{{ request.point_cost.toLocaleString() }}</span>
              <span class="cost-label">points</span>
            </div>
            <div class="user-points" :class="{ insufficient: !hasEnoughPoints(request) }">
              User has: {{ request.user_current_points.toLocaleString() }}
              <i v-if="!hasEnoughPoints(request)" class="bi-exclamation-triangle"></i>
            </div>
          </div>

          <!-- Request Date -->
          <div class="request-date">
            <div class="date-label">Requested</div>
            <div class="date-value">{{ formatDate(request.requested_at) }}</div>
          </div>

          <!-- Actions -->
          <div class="request-actions">
            <button
              @click="approveRequest(request)"
              :disabled="model.processingRequestId === request.request_id || !hasEnoughPoints(request)"
              class="btn-approve"
              :title="!hasEnoughPoints(request) ? 'User has insufficient points' : 'Approve this redemption'">
              <i class="bi-check-circle"></i>
              <span>Approve</span>
            </button>
            <button
              @click="openRejectModal(request)"
              :disabled="model.processingRequestId === request.request_id"
              class="btn-reject"
              title="Reject this redemption">
              <i class="bi-x-circle"></i>
              <span>Reject</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Popular Items Section -->
      <div v-if="model.stats.popular_items && model.stats.popular_items.length > 0" class="popular-items-section">
        <h3 class="section-title">
          <i class="bi-trophy"></i> Most Popular Items
        </h3>
        <div class="popular-items-list">
          <div v-for="item in model.stats.popular_items" :key="item.name" class="popular-item">
            <div class="item-name">{{ item.name }}</div>
            <div class="redemption-count">{{ item.redemption_count }} redemptions</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Reject Modal -->
    <div v-if="model.showRejectModal" class="modal-overlay" @click="closeRejectModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Reject Redemption Request</h3>
          <button @click="closeRejectModal" class="modal-close">
            <i class="bi-x-lg"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="reject-info">
            <p><strong>User:</strong> {{ model.selectedRequest?.username }}</p>
            <p><strong>Item:</strong> {{ model.selectedRequest?.item_name }}</p>
            <p><strong>Cost:</strong> {{ model.selectedRequest?.point_cost }} points</p>
          </div>

          <div class="form-group">
            <label for="rejection-reason">Reason for Rejection *</label>
            <textarea
              id="rejection-reason"
              v-model="model.rejectionReason"
              class="form-control"
              rows="4"
              placeholder="Please provide a reason for rejecting this redemption request..."
              required></textarea>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="closeRejectModal" class="btn-secondary">Cancel</button>
          <button
            @click="confirmReject"
            :disabled="!model.rejectionReason.trim() || model.processingRequestId"
            class="btn-reject">
            <i class="bi-x-circle"></i> Reject Request
          </button>
        </div>
      </div>
    </div>
  </div>
`,

  adminRedemptionCatalog: `
  <div data-component="admin-redemption-catalog">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Redemption Catalog Management</h4>
              <button class="top-margin" data-button="submit" v-on:click="addItem()">Add Catalog Item</button>
            </div>

            <!-- Add/Edit Form -->
            <div class="row form" v-bind:class="{ visible: model.editMode }">
              <div>
                <i class="bi-x-lg close" v-on:click="cancelEdit()"></i>

                <div class="col-12 scroll_sidebar">
                  <!-- Item Type Selection -->
                  <div>
                    <label>Item Type</label>
                    <select class="form-control" v-model="model.catalogItem.item_type" @change="onItemTypeChange()">
                      <option value="frame">Frame</option>
                      <option value="background">Background</option>
                      <option value="event_card">Event Card</option>
                      <option value="exclusive_card">Exclusive Streamer Card</option>
                      <option value="subscription">Subscription</option>
                    </select>
                  </div>

                  <!-- Item Selection (not for subscriptions) -->
                  <div v-if="!isSubscriptionType">
                    <label>Select {{ getItemTypeLabel(model.catalogItem.item_type) }}</label>
                    <select class="form-control" v-model="model.catalogItem.item_id">
                      <option value="">-- Select Item --</option>
                      <option v-for="item in availableItemsForType" :key="item.id" :value="item.id">
                        {{ item.name || item.id }}
                      </option>
                    </select>
                  </div>

                  <!-- Subscription Duration (only for subscriptions) -->
                  <div v-if="isSubscriptionType">
                    <label>Subscription Duration (days)</label>
                    <input class="form-control" v-model.number="model.catalogItem.subscription_duration_days" type="number" min="1">
                  </div>

                  <!-- Name -->
                  <div>
                    <label>Display Name *</label>
                    <input class="form-control" v-model="model.catalogItem.name" type="text" placeholder="e.g., Premium Gold Frame">
                  </div>

                  <!-- Description -->
                  <div>
                    <label>Description</label>
                    <textarea class="form-control" v-model="model.catalogItem.description" rows="3" placeholder="Optional description for this item"></textarea>
                  </div>

                  <!-- Point Cost -->
                  <div>
                    <label>Point Cost *</label>
                    <input class="form-control" v-model.number="model.catalogItem.point_cost" type="number" min="1">
                  </div>

                  <!-- Max Redemptions Per User -->
                  <div>
                    <label>Max Redemptions Per User</label>
                    <input class="form-control" v-model.number="model.catalogItem.max_redemptions_per_user" type="number" min="1">
                    <small>How many times can one user redeem this item</small>
                  </div>

                  <!-- Stock Quantity -->
                  <div>
                    <label>Stock Quantity (Optional)</label>
                    <input class="form-control" v-model.number="model.catalogItem.stock_quantity" type="number" min="0" placeholder="Leave empty for unlimited">
                    <small>Total available stock (empty = unlimited)</small>
                  </div>

                  <!-- Is Featured -->
                  <div style="margin-bottom: 15px;">
                    <div style="display: flex; align-items: center; margin-bottom: 5px;">
                      <div class="form-check form-switch">
                        <input type="checkbox" class="form-check-input" v-model="model.catalogItem.is_featured" id="is_featured">
                      </div>
                      <label for="is_featured" style="margin: 0;">Featured Item</label>
                    </div>
                    <small style="margin-left: 55px;">Featured items appear first in the catalog</small>
                  </div>

                  <!-- Featured Until Date -->
                  <div v-if="model.catalogItem.is_featured">
                    <label>Featured Until (Optional)</label>
                    <input class="form-control" v-model="model.catalogItem.featured_until" type="datetime-local">
                    <small>Featured status will automatically expire at this date/time. Leave empty for permanent.</small>
                  </div>

                  <!-- Requires Admin Approval -->
                  <div style="margin-bottom: 15px;">
                    <div style="display: flex; align-items: center; margin-bottom: 5px;">
                      <div class="form-check form-switch">
                        <input type="checkbox" class="form-check-input" v-model="model.catalogItem.requires_approval" id="requires_approval">
                      </div>
                      <label for="requires_approval" style="margin: 0;">Requires Admin Approval</label>
                    </div>
                    <small style="margin-left: 55px;">Users must wait for admin approval when redeeming this item</small>
                  </div>
                </div>

                <button class="top-margin" data-button="submit" v-on:click="saveItem()" :disabled="model.loading">
                  {{ model.loading ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </div>

            <!-- Loading State -->
            <div v-if="model.loading && !model.editMode" class="loading-state">
              <p>Loading catalog...</p>
            </div>

            <!-- Error State -->
            <div v-if="model.error" class="error-state">
              <p>{{ model.error }}</p>
              <button v-on:click="loadCatalog()">Retry</button>
            </div>

            <!-- Catalog Items Table -->
            <div v-if="!model.loading && !model.error" class="body">
              <table>
                <thead>
                  <tr>
                    <th>Active</th>
                    <th>Image</th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Point Cost</th>
                    <th>Stock</th>
                    <th>Approval</th>
                    <th>Featured</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="model.catalogItems.length === 0">
                    <td colspan="10" style="text-align: center;">No catalog items yet. Click "Add Catalog Item" to create one.</td>
                  </tr>
                  <tr v-for="item in model.catalogItems" :key="item.id">
                    <td>
                      <div class="form-check form-switch">
                        <input type="checkbox" :checked="item.is_active === true || item.is_active == 1" v-on:change="toggleStatus(item)" class="form-check-input">
                      </div>
                    </td>
                    <td>
                      <div class="catalog-image-wrapper">
                        <img v-if="item.image_url" :src="item.image_url" :alt="item.name" class="catalog-item-image" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
                        <div v-if="!item.image_url" class="catalog-image-placeholder">
                          <i class="bi-image"></i>
                        </div>
                      </div>
                    </td>
                    <td>
                      {{ getItemTypeLabel(item.item_type) }}
                    </td>
                    <td>
                      <strong>{{ item.name }}</strong>
                    </td>
                    <td>
                      <span v-if="item.description">{{ item.description.substring(0, 40) }}...</span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      {{ item.point_cost.toLocaleString() }} pts
                    </td>
                    <td>
                      <span v-if="item.stock_quantity === null">∞</span>
                      <span v-else>{{ item.remaining_stock || 0 }} / {{ item.stock_quantity }}</span>
                    </td>
                    <td>
                      <span v-if="item.requires_approval == 1 || item.requires_approval === true">Required</span>
                      <span v-else>Auto</span>
                    </td>
                    <td>
                      <span v-if="item.is_featured == 1 || item.is_featured === true">⭐</span>
                    </td>
                    <td>
                      <button class="btn-small" v-on:click="editItem(item)">Edit</button>
                      <button class="btn-small btn-danger" v-on:click="deleteItem(item)">Delete</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
`,

giveExclusiveCard: `
  <div data-component="give-exclusive-card" class="always-display">
    <div class="queue-card queue-card-action">
      <div class="queue-card-header">
        <div class="queue-header-content">
          <div class="queue-icon-wrapper queue-icon-exclusive">
            <i class="bi-star-fill"></i>
          </div>
          <div class="queue-title-group">
            <h4 class="queue-title">Give Exclusive Card</h4>
            <p class="queue-subtitle">Give exclusive cards to viewers</p>
          </div>
        </div>
      </div>
      <div class="queue-card-body">
        <div v-if="Object.keys(model.userCards).length === 0" class="empty-state">
          <i class="bi-inbox"></i>
          <p>No exclusive cards in inventory. Redeem cards from the catalog first!</p>
        </div>

        <div v-else>
          <div class="action-card-content">
            <div class="card-inventory-section">
              <div class="inventory-header">
                <i class="bi-collection"></i>
                <span>Your Exclusive Cards</span>
              </div>
              <div class="inventory-list">
                <div class="inventory-item card-item" v-for="card in model.userCards" :key="card.cardId" style="display: flex; align-items: center; gap: 12px;">
                  <div class="card-preview-wrapper" style="width: 30px; height: 42px; overflow: visible; flex-shrink: 0;">
                    <div style="transform: scale(0.1); transform-origin: top left;">
                      <playingCard :card="{ ...card, image: root + '/images/exclusive-cards/' + card.cardId + '.png' }" :show="true"></playingCard>
                    </div>
                  </div>
                  <div class="card-details" style="display: flex; flex-direction: column; gap: 4px;">
                    <div class="card-info" style="display: block ; align-items: center; gap: 8px;">
                      <span class="card-name"><strong>{{ card.name }}</strong></span>
                      <span class="card-badge tier-badge" :class="'tier-' + card.tier">Tier {{ card.tier }}</span>
                      <span v-if="card.quantity" class="card-badge quantity-badge" style="background: #6366f1; margin-left: 4px;">x{{ card.quantity }}</span>
                    </div>
                    <span class="card-date" style="font-size: 12px; opacity: 0.7;">Redeemed: {{ new Date(card.dateRedeemed).toLocaleDateString() }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="action-form-section">
              <div class="form-group">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Viewer Display Name: Type the Twitch display name of the viewer you want to give to.">
                  <i class="bi-person"></i> Viewer Display Name
                </label>
                <input class="form-control modern-input search" name="exclusive-card-user" v-on:keyup="searchUsers()" type="text" placeholder="Search viewer...">
              </div>
              <div class="form-group">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Card: Select an exclusive card to give away.">
                  <i class="bi-star"></i> Select Card
                </label>
                <select class="form-select modern-select" v-model="model.cardId">
                  <option value="">-- Select Card --</option>
                  <option v-for="(card, key) in model.userCards" :key="card.cardId" :value="card.cardId">
                    {{ card.name }} (Tier {{ card.tier }}) x{{ card.quantity }}
                  </option>
                </select>
              </div>
              <button class="settings-save-btn action-submit-btn" data-button="submit" v-on:click="save()" :disabled="model.saving">
                <i class="bi-check-lg"></i>
                <span>{{ model.saving ? 'Giving...' : 'Give Card' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  `,

  exclusiveCards: `
  <div data-component="exclusive-cards">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-star-fill"></i>
              <div>
                <h2>Exclusive Streamer Cards</h2>
                <p class="admin-subtitle quest-subtitle">Manage exclusive streamer cards</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Exclusive Card</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i>
            <div class="col-12 scroll_sidebar">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be redeemed or used in a battle.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tier: The card's tier (1=Standard, 2=Ultra, 3=Legendary, 4=Ultimate).">Tier</label>
                    <select class="form-select" v-model="model.card.tier">
                      <option v-for="(value, key) in model.tiers" v-bind:value="parseInt(key)">
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                    <select class="form-select" v-model="model.card.type">
                      <option value="">Select Type</option>
                      <option v-for="(value, key) in model.types" v-bind:value="key">
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ability: The card's ability.">Ability</label>
                    <select class="form-select" v-model="model.card.ability">
                      <option value="">No Ability Selected</option>
                      <option v-for="(value, key) in model.abilities" v-bind:value="key">
                      {{ value.name }} - {{ value.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Innate Trait: A trait the card inflicts on the enemy each time its ability fires.">Innate Trait</label>
                    <select class="form-select" v-model="model.card.trait">
                      <option value="">No Trait</option>
                      <option v-for="trait in model.traits" :key="trait.id" :value="trait.id">
                        {{ trait.name }} — {{ trait.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="HP: The card's hit points.">HP</label>
                    <input class="form-control" v-model="model.card.hp" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Attack: The card's attack points.">Attack</label>
                    <input class="form-control" v-model="model.card.attack" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Defense: The card's defense points.">Defence</label>
                    <input class="form-control" v-model="model.card.defence" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Accuracy: The card's attack accuracy.">Accuracy</label>
                    <input class="form-control" v-model="model.card.accuracy" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Speed: The card's speed points.">Speed</label>
                    <input class="form-control" v-model="model.card.speed" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Exclusive Until: Optional date when exclusivity expires (leave empty for permanent).">Exclusive Until</label>
                    <input class="form-control" v-model="model.card.exclusiveUntil" type="datetime-local">
                  </div>
                  <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                    <i class="bi-check-lg"></i> Save Exclusive Card
                  </button>
                  <div v-if="model.card.id" class="upload-section">
                    <file-upload
                      :multiple="false"
                      upload-type="exclusive-cards"
                      :upload-id="model.card.id"
                      accepted-types="image/*"
                      :max-size="5 * 1024 * 1024"
                      :existing-images="model.card.image"
                      :allow-remove-existing="true"
                      :image-base-url="getCardUrl()"
                      @upload-success="handleCardImageUpload">
                    </file-upload>
                  </div>
                </div>
              </div>
            </div>

            <div class="admin-table-wrapper quest-table-wrapper">
              <table class="admin-table quest-table">
                <thead>
                  <tr>
                    <th class="th-level">Active</th>
                    <th class="th-name">Name</th>
                    <th class="th-name">Image</th>
                    <th class="th-name">Tier</th>
                    <th class="th-level">HP</th>
                    <th class="th-level">Attack</th>
                    <th class="th-level">Defence</th>
                    <th class="th-level">Speed</th>
                    <th class="th-level">Accuracy</th>
                    <th class="th-name">Exclusive Until</th>
                    <th class="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="card in model.cards" :key="card.id">
                    <tr class="admin-table-row quest-row" v-on:click="edit(card.id)">
                      <td class="td-level">
                        <i v-if="card.active == true" class="bi-check-lg"></i>
                        <i v-if="card.active == false" class="bi-x-lg"></i>
                      </td>
                      <td class="td-name">
                        <div class="admin-name-cell quest-name-cell">
                          <span class="admin-name quest-name" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">{{ card.name }}</span>
                        </div>
                      </td>
                      <td class="td-name">
                        <img v-if="card.image && card.image[0]" :src="getCardUrl() + card.image[0]" :alt="card.name + ' image'" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer;" @click.stop @error="$event.target.style.display='none'" />
                        <span v-else style="color: #999;">No image</span>
                      </td>
                      <td class="td-name">
                        {{ model.tiers[card.tier].name }}
                      </td>
                      <td class="td-level">
                        {{ card.hp }}
                      </td>
                      <td class="td-level">
                        {{ card.attack }}
                      </td>
                      <td class="td-level">
                        {{ card.defence }}
                      </td>
                      <td class="td-level">
                        {{ card.speed }}
                      </td>
                      <td class="td-level">
                        {{ card.accuracy }}
                      </td>
                      <td class="td-name">
                        {{ card.exclusiveUntil ? card.exclusiveUntil.substring(0, 10) : 'Permanent' }}
                      </td>
                      <td class="td-actions">
                        <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(card.id)" title="Edit Exclusive Card">
                          <i class="bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
`,
  legacyCardLibrary: `
   <div data-component="legacy-card-library">
      <h1>asdasdasdasdas</h1>
   </div>

`,

  leaderBoardLegacy: `
    <div data-component="leaderboardlegacy" class="leaderboard">
      <section>
        <div v-if="!model.isLoggedIn" class="loading-container">
            <span class="loader"></span>
            <p>please wait...</p>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Legacy Leaderboard (All-Time)</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="user in model.top">
                      <div class="user">
                        <div class="info">
                          <img :src="user.profileImage" />
                          <span class="trophy">
                            <i class="bi-trophy-fill"></i>
                          </span>
                          <p class="name" :title="user.user">{{ user.user }}</p>
                        </div>
                        <div class="wins">
                          <p>{{ user.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-2 col-md-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Rank</label>
                    </div>
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Username</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Win Rate</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">XP</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Level</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="user in model.users">
                      <div class="col-2 col-md-2">
                        <p>{{ user.rank }}</p>
                      </div>
                      <div class="col-3 col-md-3 info">
                        <img :src="user.profileImage" />
                        <p :title="user.user">{{ user.user }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.wins }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.losses }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.winRate }}%</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.xp }}</p>
                      </div>
                       <div class="col-1 d-md-block">
                        <p>{{ user.level }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pagination-controls">
                <div class="col-12">
                  <button v-if="model.currentPage > 0" @click="previousPage()" class="btn btn-secondary">Previous</button>
                  <span class="page-info">Page {{ model.currentPage + 1 }} of {{ model.totalPages || 1 }}</span>
                  <button v-if="model.currentPage < model.totalPages - 1" @click="nextPage()" class="btn btn-secondary">Next</button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  leaderBoardLegacyTeam: `
    <div data-component="leaderboardlegacyteam" class="leaderboard">
       <section>
        <div v-if="!model.isLoggedIn" class="loading-container">
            <span class="loader"></span>
            <p>please wait...</p>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <div class="header-container">
                  <h4>Legacy Team Leaderboard (All-Time)</h4>
                    <select class="form-select seasonal" v-model="model.selectedOption">
                    <option v-for="(option, index) in model.options" :key="index" :value="index">
                         {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>

             <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="team in model.top" :key="team.teamId">
                      <div class="user">
                        <div class="team-info">
                          <div class="member" v-for="(member, index) in team.members" :key="index">
                            <p :title="member.displayName">{{ member.displayName }}</p>
                          </div>
                        </div>
                        <span class="trophy">
                          <i class="bi-trophy-fill"></i>
                        </span>
                        <p class="name" :title="team.teamName">{{ team.teamName }}</p>
                        <div class="wins">
                          <p>{{ team.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-2 col-md-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Rank</label>
                    </div>
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Team Name</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Members</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Win Rate</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="team in model.teams">
                      <div class="col-2 col-md-2">
                        <p>{{ team.rank }}</p>
                      </div>
                      <div class="col-3 col-md-3 info">
                        <p :title="team.teamName">{{ team.teamName }}</p>
                      </div>
                      <div class="col-2">
                        <div v-for="(member, index) in team.members" :key="index" class="member-tag">
                          {{ member.displayName }}
                        </div>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ team.wins }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ team.losses }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ team.winRate }}%</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pagination-controls">
                <div class="col-12">
                  <button v-if="model.currentPage > 0" @click="previousPage()" class="btn btn-secondary">Previous</button>
                  <span class="page-info">Page {{ model.currentPage + 1 }} of {{ model.totalPages || 1 }}</span>
                  <button v-if="model.currentPage < model.totalPages - 1" @click="nextPage()" class="btn btn-secondary">Next</button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  streamerVisibilityPanel: `
    <div class="card streamer-visibility-panel">
      <div class="card-header">
        <h3>🎬 Stream Visibility Settings</h3>
        <button @click="togglePanel" class="gear-button">
          ⚙️
        </button>
      </div>

      <div v-if="panelExpanded" class="card-body">
        <div class="current-setting">
          <p><strong>Current Setting:</strong></p>
          <div class="setting-badge" :class="currentSetting">
            {{ currentSetting === 'all' ? '👁️ Show All Battles/Packs' : '🔒 Show Only My Battles/Packs' }}
          </div>
        </div>

        <div class="setting-toggle">
          <p><strong>Change Setting:</strong></p>
          <div class="toggle-buttons">
            <button @click="changeSetting('all')" :class="{ active: currentSetting === 'all' }" class="toggle-btn" :disabled="isSaving">👁️ Show All</button>
            <button @click="changeSetting('own')" :class="{ active: currentSetting === 'own' }" class="toggle-btn" :disabled="isSaving">🔒 Show Only Mine</button>
          </div>
          <p v-if="settingChangeMessage" :class="messageType" class="message">{{ settingChangeMessage }}</p>
        </div>

        <div class="pending-requests" v-if="pendingRequests.length > 0">
          <h4>Pending Requests ({{ pendingRequests.length }})</h4>
          <div class="requests-list">
            <div v-for="request in pendingRequests" :key="request.id" class="request-item">
              <div class="request-info">
                <p><strong>@{{ request.requestedByTwitchId }}</strong> <span class="role-badge" :class="request.requestedByRole">{{ request.requestedByRole }}</span></p>
                <p class="request-message">Requests: <strong>{{ request.requestedSetting === 'all' ? '👁️ Show All' : '🔒 Show Only My Content' }}</strong></p>
                <p class="request-date">{{ formatDate(request.dateCreated) }}</p>
              </div>
              <div class="request-actions">
                <button @click="approveRequest(request.id, request.requestedSetting)" class="approve-btn" :disabled="isProcessing">✓ Approve</button>
                <button @click="denyRequest(request.id)" class="deny-btn" :disabled="isProcessing">✗ Deny</button>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="no-requests"><p>No pending requests</p></div>

        <div class="info-section">
          <h4>ℹ️ How It Works</h4>
          <ul>
            <li><strong>Show All:</strong> All battles and pack openings appear on your stream</li>
            <li><strong>Show Only Mine:</strong> Only your battles/packs appear on the stream</li>
            <li><strong>Requests:</strong> Viewers can request you to change this setting</li>
          </ul>
        </div>
      </div>

      <div v-else class="card-summary">
        <p>Current: <strong>{{ currentSetting === 'all' ? 'All Content' : 'Only My Content' }}</strong></p>
        <p v-if="pendingRequests.length > 0" class="pending-badge">📬 {{ pendingRequests.length }} pending request{{ pendingRequests.length !== 1 ? 's' : '' }}</p>
      </div>
    </div>
  `,

  visibilityRequestButton: `
    <div class="visibility-request-button">
      <button v-if="!requestSent && !isBattleVisible" @click="sendRequest" class="request-btn" :disabled="isSending" :title="buttonTitle">
        <i class="fas fa-comment"></i> Request Stream to Show All
      </button>

      <div v-if="requestSent" class="request-sent-message">
        <i class="fas fa-check-circle"></i> Request sent to streamer
        <button @click="closeMessage" class="close-btn">×</button>
      </div>

      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
        <button @click="clearError" class="close-btn">×</button>
      </div>

      <div v-if="showRequestModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <h3>Request Visibility Change</h3>
          <p>You're requesting the streamer to show all battles and pack openings.</p>

          <div class="request-preview">
            <p><strong>Current Setting:</strong> Show Only Streamer's Content</p>
            <p><strong>Requested Setting:</strong> Show All Content</p>
          </div>

          <div v-if="userRole === 'mod'" class="mod-note">
            <i class="fas fa-info-circle"></i> You're a mod - your request will be prioritized
          </div>

          <div class="request-actions">
            <button @click="confirmRequest" :disabled="isSending" class="confirm-btn">
              <span v-if="!isSending">Send Request</span>
              <span v-else><i class="fas fa-spinner fa-spin"></i> Sending...</span>
            </button>
            <button @click="closeModal" class="cancel-btn">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  `,

  streamerObsSettings: `
    <div class="card streamer-obs-settings-panel">
      <div class="card-header">
        <h3>📺 Pack Opening Display Mode</h3>
        <button @click="togglePanel" class="gear-button" title="Toggle settings panel">
          ⚙️
        </button>
      </div>

      <div v-if="panelExpanded" class="card-body obs-settings-body">
        <!-- Display Mode Selection -->
        <div class="display-mode-section">
          <h4>How Do You Want to Display Pack Openings?</h4>
          <p class="setting-description">Choose whether pack animations appear on your OBS broadcast or exclusively in the Twitch extension.</p>

          <div class="display-mode-options">
            <!-- Broadcast Mode -->
            <div class="mode-option">
              <div class="mode-header">
                <input
                  type="radio"
                  id="mode-broadcast"
                  value="broadcast"
                  v-model="displayMode"
                  @change="changeDisplayMode('broadcast')"
                  class="mode-radio"
                >
                <label for="mode-broadcast" class="mode-label">
                  <span class="mode-icon">📺</span>
                  <span class="mode-title">Show on OBS Broadcast</span>
                </label>
              </div>
              <p class="mode-description">Pack animations display on your stream for all viewers to see. Visible in OBS overlay when enabled.</p>
              <div class="mode-benefits">
                <span class="benefit">✓ Everyone sees the animation</span>
                <span class="benefit">✓ Exciting for stream viewers</span>
                <span class="benefit">✓ Great for content</span>
              </div>
            </div>

            <!-- Extension Only Mode -->
            <div class="mode-option">
              <div class="mode-header">
                <input
                  type="radio"
                  id="mode-extension"
                  value="extension"
                  v-model="displayMode"
                  @change="changeDisplayMode('extension')"
                  class="mode-radio"
                >
                <label for="mode-extension" class="mode-label">
                  <span class="mode-icon">🔒</span>
                  <span class="mode-title">Extension Only (Hidden from OBS)</span>
                </label>
              </div>
              <p class="mode-description">Pack animations only appear in the Twitch extension. Hidden from OBS broadcast completely.</p>
              <div class="mode-benefits">
                <span class="benefit">✓ Private animations only</span>
                <span class="benefit">✓ Keeps OBS clean</span>
                <span class="benefit">✓ Viewers control visibility</span>
              </div>
            </div>
          </div>

          <!-- Current Status -->
          <div v-if="displayMode" class="mode-status">
            <div class="status-badge" :class="'status-' + displayMode">
              {{ displayMode === 'broadcast' ? '📺 Currently showing on OBS broadcast' : '🔒 Currently showing in extension only' }}
            </div>
          </div>
        </div>

        <!-- Info Section -->
        <div class="info-section">
          <h4>ℹ️ About Viewer Preferences</h4>
          <p>Regardless of your display mode choice:</p>
          <ul>
            <li><strong>Viewers Control Their View:</strong> Each viewer chooses what they see in the extension</li>
            <li><strong>Show All:</strong> Viewers can see all packs opened on the stream</li>
            <li><strong>Only My Packs:</strong> Viewers see only packs opened for them</li>
            <li><strong>Hide All:</strong> Viewers can hide all animations</li>
            <li><strong>Independent:</strong> Your display mode choice doesn't override viewer preferences</li>
          </ul>
        </div>
      </div>

      <!-- Collapsed State -->
      <div v-else class="card-collapsed">
        <div class="collapsed-summary">
          <span class="summary-badge" :class="'mode-' + displayMode">
            {{ displayMode === 'broadcast' ? '📺 Show on OBS' : '🔒 Extension Only' }}
          </span>
        </div>
      </div>
    </div>
  `,

  packOpeningRequestButton: `<div class="pack-request-button-container">
      <!-- Button to trigger request modal -->
      <button
        v-if="!showRequestModal && canShowButton"
        @click="openRequestModal"
        class="btn btn-outline-primary btn-sm pack-request-btn"
        :disabled="isLoading"
      >
        <i class="bi bi-hand-thumbs-up"></i>
        {{ isLoading ? 'Submitting...' : 'Request Pack Opening' }}
      </button>

      <!-- Request Modal -->
      <div v-if="showRequestModal" class="modal-overlay pack-request-modal" @click.self="closeRequestModal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Request Pack Opening</h5>
            <button type="button" class="btn-close" @click="closeRequestModal"></button>
          </div>

          <div class="modal-body">
            <!-- Status Messages -->
            <div v-if="statusMessage" :class="['alert', statusMessage.type]">
              {{ statusMessage.text }}
            </div>

            <!-- Available Packs Selection -->
            <div v-if="!submitting" class="pack-selection">
              <label for="pack-select" class="form-label">Select Pack to Request:</label>
              <select
                id="pack-select"
                v-model="selectedPackId"
                class="form-control"
                :disabled="availablePacks.length === 0"
              >
                <option value="">-- Choose a pack --</option>
                <option v-for="pack in availablePacks" :key="pack.id" :value="pack.id">
                  {{ pack.displayName }} ({{ pack.type }})
                </option>
              </select>

              <!-- Cooldown Warning -->
              <div v-if="cooldownInfo.isOnCooldown" class="alert alert-warning mt-3">
                <small>
                  <i class="bi bi-clock"></i>
                  You can submit another request in {{ formatTimeRemaining(cooldownInfo.timeRemaining) }}
                </small>
              </div>

              <!-- Request Info -->
              <div class="request-info mt-3">
                <p class="text-muted small">
                  The streamer will review your request and open your pack on stream if approved.
                  You'll see your pack opening on the overlay based on your visibility settings.
                </p>
              </div>
            </div>

            <!-- Submission Loading State -->
            <div v-if="submitting" class="text-center py-4">
              <div class="spinner-border text-primary mb-3" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p>Submitting your request...</p>
            </div>

            <!-- Success State -->
            <div v-if="showSuccessState" class="success-state text-center">
              <div class="success-icon mb-3">
                <i class="bi bi-check-circle-fill text-success" style="font-size: 3rem;"></i>
              </div>
              <h6>Request Submitted!</h6>
              <p class="text-muted small">
                The streamer has received your request. You'll be notified when they respond.
              </p>
              <p class="text-muted small">
                Current status: <strong>{{ requestStatus }}</strong>
              </p>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeRequestModal"
              :disabled="submitting"
            >
              {{ showSuccessState ? 'Close' : 'Cancel' }}
            </button>
            <button
              v-if="!showSuccessState && !submitting && selectedPackId"
              type="button"
              class="btn btn-primary"
              @click="submitRequest"
              :disabled="!selectedPackId || cooldownInfo.isOnCooldown"
            >
              Submit Request
            </button>
          </div>
        </div>
      </div>

      <!-- Request Status Indicator (shows in background) -->
      <div v-if="userRequests.pending.length > 0" class="request-status-badge">
        <span class="badge bg-warning">
          <i class="bi bi-hourglass-split"></i>
          {{ userRequests.pending.length }} Request{{ userRequests.pending.length !== 1 ? 's' : '' }} Pending
        </span>
      </div>
    </div>`,

  packOpeningRequestQueue: `<div class="pack-request-queue-container">
      <div class="request-queue-card">
        <!-- Header -->
        <div class="queue-header">
          <h5 class="mb-0">
            <i class="bi bi-inbox"></i> Pack Opening Requests
          </h5>
          <div class="queue-stats">
            <small class="text-muted">
              Pending: <strong>{{ requests.pending.length }}</strong> |
              Approved: <strong>{{ requests.approved.length }}</strong> |
              Total: <strong>{{ allRequests.length }}</strong>
            </small>
          </div>
        </div>

        <!-- Filter Tabs -->
        <div class="queue-filters">
          <button
            v-for="status in ['pending', 'approved', 'declined']"
            :key="status"
            @click="currentFilter = status"
            :class="['filter-btn', { active: currentFilter === status }]"
          >
            {{ formatStatus(status) }}
            <span class="badge">{{ requests[status].length }}</span>
          </button>
        </div>

        <!-- Loading State -->
        <div v-if="loading" class="queue-loading">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <span class="ms-2">Loading requests...</span>
        </div>

        <!-- Empty State -->
        <div v-else-if="filteredRequests.length === 0" class="queue-empty">
          <i class="bi bi-inbox"></i>
          <p>No {{ currentFilter }} requests</p>
        </div>

        <!-- Requests List -->
        <div v-else class="requests-list">
          <div
            v-for="request in filteredRequests"
            :key="request.id"
            :class="['request-item', \`status-\${request.status}\`]"
          >
            <!-- Request Header -->
            <div class="request-header">
              <div class="requester-info">
                <h6 class="requester-name">{{ request.requestedByUsername }}</h6>
                <small class="request-time">
                  Requested {{ formatDate(request.dateCreated) }}
                </small>
              </div>
              <div class="request-badge">
                <span :class="['badge', \`bg-\${getStatusColor(request.status)}\`]">
                  {{ formatStatus(request.status) }}
                </span>
              </div>
            </div>

            <!-- Pack Details -->
            <div class="request-pack-details">
              <div class="pack-type-badge">
                <span :class="['badge', \`bg-\${getPackTypeColor(request.packType)}\`]">
                  {{ request.packType || 'Standard' }} Pack
                </span>
              </div>
              <div class="pack-id-info">
                <small class="text-muted">ID: {{ request.packId }}</small>
              </div>
            </div>

            <!-- Response Message (if declined) -->
            <div v-if="request.status === 'declined' && request.streamerResponse" class="response-message">
              <div class="alert alert-light mb-2">
                <strong>Reason:</strong> {{ request.streamerResponse }}
              </div>
            </div>

            <!-- Action Buttons (for pending requests) -->
            <div v-if="request.status === 'pending'" class="request-actions">
              <button
                @click="approveRequest(request)"
                :disabled="approving === request.id"
                class="btn btn-sm btn-success"
              >
                <span v-if="approving === request.id" class="spinner-border spinner-border-sm me-2"></span>
                <i class="bi bi-check-circle"></i> Approve
              </button>
              <button
                @click="showDeclineModal(request)"
                :disabled="approving === request.id"
                class="btn btn-sm btn-danger"
              >
                <i class="bi bi-x-circle"></i> Decline
              </button>
            </div>

            <!-- Metadata Footer -->
            <div v-if="request.dateResponded" class="request-footer">
              <small class="text-muted">
                Responded {{ formatDate(request.dateResponded) }}
                <span v-if="request.respondedBy"> by {{ request.respondedBy }}</span>
              </small>
            </div>
          </div>
        </div>

        <!-- Auto-refresh Status -->
        <div class="queue-footer">
          <small class="text-muted">
            <i class="bi bi-arrow-repeat"></i>
            Auto-refreshing every 30 seconds
            <span v-if="lastRefreshed" class="ms-2">(Last updated: {{ formatTime(lastRefreshed) }})</span>
          </small>
        </div>
      </div>

      <!-- Decline Reason Modal -->
      <div v-if="showDeclineReasonModal" class="modal-overlay" @click.self="closeDeclineModal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Decline Request</h5>
            <button type="button" class="btn-close" @click="closeDeclineModal"></button>
          </div>

          <div class="modal-body">
            <p class="mb-3">
              Request from <strong>{{ declineModalRequest?.requestedByUsername }}</strong>
            </p>

            <label for="decline-reason" class="form-label">Reason (optional):</label>
            <textarea
              id="decline-reason"
              v-model="declineReason"
              class="form-control"
              rows="3"
              placeholder="Explain why you're declining this request (viewer will see this)"
              :disabled="approving === declineModalRequest?.id"
            ></textarea>
            <small class="text-muted d-block mt-2">
              The viewer will receive a notification with your response.
            </small>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeDeclineModal"
              :disabled="approving === declineModalRequest?.id"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="declineRequest"
              :disabled="approving === declineModalRequest?.id"
            >
              <span v-if="approving === declineModalRequest?.id" class="spinner-border spinner-border-sm me-2"></span>
              Decline Request
            </button>
          </div>
        </div>
      </div>

      <!-- Notification Toast -->
      <div v-if="notificationMessage" :class="['notification-toast', notificationMessage.type]">
        <i :class="getNotificationIcon(notificationMessage.type)"></i>
        {{ notificationMessage.text }}
      </div>
    </div>`,

  streamersList: `
    <div class="streamers-list-container">

      <!-- Premium Header -->
      <div class="streamers-header">
        <div class="streamers-header-left">
          <div class="streamers-title-wrap">
            <i class="bi-broadcast"></i>
            <h1 class="streamers-title">Live Channels</h1>
            <span v-if="model.hasResults" class="streamers-count">
              {{ sortedStreamers.length + sortedFeaturedStreamers.length }}
            </span>
          </div>
          <p class="streamers-subtitle">Official Battledogs Community Streamers</p>
        </div>
        <div class="streamers-header-right">
          <div class="streamers-search-wrap">
            <i class="bi-search streamers-search-icon"></i>
            <input
              type="text"
              class="streamers-search-input"
              placeholder="Search streamer..."
              v-model="model.searchQuery"
            />
            <button v-if="model.searchQuery" class="streamers-search-clear" @click="model.searchQuery = ''">
              <i class="bi-x"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="model.isLoading" class="streamers-loading">
        <div class="spinner"></div>
        <p>Loading streamers...</p>
      </div>

      <!-- Error State -->
      <div v-else-if="model.error" class="streamers-error">
        <p>{{ model.error }}</p>
        <button @click="loadStreamers()" class="retry-btn">
          <i class="bi-arrow-clockwise"></i> Retry
        </button>
      </div>

      <template v-else>

        <!-- Featured Streamers — Horizontal Scroll Cards -->
        <div v-if="model.featuredStreamers.length > 0" class="featured-streamers-section">
          <div class="section-header">
            <i class="bi-star-fill section-icon featured-icon"></i>
            <h2 class="section-label">Featured Streamers</h2>
          </div>
          <div class="featured-streamers-scroll">
            <div
              v-for="streamer in sortedFeaturedStreamers"
              :key="'featured-' + streamer.id"
              class="featured-card"
              :class="{ 'is-live': streamer.isLive }"
              @click="openTwitchChannel(streamer)"
            >
              <div class="featured-badge">
                <i class="bi-star-fill"></i> Featured
              </div>
              <div class="featured-avatar-wrap">
                <img
                  :src="streamer.twitchProfileImage"
                  :alt="streamer.twitchDisplayName"
                  class="featured-avatar"
                  @error="$event.target.src='/images/default-avatar.png'"
                />
                <span class="avatar-status-dot" :class="{ live: streamer.isLive }"></span>
              </div>
              <div class="featured-info">
                <h3 class="featured-name">{{ streamer.twitchDisplayName }}</h3>
                <span class="featured-handle">@{{ streamer.twitchLogin }}</span>
                <div v-if="streamer.isLive" class="featured-live-row">
                  <span class="live-pulse-badge"><span class="dot"></span> LIVE</span>
                  <span class="featured-viewers">
                    <i class="bi-eye-fill"></i> {{ formatViewerCount(streamer.viewerCount) }}
                  </span>
                </div>
                <p v-if="streamer.isLive && streamer.streamTitle" class="featured-stream-title">
                  {{ streamer.streamTitle }}
                </p>
              </div>
              <button class="btn-watch" @click.stop="openTwitchChannel(streamer)">
                <i class="bi-twitch"></i> Watch
              </button>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div v-if="!model.hasResults && model.featuredStreamers.length === 0" class="streamers-empty">
          <i class="bi-broadcast" style="font-size:3rem;opacity:0.25;display:block;margin-bottom:1rem;"></i>
          <p>No streamers found.</p>
        </div>

        <!-- All Streamers — Premium List Rows -->
        <div v-if="model.streamers.length > 0" class="all-streamers-section">
          <div v-if="model.featuredStreamers.length > 0" class="section-header">
            <i class="bi-people-fill section-icon all-icon"></i>
            <h2 class="section-label">All Streamers</h2>
          </div>
          <div class="streamers-premium-list">
            <div v-if="filteredStreamers.length === 0 && model.searchQuery" class="streamers-no-results">
              <i class="bi-search" style="font-size:1.5rem;opacity:0.35;"></i>
              <p>No streamers match "{{ model.searchQuery }}"</p>
            </div>
            <div
              v-for="streamer in filteredStreamers"
              :key="streamer.id"
              class="streamer-row"
              :class="{ 'is-live': streamer.isLive }"
            >
              <div class="row-live-bar" :class="{ visible: streamer.isLive }"></div>
              <div class="row-avatar-wrap">
                <img
                  :src="streamer.twitchProfileImage"
                  :alt="streamer.twitchDisplayName"
                  class="row-avatar"
                  @error="$event.target.src='/images/default-avatar.png'"
                />
                <span class="row-status-dot" :class="{ live: streamer.isLive }"></span>
              </div>
              <div class="row-info">
                <div class="row-name-line">
                  <span class="row-display-name">{{ streamer.twitchDisplayName }}</span>
                  <span class="row-handle">@{{ streamer.twitchLogin }}</span>
                  <span v-if="streamer.isLive" class="live-chip">
                    <span class="dot"></span> LIVE
                  </span>
                </div>
                <div class="row-meta">
                  <span v-if="streamer.isLive && streamer.gameName" class="row-game">
                    <i class="bi-controller"></i> {{ streamer.gameName }}
                  </span>
                  <span v-if="streamer.isLive && streamer.streamTitle" class="row-title" :title="streamer.streamTitle">
                    {{ streamer.streamTitle }}
                  </span>
                </div>
              </div>
              <div class="row-right">
                <div v-if="streamer.isLive" class="row-viewers">
                  <i class="bi-eye-fill"></i>
                  <span>{{ formatViewerCount(streamer.viewerCount) }}</span>
                </div>
                <button class="btn-watch" @click="openTwitchChannel(streamer)">
                  <i class="bi-twitch"></i> Watch
                </button>
              </div>
            </div>
          </div>
        </div>

      </template>
    </div>`,

streamerEvents: `
  <div data-component="streamer-events">
    <section class="quest-line-section">
      <div class="quest-line-container">

        <!-- Loading State -->
        <div v-if="model.isLoading" class="text-center p-4">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- No Subscription Warning -->
        <div v-else-if="!model.hasSubscription" class="alert alert-warning">
          <i class="bi-exclamation-triangle"></i>
          <strong>Subscription Required</strong>
          <p>You need an active subscription to create events. Please subscribe to access this feature.</p>
        </div>

        <!-- Main Content -->
        <template v-else>
          <!-- Header Panel with Tier Info -->
          <div class="admin-header-panel quest-header-panel">
            <div class="admin-header-content quest-header-content">
              <div class="admin-header-title quest-header-title">
                <i class="bi-calendar-event"></i>
                <div>
                  <h2>Streamer Events</h2>
                  <p class="admin-subtitle quest-subtitle">
                    <span class="badge bg-primary">{{ tierName }}</span>
                    Create events for your community
                  </p>
                </div>
              </div>
              <button class="admin-add-btn quest-add-btn" data-button="submit" v-on:click="add()">
                <i class="bi-plus-lg"></i>
                <span>New Event</span>
              </button>
            </div>
          </div>

          <!-- Inventory Display -->
          <div class="inventory-overview mb-4">
            <div class="row">
              <div class="col-md-2">
                <div class="inventory-card">
                  <span class="inventory-label">Prime Packs</span>
                  <span class="inventory-value">{{ model.inventory.prime }}</span>
                </div>
              </div>
              <div class="col-md-2" v-if="model.tierAccess.allowedPacks && model.tierAccess.allowedPacks.includes('ultra')">
                <div class="inventory-card">
                  <span class="inventory-label">Ultra Packs</span>
                  <span class="inventory-value">{{ model.inventory.ultra }}</span>
                </div>
              </div>
              <div class="col-md-2" v-if="model.tierAccess.allowedPacks && model.tierAccess.allowedPacks.includes('legendary')">
                <div class="inventory-card">
                  <span class="inventory-label">Legendary Packs</span>
                  <span class="inventory-value">{{ model.inventory.legendary }}</span>
                </div>
              </div>
              <div class="col-md-2" v-if="model.tierAccess.allowChests">
                <div class="inventory-card">
                  <span class="inventory-label">Chests</span>
                  <span class="inventory-value">{{ model.inventory.chest }}</span>
                </div>
              </div>
              <div class="col-md-2" v-if="model.tierAccess.allowOwnedShopItems">
                <div class="inventory-card">
                  <span class="inventory-label">Owned Items</span>
                  <span class="inventory-value">{{ Object.keys(model.ownedShopItems.frames).length + Object.keys(model.ownedShopItems.backgrounds).length }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Edit Form Sidebar -->
          <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
            <div>
              <i class="bi-x-lg close" v-on:click="reset()"></i>
              <div class="col-12 scroll_sidebar">

                <!-- Event Details -->
                <h5>Event Details</h5>
                <hr>
                <div>
                  <label>Event Name</label>
                  <input class="form-control" v-model="model.event.name" type="text">
                </div>
                <div>
                  <label>Event Description</label>
                  <textarea cols="50" type="text" class="form-control" v-model="model.event.description"></textarea>
                </div>
                <div>
                  <label>From</label>
                  <input type="datetime-local" class="form-control" v-model="model.event.from">
                </div>
                <div>
                  <label>To</label>
                  <input type="datetime-local" class="form-control" v-model="model.event.to">
                </div>

                <!-- Event Type Selection -->
                <div>
                  <h5>Event Type</h5>
                  <hr>
                  <div class="radio-input">
                    <label>
                      <input type="radio" class="input" checked name="event-type" @change="inputValue('custom')">
                      Custom
                    </label>
                    <label v-if="canCreateQuest">
                      <input type="radio" class="input" name="event-type" @change="inputValue('quest')">
                      Quest
                    </label>
                    <label v-if="canCreateTournament">
                      <input type="radio" class="input" name="event-type" @change="inputValue('tournament')">
                      Tournament
                    </label>
                  </div>
                  <small v-if="!canCreateQuest" class="text-muted">
                    <i class="bi-lock"></i> Quest events require Ultra Plus or higher
                  </small>
                  <small v-if="!canCreateTournament" class="text-muted d-block">
                    <i class="bi-lock"></i> Tournament events require Legendary Plus
                  </small>
                </div>

                <!-- Custom Event Rules -->
                <div v-if="model.isCustomEnabled && model.event.custom">
                  <h5>Rules</h5>
                  <hr>
                  <div>
                    <label>Battle Options</label>
                    <select class="form-select" v-model="model.event.custom.battleOption">
                      <option v-for="battleOption in model.battle_options" :key="battleOption.value" :value="battleOption.value">
                        {{ battleOption.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <div class="radio-input">
                      <label>
                        <input type="radio" class="input" name="mode-options" value="to_win" v-model="model.event.custom.selectedMode">
                        To win
                      </label>
                      <label>
                        <input type="radio" class="input" name="mode-options" value="to_defeat" v-model="model.event.custom.selectedMode">
                        To defeat
                      </label>
                      <label>
                        <input type="radio" class="input" name="mode-options" value="any" v-model="model.event.custom.selectedMode">
                        Both
                      </label>
                      <label>
                        <input type="radio" class="input" name="mode-options" value="battle" v-model="model.event.custom.selectedMode">
                        Battle
                      </label>
                    </div>
                  </div>
                  <div>
                    <h6>Card Configuration</h6>
                    <hr>
                    <label>Create Team</label>
                    <div class="form-check form-switch">
                      <input v-model="model.event.custom.cardTeam" @change="generateCardTeam(model.event.custom.cardTeam)" type="checkbox" class="form-check-input">
                    </div>
                    <div v-if="model.event.custom.cardTeam">
                      <label>Team Name</label>
                      <input class="form-control" v-model="model.event.custom.teamName" type="text">
                    </div>
                    <event-card-manager
                      :event-cards="model.event.custom.cards"
                      :temporary-cards="model.event.custom.temporaryCards"
                      :available-cards="model.cards"
                      :abilities="model.abilities"
                      :types="model.types"
                      :traits="model.traits"
                      :mode="model.event.custom.cardManagementMode"
                      :is-team-enabled="model.event.custom.cardTeam"
                      :battle-type="model.event.custom.battleOption"
                      @mode-changed="handleCardModeChange"
                      @cards-updated="handleExistingCardsUpdate"
                      @temporary-cards-updated="handleTemporaryCardsUpdate"
                    />
                    <div>
                      <label>Wins needed</label>
                      <input class="form-control" v-model="model.event.custom.wins" type="number">
                    </div>
                    <div>
                      <label>Attempt Count</label>
                      <input class="form-control" v-model="model.event.custom.attempt" type="number">
                    </div>
                    <div>
                      <label>Retry Count</label>
                      <input class="form-control" v-model="model.event.custom.retry" type="number">
                    </div>
                  </div>
                </div>

                <!-- Quest Event (if allowed) -->
                <div v-if="model.isQuestEnabled && model.event.quest">
                  <QuestForm
                    :model="model.event.quest"
                    :cards="model.cards"
                    :packs="model.packs"
                    :randomcard="availableRandomCards"
                    @input-changed="handleQuestChange"
                  />
                </div>

                <!-- Tournament Event (if allowed) -->
                <div v-if="model.isTournamentEnabled && model.event.tournament">
                  <h5>Select Tournament</h5>
                  <hr>
                  <div>
                    <label>Tournament</label>
                    <select class="form-select" v-model="model.event.tournament.tournamentId">
                      <option :value="null">-- Select Tournament --</option>
                      <option v-for="(tournament, id) in model.tournaments" :key="id" :value="id">
                        {{ tournament.name }}
                      </option>
                    </select>
                  </div>
                  <div v-if="model.event.tournament.tournamentId && model.tournaments[model.event.tournament.tournamentId]" class="mt-3">
                    <div class="card">
                      <div class="card-body">
                        <h6 class="card-title">{{ model.tournaments[model.event.tournament.tournamentId].name }}</h6>
                        <p class="card-text text-muted">{{ model.tournaments[model.event.tournament.tournamentId].description }}</p>
                        <div class="row">
                          <div class="col-6">
                            <small><strong>Players:</strong> {{ model.tournaments[model.event.tournament.tournamentId].bracket }}</small>
                          </div>
                          <div class="col-6">
                            <small><strong>Battle Mode:</strong> {{ model.tournaments[model.event.tournament.tournamentId].battleOption }}</small>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-12">
                            <small><strong>Rules:</strong> {{ model.tournaments[model.event.tournament.tournamentId].rules || 'No Limits' }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <small v-if="Object.keys(model.tournaments).length === 0" class="text-warning d-block mt-2">
                    <i class="bi-exclamation-triangle"></i> No tournaments found. Create a tournament first.
                  </small>
                </div>

                <!-- Rewards Section -->
                <h5>Rewards</h5>
                <hr>
                <div class="tier-notice mb-2">
                  <small class="text-muted">
                    <i class="bi-info-circle"></i> Rewards are limited based on your {{ tierName }} subscription and available inventory.
                  </small>
                </div>
                <StreamerRewardsComponent
                  :rewards="model.event.rewards"
                  :tier-access="model.tierAccess"
                  :inventory="model.inventory"
                  :streamer-packs="model.streamerPacks"
                  :packs="model.packs"
                  :chests="model.chests"
                  :cards="model.cards"
                  :owned-exclusive-cards="model.ownedExclusiveCards"
                  :owned-shop-items="availableShopItems"
                  @reward-changed="handleRewardChange"
                />

                <button class="admin-save-btn quest-save-btn" data-button="submit" v-on:click="save()">
                  <i class="bi-check-lg"></i> Save Event
                </button>
              </div>
            </div>
          </div>

          <!-- Events Table -->
          <div class="admin-table-wrapper quest-table-wrapper">
            <table class="admin-table quest-table">
              <thead>
                <tr>
                  <th class="th-toggle"><i class="bi-eye"></i></th>
                  <th class="th-name">Event Name</th>
                  <th class="th-rules">Description</th>
                  <th class="th-date">Start Date</th>
                  <th class="th-date">End Date</th>
                  <th class="th-mode">Type</th>
                  <th class="th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(event, index) in model.events" :key="index">
                  <tr class="admin-table-row quest-row" :class="{ 'expanded': model.expandedRow === index }">
                    <td class="td-toggle" @click="toggleDetails(index)">
                      <button class="admin-toggle-btn toggle-btn" :class="{ 'active': model.expandedRow === index }">
                        <i v-if="model.expandedRow === index" class="bi-eye-fill"></i>
                        <i v-else class="bi-eye-slash"></i>
                      </button>
                    </td>
                    <td class="td-name" @click="toggleDetails(index)">
                      <div class="admin-name-cell quest-name-cell">
                        <span class="admin-name quest-name">{{ event.name }}</span>
                      </div>
                    </td>
                    <td class="td-rules" @click="toggleDetails(index)">
                      <span class="admin-rules-text rules-text" :title="event.description">{{ event.description }}</span>
                    </td>
                    <td class="td-date" @click="toggleDetails(index)">
                      <div class="date-cell">
                        <span class="date-value">{{ formattedDate(event.from) }}</span>
                      </div>
                    </td>
                    <td class="td-date" @click="toggleDetails(index)">
                      <div class="date-cell">
                        <span class="date-value">{{ formattedDate(event.to) }}</span>
                      </div>
                    </td>
                    <td class="td-mode" @click="toggleDetails(index)">
                      <span class="admin-badge-mode mode-badge" :class="getEventType(event).toLowerCase()">
                        {{ getEventType(event) }}
                      </span>
                    </td>
                    <td class="td-actions">
                      <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(event.id)" title="Edit Event">
                        <i class="bi-pencil"></i>
                      </button>
                    </td>
                  </tr>

                  <!-- Expanded Details Row -->
                  <tr class="admin-details-row quest-details-row" v-show="model.expandedRow === index">
                    <td colspan="7">
                      <div class="admin-details-panel quest-details-panel">
                        <div class="details-grid">
                          <template v-if="event.custom">
                            <div class="detail-card">
                              <div class="detail-card-header">
                                <i class="bi-gear"></i>
                                <h4>Custom Event Rules</h4>
                              </div>
                              <div class="detail-card-body">
                                <div class="rewards-grid">
                                  <div class="reward-item">
                                    <span class="reward-label">Battle Rules</span>
                                    <span class="reward-value">{{ battleRules(event.custom.selectedMode) }}</span>
                                  </div>
                                  <div class="reward-item">
                                    <span class="reward-label">Battle Mode</span>
                                    <span class="reward-value">{{ event.custom.battleOption }}</span>
                                  </div>
                                  <div class="reward-item">
                                    <span class="reward-label">Wins Needed</span>
                                    <span class="reward-value">{{ event.custom.wins }}</span>
                                  </div>
                                  <div class="reward-item">
                                    <span class="reward-label">Retry Count</span>
                                    <span class="reward-value">{{ event.custom.retry }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="event.quest">
                            <div class="detail-card">
                              <div class="detail-card-header">
                                <i class="bi-flag"></i>
                                <h4>Quest Details</h4>
                              </div>
                              <div class="detail-card-body">
                                <div class="rewards-grid">
                                  <div class="reward-item">
                                    <span class="reward-label">Quest Name</span>
                                    <span class="reward-value">{{ event.quest.name }}</span>
                                  </div>
                                  <div class="reward-item">
                                    <span class="reward-label">Wins Needed</span>
                                    <span class="reward-value">{{ event.quest.wins }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="event.tournament">
                            <div class="detail-card">
                              <div class="detail-card-header">
                                <i class="bi-trophy"></i>
                                <h4>Tournament Details</h4>
                              </div>
                              <div class="detail-card-body">
                                <div class="rewards-grid">
                                  <div class="reward-item" v-if="model.tournaments[event.tournament.tournamentId]">
                                    <span class="reward-label">Tournament</span>
                                    <span class="reward-value">{{ model.tournaments[event.tournament.tournamentId].name }}</span>
                                  </div>
                                  <div class="reward-item" v-if="model.tournaments[event.tournament.tournamentId]">
                                    <span class="reward-label">Players</span>
                                    <span class="reward-value">{{ model.tournaments[event.tournament.tournamentId].bracket }}</span>
                                  </div>
                                  <div class="reward-item" v-if="model.tournaments[event.tournament.tournamentId]">
                                    <span class="reward-label">Battle Mode</span>
                                    <span class="reward-value">{{ model.tournaments[event.tournament.tournamentId].battleOption }}</span>
                                  </div>
                                  <div class="reward-item" v-if="model.tournaments[event.tournament.tournamentId]">
                                    <span class="reward-label">Rules</span>
                                    <span class="reward-value">{{ model.tournaments[event.tournament.tournamentId].rules || 'No Limits' }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="detail-card" v-if="event.rewards">
                            <div class="detail-card-header">
                              <i class="bi-gift"></i>
                              <h4>Rewards</h4>
                            </div>
                            <div class="detail-card-body">
                              <div class="rewards-grid">
                                <div class="reward-item" v-if="event.rewards.xp > 0">
                                  <span class="reward-label">XP</span>
                                  <span class="reward-value">{{ event.rewards.xp }}</span>
                                </div>
                                <div class="reward-item" v-if="event.rewards.barks > 0">
                                  <span class="reward-label">Barks</span>
                                  <span class="reward-value">{{ event.rewards.barks }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr v-if="Object.keys(model.events).length === 0">
                  <td colspan="7" class="text-center p-4">
                    <p class="text-muted">No events created yet. Click "New Event" to get started.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </section>
  </div>`,

  cardBacks: `
  <div data-component="card-backs">
    <section class="quest-line-section">
      <div class="quest-line-container">

        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-layers-fill"></i>
              <div>
                <h2>Card Backings</h2>
                <p class="admin-subtitle quest-subtitle">Manage card backing cosmetics for shop, store, packs, chests &amp; rewards</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Card Backing</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i>
            <div class="col-12 scroll_sidebar">

              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Makes this card backing available in the system.">Active</label>
                <div class="form-check form-switch">
                  <input v-model="model.back.active" type="checkbox" class="form-check-input">
                </div>
              </div>

              <div>
                <label>Name</label>
                <input class="form-control" v-model="model.back.name" type="text" placeholder="e.g. Obsidian Backing">
              </div>

              <div>
                <label>Description</label>
                <textarea class="form-control" v-model="model.back.description" rows="3" placeholder="Brief description of this card backing..."></textarea>
              </div>

              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Rarity tier that determines drop rates and visual framing.">Rarity</label>
                <select class="form-select" v-model="model.back.rarity">
                  <option value="standard">Standard</option>
                  <option value="ultra">Ultra</option>
                  <option value="legendary">Legendary</option>
                  <option value="ultimate">Ultimate</option>
                </select>
              </div>

              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cost in reward points when listed in the Reward Points Shop (0 = free).">Point Cost</label>
                <input class="form-control" v-model.number="model.back.point_cost" type="number" min="0" placeholder="0">
              </div>

              <div class="card-backs-availability">
                <label>Availability</label>
                <div class="card-backs-availability-grid">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="model.back.available_shop" id="avail_shop">
                    <label class="form-check-label" for="avail_shop">
                      <i class="bi-gem"></i> Reward Points Shop
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="model.back.available_store" id="avail_store">
                    <label class="form-check-label" for="avail_store">
                      <i class="bi-shop"></i> Store
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="model.back.available_packs" id="avail_packs">
                    <label class="form-check-label" for="avail_packs">
                      <i class="bi-collection"></i> Packs
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="model.back.available_chest" id="avail_chest">
                    <label class="form-check-label" for="avail_chest">
                      <i class="bi-box-seam"></i> Chest
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="model.back.available_reward" id="avail_reward">
                    <label class="form-check-label" for="avail_reward">
                      <i class="bi-trophy"></i> Reward
                    </label>
                  </div>
                </div>
              </div>

              <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Card Backing
              </button>

              <div v-if="model.back.id" class="upload-section">
                <label class="upload-label">Backing Image</label>
                <div v-if="model.back.image && model.back.image[0]" class="card-back-preview">
                  <img :src="getBackUrl() + model.back.image[0]" :alt="model.back.name + ' backing'" class="card-back-preview-img" style="width: 110px; height: 230px; object-fit: contain;" @error="$event.target.style.display='none'" />
                </div>
                <file-upload
                  :multiple="false"
                  upload-type="card-backs"
                  :upload-id="model.back.id"
                  accepted-types="image/*"
                  :max-size="5 * 1024 * 1024"
                  :existing-images="model.back.image"
                  :allow-remove-existing="true"
                  :image-base-url="getBackUrl()"
                  @upload-success="handleImageUpload">
                </file-upload>
              </div>
              <div v-else class="upload-section upload-notice">
                <i class="bi-info-circle"></i> Save the card backing first to enable image upload.
              </div>

            </div>
          </div>
        </div>

        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-level">Active</th>
                <th class="th-name">Image</th>
                <th class="th-name">Name</th>
                <th class="th-name">Rarity</th>
                <th class="th-level">Points</th>
                <th class="th-name">Available In</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="back in model.backs" :key="back.id">
                <tr class="admin-table-row quest-row" v-on:click="edit(back.id)">
                  <td class="td-level">
                    <i v-if="back.active" class="bi-check-lg text-success"></i>
                    <i v-else class="bi-x-lg text-danger"></i>
                  </td>
                  <td class="td-name">
                    <img v-if="back.image && back.image[0]"
                      :src="getBackUrl() + back.image[0]"
                      :alt="back.name"
                      class="card-back-thumb"
                      @click.stop
                      @error="$event.target.style.display='none'" />
                    <span v-else class="text-muted small">No image</span>
                  </td>
                  <td class="td-name">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="back.description">{{ back.name }}</span>
                    </div>
                  </td>
                  <td class="td-name">
                    <span class="card-back-rarity-badge" :class="'rarity-' + back.rarity">{{ back.rarity }}</span>
                  </td>
                  <td class="td-level">
                    {{ back.point_cost > 0 ? back.point_cost.toLocaleString() : '—' }}
                  </td>
                  <td class="td-name">
                    <span class="availability-badge" v-if="back.available_shop" title="Reward Points Shop"><i class="bi-gem"></i></span>
                    <span class="availability-badge" v-if="back.available_store" title="Store"><i class="bi-shop"></i></span>
                    <span class="availability-badge" v-if="back.available_packs" title="Packs"><i class="bi-collection"></i></span>
                    <span class="availability-badge" v-if="back.available_chest" title="Chest"><i class="bi-box-seam"></i></span>
                    <span class="availability-badge" v-if="back.available_reward" title="Reward"><i class="bi-trophy"></i></span>
                    <span v-if="!back.available_shop && !back.available_store && !back.available_packs && !back.available_chest && !back.available_reward" class="text-muted small">None</span>
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(back.id)" title="Edit">
                      <i class="bi-pencil"></i>
                    </button>
                    <button class="admin-action-btn admin-delete-btn action-btn delete-btn" v-on:click.stop="remove(back.id)" title="Delete">
                      <i class="bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </template>
              <tr v-if="Object.keys(model.backs).length === 0">
                <td colspan="7" class="text-center p-4">
                  <p class="text-muted">No card backings yet. Click "Add Card Backing" to get started.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>`,

  adminExoticCards: `
  <div data-component="admin-exotic-cards">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-gem"></i>
              <div>
                <h2>Exotic Cards</h2>
                <p class="admin-subtitle quest-subtitle">1-of-a-kind cards awarded through exclusive events</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Exotic Card</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i>
            <div class="col-12 scroll_sidebar">

              <!-- Mode switch (only when creating a new exotic, not editing existing) -->
              <div v-if="!model.card.id">
                <label>Card Mode</label>
                <div class="btn-group w-100">
                  <button type="button" class="btn" :class="model.mode === 'new' ? 'btn-primary' : 'btn-outline-secondary'" v-on:click="switchMode('new')">
                    <i class="bi-plus-circle"></i> Create New
                  </button>
                  <button type="button" class="btn" :class="model.mode === 'modify' ? 'btn-primary' : 'btn-outline-secondary'" v-on:click="switchMode('modify')">
                    <i class="bi-pencil-square"></i> Modify Existing Card
                  </button>
                </div>
              </div>

              <!-- Base card selector shown only in modify mode -->
              <div v-if="model.mode === 'modify' && !model.card.id">
                <label>Select Base Card</label>
                <select class="form-select" v-model="model.baseCardId" v-on:change="selectBaseCard(model.baseCardId)">
                  <option value="">-- Select a card to base this on --</option>
                  <option v-for="(card, key) in model.allCards" :value="key" :key="key">
                    {{ card.name }}
                  </option>
                </select>
                <small class="text-muted">Stats are copied so you can customise them. The original card is not changed.</small>
              </div>

              <div>
                <label>Active</label>
                <div class="form-check form-switch">
                  <input v-model="model.card.active" type="checkbox" class="form-check-input">
                </div>
              </div>
              <div>
                <label>Name</label>
                <input class="form-control" v-model="model.card.name" type="text" placeholder="Exotic card name">
              </div>
              <div>
                <label>Type</label>
                <select class="form-select" v-model="model.card.type">
                  <option value="">Select Type</option>
                  <option v-for="(value, key) in model.types" v-bind:value="key">{{ value.name }}</option>
                </select>
              </div>
              <div>
                <label>Ability</label>
                <select class="form-select" v-model="model.card.ability">
                  <option value="">No Ability</option>
                  <option v-for="(value, key) in model.abilities" v-bind:value="key">
                    {{ value.name }} - {{ value.description }}
                  </option>
                </select>
              </div>
              <div>
                <label>Innate Trait</label>
                <select class="form-select" v-model="model.card.trait">
                  <option value="">No Trait</option>
                  <option v-for="trait in model.traits" :key="trait.id" :value="trait.id">
                    {{ trait.name }} - {{ trait.description }}
                  </option>
                </select>
              </div>
              <div>
                <label>HP</label>
                <input class="form-control" v-model="model.card.hp" type="number">
              </div>
              <div>
                <label>Physical Attack</label>
                <input class="form-control" v-model="model.card.pAtk" type="number">
              </div>
              <div>
                <label>Magic Attack</label>
                <input class="form-control" v-model="model.card.mAtk" type="number">
              </div>
              <div>
                <label>Armor</label>
                <input class="form-control" v-model="model.card.armor" type="number">
              </div>
              <div>
                <label>Ward</label>
                <input class="form-control" v-model="model.card.ward" type="number">
              </div>
              <div>
                <label>Speed</label>
                <input class="form-control" v-model="model.card.speed" type="number">
              </div>
              <div>
                <label>Accuracy</label>
                <input class="form-control" v-model="model.card.accuracy" type="number">
              </div>
              <div>
                <label>Crit Chance (%)</label>
                <input class="form-control" v-model="model.card.critChance" type="number">
              </div>
              <div>
                <label>Crit Damage (%)</label>
                <input class="form-control" v-model="model.card.critDamage" type="number">
              </div>
              <div>
                <label>Stamina</label>
                <input class="form-control" v-model="model.card.stamina" type="number">
              </div>
              <div>
                <label>Mana</label>
                <input class="form-control" v-model="model.card.mana" type="number">
              </div>
              <div>
                <label>Ultimate</label>
                <div class="form-check form-switch">
                  <input v-model="model.card.ultimate" type="checkbox" class="form-check-input" true-value="1" false-value="0">
                </div>
              </div>

              <hr>

              <!-- Prize assignment -->
              <div>
                <label><i class="bi-trophy"></i> Assign as Prize</label>
                <select class="form-select" v-model="model.reward.target" v-on:change="model.reward.targetId = null">
                  <option :value="null">-- No assignment --</option>
                  <option value="event">Active Event</option>
                  <option value="quest">Quest</option>
                </select>
              </div>

              <div v-if="model.reward.target === 'event'">
                <label>Select Event</label>
                <select class="form-select" v-model="model.reward.targetId">
                  <option :value="null">-- Select Event --</option>
                  <option v-for="event in activeEvents" :value="event.id" :key="event.id">
                    {{ event.name }} ({{ event.from ? event.from.substring(0,10) : '' }} - {{ event.to ? event.to.substring(0,10) : '' }})
                  </option>
                </select>
                <small v-if="activeEvents.length === 0" class="text-muted">No active events found.</small>
              </div>

              <div v-if="model.reward.target === 'quest'">
                <label>Select Quest</label>
                <select class="form-select" v-model="model.reward.targetId">
                  <option :value="null">-- Select Quest --</option>
                  <option v-for="quest in model.quests" :value="quest.id" :key="quest.id">
                    {{ quest.name }}
                  </option>
                </select>
                <small v-if="model.quests.length === 0" class="text-muted">No quests found.</small>
              </div>

              <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Exotic Card
              </button>

              <div v-if="model.card.id" class="upload-section">
                <file-upload
                  :multiple="false"
                  upload-type="cards"
                  :upload-id="model.card.id"
                  accepted-types="image/*"
                  :max-size="5 * 1024 * 1024"
                  :existing-images="model.card.image"
                  :allow-remove-existing="true"
                  :image-base-url="getCardUrl()"
                  @upload-success="handleCardImageUpload">
                </file-upload>
              </div>

            </div>
          </div>
        </div>

        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-level">Active</th>
                <th class="th-name">Name</th>
                <th class="th-name">Image</th>
                <th class="th-level">HP</th>
                <th class="th-level">pAtk</th>
                <th class="th-level">mAtk</th>
                <th class="th-level">Armor</th>
                <th class="th-level">Ward</th>
                <th class="th-level">Speed</th>
                <th class="th-level">Acc</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="card in model.cards" :key="card.id">
                <tr class="admin-table-row quest-row" v-on:click="edit(card.id)">
                  <td class="td-level">
                    <i v-if="card.active" class="bi-check-lg"></i>
                    <i v-else class="bi-x-lg"></i>
                  </td>
                  <td class="td-name">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ card.name }}</span>
                    </div>
                  </td>
                  <td class="td-name">
                        <img v-if="card.image && card.image[0]" :src="getCardUrl() + card.image[0]" :alt="card.name + ' image'" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer;" @click.stop @error="$event.target.style.display='none'" />
                        <span v-else style="color: #999;">No image</span>
                      </td>
                  <td class="td-level">{{ card.hp }}</td>
                  <td class="td-level">{{ card.pAtk }}</td>
                  <td class="td-level">{{ card.mAtk }}</td>
                  <td class="td-level">{{ card.armor }}</td>
                  <td class="td-level">{{ card.ward }}</td>
                  <td class="td-level">{{ card.speed }}</td>
                  <td class="td-level">{{ card.accuracy }}</td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(card.id)" title="Edit">
                      <i class="bi-pencil"></i>
                    </button>
                    <button class="admin-action-btn admin-delete-btn action-btn delete-btn" v-on:click.stop="delete(card.id)" title="Delete">
                      <i class="bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </template>
              <tr v-if="Object.keys(model.cards).length === 0">
                <td colspan="11" class="text-center p-4">
                  <p class="text-muted">No exotic cards yet. Click "Add Exotic Card" to create one.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>`,

  variantDeltaCard: `
<div data-component="variant-delta-card" :key="card.id" :id="card.id" :data-id="card.id"
  class="playing-card-container"
  :class="{ show: model.show, selected: card.selected }"
  :data-number="card.cardNumber"
  :data-tier="card.tier"
  v-on:click="select(card)">
  <div class="playing-card-wrapper">
    <div class="playing-card"
      :class="{ flipped: model.show, disabled: card.name === '' }"
      v-on:click="flip(card.id)">
      <div class="playing-card-face playing-card-backing"></div>
      <div v-if="card.name == ''" class="playing-card-face playing-card-front disabled" :data-tier="card.tier"></div>
      <div v-if="card.name" class="playing-card-face playing-card-front" :data-tier="card.tier" :style="{ 'background-image': 'url(' + card.image + ')' }">
        <div class="playing-card-front-frame">
          <div class="top">
            <p :title="card.name.split(' ')[0].slice(0, 7)">{{ card.name.split(' ')[0].slice(0, 7) }}</p>
            <p :title="card.type">{{ card.type }}</p>
          </div>
          <div class="bottom is-hidden">
            <div class="ability">{{ card.description }}</div>
          </div>
          <div class="info is-visible">
            <p class="number" v-if="card.cardNumber">Battle Number: #{{ card.cardNumber }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,

deltaLibraryCard: `
<div data-component="delta-library-card" :data-id="card.id" class="delta-library-card">
  <div class="delta-library-card-image" :style="card.image ? {'background-image': 'url(' + card.image + ')'} : {}">
    <div v-if="!card.image" class="delta-library-card-no-image"><i class="bi bi-triangle-fill"></i></div>
  </div>
  <div class="delta-library-card-body">
    <div class="delta-library-card-header">
      <h4 class="delta-library-card-name">{{ card.name }}</h4>
      <span class="delta-library-card-tier">Tier {{ card.tier }}</span>
    </div>
    <p class="delta-library-card-description">{{ card.description }}</p>
    <div class="delta-library-card-effect">{{ card.effect }}</div>
    <span class="delta-library-card-category">{{ card.category }}</span>
  </div>
</div>
`,

cardDeltaCards: `
  <div data-component="admin-delta-cards">
    <section class="quest-line-section">
      <div class="quest-line-container">
        <div class="admin-header-panel quest-header-panel">
          <div class="admin-header-content quest-header-content">
            <div class="admin-header-title quest-header-title">
              <i class="bi-stars"></i>
              <div>
                <h2>Delta Cards</h2>
                <p class="admin-subtitle quest-subtitle">Manage equippable delta cards</p>
              </div>
            </div>
            <button class="admin-add-btn quest-add-btn top-margin" data-button="submit" v-on:click="add()">
              <i class="bi-plus-lg"></i>
              <span>Add Delta Card</span>
            </button>
          </div>
        </div>

        <div class="row form admin-form-panel quest-form-panel" v-bind:class="{ visible: model.edit }">
          <div>
            <i class="bi-x-lg close" v-on:click="reset()"></i>
            <div class="col-12 scroll_sidebar">
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables this delta card so it can be equipped.">Active</label>
                <div class="form-check form-switch">
                  <input v-model="model.deltaCard.active" type="checkbox" class="form-check-input">
                </div>
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The delta card's name.">Name</label>
                <input class="form-control" v-model="model.deltaCard.name" type="text">
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Category: The category grouping for this delta card.">Category</label>
                <input class="form-control" v-model="model.deltaCard.category" type="text">
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Short flavour summary of the delta card.">Description</label>
                <input class="form-control" v-model="model.deltaCard.description" type="text">
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Effect: The exact mechanical effect text.">Effect</label>
                <textarea class="form-control" v-model="model.deltaCard.effect" rows="3"></textarea>
              </div>
              <div>
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reach Level: Minimum card level required to equip this delta card. Set to 0 for no requirement.">Reach Level</label>
                <input class="form-control" v-model.number="model.deltaCard.min_card_level" type="number" min="0">
              </div>
              <button class="admin-save-btn quest-save-btn top-margin" data-button="submit" v-on:click="save()">
                <i class="bi-check-lg"></i> Save Delta Card
              </button>
              <div v-if="model.deltaCard.id" class="upload-section">
                <file-upload
                  :multiple="false"
                  upload-type="delta-cards"
                  :upload-id="model.deltaCard.id"
                  accepted-types="image/*"
                  :max-size="5 * 1024 * 1024"
                  :existing-images="model.deltaCard.image"
                  :allow-remove-existing="false"
                  :image-base-url="getDeltaCardUrl()"
                  @upload-success="handleDeltaCardImageUpload">
                </file-upload>
              </div>
            </div>
          </div>
        </div>

        <div class="admin-table-wrapper quest-table-wrapper">
          <table class="admin-table quest-table">
            <thead>
              <tr>
                <th class="th-level">Active</th>
                <th class="th-image">Image</th>
                <th class="th-name">Name</th>
                <th class="th-name">Category</th>
                <th class="th-rules">Effect</th>
                <th class="th-level">Reach Lv.</th>
                <th class="th-level">Function ID</th>
                <th class="th-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="card in model.deltaCards" :key="card.id">
                <tr class="admin-table-row quest-row" v-on:click="edit(card.id)">
                  <td class="td-level">
                    <i v-if="card.active == true" class="bi-check-lg"></i>
                    <i v-if="card.active == false" class="bi-x-lg"></i>
                  </td>
                  <td class="td-image">
                    <img v-if="card.image && card.image.length"
                          :src="getDeltaCardUrl() + card.image[0]"
                          class="admin-table-image"
                          :alt="card.name">
                    <span v-else class="no-image">—</span>
                  </td>
                  <td class="td-name">
                    <div class="admin-name-cell quest-name-cell">
                      <span class="admin-name quest-name">{{ card.name }}</span>
                    </div>
                  </td>
                  <td class="td-name">
                    <span>{{ card.category }}</span>
                  </td>
                  <td class="td-rules">
                    <span class="admin-rules-text rules-text" :title="card.effect">{{ card.effect }}</span>
                  </td>
                  <td class="td-level">
                    {{ card.min_card_level > 0 ? card.min_card_level : '—' }}
                  </td>
                  <td class="td-level">
                    {{ card.id }}
                  </td>
                  <td class="td-actions">
                    <button class="admin-action-btn admin-edit-btn action-btn edit-btn" v-on:click.stop="edit(card.id)" title="Edit Delta Card">
                      <i class="bi-pencil"></i>
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  </div>
`
};
